import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const Component$78 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    }), /*#__PURE__*/jsx("path", {
      d: "M20.75 6.99c-.14-.55-.69-.87-1.24-.75-2.38.53-5.03.76-7.51.76s-5.13-.23-7.51-.76c-.55-.12-1.1.2-1.24.75-.14.56.2 1.13.75 1.26 1.61.36 3.35.61 5 .75v12c0 .55.45 1 1 1s1-.45 1-1v-5h2v5c0 .55.45 1 1 1s1-.45 1-1V9c1.65-.14 3.39-.39 4.99-.75.56-.13.9-.7.76-1.26M12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2"
    })]
  });
};
const AccessibilityFilled = /*#__PURE__*/forwardRef(Component$78);

const Component$77 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M6 17q-.425 0-.713-.288Q5 16.425 5 16v-5.025q0-.425.287-.7Q5.575 10 6 10t.713.287Q7 10.575 7 11v5.025q0 .425-.287.7Q6.425 17 6 17m6 0q-.425 0-.712-.288Q11 16.425 11 16v-5.025q0-.425.288-.7Q11.575 10 12 10t.713.287T13 11v5.025q0 .425-.287.7Q12.425 17 12 17m-9.025 4q-.425 0-.7-.288Q2 20.425 2 20t.288-.712Q2.575 19 3 19h18.025q.425 0 .7.288.275.287.275.712t-.288.712Q21.425 21 21 21ZM18 17q-.425 0-.712-.288Q17 16.425 17 16v-5.025q0-.425.288-.7Q17.575 10 18 10t.712.287Q19 10.575 19 11v5.025q0 .425-.288.7Q18.425 17 18 17M12.9 1.45l8.425 4.2q.325.175.5.487.175.313.175.688 0 .5-.362.837-.363.338-.863.338H3.25q-.5 0-.875-.338Q2 7.325 2 6.825q0-.375.163-.688.162-.312.512-.462L11.1 1.45q.425-.2.9-.2t.9.2M6.45 6h11.1Zm0 0h11.1L12 3.25Z"
    })
  });
};
const AccountBalance = /*#__PURE__*/forwardRef(Component$77);

const Component$76 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M6 17q-.425 0-.713-.288Q5 16.425 5 16v-5.025q0-.425.287-.7Q5.575 10 6 10t.713.287Q7 10.575 7 11v5.025q0 .425-.287.7Q6.425 17 6 17m6 0q-.425 0-.712-.288Q11 16.425 11 16v-5.025q0-.425.288-.7Q11.575 10 12 10t.713.287T13 11v5.025q0 .425-.287.7Q12.425 17 12 17m-9.025 4q-.425 0-.7-.288Q2 20.425 2 20t.288-.712Q2.575 19 3 19h18.025q.425 0 .7.288.275.287.275.712t-.288.712Q21.425 21 21 21ZM18 17q-.425 0-.712-.288Q17 16.425 17 16v-5.025q0-.425.288-.7Q17.575 10 18 10t.712.287Q19 10.575 19 11v5.025q0 .425-.288.7Q18.425 17 18 17M12.9 1.45l8.425 4.2q.325.175.5.487.175.313.175.688 0 .5-.362.837-.363.338-.863.338H3.25q-.5 0-.875-.338Q2 7.325 2 6.825q0-.35.163-.675.162-.325.512-.475L11.1 1.45q.425-.2.9-.2t.9.2"
    })
  });
};
const AccountBalanceFilled = /*#__PURE__*/forwardRef(Component$76);

const Component$75 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M680-120q-33 0-56.5-23.5T600-200v-40h-80q-33 0-56.5-23.5T440-320v-320h-80v40q0 33-23.5 56.5T280-520H160q-33 0-56.5-23.5T80-600v-160q0-33 23.5-56.5T160-840h120q33 0 56.5 23.5T360-760v40h240v-40q0-33 23.5-56.5T680-840h120q33 0 56.5 23.5T880-760v160q0 33-23.5 56.5T800-520H680q-33 0-56.5-23.5T600-600v-40h-80v320h80v-40q0-33 23.5-56.5T680-440h120q33 0 56.5 23.5T880-360v160q0 33-23.5 56.5T800-120zM160-760v160zm520 400v160zm0-400v160zm0 160h120v-160H680zm0 400h120v-160H680zM160-600h120v-160H160z"
    })
  });
};
const AccountTree = /*#__PURE__*/forwardRef(Component$75);

const Component$74 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M680-120q-33 0-56.5-23.5T600-200v-40h-80q-33 0-56.5-23.5T440-320v-320h-80v40q0 33-23.5 56.5T280-520H160q-33 0-56.5-23.5T80-600v-160q0-33 23.5-56.5T160-840h120q33 0 56.5 23.5T360-760v40h240v-40q0-33 23.5-56.5T680-840h120q33 0 56.5 23.5T880-760v160q0 33-23.5 56.5T800-520H680q-33 0-56.5-23.5T600-600v-40h-80v320h80v-40q0-33 23.5-56.5T680-440h120q33 0 56.5 23.5T880-360v160q0 33-23.5 56.5T800-120z"
    })
  });
};
const AccountTreeFilled = /*#__PURE__*/forwardRef(Component$74);

const Component$73 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M440-440H240q-17 0-28.5-11.5T200-480t11.5-28.5T240-520h200v-200q0-17 11.5-28.5T480-760t28.5 11.5T520-720v200h200q17 0 28.5 11.5T760-480t-11.5 28.5T720-440H520v200q0 17-11.5 28.5T480-200t-28.5-11.5T440-240z"
    })
  });
};
const Add = /*#__PURE__*/forwardRef(Component$73);

const Component$72 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 17q.425 0 .713-.288Q13 16.425 13 16v-3h3.025q.425 0 .7-.288Q17 12.425 17 12t-.288-.713Q16.425 11 16 11h-3V7.975q0-.425-.287-.7Q12.425 7 12 7t-.712.287Q11 7.575 11 8v3H7.975q-.425 0-.7.287Q7 11.575 7 12t.287.712Q7.575 13 8 13h3v3.025q0 .425.288.7.287.275.712.275m0 5q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22m0-2q3.325 0 5.663-2.337T20 12t-2.337-5.663Q15.325 4 12 4T6.338 6.337Q4 8.675 4 12t2.338 5.663Q8.675 20 12 20"
    })
  });
};
const AddCircle = /*#__PURE__*/forwardRef(Component$72);

const Component$71 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 17q.425 0 .713-.288Q13 16.425 13 16v-3h3.025q.425 0 .7-.288Q17 12.425 17 12t-.288-.713Q16.425 11 16 11h-3V7.975q0-.425-.287-.7Q12.425 7 12 7t-.712.287Q11 7.575 11 8v3H7.975q-.425 0-.7.287Q7 11.575 7 12t.287.712Q7.575 13 8 13h3v3.025q0 .425.288.7.287.275.712.275m0 5q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22"
    })
  });
};
const AddCircleFilled = /*#__PURE__*/forwardRef(Component$71);

const Component$70 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M280-280q-83 0-141.5-58.5T80-480t58.5-141.5T280-680h120q17 0 28.5 11.5T440-640t-11.5 28.5T400-600H280q-50 0-85 35t-35 85 35 85 85 35h120q17 0 28.5 11.5T440-320t-11.5 28.5T400-280zm80-160q-17 0-28.5-11.5T320-480t11.5-28.5T360-520h240q17 0 28.5 11.5T640-480t-11.5 28.5T600-440zm520-40h-80q0-50-35-85t-85-35H560q-17 0-28.5-11.5T520-640t11.5-28.5T560-680h120q83 0 141.5 58.5T880-480M720-160q-17 0-28.5-11.5T680-200v-80h-80q-17 0-28.5-11.5T560-320t11.5-28.5T600-360h80v-80q0-17 11.5-28.5T720-480t28.5 11.5T760-440v80h80q17 0 28.5 11.5T880-320t-11.5 28.5T840-280h-80v80q0 17-11.5 28.5T720-160"
    })
  });
};
const AddLink = /*#__PURE__*/forwardRef(Component$70);

const Component$6$ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M4.2 9.2c-.2 0-.5-.1-.7-.3s-.3-.5-.3-.7c0-.3.1-.5.3-.7s.5-.3.7-.3h16c.3 0 .5.1.7.3s.3.4.3.7-.1.5-.3.7-.4.3-.7.3zm0 4c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3h16c.3 0 .5.1.7.3s.3.4.3.7-.1.5-.3.7-.4.3-.7.3zm0 4c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3h7c.3 0 .5.1.7.3s.3.4.3.7-.1.5-.3.7-.4.3-.7.3zm0 3.9c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3h7c.3 0 .5.1.7.3s.3.4.3.7-.1.5-.3.7-.4.3-.7.3zm0-15.9c-.2 0-.5-.1-.7-.3s-.3-.5-.3-.7.1-.5.3-.7.5-.3.7-.3h16c.3 0 .5.1.7.3s.3.4.3.7-.1.5-.3.7-.4.3-.7.3zm13.5 15.9c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7v-1h-1c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3h1v-1c0-.3.1-.5.3-.7s.4-.3.7-.3.5.1.7.3.3.4.3.7v1h1c.3 0 .5.1.7.3s.3.4.3.7-.1.5-.3.7-.4.3-.7.3h-1v1c0 .3-.1.5-.3.7-.1.3-.4.3-.7.3"
    })
  });
};
const AddListicon = /*#__PURE__*/forwardRef(Component$6$);

const Component$6_ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-640q-66 0-113 47t-47 113q0 45 22.5 83t62.5 59q16 8 22.5 23.5T427-283q-7 14-21 21t-28 0q-63-30-100.5-89T240-480q0-100 70-170t170-70q71 0 130.5 37.5T699-580q6 14-.5 28T678-532q-16 7-32 0t-24-23q-21-40-59-62.5T480-640m0-160q-134 0-227 93t-93 227q0 126 83 216t208 102q17 2 29.5 15t11.5 30-12.5 28T451-79q-78-5-145.5-39t-118-88.5-79-125T80-480q0-83 31.5-156T197-763t127-85.5T480-880q157 0 273.5 107T881-509q2 16-9.5 27.5T843-469t-30.5-11-15.5-29q-15-120-104.5-205.5T480-800m302 700L650-231l-30 91q-5 14-19 13.5T582-141l-91-303q-4-11 5-20t20-5l303 91q14 5 14.5 19T820-340l-91 30 132 132q17 17 17 39t-17 39-39.5 17-39.5-17"
    })
  });
};
const AdsClick = /*#__PURE__*/forwardRef(Component$6_);

const Component$6Z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m438-412-57-57q-12-12-28-12t-28 12-12 28.5 12 28.5l85 86q12 12 28 12t28-12l170-170q12-12 12-28.5T636-553t-28.5-12-28.5 12zm42 332q-75 0-140.5-28.5t-114-77-77-114T120-440t28.5-140.5 77-114 114-77T480-800t140.5 28.5 114 77 77 114T840-440t-28.5 140.5-77 114-114 77T480-80M82-668q-11-11-11-28t11-28l114-114q11-11 28-11t28 11 11 28-11 28L138-668q-11 11-28 11t-28-11m796 0q-11 11-28 11t-28-11L708-782q-11-11-11-28t11-28 28-11 28 11l114 114q11 11 11 28t-11 28M480-160q117 0 198.5-81.5T760-440t-81.5-198.5T480-720t-198.5 81.5T200-440t81.5 198.5T480-160"
    })
  });
};
const AlarmOn = /*#__PURE__*/forwardRef(Component$6Z);

const Component$6Y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m438-412-57-57q-12-12-28-12t-28 12-12 28.5 12 28.5l85 86q12 12 28 12t28-12l170-170q12-12 12-28.5T636-553t-28.5-12-28.5 12zm42 332q-75 0-140.5-28.5t-114-77-77-114T120-440t28.5-140.5 77-114 114-77T480-800t140.5 28.5 114 77 77 114T840-440t-28.5 140.5-77 114-114 77T480-80M82-668q-11-11-11-28t11-28l114-114q11-11 28-11t28 11 11 28-11 28L138-668q-11 11-28 11t-28-11m796 0q-11 11-28 11t-28-11L708-782q-11-11-11-28t11-28 28-11 28 11l114 114q11 11 11 28t-11 28"
    })
  });
};
const AlarmOnFilled = /*#__PURE__*/forwardRef(Component$6Y);

const Component$6X = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-80q-61 0-125-22t-116-60-85.5-89T120-360v-80q0-12 11-18t21 2l91 68q14 11 15.5 29.5T247-327l-29 29q29 51 92 88t130 47v-357h-80q-17 0-28.5-11.5T320-560t11.5-28.5T360-600h80v-47q-35-13-57.5-43.5T360-760q0-50 35-85t85-35 85 35 35 85q0 39-22.5 69.5T520-647v47h80q17 0 28.5 11.5T640-560t-11.5 28.5T600-520h-80v357q67-10 130-47t92-88l-29-29q-13-13-11.5-31.5T717-388l91-68q10-8 21-2t11 18v80q0 58-33.5 109T721-162t-116 60-125 22m0-640q17 0 28.5-11.5T520-760t-11.5-28.5T480-800t-28.5 11.5T440-760t11.5 28.5T480-720"
    })
  });
};
const Anchor = /*#__PURE__*/forwardRef(Component$6X);

const Component$6W = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 21q-.825 0-1.413-.587Q3 19.825 3 19V9q0-.825.587-1.413Q4.175 7 5 7h2V5q0-.825.588-1.413Q8.175 3 9 3h6q.825 0 1.413.587Q17 4.175 17 5v6h2q.825 0 1.413.587Q21 12.175 21 13v6q0 .825-.587 1.413Q19.825 21 19 21h-6v-4h-2v4Zm0-2h2v-2H5Zm0-4h2v-2H5Zm0-4h2V9H5Zm4 4h2v-2H9Zm0-4h2V9H9Zm0-4h2V5H9Zm4 8h2v-2h-2Zm0-4h2V9h-2Zm0-4h2V5h-2Zm4 12h2v-2h-2Zm0-4h2v-2h-2Z"
    })
  });
};
const Apartment = /*#__PURE__*/forwardRef(Component$6W);

const Component$6V = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M240-160q-33 0-56.5-23.5T160-240t23.5-56.5T240-320t56.5 23.5T320-240t-23.5 56.5T240-160m240 0q-33 0-56.5-23.5T400-240t23.5-56.5T480-320t56.5 23.5T560-240t-23.5 56.5T480-160m240 0q-33 0-56.5-23.5T640-240t23.5-56.5T720-320t56.5 23.5T800-240t-23.5 56.5T720-160M240-400q-33 0-56.5-23.5T160-480t23.5-56.5T240-560t56.5 23.5T320-480t-23.5 56.5T240-400m240 0q-33 0-56.5-23.5T400-480t23.5-56.5T480-560t56.5 23.5T560-480t-23.5 56.5T480-400m240 0q-33 0-56.5-23.5T640-480t23.5-56.5T720-560t56.5 23.5T800-480t-23.5 56.5T720-400M240-640q-33 0-56.5-23.5T160-720t23.5-56.5T240-800t56.5 23.5T320-720t-23.5 56.5T240-640m240 0q-33 0-56.5-23.5T400-720t23.5-56.5T480-800t56.5 23.5T560-720t-23.5 56.5T480-640m240 0q-33 0-56.5-23.5T640-720t23.5-56.5T720-800t56.5 23.5T800-720t-23.5 56.5T720-640"
    })
  });
};
const Apps = /*#__PURE__*/forwardRef(Component$6V);

const Component$6U = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 21q-.825 0-1.413-.587Q3 19.825 3 19V6.5q0-.375.125-.675t.325-.575l1.4-1.7q.2-.275.5-.413T6 3h12q.35 0 .65.137.3.138.5.413l1.4 1.7q.2.275.325.575T21 6.5V19q0 .825-.587 1.413Q19.825 21 19 21Zm.4-15h13.2l-.85-1H6.25ZM5 19h14V8H5zm7-1.425q.2 0 .375-.063.175-.062.325-.212l2.6-2.6q.275-.275.275-.7t-.275-.7-.7-.275-.7.275l-.9.9V11q0-.425-.287-.713Q12.425 10 12 10t-.712.287T11 11v3.2l-.9-.9q-.275-.275-.7-.275t-.7.275-.275.7.275.7l2.6 2.6q.15.15.325.212.175.063.375.063M5 19V8z"
    })
  });
};
const Archive = /*#__PURE__*/forwardRef(Component$6U);

const Component$6T = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 21q-.825 0-1.413-.587Q3 19.825 3 19V6.5q0-.375.125-.675t.325-.575l1.4-1.7q.2-.275.5-.413T6 3h12q.35 0 .65.137.3.138.5.413l1.4 1.7q.2.275.325.575T21 6.5V19q0 .825-.587 1.413Q19.825 21 19 21Zm.4-15h13.2l-.85-1H6.25ZM12 17.575q.2 0 .375-.063.175-.062.325-.212l2.6-2.6q.275-.275.275-.7t-.275-.7-.7-.275-.7.275l-.9.9V11q0-.425-.287-.713Q12.425 10 12 10t-.712.287T11 11v3.2l-.9-.9q-.275-.275-.7-.275t-.7.275-.275.7.275.7l2.6 2.6q.15.15.325.212.175.063.375.063"
    })
  });
};
const ArchiveFilled = /*#__PURE__*/forwardRef(Component$6T);

const Component$6S = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "m12.7 15.3 2.6-2.6q.3-.3.3-.7t-.3-.7l-2.625-2.625a.9.9 0 0 0-.687-.263.98.98 0 0 0-.688.288.95.95 0 0 0-.275.7.95.95 0 0 0 .275.7l.9.9H8.975a.93.93 0 0 0-.7.287A1 1 0 0 0 8 12q0 .424.288.712A.97.97 0 0 0 9 13h3.2l-.925.925a.9.9 0 0 0-.263.688.98.98 0 0 0 .288.687.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275M12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12a9.7 9.7 0 0 1 .788-3.9 10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.138A9.7 9.7 0 0 1 12 2a9.7 9.7 0 0 1 3.9.787 10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12q0 1.77-.574 3.359a5 5 0 0 0-1.736-1.066Q20 13.213 20 12q0-3.325-2.337-5.663T12 4c-3.325 0-4.104.779-5.662 2.337Q4 8.675 4 12c0 3.325.78 4.104 2.338 5.663Q8.675 20 12 20q.558 0 1.087-.066c.131.693.405 1.335.79 1.895A10 10 0 0 1 12 22m6.069 1a.53.53 0 0 1-.396-.166.57.57 0 0 1-.16-.41v-5.023l-.717.536a.43.43 0 0 1-.377.096.5.5 0 0 1-.328-.236.5.5 0 0 1-.08-.403.55.55 0 0 1 .216-.351l1.212-.908a.7.7 0 0 1 .414-.135.76.76 0 0 1 .414.096q.147.09.253.282a.8.8 0 0 1 .105.37v5.677a.57.57 0 0 1-.16.409.53.53 0 0 1-.396.166",
      clipRule: "evenodd"
    })
  });
};
const ArrowCircleCount = /*#__PURE__*/forwardRef(Component$6S);

const Component$6R = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M12 15.575a.95.95 0 0 0 .7-.275l2.6-2.6a.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7l-2.625-2.625a.9.9 0 0 0-.687-.263.98.98 0 0 0-.688.288.95.95 0 0 0-.275.7.95.95 0 0 0 .275.7l.9.9H8.975a.93.93 0 0 0-.7.287A1 1 0 0 0 8 12q0 .424.288.712A.97.97 0 0 0 9 13h3.2l-.925.925a.9.9 0 0 0-.263.688.98.98 0 0 0 .288.687.95.95 0 0 0 .7.275M12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12a9.7 9.7 0 0 1 .788-3.9 10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.138A9.7 9.7 0 0 1 12 2a9.7 9.7 0 0 1 3.9.787 10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12q0 1.77-.573 3.359a5 5 0 0 0-7.55 6.47A10 10 0 0 1 12 22m6.069 1a.53.53 0 0 1-.396-.166.57.57 0 0 1-.16-.41v-5.023l-.717.536a.43.43 0 0 1-.377.096.5.5 0 0 1-.328-.236.5.5 0 0 1-.08-.403.55.55 0 0 1 .216-.351l1.212-.908a.7.7 0 0 1 .414-.135.76.76 0 0 1 .414.096q.148.09.253.282a.8.8 0 0 1 .105.37v5.677a.57.57 0 0 1-.16.409.53.53 0 0 1-.396.166",
      clipRule: "evenodd"
    })
  });
};
const ArrowCircleCountFilled = /*#__PURE__*/forwardRef(Component$6R);

const Component$6Q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m12.7 15.3 2.6-2.6q.3-.3.3-.7t-.3-.7l-2.625-2.625q-.275-.275-.687-.263T11.3 8.7t-.275.7.275.7l.9.9H8.975q-.425 0-.7.287Q8 11.575 8 12t.288.712T9 13h3.2l-.925.925q-.275.275-.263.688t.288.687q.275.275.7.275t.7-.275M12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22m0-2q3.325 0 5.663-2.337T20 12t-2.337-5.663Q15.325 4 12 4T6.338 6.337Q4 8.675 4 12t2.338 5.663Q8.675 20 12 20m0-8"
    })
  });
};
const ArrowCircleRight = /*#__PURE__*/forwardRef(Component$6Q);

const Component$6P = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block",
      "transform": "rotate(180deg)"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m12.7 15.3 2.6-2.6q.3-.3.3-.7t-.3-.7l-2.625-2.625q-.275-.275-.687-.263T11.3 8.7t-.275.7.275.7l.9.9H8.975q-.425 0-.7.287Q8 11.575 8 12t.288.712T9 13h3.2l-.925.925q-.275.275-.263.688t.288.687q.275.275.7.275t.7-.275M12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22m0-2q3.325 0 5.663-2.337T20 12t-2.337-5.663Q15.325 4 12 4T6.338 6.337Q4 8.675 4 12t2.338 5.663Q8.675 20 12 20m0-8"
    })
  });
};
const ArrowCircleLeft = /*#__PURE__*/forwardRef(Component$6P);

const Component$6O = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m12.7 15.3 2.6-2.6q.275-.275.275-.7t-.275-.7l-2.625-2.625q-.275-.275-.687-.263T11.3 8.7t-.275.7.275.7l.9.9H8.975q-.425 0-.7.287Q8 11.575 8 12t.288.712T9 13h3.2l-.925.925q-.275.275-.263.688t.288.687q.275.275.7.275t.7-.275M12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22"
    })
  });
};
const ArrowCircleRightFilled = /*#__PURE__*/forwardRef(Component$6O);

const Component$6N = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block",
      "transform": "rotate(180deg)"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m12.7 15.3 2.6-2.6q.275-.275.275-.7t-.275-.7l-2.625-2.625q-.275-.275-.687-.263T11.3 8.7t-.275.7.275.7l.9.9H8.975q-.425 0-.7.287Q8 11.575 8 12t.288.712T9 13h3.2l-.925.925q-.275.275-.263.688t.288.687q.275.275.7.275t.7-.275M12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22"
    })
  });
};
const ArrowCircleLeftFilled = /*#__PURE__*/forwardRef(Component$6N);

const Component$6M = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M11.3 19.3q-.275-.275-.288-.7t.263-.7l4.9-4.9H5q-.425 0-.713-.288Q4 12.425 4 12t.287-.713Q4.575 11 5 11h11.175l-4.9-4.9q-.275-.275-.263-.7t.288-.7.7-.275q.425 0 .7.275l6.6 6.6q.15.125.213.312.062.188.062.388t-.062.375-.213.325l-6.6 6.6q-.275.275-.7.275t-.7-.275"
    })
  });
};
const ArrowForward = /*#__PURE__*/forwardRef(Component$6M);

const Component$6L = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M7.15 21.1q-.375-.375-.375-.888 0-.512.375-.887L14.475 12l-7.35-7.35q-.35-.35-.35-.875t.375-.9.888-.375.887.375l8.4 8.425q.15.15.213.325.062.175.062.375t-.062.375-.213.325L8.9 21.125q-.35.35-.862.35-.513 0-.888-.375"
    })
  });
};
const ArrowForwardIos = /*#__PURE__*/forwardRef(Component$6L);

const Component$6K = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block",
      "transform": "rotate(180deg)"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M7.15 21.1q-.375-.375-.375-.888 0-.512.375-.887L14.475 12l-7.35-7.35q-.35-.35-.35-.875t.375-.9.888-.375.887.375l8.4 8.425q.15.15.213.325.062.175.062.375t-.062.375-.213.325L8.9 21.125q-.35.35-.862.35-.513 0-.888-.375"
    })
  });
};
const ArrowBackwards = /*#__PURE__*/forwardRef(Component$6K);

const Component$6J = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm0-80h560v-560H200zm0-560v560zm120 480h200q17 0 28.5-11.5T560-320t-11.5-28.5T520-360H320q-17 0-28.5 11.5T280-320t11.5 28.5T320-280m0-160h320q17 0 28.5-11.5T680-480t-11.5-28.5T640-520H320q-17 0-28.5 11.5T280-480t11.5 28.5T320-440m0-160h320q17 0 28.5-11.5T680-640t-11.5-28.5T640-680H320q-17 0-28.5 11.5T280-640t11.5 28.5T320-600"
    })
  });
};
const Article = /*#__PURE__*/forwardRef(Component$6J);

const Component$6I = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm120-160h200q17 0 28.5-11.5T560-320t-11.5-28.5T520-360H320q-17 0-28.5 11.5T280-320t11.5 28.5T320-280m0-160h320q17 0 28.5-11.5T680-480t-11.5-28.5T640-520H320q-17 0-28.5 11.5T280-480t11.5 28.5T320-440m0-160h320q17 0 28.5-11.5T680-640t-11.5-28.5T640-680H320q-17 0-28.5 11.5T280-640t11.5 28.5T320-600"
    })
  });
};
const ArticleFilled = /*#__PURE__*/forwardRef(Component$6I);

const Component$6H = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M9 16.6c-1.3 0-2.3-.3-3-.8-.6-.6-1-1.3-1-2.2s.4-1.6 1.1-2.1 1.6-.8 2.9-.9q.75 0 1.2-.3c.3-.2.4-.3.4-.5 0-.4-.2-.7-.6-.8-.4-.3-1.1-.4-2-.5L8.1 7c1.3.1 2.3.4 3 .8.7.5 1 1.1 1 1.9 0 .7-.3 1.2-.8 1.6-.5.5-1.3.7-2.2.8s-1.5.2-1.9.5-.6.6-.6 1.1.2.8.6 1 1.1.4 2 .4zm8.1-4.9L15 9.6l-5.2 5.1c-.1.1-.2.2-.2.3-.1.1-.1.3-.1.4v1.2c0 .1.1.2.2.3s.2.1.4.1h1.2c.1 0 .3 0 .4-.1s.2-.1.3-.2zm.6-.6.7-.7c.2-.2.3-.4.3-.7s-.1-.5-.3-.7l-.7-.7c-.2-.2-.4-.3-.7-.3s-.5.1-.7.3l-.7.7zM8.1 21.2c1.2.5 2.5.8 3.9.8s2.7-.3 3.9-.8 2.3-1.2 3.2-2.1 1.6-2 2.1-3.2.8-2.5.8-3.9-.3-2.7-.8-3.9-1.2-2.3-2.1-3.2-2-1.6-3.2-2.1S13.4 2 12 2s-2.7.3-3.9.8S5.8 4 4.9 4.9s-1.6 2-2.1 3.2S2 10.6 2 12s.3 2.7.8 3.9 1.2 2.3 2.1 3.2 2 1.6 3.2 2.1m9.6-3.5C16.1 19.2 14.2 20 12 20s-4.1-.8-5.7-2.3S4 14.2 4 12s.8-4.1 2.3-5.7S9.8 4 12 4s4.1.8 5.7 2.3S20 9.8 20 12s-.8 4.1-2.3 5.7"
    })
  });
};
const AssignState = /*#__PURE__*/forwardRef(Component$6H);

const Component$6G = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-6-6.2c.7.5 1.7.8 3 .8l.2-1.5c-.9 0-1.6-.2-2-.4s-.6-.5-.6-1 .2-.8.6-1.1 1-.4 1.9-.5 1.7-.3 2.2-.8c.5-.4.8-.9.8-1.6 0-.8-.3-1.4-1-1.9-.7-.4-1.7-.7-3-.8L8 8.5c.9.1 1.6.2 2 .5.4.1.6.4.6.8 0 .2-.1.3-.4.5q-.45.3-1.2.3c-1.3.1-2.2.4-2.9.9S5 12.7 5 13.6s.4 1.6 1 2.2m9-6.2 2.1 2.1-5.1 5c-.05.05-.1.075-.15.1s-.1.05-.15.1c-.1.1-.3.1-.4.1h-1.2c-.2 0-.3 0-.4-.1s-.2-.2-.2-.3v-1.2c0-.1 0-.3.1-.4 0-.1.1-.2.2-.3zm3.4.8-.7.7L15.6 9l.7-.7c.2-.2.4-.3.7-.3s.5.1.7.3l.7.7c.2.2.3.4.3.7s-.1.5-.3.7",
      clipRule: "evenodd"
    })
  });
};
const AssignStateFilled = /*#__PURE__*/forwardRef(Component$6G);

const Component$6F = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22 68.5 22 43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm0-80h560v-560H200zm120-80h200q17 0 28.5-11.5T560-320t-11.5-28.5T520-360H320q-17 0-28.5 11.5T280-320t11.5 28.5T320-280m0-160h320q17 0 28.5-11.5T680-480t-11.5-28.5T640-520H320q-17 0-28.5 11.5T280-480t11.5 28.5T320-440m0-160h320q17 0 28.5-11.5T680-640t-11.5-28.5T640-680H320q-17 0-28.5 11.5T280-640t11.5 28.5T320-600m160-190q13 0 21.5-8.5T510-820t-8.5-21.5T480-850t-21.5 8.5T450-820t8.5 21.5T480-790M200-200v-560z"
    })
  });
};
const Assignment = /*#__PURE__*/forwardRef(Component$6F);

const Component$6E = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22 68.5 22 43.5 58h168q33 0 56.5 23.5T840-760v268q-19-9-39-15.5t-41-9.5v-243H200v560h242q3 22 9.5 42t15.5 38zm0-120v40-560 243-3zm120-40h123q3-21 9.5-41t14.5-39H320q-17 0-28.5 11.5T280-320t11.5 28.5T320-280m0-160h204q32-30 71.5-50t84.5-27v-3H320q-17 0-28.5 11.5T280-480t11.5 28.5T320-440m0-160h320q17 0 28.5-11.5T680-640t-11.5-28.5T640-680H320q-17 0-28.5 11.5T280-640t11.5 28.5T320-600m160-190q13 0 21.5-8.5T510-820t-8.5-21.5T480-850t-21.5 8.5T450-820t8.5 21.5T480-790M720-40q-83 0-141.5-58.5T520-240t58.5-141.5T720-440t141.5 58.5T920-240 861.5-98.5 720-40m-20-180v80q0 8 6 14t14 6 14-6 6-14v-80h80q8 0 14-6t6-14-6-14-14-6h-80v-80q0-8-6-14t-14-6-14 6-6 14v80h-80q-8 0-14 6t-6 14 6 14 14 6z"
    })
  });
};
const AssignmentAdd = /*#__PURE__*/forwardRef(Component$6E);

const Component$6D = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-790q13 0 21.5-8.5T510-820t-8.5-21.5T480-850t-21.5 8.5T450-820t8.5 21.5T480-790M720-40q-83 0-141.5-58.5T520-240t58.5-141.5T720-440t141.5 58.5T920-240 861.5-98.5 720-40m-253-80H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22 68.5 22 43.5 58h168q33 0 56.5 23.5T840-760v268q-29-14-58.5-21t-61.5-7q-11 0-20.5.5T680-517v-3H320q-17 0-28.5 11.5T280-480t11.5 28.5T320-440h205q-18 17-32.5 37T467-360H320q-17 0-28.5 11.5T280-320t11.5 28.5T320-280h123q-2 10-2.5 19.5T440-240q0 33 6 61.5t21 58.5m233-100v80q0 8 6 14t14 6 14-6 6-14v-80h80q8 0 14-6t6-14-6-14-14-6h-80v-80q0-8-6-14t-14-6-14 6-6 14v80h-80q-8 0-14 6t-6 14 6 14 14 6zM320-600h320q17 0 28.5-11.5T680-640t-11.5-28.5T640-680H320q-17 0-28.5 11.5T280-640t11.5 28.5T320-600"
    })
  });
};
const AssignmentAddFilled = /*#__PURE__*/forwardRef(Component$6D);

const Component$6C = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22 68.5 22 43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm120-160h200q17 0 28.5-11.5T560-320t-11.5-28.5T520-360H320q-17 0-28.5 11.5T280-320t11.5 28.5T320-280m0-160h320q17 0 28.5-11.5T680-480t-11.5-28.5T640-520H320q-17 0-28.5 11.5T280-480t11.5 28.5T320-440m0-160h320q17 0 28.5-11.5T680-640t-11.5-28.5T640-680H320q-17 0-28.5 11.5T280-640t11.5 28.5T320-600m160-190q13 0 21.5-8.5T510-820t-8.5-21.5T480-850t-21.5 8.5T450-820t8.5 21.5T480-790"
    })
  });
};
const AssignmentFilled = /*#__PURE__*/forwardRef(Component$6C);

const Component$6B = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M11.5 22q-2.3 0-3.9-1.6T6 16.5V6q0-1.65 1.175-2.825T10 2t2.825 1.175T14 6v9.5q0 1.05-.725 1.775T11.5 18t-1.775-.725T9 15.5V6.75q0-.325.213-.537Q9.425 6 9.75 6t.538.213q.212.212.212.537v8.75q0 .425.288.712.287.288.712.288t.713-.288.287-.712V6q0-1.05-.725-1.775T10 3.5t-1.775.725T7.5 6v10.5q0 1.65 1.175 2.825T11.5 20.5t2.825-1.175T15.5 16.5V6.75q0-.325.213-.537Q15.925 6 16.25 6t.538.213q.212.212.212.537v9.75q0 2.3-1.6 3.9T11.5 22"
    })
  });
};
const AttachFile = /*#__PURE__*/forwardRef(Component$6B);

const Component$6A = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M11.75 22q-2.6 0-4.425-1.825T5.5 15.75V6.5q0-1.875 1.313-3.188Q8.125 2.001 10 2q1.875 0 3.188 1.313Q14.5 4.624 14.5 6.5V13q0 .424-.287.713A.97.97 0 0 1 13.5 14a.97.97 0 0 1-.713-.287A.97.97 0 0 1 12.5 13V6.5q-.025-1.05-.738-1.775Q11.05 4 10 4c-1.05 0-1.292.242-1.775.725Q7.5 5.45 7.5 6.5v9.25q-.025 1.775 1.225 3.012T11.75 20q.425 0 .8-.087.375-.088.725-.213a1 1 0 0 1 .775.012q.375.163.525.563a1 1 0 0 1-.012.775.95.95 0 0 1-.563.525 7 7 0 0 1-1.088.313A6 6 0 0 1 11.75 22M17 21a.97.97 0 0 1-.712-.288A.97.97 0 0 1 16 20v-2h-2a.97.97 0 0 1-.713-.288A.97.97 0 0 1 13 17a.97.97 0 0 1 .287-.712A.97.97 0 0 1 14 16h2v-2a.97.97 0 0 1 .288-.713A.97.97 0 0 1 17 13a.97.97 0 0 1 .712.287Q18 13.575 18 14v2h2q.424 0 .712.288.288.287.288.712c0 .425-.096.52-.288.712A.97.97 0 0 1 20 18h-2v2q0 .424-.288.712A.97.97 0 0 1 17 21m-7-4a.97.97 0 0 1-.713-.288A.97.97 0 0 1 9 16V7q0-.424.287-.713A.97.97 0 0 1 10 6q.424 0 .713.287Q11 6.575 11 7v9a.97.97 0 0 1-.287.712A.97.97 0 0 1 10 17m7-6a.97.97 0 0 1-.712-.287A.97.97 0 0 1 16 10V7a.97.97 0 0 1 .288-.713A.97.97 0 0 1 17 6a.97.97 0 0 1 .712.287Q18 6.575 18 7v3a.97.97 0 0 1-.288.713A.97.97 0 0 1 17 11"
    })
  });
};
const AttachFileAdd = /*#__PURE__*/forwardRef(Component$6A);

const Component$6z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M9.81 14.1h4.034l.733 2.04q.091.252.298.39.206.137.459.137a.77.77 0 0 0 .675-.355.75.75 0 0 0 .08-.745L12.95 7.134a.8.8 0 0 0-.31-.401.85.85 0 0 0-.492-.15h-.642a.85.85 0 0 0-.492.15.8.8 0 0 0-.31.4l-3.14 8.457a.73.73 0 0 0 .08.734q.241.343.677.343.252 0 .458-.149a.83.83 0 0 0 .298-.4zm.505-1.466 1.466-4.171h.092l1.467 4.17z"
    }), /*#__PURE__*/jsx("path", {
      d: "M20.167 6.309V4.75q0-.39.263-.653a.9.9 0 0 1 .653-.264q.39 0 .653.264A.9.9 0 0 1 22 4.75v3.667q0 .39-.264.653a.9.9 0 0 1-.653.264h-3.666a.9.9 0 0 1-.654-.264.9.9 0 0 1-.263-.653q0-.39.263-.653a.9.9 0 0 1 .653-.264h1.33a8.36 8.36 0 0 0-2.968-2.693 8 8 0 0 0-3.862-.974q-2.383 0-4.354 1.238a8.24 8.24 0 0 0-3.025 3.323q-.206.39-.539.619a.95.95 0 0 1-.768.137q-.412-.09-.538-.47-.126-.378.08-.813a10.1 10.1 0 0 1 3.69-4.263Q8.915 2 11.916 2q2.475 0 4.641 1.134a10.1 10.1 0 0 1 3.61 3.175M21.015 13q.39 0 .63.287.24.285.172.676a12 12 0 0 1-.596 1.982 10 10 0 0 1-.986 1.822q-.228.345-.595.39t-.665-.252q-.321-.32-.321-.7 0-.377.252-.767.39-.595.619-1.192.23-.595.412-1.306.092-.412.379-.676a1 1 0 0 1 .699-.264m-8.182 8.205q0-.435.264-.71.263-.276.699-.367a7.5 7.5 0 0 0 1.271-.413q.585-.252 1.18-.641.367-.253.745-.23.38.023.7.344a.76.76 0 0 1 .24.63q-.034.356-.355.608a11 11 0 0 1-1.776.974 9.5 9.5 0 0 1-1.96.584.88.88 0 0 1-.71-.16.74.74 0 0 1-.298-.62m-6.738-2.017q.32-.321.71-.332t.757.24q.595.39 1.192.62.595.229 1.306.412.412.09.676.378a1 1 0 0 1 .264.699.75.75 0 0 1-.287.619.8.8 0 0 1-.676.16 10.2 10.2 0 0 1-1.994-.573q-.895-.367-1.81-.985a.84.84 0 0 1-.367-.596.74.74 0 0 1 .23-.642M2.795 13q.435 0 .71.264.276.264.367.699.184.71.424 1.295.24.584.63 1.203.252.366.23.745-.023.378-.344.699a.73.73 0 0 1-.63.229q-.356-.046-.608-.367a10 10 0 0 1-.985-1.81 10.2 10.2 0 0 1-.573-1.994.8.8 0 0 1 .16-.676.75.75 0 0 1 .62-.287"
    })]
  });
};
const AutoCreate = /*#__PURE__*/forwardRef(Component$6z);

const Component$6y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M240-478q0 16 2 31.5t7 30.5q5 17-1 32.5T227-361q-16 8-31.5 1.5T175-383q-8-23-11.5-47t-3.5-48q0-134 93-228t227-94h7l-36-36q-11-11-11-28t11-28 28-11 28 11l104 104q12 12 12 28t-12 28L507-628q-11 11-28 11t-28-11-11-28 11-28l36-36h-7q-100 0-170 70.5T240-478m480-4q0-16-2-31.5t-7-30.5q-5-17 1-32.5t21-22.5q16-8 31.5-1.5T785-577q8 23 11.5 47t3.5 48q0 134-93 228t-227 94h-7l36 36q11 11 11 28t-11 28-28 11-28-11L349-172q-12-12-12-28t12-28l104-104q11-11 28-11t28 11 11 28-11 28l-36 36h7q100 0 170-70.5T720-482"
    })
  });
};
const Autorenew = /*#__PURE__*/forwardRef(Component$6y);

const Component$6x = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M5 16.75v-5c0-.27.1-.53.29-.71.19-.19.45-.29.71-.29.28 0 .52.1.71.29s.29.43.29.71v5c0 .28-.1.52-.29.71s-.45.29-.71.29a.99.99 0 0 1-1-1m6-3.59v3.59c0 .28.1.52.29.71s.43.29.71.29.52-.1.71-.29.29-.45.29-.71v-1.59l4.59 4.59H3c-.27 0-.53.1-.71.29-.19.19-.29.45-.29.71 0 .28.1.52.29.71s.43.29.71.29h16.59l.8.8c.38.4 1.02.41 1.41.02.4-.38.41-1.02.02-1.41L4.12 3.46a.987.987 0 0 0-1.41-.02c-.39.39-.41 1.02-.02 1.41l1.04 1.04-1.22.61c-.15.08-.27.19-.36.32A.78.78 0 0 0 2 7.3v.55c0 .25.09.46.26.64.17.17.4.27.64.26h3.69zm6-1.41v1.87l2 2v-3.87c0-.27-.1-.53-.29-.71-.19-.19-.45-.29-.71-.29-.27 0-.53.1-.71.29-.19.19-.29.45-.29.71m-6.87-5 2 2H21a.99.99 0 0 0 1-1v-.38c0-.18-.05-.36-.14-.53a.9.9 0 0 0-.41-.38L12.9 2.2c-.28-.13-.59-.2-.9-.2s-.62.07-.9.2L7.42 4.04l1.49 1.49L12 4l5.55 2.75z"
    })
  });
};
const BankAnonymous = /*#__PURE__*/forwardRef(Component$6x);

const Component$6w = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M5 16.89v-5q0-.424.287-.712A.97.97 0 0 1 6 10.891q.424 0 .713.287.287.288.287.713v5q0 .424-.287.712a.97.97 0 0 1-.713.288.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712m6 0v-5q0-.424.287-.712a.97.97 0 0 1 .713-.287q.424 0 .713.287.287.288.287.713v5q0 .424-.287.712a.97.97 0 0 1-.713.288.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712m10-8H2.9a.87.87 0 0 1-.637-.262A.87.87 0 0 1 2 7.991v-.55q0-.276.138-.475.137-.2.362-.325l8.6-4.3q.425-.2.9-.2t.9.2l8.55 4.275q.274.125.413.375.137.249.137.525v.375q0 .424-.288.712a.97.97 0 0 1-.712.288m-14.525-2h11.05L12 4.14zM3 21.89a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.712q0-.425.288-.713A.97.97 0 0 1 3 19.891h10.05q.424 0 .712.287.288.288.288.713 0 .424-.288.712a.97.97 0 0 1-.712.288zm15-8.25a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.712v-.75q0-.426.288-.713a.97.97 0 0 1 .712-.287q.424 0 .712.287.288.288.288.713v.75q0 .424-.288.712a.97.97 0 0 1-.712.288m.269 3.127v2.786l-.79-.767a.83.83 0 0 0-.613-.242.83.83 0 0 0-.614.242.81.81 0 0 0-.252.625.86.86 0 0 0 .252.602l2.28 2.281a.84.84 0 0 0 .948.195.8.8 0 0 0 .28-.195l2.28-2.281a.8.8 0 0 0 .253-.614.93.93 0 0 0-.254-.614.88.88 0 0 0-.614-.274.8.8 0 0 0-.614.252l-.788.79v-2.786a.85.85 0 0 0-.253-.624.85.85 0 0 0-.624-.253.85.85 0 0 0-.625.253.85.85 0 0 0-.252.624"
    })
  });
};
const BelowCompany = /*#__PURE__*/forwardRef(Component$6w);

const Component$6v = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12.5 11.95a5.7 5.7 0 0 0 1.113-1.825A6 6 0 0 0 14 8q0-1.1-.387-2.125A5.7 5.7 0 0 0 12.5 4.05q1.5.2 2.5 1.325T16 8t-1 2.625a3.94 3.94 0 0 1-2.5 1.325M18 20v-3q0-.9-.4-1.713a5.1 5.1 0 0 0-1.05-1.437q1.275.45 2.363 1.162Q20 15.725 20 17v3zM8 12q-1.65 0-2.825-1.175T4 8t1.175-2.825T8 4t2.825 1.175T12 8t-1.175 2.825T8 12m-8 8v-2.8q0-.85.438-1.562.437-.713 1.162-1.088a14.8 14.8 0 0 1 3.15-1.163A13.8 13.8 0 0 1 8 13q1.65 0 3.25.387 1.6.388 3.15 1.163.724.375 1.162 1.087Q16 16.35 16 17.2V20zm8-10q.825 0 1.412-.588Q10 8.826 10 8q0-.824-.588-1.412A1.93 1.93 0 0 0 8 6q-.824 0-1.412.588A1.93 1.93 0 0 0 6 8q0 .825.588 1.412Q7.175 10 8 10m-6 8h12v-.8a.97.97 0 0 0-.5-.85q-1.35-.675-2.725-1.012a11.6 11.6 0 0 0-5.55 0Q3.85 15.675 2.5 16.35a.97.97 0 0 0-.5.85zM19.869 7.21v2.786h-.001l-.789-.767a.83.83 0 0 0-.613-.242.83.83 0 0 0-.614.242.81.81 0 0 0-.252.625.86.86 0 0 0 .252.602l2.28 2.281a.84.84 0 0 0 .948.195.8.8 0 0 0 .28-.195l2.279-2.281a.8.8 0 0 0 .253-.615.93.93 0 0 0-.253-.613.88.88 0 0 0-.614-.274.8.8 0 0 0-.614.252l-.789.79V7.21a.85.85 0 0 0-.252-.624.85.85 0 0 0-.624-.254.85.85 0 0 0-.625.254.85.85 0 0 0-.252.624"
    })
  });
};
const BelowUnit = /*#__PURE__*/forwardRef(Component$6v);

const Component$6u = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h480q33 0 56.5 23.5T800-800v640q0 33-23.5 56.5T720-80zm0-80h480v-640h-80v245q0 12-10 17.5t-20-.5l-49-30q-10-6-20.5-6t-20.5 6l-49 30q-10 6-20.5.5T440-555v-245H240zm0 0v-640zm200-395q0 12 10.5 17.5t20.5-.5l49-30q10-6 20.5-6t20.5 6l49 30q10 6 20 .5t10-17.5q0 12-10 17.5t-20-.5l-49-30q-10-6-20.5-6t-20.5 6l-49 30q-10 6-20.5.5T440-555"
    })
  });
};
const Book = /*#__PURE__*/forwardRef(Component$6u);

const Component$6t = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h480q33 0 56.5 23.5T800-800v640q0 33-23.5 56.5T720-80zm200-720v245q0 12 9.5 17.5t20.5-.5l49-29q10-6 20.5-6t20.5 6l49 29q11 6 21 .5t10-17.5v-245z"
    })
  });
};
const BookFilled = /*#__PURE__*/forwardRef(Component$6t);

const Component$6s = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m480-240-168 72q-40 17-76-6.5T200-241v-519q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v519q0 43-36 66.5t-76 6.5zm0-88 200 86v-518H280v518zm0-432H280h400z"
    })
  });
};
const Bookmark = /*#__PURE__*/forwardRef(Component$6s);

const Component$6r = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m480-240-168 72q-40 17-76-6.5T200-241v-519q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v519q0 43-36 66.5t-76 6.5z"
    })
  });
};
const BookmarkFilled = /*#__PURE__*/forwardRef(Component$6r);

const Component$6q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-320"
    })
  });
};
const Brightness1 = /*#__PURE__*/forwardRef(Component$6q);

const Component$6p = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80"
    })
  });
};
const Brightness1Filled = /*#__PURE__*/forwardRef(Component$6p);

const Component$6o = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-120q-65 0-120.5-32T272-240h-72q-17 0-28.5-11.5T160-280t11.5-28.5T200-320h44q-3-20-3.5-40t-.5-40h-40q-17 0-28.5-11.5T160-440t11.5-28.5T200-480h40q0-20 .5-40t3.5-40h-44q-17 0-28.5-11.5T160-600t11.5-28.5T200-640h72q14-23 31.5-43t40.5-35l-37-38q-11-11-11-27.5t12-28.5q11-11 28-11t28 11l58 58q28-9 57-9t57 9l60-59q11-11 27.5-11t28.5 12q11 11 11 28t-11 28l-38 38q23 15 41.5 34.5T688-640h72q17 0 28.5 11.5T800-600t-11.5 28.5T760-560h-44q3 20 3.5 40t.5 40h40q17 0 28.5 11.5T800-440t-11.5 28.5T760-400h-40q0 20-.5 40t-3.5 40h44q17 0 28.5 11.5T800-280t-11.5 28.5T760-240h-72q-32 56-87.5 88T480-120m0-80q66 0 113-47t47-113v-160q0-66-47-113t-113-47-113 47-47 113v160q0 66 47 113t113 47m-40-120h80q17 0 28.5-11.5T560-360t-11.5-28.5T520-400h-80q-17 0-28.5 11.5T400-360t11.5 28.5T440-320m0-160h80q17 0 28.5-11.5T560-520t-11.5-28.5T520-560h-80q-17 0-28.5 11.5T400-520t11.5 28.5T440-480m40 40"
    })
  });
};
const BugReport = /*#__PURE__*/forwardRef(Component$6o);

const Component$6n = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-120q-65 0-120.5-32T272-240h-72q-17 0-28.5-11.5T160-280t11.5-28.5T200-320h44q-3-20-3.5-40t-.5-40h-40q-17 0-28.5-11.5T160-440t11.5-28.5T200-480h40q0-20 .5-40t3.5-40h-44q-17 0-28.5-11.5T160-600t11.5-28.5T200-640h72q14-23 31.5-43t40.5-35l-37-38q-11-11-11-27.5t12-28.5q11-11 28-11t28 11l58 58q28-9 57-9t57 9l60-59q11-11 27.5-11t28.5 12q11 11 11 28t-11 28l-38 38q23 15 41.5 34.5T688-640h72q17 0 28.5 11.5T800-600t-11.5 28.5T760-560h-44q3 20 3.5 40t.5 40h40q17 0 28.5 11.5T800-440t-11.5 28.5T760-400h-40q0 20-.5 40t-3.5 40h44q17 0 28.5 11.5T800-280t-11.5 28.5T760-240h-72q-32 56-87.5 88T480-120m-40-200h80q17 0 28.5-11.5T560-360t-11.5-28.5T520-400h-80q-17 0-28.5 11.5T400-360t11.5 28.5T440-320m0-160h80q17 0 28.5-11.5T560-520t-11.5-28.5T520-560h-80q-17 0-28.5 11.5T400-520t11.5 28.5T440-480"
    })
  });
};
const BugReportFilled = /*#__PURE__*/forwardRef(Component$6n);

const Component$6m = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M11 2.4v3.8c0 .2.3.4.6.4s.6-.2.6-.4V2.4c0-.2-.3-.4-.6-.4s-.6.2-.6.4m7.6 2-2.7 2.7c-.1.2-.1.4.1.7s.6.2.8.1l2.7-2.7c.2-.1.1-.5-.1-.7s-.7-.3-.8-.1m2.3 6.3h-2.6c-.2 0-.3.3-.3.6s.1.6.3.6h2.6c.2 0 .3-.3.3-.6s-.1-.6-.3-.6m-1.5 6.1L17.6 15c-.1-.1-.4 0-.6.2s-.3.5-.2.6l1.9 1.8c.1.1.4 0 .6-.2s.3-.4.1-.6M4.9 10.7H2.3c-.2 0-.3.3-.3.6s.1.6.3.6h2.6c.2 0 .3-.3.3-.6s-.1-.6-.3-.6m.7 4.3-1.8 1.8c-.1.1 0 .4.2.6s.5.3.6.2l1.8-1.8c.1-.1 0-.4-.2-.6s-.5-.3-.6-.2M3.7 5.2l2.7 2.7c.1.1.4.1.7-.2s.3-.5.2-.7L4.6 4.4c-.2-.2-.5-.1-.7.1s-.3.6-.2.7m12 7.3c0-2.3-1.9-4.2-4.2-4.2s-4.2 1.9-4.2 4.2c0 1.3.6 2.4 1.5 3.2v2c0 .2.1.4.3.4h4.7c.2 0 .4-.2.4-.4v-2c1-.7 1.5-1.9 1.5-3.2m-2.4 6.8H9.7c-.2 0-.4.2-.4.5s.2.5.4.5h3.6c.2 0 .4-.2.4-.5-.1-.3-.2-.5-.4-.5m-.3 1.8h-3l.8.8c.1.1.3.1.4.1h.6s.3 0 .4-.1z"
    })
  });
};
const Bulb = /*#__PURE__*/forwardRef(Component$6m);

const Component$6l = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M320-320v50q0 13 8.5 21.5T350-240t21.5-8.5T380-270v-50h50q13 0 21.5-8.5T460-350t-8.5-21.5T430-380h-50v-50q0-13-8.5-21.5T350-460t-21.5 8.5T320-430v50h-50q-13 0-21.5 8.5T240-350t8.5 21.5T270-320zm230 50h140q13 0 21.5-8.5T720-300t-8.5-21.5T690-330H550q-13 0-21.5 8.5T520-300t8.5 21.5T550-270m0-100h140q13 0 21.5-8.5T720-400t-8.5-21.5T690-430H550q-13 0-21.5 8.5T520-400t8.5 21.5T550-370M280-592h140q13 0 21.5-8.5T450-622t-8.5-21.5T420-652H280q-13 0-21.5 8.5T250-622t8.5 21.5T280-592m-80 472q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm0-80h560v-560H200zm0-560v560zm420 182 35 35q9 9 21 9t21-9q8-8 8.5-20.5T698-585l-36-37 35-35q9-9 9-21t-9-21-21-9-21 9l-35 35-35-35q-9-9-21-9t-21 9-9 21 9 21l35 35-36 37q-8 9-8 21t9 21 21 9 21-9z"
    })
  });
};
const Calculate = /*#__PURE__*/forwardRef(Component$6l);

const Component$6k = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M320-320v50q0 13 8.5 21.5T350-240t21.5-8.5T380-270v-50h50q13 0 21.5-8.5T460-350t-8.5-21.5T430-380h-50v-50q0-13-8.5-21.5T350-460t-21.5 8.5T320-430v50h-50q-13 0-21.5 8.5T240-350t8.5 21.5T270-320zm230 50h140q13 0 21.5-8.5T720-300t-8.5-21.5T690-330H550q-13 0-21.5 8.5T520-300t8.5 21.5T550-270m0-100h140q13 0 21.5-8.5T720-400t-8.5-21.5T690-430H550q-13 0-21.5 8.5T520-400t8.5 21.5T550-370M280-592h140q13 0 21.5-8.5T450-622t-8.5-21.5T420-652H280q-13 0-21.5 8.5T250-622t8.5 21.5T280-592m-80 472q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm420-458 35 35q9 9 21 9t21-9q8-8 8.5-20.5T698-585l-36-37 35-35q9-9 9-21t-9-21-21-9-21 9l-35 35-35-35q-9-9-21-9t-21 9-9 21 9 21l35 35-36 37q-8 9-8 21t9 21 21 9 21-9z"
    })
  });
};
const CalculateFilled = /*#__PURE__*/forwardRef(Component$6k);

const Component$6j = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 14q-.425 0-.712-.288Q11 13.425 11 13t.288-.713T12 12t.713.287Q13 12.575 13 13t-.287.712T12 14m-4 0q-.425 0-.713-.288Q7 13.425 7 13t.287-.713Q7.575 12 8 12t.713.287T9 13t-.287.712Q8.425 14 8 14m8 0q-.425 0-.712-.288Q15 13.425 15 13t.288-.713T16 12t.712.287Q17 12.575 17 13t-.288.712Q16.425 14 16 14m-4 4q-.425 0-.712-.288Q11 17.425 11 17t.288-.712Q11.575 16 12 16t.713.288Q13 16.575 13 17t-.287.712Q12.425 18 12 18m-4 0q-.425 0-.713-.288Q7 17.425 7 17t.287-.712Q7.575 16 8 16t.713.288Q9 16.575 9 17t-.287.712Q8.425 18 8 18m8 0q-.425 0-.712-.288Q15 17.425 15 17t.288-.712Q15.575 16 16 16t.712.288Q17 16.575 17 17t-.288.712Q16.425 18 16 18M5 22q-.825 0-1.413-.587Q3 20.825 3 20V6q0-.825.587-1.412Q4.175 4 5 4h1V3q0-.425.287-.713Q6.575 2 7 2t.713.287Q8 2.575 8 3v1h8V3q0-.425.288-.713Q16.575 2 17 2t.712.287Q18 2.575 18 3v1h1q.825 0 1.413.588Q21 5.175 21 6v14q0 .825-.587 1.413Q19.825 22 19 22Zm0-2h14V10H5zM5 8h14V6H5Zm0 0V6z"
    })
  });
};
const CalendarMonth = /*#__PURE__*/forwardRef(Component$6j);

const Component$6i = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 14q-.425 0-.712-.288Q11 13.425 11 13t.288-.713T12 12t.713.287Q13 12.575 13 13t-.287.712T12 14m-4 0q-.425 0-.713-.288Q7 13.425 7 13t.287-.713Q7.575 12 8 12t.713.287T9 13t-.287.712Q8.425 14 8 14m8 0q-.425 0-.712-.288Q15 13.425 15 13t.288-.713T16 12t.712.287Q17 12.575 17 13t-.288.712Q16.425 14 16 14m-4 4q-.425 0-.712-.288Q11 17.425 11 17t.288-.712Q11.575 16 12 16t.713.288Q13 16.575 13 17t-.287.712Q12.425 18 12 18m-4 0q-.425 0-.713-.288Q7 17.425 7 17t.287-.712Q7.575 16 8 16t.713.288Q9 16.575 9 17t-.287.712Q8.425 18 8 18m8 0q-.425 0-.712-.288Q15 17.425 15 17t.288-.712Q15.575 16 16 16t.712.288Q17 16.575 17 17t-.288.712Q16.425 18 16 18M5 22q-.825 0-1.413-.587Q3 20.825 3 20V6q0-.825.587-1.412Q4.175 4 5 4h1V3q0-.425.287-.713Q6.575 2 7 2t.713.287Q8 2.575 8 3v1h8V3q0-.425.288-.713Q16.575 2 17 2t.712.287Q18 2.575 18 3v1h1q.825 0 1.413.588Q21 5.175 21 6v14q0 .825-.587 1.413Q19.825 22 19 22Zm0-2h14V10H5z"
    })
  });
};
const CalendarMonthFilled = /*#__PURE__*/forwardRef(Component$6i);

const Component$6h = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M19.95 21q-3.225 0-6.287-1.438-3.063-1.437-5.425-3.8-2.363-2.362-3.8-5.425Q3 7.275 3 4.05q0-.45.3-.75t.75-.3H8.1q.35 0 .625.225t.325.575l.65 3.5q.05.35-.012.637-.063.288-.288.513L6.975 10.9q1.05 1.8 2.638 3.375T13.1 17l2.35-2.35q.225-.225.588-.338.362-.112.712-.062l3.45.7q.35.075.575.337.225.263.225.613v4.05q0 .45-.3.75t-.75.3M6.025 9l1.65-1.65L7.25 5H5.025q.125 1.025.35 2.025T6.025 9M19 18.95v-2.2l-2.35-.475-1.675 1.675q.975.425 1.988.675T19 18.95M6.025 9"
    })
  });
};
const Call = /*#__PURE__*/forwardRef(Component$6h);

const Component$6g = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-640q118 0 232.5 47.5T916-450q12 12 12 28t-12 28l-92 90q-11 11-25.5 12t-26.5-8l-116-88q-8-6-12-14t-4-18v-114q-38-12-78-19t-82-7-82 7-78 19v114q0 10-4 18t-12 14l-116 88q-12 9-26.5 8T136-304l-92-90q-12-12-12-28t12-28q88-95 203-142.5T480-640M240-502q-29 15-56 34.5T128-424l40 40 72-56zm480 2v60l72 56 40-38q-29-26-56-45t-56-33m0 0"
    })
  });
};
const CallEnd = /*#__PURE__*/forwardRef(Component$6g);

const Component$6f = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-640q118 0 232.5 47.5T916-450q12 12 12 28t-12 28l-92 90q-11 11-25.5 12t-26.5-8l-116-88q-8-6-12-14t-4-18v-114q-38-12-78-19t-82-7-82 7-78 19v114q0 10-4 18t-12 14l-116 88q-12 9-26.5 8T136-304l-92-90q-12-12-12-28t12-28q88-95 203-142.5T480-640"
    })
  });
};
const CallEndFilled = /*#__PURE__*/forwardRef(Component$6f);

const Component$6e = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M19.95 21q-3.225 0-6.287-1.438-3.063-1.437-5.425-3.8-2.363-2.362-3.8-5.425Q3 7.275 3 4.05q0-.45.3-.75t.75-.3H8.1q.35 0 .625.225t.325.575l.65 3.5q.05.35-.012.637-.063.288-.288.513L7 10.9q1.05 1.8 2.625 3.375T13.1 17l2.35-2.35q.225-.225.588-.338.362-.112.712-.062l3.45.7q.35.075.575.337.225.263.225.613v4.05q0 .45-.3.75t-.75.3"
    })
  });
};
const CallFilled = /*#__PURE__*/forwardRef(Component$6e);

const Component$6d = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M7.7 16.3q.275.275.7.275t.7-.275l2.9-2.9 2.925 2.925q.275.275.688.262.412-.012.687-.287t.275-.7-.275-.7L13.4 12l2.925-2.925q.275-.275.262-.688-.012-.412-.287-.687t-.7-.275-.7.275L12 10.6 9.075 7.675Q8.8 7.4 8.388 7.412T7.7 7.7q-.275.275-.275.7t.275.7l2.9 2.9-2.925 2.925q-.275.275-.262.687.012.413.287.688M12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22m0-2q3.325 0 5.663-2.337T20 12t-2.337-5.663Q15.325 4 12 4T6.338 6.337Q4 8.675 4 12t2.338 5.663Q8.675 20 12 20"
    })
  });
};
const Cancel = /*#__PURE__*/forwardRef(Component$6d);

const Component$6c = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M7.7 16.3q.275.275.7.275t.7-.275l2.9-2.9 2.925 2.925q.275.275.688.262.412-.012.687-.287t.275-.7-.275-.7L13.4 12l2.925-2.925q.275-.275.262-.688-.012-.412-.287-.687t-.7-.275-.7.275L12 10.6 9.075 7.675Q8.8 7.4 8.388 7.412T7.7 7.7q-.275.275-.275.7t.275.7l2.9 2.9-2.925 2.925q-.275.275-.262.687.012.413.287.688M12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22"
    })
  });
};
const CancelFilled = /*#__PURE__*/forwardRef(Component$6c);

const Component$6b = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M15.6 11.1c.2.2.4.3.7.3s.5-.1.7-.3.3-.4.3-.7-.1-.5-.3-.7-.4-.3-.7-.3-.5.1-.7.3-.3.4-.3.7.1.5.3.7m-4 0c.2.2.4.3.7.3s.5-.1.7-.3.3-.4.3-.7-.1-.5-.3-.7-.4-.3-.7-.3-.5.1-.7.3-.3.4-.3.7.1.5.3.7m-4 0c.2.2.4.3.7.3s.5-.1.7-.3.3-.4.3-.7-.1-.5-.3-.7-.4-.3-.7-.3-.5.1-.7.3-.3.4-.3.7.1.5.3.7m13 9.6-2.3-2.3h-6.5c0-.7-.1-1.4-.3-2h8.8v-12h-16v8.2c-.7.2-1.4.5-2 .9V4.4c0-.5.2-1 .6-1.4s.9-.6 1.4-.6h16c.6 0 1 .2 1.4.6s.6.9.6 1.4V20c0 .4-.2.8-.6.9-.4.2-.8.1-1.1-.2M8.3 19H5.1l.9.9c.2.2.3.4.3.7s-.1.5-.3.7-.4.3-.7.3-.5-.1-.7-.3L2 18.7c-.2-.2-.3-.4-.3-.7s.1-.5.3-.7l2.6-2.6c.2-.2.4-.3.7-.3s.5.1.7.3.3.4.3.7-.1.5-.3.7l-.9.9h3.2c.3 0 .5.1.7.3s.3.4.3.7-.1.5-.3.7-.4.3-.7.3"
    })
  });
};
const ChatLeft = /*#__PURE__*/forwardRef(Component$6b);

const Component$6a = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M22.3 4.4V20c0 .4-.201.8-.603.9-.402.2-.804.1-1.105-.2l-2.312-2.3h-6.53c0-3.3-2.713-6-6.03-6-1.306 0-2.512.4-3.517 1.1V4.4c0-.5.201-1 .603-1.4s.905-.6 1.407-.6H20.29c.603 0 1.005.2 1.407.6.503.4.603.8.603 1.4m-6.707 6.7c.201.2.402.3.704.3s.502-.1.703-.3.301-.4.301-.7-.1-.5-.301-.7a.97.97 0 0 0-.703-.3c-.302 0-.503.1-.704.3s-.301.4-.301.7.1.5.301.7m-4 0c.201.2.402.3.704.3s.502-.1.703-.3.301-.4.301-.7-.1-.5-.301-.7a.93.93 0 0 0-.704-.3c-.3 0-.502.1-.703.3s-.273.4-.273.7.072.5.273.7m-4 0c.201.2.503.3.704.3.301 0 .502-.1.703-.3s.301-.4.301-.7-.1-.5-.301-.7-.402-.3-.703-.3c-.302 0-.503.1-.704.3a.9.9 0 0 0-.293.7c0 .3.092.5.293.7m.639 7.9H5.117l.904.9c.2.2.301.4.301.7s-.1.5-.301.7-.402.3-.703.3c-.302 0-.503-.1-.704-.3l-2.613-2.6c-.2-.2-.301-.4-.301-.7s.1-.5.301-.7l2.513-2.6c.2-.2.502-.3.703-.3.301 0 .502.1.703.3s.302.4.302.7-.1.5-.302.7l-.904.9h3.216c.301 0 .502.1.703.3s.302.4.302.7-.101.5-.302.7c-.1.2-.402.3-.703.3"
    })
  });
};
const ChatLeftFilled = /*#__PURE__*/forwardRef(Component$6a);

const Component$69 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M8.4 11.1c-.2.2-.4.3-.7.3s-.5-.1-.7-.3-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3.5.1.7.3.3.4.3.7-.1.5-.3.7m4 0c-.2.2-.4.3-.7.3s-.5-.1-.7-.3-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3.5.1.7.3.3.4.3.7-.1.5-.3.7m4 0c-.2.2-.4.3-.7.3s-.5-.1-.7-.3-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3.5.1.7.3.3.4.3.7-.1.5-.3.7m-13 9.6 2.3-2.3h6.5c0-.7.1-1.4.3-2H3.7v-12h16v8.2c.7.2 1.4.5 2 .9V4.4c0-.5-.2-1-.6-1.4s-.9-.6-1.4-.6h-16c-.6 0-1 .2-1.4.6s-.6.9-.6 1.4V20c0 .4.2.8.6.9.4.2.8.1 1.1-.2M15.7 19h3.2l-.9.9c-.2.2-.3.4-.3.7s.1.5.3.7.4.3.7.3.5-.1.7-.3l2.6-2.6c.2-.2.3-.4.3-.7s-.1-.5-.3-.7l-2.6-2.6c-.2-.2-.4-.3-.7-.3s-.5.1-.7.3-.3.4-.3.7.1.5.3.7l.9.9h-3.2c-.3 0-.5.1-.7.3s-.3.4-.3.7.1.5.3.7.4.3.7.3"
    })
  });
};
const ChatRight = /*#__PURE__*/forwardRef(Component$69);

const Component$68 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M1.7 4.4V20c0 .4.2.8.603.9.402.2.804.1 1.105-.2l2.311-2.3h6.532c0-3.3 2.713-6 6.03-6 1.306 0 2.512.4 3.517 1.1V4.4c0-.5-.201-1-.603-1.4a2 2 0 0 0-1.407-.6H3.71c-.603 0-1.005.2-1.407.6-.503.4-.603.8-.603 1.4m6.707 6.7c-.201.2-.402.3-.704.3s-.502-.1-.703-.3-.302-.4-.302-.7.101-.5.302-.7a.97.97 0 0 1 .703-.3c.302 0 .503.1.704.3s.301.4.301.7-.1.5-.301.7m4 0c-.201.2-.402.3-.704.3s-.502-.1-.703-.3-.302-.4-.302-.7.101-.5.302-.7a.93.93 0 0 1 .703-.3c.302 0 .503.1.704.3s.273.4.273.7-.072.5-.273.7m4 0c-.201.2-.503.3-.704.3-.301 0-.502-.1-.703-.3s-.302-.4-.302-.7.101-.5.302-.7.402-.3.703-.3c.302 0 .503.1.704.3s.293.4.293.7a.9.9 0 0 1-.293.7m-.639 7.9h3.115l-.904.9c-.201.2-.302.4-.302.7s.101.5.302.7.402.3.703.3c.302 0 .503-.1.704-.3l2.613-2.6c.2-.2.3-.4.3-.7s-.1-.5-.3-.7l-2.513-2.6c-.2-.2-.502-.3-.703-.3-.302 0-.503.1-.704.3s-.301.4-.301.7.1.5.301.7l.905.9h-3.216c-.301 0-.502.1-.703.3s-.302.4-.302.7.1.5.302.7c.1.2.402.3.703.3"
    })
  });
};
const ChatRightFilled = /*#__PURE__*/forwardRef(Component$68);

const Component$67 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M9.55 17.575q-.2 0-.375-.063Q9 17.45 8.85 17.3L4.55 13q-.275-.275-.263-.713t.288-.712.7-.275.7.275L9.55 15.15l8.475-8.475q.275-.275.713-.275t.712.275q.275.275.275.712 0 .438-.275.713l-9.2 9.2q-.15.15-.325.212-.175.063-.375.063"
    })
  });
};
const Check = /*#__PURE__*/forwardRef(Component$67);

const Component$66 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m10.6 13.8-2.175-2.175q-.275-.275-.687-.262-.413.012-.688.287t-.275.7.275.7L9.9 15.9q.275.275.7.275t.7-.275l5.675-5.675q.275-.275.263-.688t-.288-.687q-.275-.275-.7-.275t-.7.275ZM12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22m0-2q3.325 0 5.663-2.337T20 12t-2.337-5.663Q15.325 4 12 4T6.338 6.337Q4 8.675 4 12t2.338 5.663Q8.675 20 12 20"
    })
  });
};
const CheckCircle = /*#__PURE__*/forwardRef(Component$66);

const Component$65 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m10.6 13.8-2.175-2.175q-.275-.275-.675-.275t-.7.3q-.275.275-.275.7t.275.7L9.9 15.9q.275.275.7.275t.7-.275l5.675-5.675q.275-.275.275-.675t-.3-.7q-.275-.275-.7-.275t-.7.275ZM12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22"
    })
  });
};
const CheckCircleFilled = /*#__PURE__*/forwardRef(Component$65);

const Component$64 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M14 9q-.425 0-.712-.288Q13 8.425 13 8t.288-.713Q13.575 7 14 7h7q.425 0 .712.287Q22 7.575 22 8t-.288.712Q21.425 9 21 9Zm0 8q-.425 0-.712-.288Q13 16.425 13 16t.288-.713T14 15h7q.425 0 .712.287.288.288.288.713t-.288.712Q21.425 17 21 17Zm-9.15-6.7L2.7 8.15q-.275-.275-.275-.7t.275-.7.7-.275.7.275l1.425 1.425 3.55-3.55q.3-.3.7-.288t.7.313q.275.3.275.7t-.275.7L6.25 10.3q-.3.3-.7.3t-.7-.3m0 8L2.7 16.15q-.275-.275-.275-.7t.275-.7.7-.275.7.275l1.425 1.425 3.55-3.55q.3-.3.7-.288t.7.313q.275.3.275.7t-.275.7L6.25 18.3q-.3.3-.7.3t-.7-.3"
    })
  });
};
const Checklist = /*#__PURE__*/forwardRef(Component$64);

const Component$63 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M504-480 348-636q-11-11-11-28t11-28 28-11 28 11l184 184q6 6 8.5 13t2.5 15-2.5 15-8.5 13L404-268q-11 11-28 11t-28-11-11-28 11-28z"
    })
  });
};
const ChevronRight = /*#__PURE__*/forwardRef(Component$63);

const Component$62 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block",
      "transform": "rotate(90deg)"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M504-480 348-636q-11-11-11-28t11-28 28-11 28 11l184 184q6 6 8.5 13t2.5 15-2.5 15-8.5 13L404-268q-11 11-28 11t-28-11-11-28 11-28z"
    })
  });
};
const ChevronDown = /*#__PURE__*/forwardRef(Component$62);

const Component$61 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block",
      "transform": "rotate(180deg)"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M504-480 348-636q-11-11-11-28t11-28 28-11 28 11l184 184q6 6 8.5 13t2.5 15-2.5 15-8.5 13L404-268q-11 11-28 11t-28-11-11-28 11-28z"
    })
  });
};
const ChevronLeft = /*#__PURE__*/forwardRef(Component$61);

const Component$60 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block",
      "transform": "rotate(270deg)"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M504-480 348-636q-11-11-11-28t11-28 28-11 28 11l184 184q6 6 8.5 13t2.5 15-2.5 15-8.5 13L404-268q-11 11-28 11t-28-11-11-28 11-28z"
    })
  });
};
const ChevronUp = /*#__PURE__*/forwardRef(Component$60);

const Component$5$ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-320"
    })
  });
};
const Circle = /*#__PURE__*/forwardRef(Component$5$);

const Component$5_ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80"
    })
  });
};
const CircleFilled = /*#__PURE__*/forwardRef(Component$5_);

const Component$5Z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-424 284-228q-11 11-28 11t-28-11-11-28 11-28l196-196-196-196q-11-11-11-28t11-28 28-11 28 11l196 196 196-196q11-11 28-11t28 11 11 28-11 28L536-480l196 196q11 11 11 28t-11 28-28 11-28-11z"
    })
  });
};
const Close = /*#__PURE__*/forwardRef(Component$5Z);

const Component$5Y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M520-480q-17 0-28.5-11.5T480-520v-240q0-17 11.5-28.5T520-800t28.5 11.5T560-760v144l236-236q11-11 28-11t28 11 11 28-11 28L616-560h144q17 0 28.5 11.5T800-520t-11.5 28.5T760-480zM108-108q-11-11-11-28t11-28l236-236H200q-17 0-28.5-11.5T160-440t11.5-28.5T200-480h240q17 0 28.5 11.5T480-440v240q0 17-11.5 28.5T440-160t-28.5-11.5T400-200v-144L164-108q-11 11-28 11t-28-11"
    })
  });
};
const CloseFullscreen = /*#__PURE__*/forwardRef(Component$5Y);

const Component$5X = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m193-479 155 155q11 11 11 28t-11 28-28 11-28-11L108-452q-6-6-8.5-13T97-480t2.5-15 8.5-13l184-184q12-12 28.5-12t28.5 12 12 28.5-12 28.5zm574-2L612-636q-11-11-11-28t11-28 28-11 28 11l184 184q6 6 8.5 13t2.5 15-2.5 15-8.5 13L668-268q-12 12-28 11.5T612-269t-12-28.5 12-28.5z"
    })
  });
};
const Code = /*#__PURE__*/forwardRef(Component$5X);

const Component$5W = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m8.825 12 1.475-1.475q.3-.3.3-.7t-.3-.7-.712-.3q-.413 0-.713.3L6.7 11.3q-.15.15-.212.325-.063.175-.063.375t.063.375.212.325l2.175 2.175q.3.3.713.3.412 0 .712-.3t.3-.7-.3-.7Zm6.35 0L13.7 13.475q-.3.3-.3.7t.3.7.713.3.712-.3L17.3 12.7q.15-.15.212-.325.063-.175.063-.375t-.063-.375-.212-.325l-2.175-2.175q-.15-.15-.337-.225t-.375-.075-.375.075q-.188.075-.338.225-.3.3-.3.7t.3.7ZM5 21q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h14q.825 0 1.413.587Q21 4.175 21 5v14q0 .825-.587 1.413Q19.825 21 19 21Zm0-2h14V5H5zM5 5v14z"
    })
  });
};
const CodeBlocks = /*#__PURE__*/forwardRef(Component$5W);

const Component$5V = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m8.825 12 1.475-1.475q.3-.3.3-.7t-.3-.7-.712-.3q-.413 0-.713.3L6.7 11.3q-.15.15-.212.325-.063.175-.063.375t.063.375.212.325l2.175 2.175q.3.3.713.3.412 0 .712-.3t.3-.7-.3-.7Zm6.35 0L13.7 13.475q-.3.3-.3.7t.3.7.713.3.712-.3L17.3 12.7q.15-.15.212-.325.063-.175.063-.375t-.063-.375-.212-.325l-2.175-2.175q-.15-.15-.337-.225t-.375-.075-.375.075q-.188.075-.338.225-.3.3-.3.7t.3.7ZM5 21q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h14q.825 0 1.413.587Q21 4.175 21 5v14q0 .825-.587 1.413Q19.825 21 19 21Z"
    })
  });
};
const CodeBlocksFilled = /*#__PURE__*/forwardRef(Component$5V);

const Component$5U = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M21.212 15.9A9.7 9.7 0 0 0 22 12a9.7 9.7 0 0 0-.788-3.9 10.1 10.1 0 0 0-2.137-3.175q-1.35-1.35-3.175-2.137A9.7 9.7 0 0 0 12 2a9.7 9.7 0 0 0-3.9.788 10.1 10.1 0 0 0-3.175 2.137Q3.575 6.275 2.787 8.1A9.7 9.7 0 0 0 2 12a9.7 9.7 0 0 0 .787 3.9 10.1 10.1 0 0 0 2.138 3.175q1.35 1.35 3.175 2.137A9.7 9.7 0 0 0 12 22a9.7 9.7 0 0 0 3.9-.788 10.1 10.1 0 0 0 3.175-2.137q1.35-1.35 2.137-3.175m-3.549-9.563Q20 8.675 20 12c0 3.325-.779 4.104-2.337 5.662Q15.325 20 12 20c-3.325 0-4.104-.78-5.663-2.338Q4 15.325 4 12c0-3.325.779-4.104 2.337-5.663Q8.675 4 12 4c3.325 0 4.104.779 5.663 2.337m-7.556 9.938q1.312.978 2.995.978a5 5 0 0 0 2.81-.847.62.62 0 0 0 .278-.496.72.72 0 0 0-.222-.569.68.68 0 0 0-.442-.212.8.8 0 0 0-.499.125q-.413.247-.912.394-.499.146-1.013.146a3.54 3.54 0 0 1-1.946-.562 3.67 3.67 0 0 1-1.334-1.481h3.28a.55.55 0 0 0 .407-.168.57.57 0 0 0 .163-.416.57.57 0 0 0-.163-.416.55.55 0 0 0-.407-.167h-3.65a4 4 0 0 1-.044-.292A3 3 0 0 1 9.394 12a3 3 0 0 1 .057-.584h3.651a.55.55 0 0 0 .407-.168.57.57 0 0 0 .163-.415.57.57 0 0 0-.163-.416.55.55 0 0 0-.407-.168h-3.28a3.67 3.67 0 0 1 1.334-1.48 3.53 3.53 0 0 1 1.946-.563q.528 0 1.012.146.486.147.913.394a.8.8 0 0 0 .507.117.7.7 0 0 0 .434-.204.72.72 0 0 0 .222-.57.62.62 0 0 0-.279-.495 5 5 0 0 0-2.81-.846q-1.681 0-2.994.977a5.24 5.24 0 0 0-1.854 2.524H6.257a.55.55 0 0 0-.407.168.57.57 0 0 0-.164.416.57.57 0 0 0 .57.583h1.74a2 2 0 0 0-.028.292v.584q0 .131.028.292h-1.74a.55.55 0 0 0-.406.167.57.57 0 0 0-.164.416.57.57 0 0 0 .57.584h1.997a5.24 5.24 0 0 0 1.854 2.524",
      clipRule: "evenodd"
    })
  });
};
const Coin = /*#__PURE__*/forwardRef(Component$5U);

const Component$5T = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M8.1 21.212A9.7 9.7 0 0 0 12 22a9.7 9.7 0 0 0 3.9-.788 10.1 10.1 0 0 0 3.175-2.137q1.35-1.35 2.137-3.175A9.7 9.7 0 0 0 22 12a9.7 9.7 0 0 0-.788-3.9 10.1 10.1 0 0 0-2.137-3.175q-1.35-1.35-3.175-2.138A9.7 9.7 0 0 0 12 2a9.7 9.7 0 0 0-3.9.787 10.1 10.1 0 0 0-3.175 2.138Q3.575 6.275 2.788 8.1A9.7 9.7 0 0 0 2 12a9.7 9.7 0 0 0 .788 3.9 10.1 10.1 0 0 0 2.137 3.175q1.35 1.35 3.175 2.137m2.007-4.937q1.312.978 2.995.978a5 5 0 0 0 2.81-.847.62.62 0 0 0 .278-.496.72.72 0 0 0-.222-.569.68.68 0 0 0-.442-.212.8.8 0 0 0-.499.125q-.414.247-.913.394a3.6 3.6 0 0 1-1.012.146 3.53 3.53 0 0 1-1.947-.562 3.67 3.67 0 0 1-1.333-1.481h3.28a.55.55 0 0 0 .407-.168.57.57 0 0 0 .163-.416.57.57 0 0 0-.163-.416.55.55 0 0 0-.407-.167h-3.65a4 4 0 0 1-.044-.292A3 3 0 0 1 9.394 12a3 3 0 0 1 .057-.584h3.65a.57.57 0 0 0 .57-.584.57.57 0 0 0-.162-.415.55.55 0 0 0-.407-.168h-3.28a3.67 3.67 0 0 1 1.334-1.48 3.53 3.53 0 0 1 1.946-.563q.528 0 1.012.146.486.147.913.394a.8.8 0 0 0 .507.117.7.7 0 0 0 .434-.204.72.72 0 0 0 .222-.57.62.62 0 0 0-.279-.495 5 5 0 0 0-2.81-.846q-1.682 0-2.994.977a5.24 5.24 0 0 0-1.854 2.524H6.257a.55.55 0 0 0-.407.168.57.57 0 0 0-.164.416.57.57 0 0 0 .57.583h1.74a2 2 0 0 0-.028.292v.584q0 .131.028.292h-1.74a.55.55 0 0 0-.406.167.57.57 0 0 0-.164.416.57.57 0 0 0 .57.584h1.997a5.24 5.24 0 0 0 1.854 2.524",
      clipRule: "evenodd"
    })
  });
};
const CoinFilled = /*#__PURE__*/forwardRef(Component$5T);

const Component$5S = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M9.5 11q.624 0 1.063-.438Q11 10.125 11 9.5q0-.624-.438-1.063A1.45 1.45 0 0 0 9.5 8q-.624 0-1.063.438A1.45 1.45 0 0 0 8 9.5q0 .624.438 1.063Q8.875 11 9.5 11m-.05 4.525a.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7.95.95 0 0 1 .275-.7l5.1-5.1a.95.95 0 0 1 .7-.275.95.95 0 0 1 .7.275.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-5.1 5.1a.95.95 0 0 1-.7.275m6.113.038A1.45 1.45 0 0 1 14.5 16q-.624 0-1.063-.438A1.45 1.45 0 0 1 13 14.5q0-.624.438-1.063A1.45 1.45 0 0 1 14.5 13q.624 0 1.063.438.437.437.437 1.062 0 .624-.438 1.063Z"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2 0h14v14H5z",
      clipRule: "evenodd"
    })]
  });
};
const Commissionmodel = /*#__PURE__*/forwardRef(Component$5S);

const Component$5R = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm4.5 8q.624 0 1.063-.438Q11 10.125 11 9.5q0-.624-.438-1.063A1.45 1.45 0 0 0 9.5 8q-.624 0-1.063.438A1.45 1.45 0 0 0 8 9.5q0 .624.438 1.063Q8.875 11 9.5 11m-.05 4.525a.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7.95.95 0 0 1 .275-.7l5.1-5.1a.95.95 0 0 1 .7-.275.95.95 0 0 1 .7.275.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-5.1 5.1a.95.95 0 0 1-.7.275m6.113.037A1.45 1.45 0 0 1 14.5 16q-.624 0-1.063-.438A1.45 1.45 0 0 1 13 14.5q0-.624.438-1.063A1.45 1.45 0 0 1 14.5 13q.624 0 1.063.438.437.437.437 1.062 0 .624-.438 1.063Z",
      clipRule: "evenodd"
    })
  });
};
const CommissionmodelFilled = /*#__PURE__*/forwardRef(Component$5R);

const Component$5Q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m15.3 13.3-3.6-3.6q-.15-.15-.212-.325-.063-.175-.063-.375t.063-.375q.062-.175.212-.325l3.6-3.6q.3-.3.7-.3t.7.3.3.712q0 .413-.3.713L14.825 8H21q.425 0 .712.287Q22 8.575 22 9t-.288.712Q21.425 10 21 10h-6.175l1.875 1.875q.3.3.3.7t-.3.7-.687.325-.713-.3m-8 5.975q.3.3.7.312t.7-.287l3.6-3.6q.15-.15.213-.325.062-.175.062-.375t-.062-.375q-.063-.175-.213-.325l-3.6-3.6q-.3-.3-.7-.3t-.7.3-.3.712q0 .413.3.713L9.175 14H3q-.425 0-.712.287Q2 14.575 2 15t.288.712Q2.575 16 3 16h6.175L7.3 17.875q-.3.3-.3.7t.3.7"
    })
  });
};
const CompareArrows = /*#__PURE__*/forwardRef(Component$5Q);

const Component$5P = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M14.708 16.75q-.845 0-1.443-.598a1.97 1.97 0 0 1-.598-1.444q0-.846.598-1.443.598-.599 1.443-.598.847 0 1.444.598.598.598.598 1.443t-.598 1.444q-.598.598-1.444.598m5.25 5.25q-.845 0-1.443-.598a1.97 1.97 0 0 1-.598-1.444q0-.846.598-1.443.598-.599 1.443-.598.846 0 1.444.598T22 19.958t-.598 1.444-1.444.598"
    }), /*#__PURE__*/jsx("path", {
      d: "M6 22c-.55 0-1.02-.2-1.41-.59S4 20.55 4 20V4c0-.55.2-1.02.59-1.41S5.45 2 6 2h7.18c.27 0 .52.05.76.15s.45.24.64.42l4.85 4.85c.18.18.32.4.43.64.1.24.15.5.15.76V10c0 .28-.1.52-.29.71s-.43.29-.71.29-.52-.1-.71-.29a.97.97 0 0 1-.29-.71V9h-4c-.28 0-.52-.1-.71-.29a.97.97 0 0 1-.29-.71V4h-7v16h4c.28 0 .52.1.71.29s.29.43.29.71-.1.52-.29.71-.43.29-.71.29zm15.709-7.604L14.406 21.7a.97.97 0 0 1-.708.301q-.405 0-.707-.3a1 1 0 0 1-.31-.7.93.93 0 0 1 .293-.697L20.277 13q.3-.3.706-.3.408 0 .708.3t.309.698a.93.93 0 0 1-.291.698"
    })]
  });
};
const Condition = /*#__PURE__*/forwardRef(Component$5P);

const Component$5O = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M4 14c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m16 0c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m-8 2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4"
    })
  });
};
const ConnectionStateFilled = /*#__PURE__*/forwardRef(Component$5O);

const Component$5N = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-40q-17 0-28.5-11.5T160-80t11.5-28.5T200-120h560q17 0 28.5 11.5T800-80t-11.5 28.5T760-40zm0-800q-17 0-28.5-11.5T160-880t11.5-28.5T200-920h560q17 0 28.5 11.5T800-880t-11.5 28.5T760-840zm280 400q50 0 85-35t35-85-35-85-85-35-85 35-35 85 35 85 85 35M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160zm70-80q45-56 109-88t141-32 141 32 109 88h70v-480H160v480zm118 0h264q-29-20-62.5-30T480-280t-69.5 10-62.5 30m132-280q-17 0-28.5-11.5T440-560t11.5-28.5T480-600t28.5 11.5T520-560t-11.5 28.5T480-520m0 40"
    })
  });
};
const Contacts = /*#__PURE__*/forwardRef(Component$5N);

const Component$5M = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-440q50 0 85-35t35-85-35-85-85-35-85 35-35 85 35 85 85 35M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160zm70-80h500q-45-56-109-88t-141-32-141 32-109 88M200-40q-17 0-28.5-11.5T160-80t11.5-28.5T200-120h560q17 0 28.5 11.5T800-80t-11.5 28.5T760-40zm0-800q-17 0-28.5-11.5T160-880t11.5-28.5T200-920h560q17 0 28.5 11.5T800-880t-11.5 28.5T760-840z"
    })
  });
};
const ContactsFilled = /*#__PURE__*/forwardRef(Component$5M);

const Component$5L = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240zm0-80h360v-480H360zM200-80q-33 0-56.5-23.5T120-160v-520q0-17 11.5-28.5T160-720t28.5 11.5T200-680v520h400q17 0 28.5 11.5T640-120t-11.5 28.5T600-80zm160-240v-480z"
    })
  });
};
const ContentCopy = /*#__PURE__*/forwardRef(Component$5L);

const Component$5K = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240zM200-80q-33 0-56.5-23.5T120-160v-520q0-17 11.5-28.5T160-720t28.5 11.5T200-680v520h400q17 0 28.5 11.5T640-120t-11.5 28.5T600-80z"
    })
  });
};
const ContentCopyFilled = /*#__PURE__*/forwardRef(Component$5K);

const Component$5J = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M4.4 22q-.825 0-1.412-.587A1.93 1.93 0 0 1 2.4 20V4q0-.825.588-1.413A1.93 1.93 0 0 1 4.4 2h7.175a1.98 1.98 0 0 1 1.4.575l4.85 4.85a1.98 1.98 0 0 1 .575 1.4V12h-2V9h-4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 11.4 8V4h-7v16h6v2zm12.3-7.475 1.075 1.075-3.875 3.85v1.05h1.05l3.875-3.85 1.05 1.05-4 4a1.03 1.03 0 0 1-.725.3H12.9a.48.48 0 0 1-.35-.15.48.48 0 0 1-.15-.35v-2.25a1.03 1.03 0 0 1 .3-.725zm3.175 3.175L16.7 14.525l1.45-1.45a.95.95 0 0 1 .7-.275.95.95 0 0 1 .7.275l1.775 1.775a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7z"
    }), /*#__PURE__*/jsx("path", {
      d: "M8.35 16.802a.59.59 0 0 1-.654.024.61.61 0 0 1-.331-.573v-6.68q0-.388.33-.573a.59.59 0 0 1 .654.024l5.26 3.34q.29.194.29.549t-.29.548l-5.26 3.34Z"
    })]
  });
};
const ContinueSigning = /*#__PURE__*/forwardRef(Component$5J);

const Component$5I = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M3.088 21.413Q3.675 22 4.5 22h6v-2.925l8-7.975V8.825a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H4.5q-.824 0-1.412.587A1.93 1.93 0 0 0 2.5 4v16q0 .825.588 1.413M16.5 9h-4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 11.5 8V4zm-9.97 7.913a.59.59 0 0 0 .654-.024l5.26-3.34a.62.62 0 0 0 .29-.549.62.62 0 0 0-.29-.549l-5.26-3.34a.59.59 0 0 0-.653-.024.61.61 0 0 0-.331.573v6.68q0 .388.33.573",
      clipRule: "evenodd"
    }), /*#__PURE__*/jsx("path", {
      d: "M12.65 21.85q.15.15.35.15h1.2q.2 0 .4-.075a.76.76 0 0 0 .325-.225l4.875-4.9-2.15-2.1-4.85 4.875a1 1 0 0 0-.212.325 1 1 0 0 0-.088.4v1.2q0 .2.15.35m5.75-7.875 2.125 2.125.7-.7a.93.93 0 0 0 .275-.688 1.02 1.02 0 0 0-.275-.712l-.7-.725a.9.9 0 0 0-.7-.3q-.425 0-.725.3z"
    })]
  });
};
const ContinueSigningFilled = /*#__PURE__*/forwardRef(Component$5I);

const Component$5H = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M7 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 20V4q0-.824.588-1.413A1.93 1.93 0 0 1 7 2h7.175a1.98 1.98 0 0 1 1.4.575l4.85 4.85a1.98 1.98 0 0 1 .575 1.4V10a.97.97 0 0 1-.288.713A.97.97 0 0 1 20 11a.97.97 0 0 1-.712-.287A.97.97 0 0 1 19 10V9h-4a.97.97 0 0 1-.713-.287A.97.97 0 0 1 14 8V4H7v16h4a.97.97 0 0 1 .713.288Q12 20.575 12 21c0 .425-.096.52-.287.712A.97.97 0 0 1 11 22z"
    }), /*#__PURE__*/jsx("path", {
      d: "m15.883 20.058-.438 1.258a.96.96 0 0 1-.371.495 1.02 1.02 0 0 1-.597.189q-.53 0-.849-.432a.95.95 0 0 1-.128-.95l2.848-7.867a1.17 1.17 0 0 1 .425-.546 1.1 1.1 0 0 1 .652-.205h.828q.36 0 .652.205.293.206.425.546l2.848 7.864a.96.96 0 0 1-.124.947 1 1 0 0 1-.856.438 1.06 1.06 0 0 1-1-.704l-.425-1.238zm.65-1.897h2.578l-1.289-3.741z"
    })]
  });
};
const CreateOffer = /*#__PURE__*/forwardRef(Component$5H);

const Component$5G = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 21q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h14q.825 0 1.413.587Q21 4.175 21 5v14q0 .825-.587 1.413Q19.825 21 19 21Zm0-2h14V5H5zm0 0V5z"
    })
  });
};
const CropSquare = /*#__PURE__*/forwardRef(Component$5G);

const Component$5F = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 21q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h14q.825 0 1.413.587Q21 4.175 21 5v14q0 .825-.587 1.413Q19.825 21 19 21Z"
    })
  });
};
const CropSquareFilled = /*#__PURE__*/forwardRef(Component$5F);

const Component$5E = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 21q-3.775 0-6.388-2.613T3 12q0-3.45 2.25-5.988Q7.5 3.475 11 3.05q.625-.075.975.45t-.025 1.1q-.425.65-.638 1.375Q11.1 6.7 11.1 7.5q0 2.25 1.575 3.825T16.5 12.9q.775 0 1.538-.225.762-.225 1.362-.625.525-.35 1.075-.038.55.313.475.988-.35 3.45-2.937 5.725Q15.425 21 12 21m0-2q2.2 0 3.95-1.212 1.75-1.213 2.55-3.163-.5.125-1 .2t-1 .075q-3.075 0-5.238-2.162Q9.1 10.575 9.1 7.5q0-.5.075-1t.2-1q-1.95.8-3.162 2.55Q5 9.8 5 12q0 2.9 2.05 4.95T12 19m-.25-6.75"
    })
  });
};
const DarkMode = /*#__PURE__*/forwardRef(Component$5E);

const Component$5D = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 21q-3.775 0-6.388-2.613T3 12q0-3.45 2.25-5.988Q7.5 3.475 11 3.05q.625-.075.975.45t-.025 1.1q-.425.65-.638 1.375Q11.1 6.7 11.1 7.5q0 2.25 1.575 3.825T16.5 12.9q.775 0 1.538-.225.762-.225 1.362-.625.525-.35 1.075-.038.55.313.475.988-.35 3.45-2.937 5.725Q15.425 21 12 21"
    })
  });
};
const DarkModeFilled = /*#__PURE__*/forwardRef(Component$5D);

const Component$5C = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm0-507h560v-133H200zm0 214h560v-134H200zm0 213h560v-133H200zm80-454q-17 0-28.5-11.5T240-694t11.5-28.5T280-734t28.5 11.5T320-694t-11.5 28.5T280-654m0 214q-17 0-28.5-11.5T240-480t11.5-28.5T280-520t28.5 11.5T320-480t-11.5 28.5T280-440m0 214q-17 0-28.5-11.5T240-266t11.5-28.5T280-306t28.5 11.5T320-266t-11.5 28.5T280-226"
    })
  });
};
const DataTable = /*#__PURE__*/forwardRef(Component$5C);

const Component$5B = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M120-640h720v-100q0-25-17.5-42.5T780-800H180q-25 0-42.5 17.5T120-740zm0 240h720v-160H120zm60 240h600q25 0 42.5-17.5T840-220v-100H120v100q0 25 17.5 42.5T180-160m20-520q-17 0-28.5-11.5T160-720t11.5-28.5T200-760t28.5 11.5T240-720t-11.5 28.5T200-680m0 240q-17 0-28.5-11.5T160-480t11.5-28.5T200-520t28.5 11.5T240-480t-11.5 28.5T200-440m0 240q-17 0-28.5-11.5T160-240t11.5-28.5T200-280t28.5 11.5T240-240t-11.5 28.5T200-200"
    })
  });
};
const DataTableFilled = /*#__PURE__*/forwardRef(Component$5B);

const Component$5A = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M7 21q-.825 0-1.412-.587Q5 19.825 5 19V6q-.425 0-.713-.287Q4 5.425 4 5t.287-.713Q4.575 4 5 4h4q0-.425.288-.713Q9.575 3 10 3h4q.425 0 .713.287Q15 3.575 15 4h4q.425 0 .712.287Q20 4.575 20 5t-.288.713Q19.425 6 19 6v13q0 .825-.587 1.413Q17.825 21 17 21ZM7 6v13h10V6Zm2 10q0 .425.288.712Q9.575 17 10 17t.713-.288Q11 16.425 11 16V9q0-.425-.287-.713Q10.425 8 10 8t-.712.287T9 9Zm4 0q0 .425.288.712.287.288.712.288t.713-.288Q15 16.425 15 16V9q0-.425-.287-.713Q14.425 8 14 8t-.712.287T13 9ZM7 6v13z"
    })
  });
};
const Delete = /*#__PURE__*/forwardRef(Component$5A);

const Component$5z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M7 21q-.825 0-1.412-.587Q5 19.825 5 19V6q-.425 0-.713-.287Q4 5.425 4 5t.287-.713Q4.575 4 5 4h4q0-.425.288-.713Q9.575 3 10 3h4q.425 0 .713.287Q15 3.575 15 4h4q.425 0 .712.287Q20 4.575 20 5t-.288.713Q19.425 6 19 6v13q0 .825-.587 1.413Q17.825 21 17 21Zm2-5q0 .425.288.712Q9.575 17 10 17t.713-.288Q11 16.425 11 16V9q0-.425-.287-.713Q10.425 8 10 8t-.712.287T9 9Zm4 0q0 .425.288.712.287.288.712.288t.713-.288Q15 16.425 15 16V9q0-.425-.287-.713Q14.425 8 14 8t-.712.287T13 9Z"
    })
  });
};
const DeleteFilled = /*#__PURE__*/forwardRef(Component$5z);

const Component$5y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M280-120q-33 0-56.5-23.5T200-200v-520q-17 0-28.5-11.5T160-760t11.5-28.5T200-800h160q0-17 11.5-28.5T400-840h160q17 0 28.5 11.5T600-800h160q17 0 28.5 11.5T800-760t-11.5 28.5T760-720v520q0 33-23.5 56.5T680-120zm0-600v520h400v-520zm0 0v520zm200 316 76 76q12 11 28.5 11t27.5-11q12-12 12-28.5T612-384l-76-76 76-76q12-12 12-28.5T612-592q-11-12-27.5-12T556-592l-76 76-76-76q-11-12-27.5-12T348-592q-11 11-11 27.5t11 28.5l76 76-76 76q-11 11-11 27.5t11 28.5q12 11 28.5 11t27.5-11z"
    })
  });
};
const DeleteForever = /*#__PURE__*/forwardRef(Component$5y);

const Component$5x = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m480-404 76 76q12 11 28.5 11t27.5-11q12-12 12-28.5T612-384l-76-76 76-76q12-12 12-28.5T612-592q-11-12-27.5-12T556-592l-76 76-76-76q-11-12-27.5-12T348-592q-11 11-11 27.5t11 28.5l76 76-76 76q-11 11-11 27.5t11 28.5q12 11 28.5 11t27.5-11zM280-120q-33 0-56.5-23.5T200-200v-520q-17 0-28.5-11.5T160-760t11.5-28.5T200-800h160q0-17 11.5-28.5T400-840h160q17 0 28.5 11.5T600-800h160q17 0 28.5 11.5T800-760t-11.5 28.5T760-720v520q0 33-23.5 56.5T680-120z"
    })
  });
};
const DeleteForeverFilled = /*#__PURE__*/forwardRef(Component$5x);

const Component$5w = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M9 18h6q.425 0 .713-.288Q16 17.425 16 17t-.287-.712Q15.425 16 15 16H9q-.425 0-.712.288Q8 16.575 8 17t.288.712Q8.575 18 9 18m0-4h6q.425 0 .713-.288Q16 13.425 16 13t-.287-.713T15 12H9q-.425 0-.712.287Q8 12.575 8 13t.288.712T9 14m-3 8q-.825 0-1.412-.587Q4 20.825 4 20V4q0-.825.588-1.413Q5.175 2 6 2h7.175q.4 0 .763.15.362.15.637.425l4.85 4.85q.275.275.425.637.15.363.15.763V20q0 .825-.587 1.413Q18.825 22 18 22Zm7-14V4H6v16h12V9h-4q-.425 0-.712-.288Q13 8.425 13 8M6 4v5zv16z"
    })
  });
};
const Description = /*#__PURE__*/forwardRef(Component$5w);

const Component$5v = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M9 18h6q.425 0 .713-.288Q16 17.425 16 17t-.287-.712Q15.425 16 15 16H9q-.425 0-.712.288Q8 16.575 8 17t.288.712Q8.575 18 9 18m0-4h6q.425 0 .713-.288Q16 13.425 16 13t-.287-.713T15 12H9q-.425 0-.712.287Q8 12.575 8 13t.288.712T9 14m-3 8q-.825 0-1.412-.587Q4 20.825 4 20V4q0-.825.588-1.413Q5.175 2 6 2h7.175q.4 0 .763.15.362.15.637.425l4.85 4.85q.275.275.425.637.15.363.15.763V20q0 .825-.587 1.413Q18.825 22 18 22Zm7-14q0 .425.288.712Q13.575 9 14 9h4l-5-5Z"
    })
  });
};
const DescriptionFilled = /*#__PURE__*/forwardRef(Component$5v);

const Component$5u = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "m19.775 22.6-5.6-5.6H7V9.825l-5.6-5.6L2.8 2.8l18.4 18.4zM9 15h3.175L9 11.825zm8-.825-2-2V9h-3.175l-2-2H17zM5 19v2q-.824 0-1.413-.588A1.93 1.93 0 0 1 3 19zm-2-2v-2h2v2zm0-4v-2h2v2zm0-4V7h2v2zm4 12v-2h2v2zM7 5V3h2v2zm4 16v-2h2v2zm0-16V3h2v2zm4 16v-2h2v2zm0-16V3h2v2zm4 12v-2h2v2zm0-4v-2h2v2zm0-4V7h2v2zm0-4V3q.825 0 1.412.587Q21 4.176 21 5z"
    })
  });
};
const Deselect = /*#__PURE__*/forwardRef(Component$5u);

const Component$5t = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M9 21.5a.97.97 0 0 1-.712-.288A.97.97 0 0 1 8 20.5q0-.424.288-.712A.97.97 0 0 1 9 19.5h1v-2H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 15.5v-11q0-.825.588-1.413A1.93 1.93 0 0 1 4 2.5h16q.825 0 1.413.587Q22 3.675 22 4.5v6.478l-2-.588V4.5H4v11h11.082l.807 2H14v2h1q.425 0 .713.288A.97.97 0 0 1 16 20.5a.97.97 0 0 1-.287.712.97.97 0 0 1-.713.288zm14.118-2.587a.7.7 0 0 0 .505-.23.7.7 0 0 0 .206-.512.66.66 0 0 0-.226-.495l-2.432-2.289 1.882-.735q.324-.127.314-.466t-.34-.426l-5.895-1.735a.45.45 0 0 0-.498.131.44.44 0 0 0-.097.495l2.21 5.652q.126.319.478.296.353-.023.44-.362l.48-1.84 2.457 2.317q.222.205.516.199",
      clipRule: "evenodd"
    })
  });
};
const DesktopWindows = /*#__PURE__*/forwardRef(Component$5t);

const Component$5s = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M9 21.5a.97.97 0 0 1-.712-.288A.97.97 0 0 1 8 20.5q0-.424.288-.712A.97.97 0 0 1 9 19.5h1v-2H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 15.5v-11q0-.825.588-1.413A1.93 1.93 0 0 1 4 2.5h16q.825 0 1.413.587Q22 3.675 22 4.5v6.49l-8.197-2.413q-.496-.15-.844.222-.347.373-.164.84L15.87 17.5H14v2h1q.425 0 .713.288A.97.97 0 0 1 16 20.5a.97.97 0 0 1-.287.712.97.97 0 0 1-.713.288zm14.118-2.587a.7.7 0 0 0 .505-.23.7.7 0 0 0 .206-.512.66.66 0 0 0-.226-.495l-2.432-2.289 1.882-.735q.324-.127.314-.466t-.34-.426l-5.895-1.735a.45.45 0 0 0-.498.131.44.44 0 0 0-.097.495l2.21 5.652q.126.319.478.296.353-.024.44-.362l.48-1.84 2.457 2.317q.222.205.516.199",
      clipRule: "evenodd"
    })
  });
};
const DesktopWindowsFilled = /*#__PURE__*/forwardRef(Component$5s);

const Component$5r = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-40q-33 0-56.5-23.5T400-120t23.5-56.5T480-200t56.5 23.5T560-120t-23.5 56.5T480-40M240-760q-33 0-56.5-23.5T160-840t23.5-56.5T240-920t56.5 23.5T320-840t-23.5 56.5T240-760m0 240q-33 0-56.5-23.5T160-600t23.5-56.5T240-680t56.5 23.5T320-600t-23.5 56.5T240-520m0 240q-33 0-56.5-23.5T160-360t23.5-56.5T240-440t56.5 23.5T320-360t-23.5 56.5T240-280m480-480q-33 0-56.5-23.5T640-840t23.5-56.5T720-920t56.5 23.5T800-840t-23.5 56.5T720-760M480-280q-33 0-56.5-23.5T400-360t23.5-56.5T480-440t56.5 23.5T560-360t-23.5 56.5T480-280m240 0q-33 0-56.5-23.5T640-360t23.5-56.5T720-440t56.5 23.5T800-360t-23.5 56.5T720-280m0-240q-33 0-56.5-23.5T640-600t23.5-56.5T720-680t56.5 23.5T800-600t-23.5 56.5T720-520m-240 0q-33 0-56.5-23.5T400-600t23.5-56.5T480-680t56.5 23.5T560-600t-23.5 56.5T480-520m0-240q-33 0-56.5-23.5T400-840t23.5-56.5T480-920t56.5 23.5T560-840t-23.5 56.5T480-760"
    })
  });
};
const Dialpad = /*#__PURE__*/forwardRef(Component$5r);

const Component$5q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 22q-.375 0-.738-.15-.362-.15-.662-.45l-8-8q-.3-.3-.45-.662T2 12t.15-.738.45-.662l8-8q.3-.3.662-.45T12 2t.738.15.662.45l8 8q.3.3.45.662T22 12t-.15.738-.45.662l-8 8q-.3.3-.662.45T12 22m-4-6 4 4 8-8-8-8-8 8Zm5.15-3-1.875 1.9q-.275.275-.275.687t.3.713q.275.275.7.275t.7-.275l3.6-3.6q.3-.3.3-.7t-.3-.7l-3.6-3.6q-.275-.275-.687-.288T11.3 7.7q-.275.275-.288.687t.263.713L13.15 11H8q-.425 0-.713.287Q7 11.575 7 12t.287.712Q7.575 13 8 13Z"
    })
  });
};
const DirectionsAlt = /*#__PURE__*/forwardRef(Component$5q);

const Component$5p = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 22q-.375 0-.738-.15-.362-.15-.662-.45l-8-8q-.3-.3-.45-.662T2 12t.15-.738.45-.662l8-8q.3-.3.662-.45T12 2t.738.15.662.45l8 8q.3.3.45.662T22 12t-.15.738-.45.662l-8 8q-.3.3-.662.45T12 22m1.15-9-1.875 1.9q-.275.275-.275.687t.3.713q.275.275.7.275t.7-.275l3.6-3.6q.3-.3.3-.7t-.3-.7l-3.6-3.6q-.275-.275-.687-.288T11.3 7.7q-.275.275-.288.687t.263.713L13.15 11H8q-.425 0-.713.287Q7 11.575 7 12t.287.712Q7.575 13 8 13Z"
    })
  });
};
const DirectionsAltFilled = /*#__PURE__*/forwardRef(Component$5p);

const Component$5o = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m791-55-91-91q-49 32-104.5 49T480-80q-83 0-156-31.5T197-197t-85.5-127T80-480q0-60 17-115.5T146-700l-91-91 57-57 736 736zm23-205-58-58q22-38 33-78.5t11-83.5q0-133-93.5-226.5T480-800q-43 0-83.5 11T318-756l-58-58q49-32 104.5-49T480-880q83 0 156 31.5T763-763t85.5 127T880-480q0 60-17 115.5T814-260M634-440l-80-80h87q17 0 28 11.5t11 28.5-11.5 28.5T640-440zm8 236L406-440h-87q-17 0-28-11.5T280-480t11.5-28.5T320-520h6L204-642q-22 38-33 78.5T160-480q0 133 93.5 226.5T480-160q43 0 83.5-11t78.5-33"
    })
  });
};
const DoNotDisturbOff = /*#__PURE__*/forwardRef(Component$5o);

const Component$5n = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m791-55-91-91q-49 32-104.5 49T480-80q-83 0-156-31.5T197-197t-85.5-127T80-480q0-60 17-115.5T146-700l-91-91 57-57 736 736zM326-520h-6q-17 0-28.5 11.5T280-480t11 28.5 28 11.5h87zm488 260L634-440h6q17 0 28.5-11.5T680-480t-11-28.5-28-11.5h-87L260-814q49-32 104.5-49T480-880q83 0 156 31.5T763-763t85.5 127T880-480q0 60-17 115.5T814-260"
    })
  });
};
const DoNotDisturbOffFilled = /*#__PURE__*/forwardRef(Component$5n);

const Component$5m = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M8 13h8.025q.425 0 .7-.288Q17 12.425 17 12t-.288-.713Q16.425 11 16 11H7.975q-.425 0-.7.287Q7 11.575 7 12t.287.712Q7.575 13 8 13m4 9q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22m0-2q3.325 0 5.663-2.337T20 12t-2.337-5.663Q15.325 4 12 4T6.338 6.337Q4 8.675 4 12t2.338 5.663Q8.675 20 12 20"
    })
  });
};
const DoNotDisturbOn = /*#__PURE__*/forwardRef(Component$5m);

const Component$5l = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M8 13h8.025q.425 0 .7-.288Q17 12.425 17 12t-.288-.713Q16.425 11 16 11H7.975q-.425 0-.7.287Q7 11.575 7 12t.287.712Q7.575 13 8 13m4 9q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22"
    })
  });
};
const DoNotDisturbOnFilled = /*#__PURE__*/forwardRef(Component$5l);

const Component$5k = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm440-80h120v-560H640zm-80 0v-560H200v560zm80 0h120z"
    })
  });
};
const DockToLeft = /*#__PURE__*/forwardRef(Component$5k);

const Component$5j = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm360-80v-560H200v560z"
    })
  });
};
const DockToLeftFilled = /*#__PURE__*/forwardRef(Component$5j);

const Component$5i = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M19.85 8.053c-.1-.24-.24-.45-.42-.64l-4.85-4.842c-.18-.18-.4-.33-.64-.42-.24-.1-.5-.15-.76-.15H6a1.88 1.88 0 0 0-1.41.58c-.39.39-.59.86-.59 1.41V20c0 .55.2 1.02.59 1.41s.86.591 1.41.591h12c.55 0 1.02-.2 1.41-.59S20 20.551 20 20V8.824c0-.27-.05-.52-.15-.76zM18 20H6V3.991h7v4.002c0 .28.1.52.29.71s.43.29.71.29h4zm-8.08-6.843a.747.747 0 0 1 .19-1.02c.33-.24.77-.16.99.16l.94 1.4.94-1.4c.22-.33.67-.4.99-.16.33.24.41.7.19 1.02l-1.24 1.84 1.24 1.841c.22.33.14.79-.19 1.021-.33.24-.77.16-.99-.16l-.94-1.4-.94 1.4c-.22.33-.67.4-.99.16a.75.75 0 0 1-.19-1.02l1.24-1.841z"
    })
  });
};
const DocumentExcel = /*#__PURE__*/forwardRef(Component$5i);

const Component$5h = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.6 21.41c.39.39.86.59 1.409.59H18c.55 0 1.02-.2 1.41-.59q.587-.585.589-1.41V8.82a1.95 1.95 0 0 0-.58-1.4l-4.847-4.85c-.18-.18-.4-.33-.64-.42-.24-.1-.499-.15-.759-.15H6c-.55 0-1.02.2-1.41.59S4 3.45 4 4v16c0 .55.2 1.02.59 1.41zm8.694-12.7a.97.97 0 0 1-.29-.71V4l4.997 5h-3.997c-.28 0-.52-.1-.71-.29m-3.168 3.43a.75.75 0 0 0-.19 1.02l1.24 1.84-1.24 1.84c-.22.33-.14.79.19 1.02.33.24.77.16.99-.16l.939-1.4.94 1.4c.22.33.669.4.989.16s.41-.7.19-1.02L12.934 15l1.24-1.84c.22-.33.14-.79-.19-1.02a.694.694 0 0 0-.99.16l-.939 1.4-.94-1.4a.687.687 0 0 0-.989-.16",
      clipRule: "evenodd"
    })
  });
};
const DocumentExcelFilled = /*#__PURE__*/forwardRef(Component$5h);

const Component$5g = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M5 21q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.413A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587.586.589.587 1.413v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm0-2h14V5H5z"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M10 16a.97.97 0 0 0 1-1v-1h2v1.033A.97.97 0 0 0 14 16a.97.97 0 0 0 1-1V9.334a1.3 1.3 0 0 0-.384-.951 1.3 1.3 0 0 0-.95-.383h-3.332a1.3 1.3 0 0 0-.95.383 1.3 1.3 0 0 0-.384.95v5.7A.97.97 0 0 0 10 16m3-4v-2h-2v2z",
      clipRule: "evenodd"
    })]
  });
};
const DocumentGeneral = /*#__PURE__*/forwardRef(Component$5g);

const Component$5f = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M13 10v2h-2v-2z"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M3.587 20.413Q4.176 20.999 5 21h14q.824 0 1.413-.587A1.93 1.93 0 0 0 21 19V5q0-.824-.587-1.413A1.93 1.93 0 0 0 19 3H5q-.824 0-1.413.587A1.93 1.93 0 0 0 3 5v14q0 .824.587 1.413m7.13-4.696A.97.97 0 0 1 10 16a.97.97 0 0 1-1-.967v-5.7a1.3 1.3 0 0 1 .384-.95 1.3 1.3 0 0 1 .95-.383h3.333a1.3 1.3 0 0 1 .949.383 1.3 1.3 0 0 1 .384.95V15a.98.98 0 0 1-.283.717A.97.97 0 0 1 14 16a.97.97 0 0 1-1-.967V14h-2v1a.97.97 0 0 1-.283.717",
      clipRule: "evenodd"
    })]
  });
};
const DocumentGeneralFilled = /*#__PURE__*/forwardRef(Component$5f);

const Component$5e = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 12c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3.5.1.7.3.3.4.3.7-.1.5-.3.7-.4.3-.7.3m0 6.5c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7V14c0-.3.1-.5.3-.7s.4-.3.7-.3.5.1.7.3.3.4.3.7v3.5c0 .3-.1.5-.3.7s-.4.3-.7.3m-7.4 2.9c.4.4.8.6 1.4.6h12c.5 0 1-.2 1.4-.6s.6-.9.6-1.4V8.8c0-.3 0-.5-.1-.8-.1-.2-.2-.5-.4-.6l-4.8-4.9c-.2-.2-.4-.3-.6-.4-.4-.1-.7-.1-.9-.1H6c-.6 0-1 .2-1.4.6S4 3.5 4 4v16c0 .5.2 1 .6 1.4M13 4v4c0 .3.1.5.3.7s.4.3.7.3h4v11H6V4z"
    })
  });
};
const DocumentInfo = /*#__PURE__*/forwardRef(Component$5e);

const Component$5d = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.6 21.4c.4.4.8.6 1.4.6h12c.5 0 1-.2 1.4-.6s.6-.9.6-1.4V8.8c0-.3 0-.5-.1-.8-.1-.2-.2-.5-.4-.6l-4.8-4.9c-.2-.2-.4-.3-.6-.4-.4-.1-.7-.1-.9-.1H6c-.6 0-1 .2-1.4.6S4 3.5 4 4v16c0 .5.2 1 .6 1.4m8.7-12.7c-.2-.2-.3-.4-.3-.7V4l5 5h-4c-.3 0-.5-.1-.7-.3M12 12c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3.5.1.7.3.3.4.3.7-.1.5-.3.7-.4.3-.7.3m0 6.5c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7V14c0-.3.1-.5.3-.7s.4-.3.7-.3.5.1.7.3.3.4.3.7v3.5c0 .3-.1.5-.3.7s-.4.3-.7.3",
      clipRule: "evenodd"
    })
  });
};
const DocumentInfoFilled = /*#__PURE__*/forwardRef(Component$5d);

const Component$5c = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.6 21.403c.4.398.9.597 1.4.597h12c.5 0 1-.199 1.4-.597s.6-.895.6-1.393V8.866c0-.299 0-.498-.1-.796-.1-.2-.2-.498-.4-.597l-4.8-4.876c-.2-.199-.4-.298-.6-.398S13.6 2 13.3 2H6c-.6 0-1 .199-1.4.597Q4 3.344 4 4.09v15.92c0 .497.2.995.6 1.393M13 4.09v3.98c0 .298.1.497.3.696.2.2.4.299.7.299h4V20.01H6V4.09zm-3 11.044c.2 0 .4.1.5.2.1.099.2.298.2.497v.696H12v-3.78c0-.2.1-.399.2-.498.1-.1.3-.2.5-.2s.4.1.5.2.2.298.2.497v4.18c0 .298-.1.497-.3.696s-.4.298-.7.298h-2.3c-.3 0-.5-.1-.7-.298-.2-.2-.3-.398-.3-.697v-1.094c0-.2.1-.398.2-.498.3-.1.5-.199.7-.199",
      clipRule: "evenodd"
    })
  });
};
const DocumentJson = /*#__PURE__*/forwardRef(Component$5c);

const Component$5b = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.6 21.403c.4.398.9.597 1.4.597h12c.5 0 1-.199 1.4-.597s.6-.895.6-1.393V8.866c0-.299 0-.498-.1-.796-.1-.2-.2-.498-.4-.597l-4.8-4.876c-.2-.199-.4-.298-.6-.398S13.6 2 13.3 2H6c-.6 0-1 .199-1.4.597Q4 3.344 4 4.09v15.92c0 .497.2.995.6 1.393m8.7-12.637c-.2-.199-.3-.398-.3-.696V4.09l5 4.975h-4c-.3 0-.5-.1-.7-.299M10 15.134c.2 0 .4.1.5.2.1.099.2.298.2.497v.696H12v-3.78c0-.2.1-.399.2-.498.1-.1.3-.2.5-.2s.4.1.5.2.2.298.2.497v4.18c0 .298-.1.497-.3.696s-.4.298-.7.298h-2.3c-.3 0-.5-.1-.7-.298-.2-.2-.3-.398-.3-.697v-1.094c0-.2.1-.398.2-.498.3-.1.4-.199.7-.199",
      clipRule: "evenodd"
    })
  });
};
const DocumentJsonFilled = /*#__PURE__*/forwardRef(Component$5b);

const Component$5a = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M18 22h-5.343c.217-.62.335-1.287.335-1.98V20H18V9h-4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 13 8V4H6v10.1a6 6 0 0 0-2 .717V4q0-.825.588-1.413A1.93 1.93 0 0 1 6 2h7.175a1.98 1.98 0 0 1 1.4.575l4.85 4.85a1.98 1.98 0 0 1 .575 1.4V20a1.93 1.93 0 0 1-.587 1.413A1.93 1.93 0 0 1 18 22M7.428 18.589h3.179q.424 0 .712.288a.97.97 0 0 1 .289.713q0 .424-.289.712a.97.97 0 0 1-.712.288H7.428l.901.9q.3.3.288.7a1 1 0 0 1-.313.701q-.3.276-.7.289a.92.92 0 0 1-.701-.289L4.3 20.29a.96.96 0 0 1-.3-.7q0-.4.3-.7l2.603-2.602A.98.98 0 0 1 7.59 16a.93.93 0 0 1 .713.288.95.95 0 0 1 .276.7.95.95 0 0 1-.276.7l-.876.9Z",
      clipRule: "evenodd"
    })
  });
};
const DocumentLeft = /*#__PURE__*/forwardRef(Component$5a);

const Component$59 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M13 20.009c0 .698-.119 1.368-.338 1.991H18a1.93 1.93 0 0 0 1.413-.587A1.93 1.93 0 0 0 20 20V8.825a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H6q-.824 0-1.412.587A1.93 1.93 0 0 0 4 4v10.81a6.001 6.001 0 0 1 9 5.2ZM13 8q0 .424.288.712A.97.97 0 0 0 14 9h4l-5-5zM7.425 18.587H10.6q.424 0 .712.288a.97.97 0 0 1 .288.712q0 .424-.288.712a.97.97 0 0 1-.712.287H7.425l.9.9q.3.3.287.7-.012.4-.312.7-.3.275-.7.287a.92.92 0 0 1-.7-.288l-2.6-2.599q-.3-.3-.3-.7t.3-.699l2.6-2.599a.98.98 0 0 1 .687-.287.93.93 0 0 1 .713.287.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7z",
      clipRule: "evenodd"
    })
  });
};
const DocumentLeftFilled = /*#__PURE__*/forwardRef(Component$59);

const Component$58 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.588 21.413Q5.175 22 6 22h12a1.93 1.93 0 0 0 1.413-.587A1.93 1.93 0 0 0 20 20V8.825a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H6q-.824 0-1.412.587A1.93 1.93 0 0 0 4 4v16q0 .825.588 1.413M13 4v4q0 .424.288.712A.97.97 0 0 0 14 9h4v11H6V4zM8 16.992h1a.97.97 0 0 0 .713-.288.97.97 0 0 0 .287-.711v-1a.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.286H7.5a.48.48 0 0 0-.35.15.48.48 0 0 0-.15.35v3.998q0 .2.15.35t.35.15a.48.48 0 0 0 .35-.15q.15-.15.15-.35zm5 2a.97.97 0 0 0 .713-.288.97.97 0 0 0 .287-.712v-2.999a.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.286h-1.5a.48.48 0 0 0-.35.15.48.48 0 0 0-.15.35v3.998q0 .2.15.35t.35.15zm3.5-2H16v1.5a.48.48 0 0 1-.15.35.48.48 0 0 1-.35.15.48.48 0 0 1-.35-.15.48.48 0 0 1-.15-.35v-3.999q0-.2.15-.35t.35-.15h1q.2 0 .35.15a.48.48 0 0 1 0 .7.48.48 0 0 1-.35.15H16v1h.5q.2 0 .35.15a.48.48 0 0 1 0 .7.48.48 0 0 1-.35.15ZM8 14.993v1h1v-1zm4 0v2.999h1v-2.999z",
      clipRule: "evenodd"
    })
  });
};
const DocumentPdf = /*#__PURE__*/forwardRef(Component$58);

const Component$57 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.588 21.412Q5.175 21.999 6 22h12a1.93 1.93 0 0 0 1.413-.587A1.93 1.93 0 0 0 20 20V8.824a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H6q-.824 0-1.412.587A1.93 1.93 0 0 0 4 3.999v16q0 .825.588 1.413m8.7-12.701A.97.97 0 0 1 13 7.999v-4l5 5h-4a.97.97 0 0 1-.712-.288M8 16.999h1a.97.97 0 0 0 .713-.288.97.97 0 0 0 .287-.712v-1a.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287H7.5a.48.48 0 0 0-.35.15.48.48 0 0 0-.15.35v4q0 .2.15.35t.35.15a.48.48 0 0 0 .35-.15q.15-.15.15-.35zm5 2a.97.97 0 0 0 .713-.288.97.97 0 0 0 .287-.712v-3a.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287h-1.5a.48.48 0 0 0-.35.15.48.48 0 0 0-.15.35v4q0 .2.15.35t.35.15zm3.5-2H16v1.5a.48.48 0 0 1-.15.35.48.48 0 0 1-.35.15.48.48 0 0 1-.35-.15.48.48 0 0 1-.15-.35v-4q0-.2.15-.35t.35-.15h1q.2 0 .35.15a.48.48 0 0 1 0 .7.48.48 0 0 1-.35.15H16v1h.5q.2 0 .35.15a.48.48 0 0 1 0 .7.48.48 0 0 1-.35.15m-8.5-2v1h1v-1zm4 0v3h1v-3z",
      clipRule: "evenodd"
    })
  });
};
const DocumentPdfFilled = /*#__PURE__*/forwardRef(Component$57);

const Component$56 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M6 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20V4q0-.825.588-1.413A1.93 1.93 0 0 1 6 2h7.175a1.98 1.98 0 0 1 1.4.575l4.85 4.85a1.98 1.98 0 0 1 .575 1.4v5.983a6 6 0 0 0-2-.72V9h-4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 13 8V4H6v16h5v.005c0 .7.12 1.37.34 1.995zm10.575-1.414H13.4a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.712q0-.424.288-.712a.97.97 0 0 1 .712-.288h3.175l-.9-.9a.91.91 0 0 1-.287-.699q.012-.4.312-.7.3-.274.7-.288.4-.012.7.288l2.6 2.6q.3.3.3.699 0 .4-.3.7l-2.6 2.598a.98.98 0 0 1-.687.287.93.93 0 0 1-.713-.287.95.95 0 0 1-.275-.7q0-.424.275-.699z",
      clipRule: "evenodd"
    })
  });
};
const DocumentRight = /*#__PURE__*/forwardRef(Component$56);

const Component$55 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M6 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20V4q0-.825.588-1.413A1.93 1.93 0 0 1 6 2h7.175a1.98 1.98 0 0 1 1.4.575l4.85 4.85a1.98 1.98 0 0 1 .575 1.4v5.984A6.001 6.001 0 0 0 11.338 22zm7-14q0 .424.288.712A.97.97 0 0 0 14 9h4l-5-5zm3.575 12.587H13.4a.97.97 0 0 1-.712-.288.97.97 0 0 1-.288-.711q0-.425.288-.712a.97.97 0 0 1 .712-.288h3.175l-.9-.9a.91.91 0 0 1-.287-.7q.012-.399.312-.699.3-.275.7-.288t.7.288l2.6 2.599q.3.3.3.7t-.3.7l-2.6 2.598a.98.98 0 0 1-.687.287.93.93 0 0 1-.713-.287.95.95 0 0 1-.275-.7q0-.424.275-.7z",
      clipRule: "evenodd"
    })
  });
};
const DocumentRightFilled = /*#__PURE__*/forwardRef(Component$55);

const Component$54 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.588 21.413Q5.175 22 6 22h6v-2H6v-.645a.5.5 0 0 0 .267.077c.558 0 1.003-.313 1.322-.642.316-.325.561-.735.753-1.085.072-.133.208-.303.208-.213.036-.038 0 .089 0 .089s.02.253.034.401c.03.292.08.663.24.948a.95.95 0 0 0 .43.411.97.97 0 0 0 .642.047c.276-.067.461-.232.585-.395a2.3 2.3 0 0 0 .226-.391c.076-.159.077-.148.087-.055.011.111.035.34.216.538.19.205.45.317.767.317l2.223.03V21.5q0 .2.15.35t.35.15h2.25a1.03 1.03 0 0 0 .725-.3l4-4 1.45-1.45a.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7l-1.775-1.775a.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275l-1.45 1.45-3.921 3.877h-2.602l-.037-.002a1 1 0 0 1-.068-.16l-.013-.04a2 2 0 0 0-.179-.412.84.84 0 0 0-.276-.272.906.906 0 0 0-1.107.184c-.133.143-.22.32-.272.428l-.003.007-.026.055a1 1 0 0 1-.12.208c-.037-.094-.071-.26-.097-.516-.01-.091-.018-.203-.027-.321a11 11 0 0 0-.056-.59 2.7 2.7 0 0 0-.099-.464 1.14 1.14 0 0 0-.266-.458.646.646 0 0 0-.778-.124c-.183.098-.308.27-.382.38-.108.162-.23.396-.35.625q-.08.155-.157.296c-.184.336-.376.645-.592.867-.212.218-.376.303-.568.303-.114-.02-.21.018-.302.094L6 4h7v4q0 .424.288.712A.97.97 0 0 0 14 9h4v3h2V8.825a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H6q-.824 0-1.412.587A1.93 1.93 0 0 0 4 4v16q0 .825.588 1.413M15.5 19.45l3.875-3.85 1.05 1.05-3.875 3.85H15.5z",
      clipRule: "evenodd"
    })
  });
};
const DocumentSubscribe = /*#__PURE__*/forwardRef(Component$54);

const Component$53 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.588 21.413Q5.175 22 6 22h6v-2.596h-.22c-.318 0-.579-.112-.768-.318a.9.9 0 0 1-.216-.537c-.01-.093-.01-.104-.087.055a2.3 2.3 0 0 1-.226.39 1.03 1.03 0 0 1-.586.396.97.97 0 0 1-.642-.047.95.95 0 0 1-.43-.411c-.158-.285-.21-.657-.239-.948-.015-.148-.034-.402-.034-.402s.036-.127 0-.088c0-.09-.136.08-.208.212-.192.351-.437.76-.753 1.085-.32.33-.753.613-1.312.613a.5.5 0 0 1 0-1c.192 0 .383-.092.595-.31.216-.222.408-.53.592-.867l.157-.296c.12-.228.242-.462.35-.624.074-.111.199-.283.382-.38a.646.646 0 0 1 .778.123c.14.14.218.313.266.459.05.15.079.311.1.464.023.174.04.391.055.59.01.118.018.23.027.32.026.257.06.422.097.517a1 1 0 0 0 .12-.208l.025-.055.004-.007c.053-.108.139-.285.272-.429a.906.906 0 0 1 1.107-.184c.129.078.216.18.276.273.089.138.146.313.179.411l.013.04a1 1 0 0 0 .068.16q.011.003.037.003h.894L20 11.1V8.825a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H6q-.824 0-1.412.587A1.93 1.93 0 0 0 4 4v16q0 .825.588 1.413m9.562.437q.15.15.35.15h1.2q.2 0 .4-.075a.76.76 0 0 0 .325-.225l4.875-4.9-2.15-2.1-4.85 4.875a1 1 0 0 0-.212.325 1 1 0 0 0-.088.4v1.2q0 .2.15.35m5.75-7.875 2.125 2.125.7-.7a.93.93 0 0 0 .275-.688 1.02 1.02 0 0 0-.275-.712l-.7-.725a.9.9 0 0 0-.7-.3q-.425 0-.725.3zM18 9h-4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 13 8V4z",
      clipRule: "evenodd"
    })
  });
};
const DocumentSubscribeFilled = /*#__PURE__*/forwardRef(Component$53);

const Component$52 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M9 14h2.7c.2-.4.4-.7.6-1.1.2-.3.5-.6.8-.9H9c-.3 0-.5.1-.7.3s-.3.4-.3.7.1.5.3.7.4.3.7.3m0 4h2.1c-.1-.3-.1-.7-.1-1s0-.7.1-1H9c-.3 0-.5.1-.7.3s-.3.4-.3.7.1.5.3.7.4.3.7.3m-3 4c-.6 0-1-.2-1.4-.6S4 20.5 4 20V4c0-.5.2-1 .6-1.4S5.4 2 6 2h7.2c.3 0 .5 0 .8.2.2.1.5.2.6.4l4.8 4.9c.2.2.3.4.4.6.2.2.2.5.2.7v1.5c-.3-.1-.6-.2-1-.2s-.6-.1-1-.1V9h-4c-.3 0-.5-.1-.7-.3S13 8.3 13 8V4H6v16h5.7c.2.4.4.7.6 1.1.2.3.5.6.8.9zm12 0c-1.4 0-2.6-.5-3.5-1.5S13 18.4 13 17s.5-2.6 1.5-3.5S16.6 12 18 12s2.6.5 3.5 1.5S23 15.6 23 17s-.5 2.6-1.5 3.5S19.4 22 18 22m.7-5.2v-2.3c0-.1-.012-.309-.1-.4-.077-.104-.25-.116-.397-.112-.1 0-.281-.015-.403.112-.1.1-.1.2-.1.4v2.3c0 .1 0 .3.1.4 0 .1.1.2.2.3l1.5 1.5c.1.1.248.133.348.133s.191-.024.352-.133c.116-.11.183-.234.167-.355 0-.1-.067-.245-.167-.345z"
    })
  });
};
const DocumentTime = /*#__PURE__*/forwardRef(Component$52);

const Component$51 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M18 9h-4c-.3 0-.5-.1-.7-.3S13 8.3 13 8V4zM4.6 21.4c.4.4.8.6 1.4.6h7.2c-.6-.5-1-1.1-1.4-1.8-.3-.7-.6-1.4-.7-2.2H9c-.3 0-.5-.1-.7-.3S8 17.3 8 17s.1-.5.3-.7.4-.3.7-.3h2.1c0-.3.1-.7.2-1 .1-.4.2-.7.4-1H9c-.3 0-.5-.1-.7-.3S8 13.3 8 13c0 0 .1-.5.3-.7s.4-.3.7-.3h4.1c.6-.7 1.4-1.1 2.2-1.5.9-.3 1.7-.5 2.7-.5.15 0 .325.025.5.05s.35.05.5.05c.3 0 .7.1 1 .2V8.8c0-.2 0-.5-.2-.7-.1-.2-.2-.4-.4-.6l-4.8-4.9c-.08-.161-.292-.258-.476-.342L14 2.2c-.3-.2-.5-.2-.8-.2H6c-.6 0-1 .2-1.4.6S4 3.5 4 4v16c0 .5.2 1 .6 1.4m9.9-.9c.9 1 2.1 1.5 3.5 1.5s2.5-.6 3.5-1.5S23 18.4 23 17s-.6-2.5-1.5-3.5S19.4 12 18 12s-2.5.6-3.5 1.5S13 15.6 13 17s.6 2.5 1.5 3.5m4.2-6v2.3l1.5 1.5c.1.1.167.244.167.345.016.12-.05.246-.167.355-.16.11-.252.133-.352.133A.5.5 0 0 1 19.5 19L18 17.5c-.1-.1-.2-.2-.2-.3-.1-.1-.1-.3-.1-.4v-2.3c0-.2 0-.3.1-.4.11-.115.27-.113.373-.112h.03c.148-.004.32.008.397.112.087.091.1.3.1.4",
      clipRule: "evenodd"
    })
  });
};
const DocumentTimeFilled = /*#__PURE__*/forwardRef(Component$51);

const Component$50 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M6 22c-.6 0-1-.2-1.4-.6S4 20.5 4 20V4c0-.5.2-1 .6-1.4S5.4 2 6 2h7.2c.3 0 .5 0 .8.2.2.1.5.2.6.4l4.8 4.9c.2.2.3.4.4.6.2.2.2.5.2.7V20c0 .5-.2 1-.6 1.4s-.8.6-1.4.6zm7-14V4H6v16h12V9h-4c-.3 0-.5-.1-.7-.3S13 8.3 13 8m1 10h-4c-.3 0-.5-.1-.7-.3S9 17.3 9 17v-4.4c0-.2.1-.3.2-.4s.2-.2.4-.2.3.1.5.2c.1.1.2.3.2.4v3.9h1.2v-2.9c0-.2.1-.3.2-.4s.3-.2.4-.2c.2 0 .3.1.4.2s.2.3.2.4v2.9h1.1v-3.9c0-.2.1-.3.2-.4s.3-.2.4-.2c.2 0 .3.1.5.2.1.1.2.3.2.4V17c0 .3-.1.5-.3.7-.3.2-.5.3-.8.3"
    })
  });
};
const DocumentWord = /*#__PURE__*/forwardRef(Component$50);

const Component$4$ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M6 22c-.6 0-1-.2-1.4-.6S4 20.5 4 20V4c0-.5.2-1 .6-1.4S5.4 2 6 2h7.2c.3 0 .5 0 .8.2.2.1.5.2.6.4l4.8 4.9c.2.2.3.4.4.6.2.2.2.5.2.7V20c0 .5-.2 1-.6 1.4s-.9.6-1.4.6zm7-14c0 .3.1.5.3.7s.4.3.7.3h4l-5-5zm-3 10h4c.3 0 .5-.1.7-.3s.3-.4.3-.7v-4.4c0-.2-.1-.3-.2-.4s-.2-.2-.4-.2-.3.1-.4.2-.2.3-.2.4v3.9h-1.1v-2.9c0-.2-.1-.3-.2-.4s-.3-.2-.5-.2-.3.1-.4.2-.2.3-.2.4v2.9h-1.1v-3.9c0-.2-.1-.3-.2-.4s-.3-.2-.5-.2-.3.1-.4.2-.2.2-.2.4V17c0 .3.1.5.3.7s.4.3.7.3"
    })
  });
};
const DocumentWordFilled = /*#__PURE__*/forwardRef(Component$4$);

const Component$4_ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M240-268 70-438q-12-12-11.5-28T71-494q12-11 28-11.5t28 11.5l142 142 56 56-29 28q-12 11-28 11.5T240-268m226 0L296-438q-11-11-11-27.5t11-28.5q12-12 28.5-12t28.5 12l141 141 340-340q12-12 28-11.5t28 12.5q11 12 11.5 28T890-636L522-268q-12 12-28 12t-28-12m28-198-57-56 170-170q11-11 27.5-11t28.5 11q12 12 12 28.5T663-635z"
    })
  });
};
const DoneAll = /*#__PURE__*/forwardRef(Component$4_);

const Component$4Z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12a9.7 9.7 0 0 1 .788-3.9 10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.138A9.7 9.7 0 0 1 12 2a9.7 9.7 0 0 1 3.9.787 10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.325 0 5.663-2.337T20 12c0-3.325-.779-4.104-2.337-5.663Q15.325 4 12 4c-3.325 0-4.104.779-5.662 2.337Q4 8.675 4 12c0 3.325.78 4.104 2.338 5.663Q8.675 20 12 20"
    }), /*#__PURE__*/jsx("path", {
      d: "M9.12 15.72c-.06 0-.18 0-.24-.06-.06 0-.12-.06-.18-.12l-2.52-2.52A.55.55 0 0 1 6 12.6c0-.18.06-.3.18-.42s.24-.18.42-.18.3.06.42.18l2.1 2.1.84.84-.42.42c-.06.06-.12.12-.18.12-.06.06-.18.06-.24.06m3.42 0c-.06 0-.18 0-.24-.06-.06 0-.12-.06-.18-.12l-2.58-2.58a.55.55 0 0 1-.18-.42c0-.18.06-.3.18-.42s.24-.18.42-.18.3.06.42.18l2.16 2.16 5.1-5.1c.12-.12.24-.18.42-.18s.3.06.42.18.18.24.18.42-.06.3-.18.42l-5.52 5.52c-.06.06-.12.12-.18.12-.12.06-.18.06-.24.06m0-3.12-.84-.84 2.52-2.52c.12-.12.24-.18.42-.18s.3.06.42.18.18.24.18.42-.06.3-.18.42z"
    })]
  });
};
const DoneAllCircle = /*#__PURE__*/forwardRef(Component$4Z);

const Component$4Y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M8.1 21.212A9.7 9.7 0 0 0 12 22a9.7 9.7 0 0 0 3.9-.788 10.1 10.1 0 0 0 3.175-2.137q1.35-1.35 2.137-3.175A9.7 9.7 0 0 0 22 12a9.7 9.7 0 0 0-.788-3.9 10.1 10.1 0 0 0-2.137-3.175q-1.35-1.35-3.175-2.138A9.7 9.7 0 0 0 12 2a9.7 9.7 0 0 0-3.9.787 10.1 10.1 0 0 0-3.175 2.138Q3.575 6.275 2.788 8.1A9.7 9.7 0 0 0 2 12a9.7 9.7 0 0 0 .788 3.9 10.1 10.1 0 0 0 2.137 3.175q1.35 1.35 3.175 2.137m.78-5.552c.06.06.18.06.24.06s.18 0 .24-.06c.06 0 .12-.06.18-.12l.42-.42-2.94-2.94A.55.55 0 0 0 6.6 12c-.18 0-.3.06-.42.18s-.18.24-.18.42.06.3.18.42l2.52 2.52c.06.06.12.12.18.12m3.42 0c.06.06.18.06.24.06s.12 0 .24-.06c.06 0 .12-.06.18-.12l5.52-5.52c.12-.12.18-.24.18-.42s-.06-.3-.18-.42a.55.55 0 0 0-.42-.18c-.18 0-.3.06-.42.18l-5.1 5.1-2.16-2.16a.55.55 0 0 0-.42-.18c-.18 0-.3.06-.42.18s-.18.24-.18.42.06.3.18.42l2.58 2.58c.06.06.12.12.18.12m-.6-3.9.84.84 2.52-2.52c.12-.12.18-.24.18-.42s-.06-.3-.18-.42a.55.55 0 0 0-.42-.18c-.18 0-.3.06-.42.18z",
      clipRule: "evenodd"
    })
  });
};
const DoneAllCircleFilled = /*#__PURE__*/forwardRef(Component$4Y);

const Component$4X = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m381-240 424-424-57-56-368 367-169-170-57 57zm0 80q-15 0-30-6t-27-18L98-410q-12-12-17.5-26.5T75-466t5.5-30T98-523l56-56q12-12 26.5-18t30.5-6 30.5 6 26.5 18l113 113 310-311q11-12 26-17.5t30-5.5 30 5.5 27 16.5l57 56q12 12 18 26.5t6 30.5-5.5 30.5T862-608L438-184q-12 12-27 18t-30 6"
    })
  });
};
const DoneOutline = /*#__PURE__*/forwardRef(Component$4X);

const Component$4W = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M442-480 287-697q-14-20-3.5-41.5T319-760q10 0 19 4.5t14 12.5l188 263-188 263q-5 8-14 12.5t-19 4.5q-24 0-35-21.5t3-41.5zm238 0L525-697q-14-20-3.5-41.5T557-760q10 0 19 4.5t14 12.5l188 263-188 263q-5 8-14 12.5t-19 4.5q-24 0-35-21.5t3-41.5z"
    })
  });
};
const DoubleArrow = /*#__PURE__*/forwardRef(Component$4W);

const Component$4V = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 15.575q-.2 0-.375-.063-.175-.062-.325-.212l-3.6-3.6q-.275-.275-.275-.7t.275-.7.712-.288q.438-.012.713.263L11 12.15V5q0-.425.288-.713Q11.575 4 12 4t.713.287Q13 4.575 13 5v7.15l1.875-1.875q.275-.275.713-.263t.712.288.275.7q0 .425-.275.7l-3.6 3.6q-.15.15-.325.212-.175.063-.375.063M6 20q-.825 0-1.412-.587Q4 18.825 4 18v-2q0-.425.287-.713Q4.575 15 5 15t.713.287Q6 15.575 6 16v2h12v-2q0-.425.288-.713Q18.575 15 19 15t.712.287Q20 15.575 20 16v2q0 .825-.587 1.413Q18.825 20 18 20Z"
    })
  });
};
const Download = /*#__PURE__*/forwardRef(Component$4V);

const Component$4U = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h287q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v447q0 33-23.5 56.5T720-80zm280-560v-160H240v640h480v-440H560q-17 0-28.5-11.5T520-640M240-800v200zv640z"
    })
  });
};
const Draft = /*#__PURE__*/forwardRef(Component$4U);

const Component$4T = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h287q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v447q0 33-23.5 56.5T720-80zm280-560q0 17 11.5 28.5T560-600h160L520-800z"
    })
  });
};
const DraftFilled = /*#__PURE__*/forwardRef(Component$4T);

const Component$4S = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m599-515-84-84-206 206q-6 6-9 13.5t-3 15.5v47q0 8 6 14t14 6h47q8 0 15.5-3t13.5-9zm24-24 28-28q12-12 12-28t-12-28l-28-28q-12-12-28-12t-28 12l-28 28zM480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-320"
    })
  });
};
const DraftOrders = /*#__PURE__*/forwardRef(Component$4S);

const Component$4R = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m599-515-84-84-206 206q-6 6-9 13.5t-3 15.5v47q0 8 6 14t14 6h47q8 0 15.5-3t13.5-9zm24-24 28-28q12-12 12-28t-12-28l-28-28q-12-12-28-12t-28 12l-28 28zM480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80"
    })
  });
};
const DraftOrdersFilled = /*#__PURE__*/forwardRef(Component$4R);

const Component$4Q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-520q-17 0-28.5-11.5T160-560t11.5-28.5T200-600h560q17 0 28.5 11.5T800-560t-11.5 28.5T760-520zm0 160q-17 0-28.5-11.5T160-400t11.5-28.5T200-440h560q17 0 28.5 11.5T800-400t-11.5 28.5T760-360z"
    })
  });
};
const DragHandle = /*#__PURE__*/forwardRef(Component$4Q);

const Component$4P = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M8 18q-.824 0-1.412-.587A1.93 1.93 0 0 1 6 16V4q0-.824.588-1.413A1.93 1.93 0 0 1 8 2h12q.824 0 1.413.587.586.589.587 1.413v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18zm0-2h12V4H8zm-2 6v-2h2v2zM4 6H2q0-.824.587-1.412A1.93 1.93 0 0 1 4 4zm6 16v-2h2v2zm4 0v-2h2v2zM4 20v2q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 20zm-2-2v-2h2v2zm0-4v-2h2v2zm0-4V8h2v2zm16 10h2q0 .824-.587 1.413A1.93 1.93 0 0 1 18 22z"
    })
  });
};
const Duplicate = /*#__PURE__*/forwardRef(Component$4P);

const Component$4O = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M8 18q-.824 0-1.412-.587A1.93 1.93 0 0 1 6 16V4q0-.824.588-1.413A1.93 1.93 0 0 1 8 2h12q.824 0 1.413.587.586.589.587 1.413v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18zm-2 4v-2h2v2zM4 6H2q0-.824.587-1.412A1.93 1.93 0 0 1 4 4zm6 16v-2h2v2zm4 0v-2h2v2zM4 20v2q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 20zm-2-2v-2h2v2zm0-4v-2h2v2zm0-4V8h2v2zm16 10h2q0 .824-.587 1.413A1.93 1.93 0 0 1 18 22z"
    })
  });
};
const DuplicateFilled = /*#__PURE__*/forwardRef(Component$4O);

const Component$4N = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 19h1.4l8.625-8.625-1.4-1.4L5 17.6ZM19.3 8.925l-4.25-4.2 1.4-1.4q.575-.575 1.413-.575.837 0 1.412.575l1.4 1.4q.575.575.6 1.388t-.55 1.387ZM4 21q-.425 0-.712-.288Q3 20.425 3 20v-2.825q0-.2.075-.387.075-.188.225-.338l10.3-10.3 4.25 4.25-10.3 10.3q-.15.15-.337.225T6.825 21ZM14.325 9.675l-.7-.7 1.4 1.4Z"
    })
  });
};
const Edit = /*#__PURE__*/forwardRef(Component$4N);

const Component$4M = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M6 22q-.825 0-1.412-.587Q4 20.825 4 20V4q0-.825.588-1.413Q5.175 2 6 2h7.175q.4 0 .763.15.362.15.637.425l4.85 4.85q.275.275.425.637.15.363.15.763V12h-2V9h-4q-.425 0-.712-.288Q13 8.425 13 8V4H6v16h6v2Zm0-2V4zm12.3-5.475 1.075 1.075-3.875 3.85v1.05h1.05l3.875-3.85 1.05 1.05-4 4q-.15.15-.338.225-.187.075-.387.075H14.5q-.2 0-.35-.15T14 21.5v-2.25q0-.2.075-.387.075-.188.225-.338Zm3.175 3.175L18.3 14.525l1.45-1.45q.275-.275.7-.275t.7.275l1.775 1.775q.275.275.275.7t-.275.7Z"
    })
  });
};
const EditDocument = /*#__PURE__*/forwardRef(Component$4M);

const Component$4L = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M6 22q-.825 0-1.412-.587Q4 20.825 4 20V4q0-.825.588-1.413Q5.175 2 6 2h7.175q.4 0 .763.15.362.15.637.425l4.85 4.85q.275.275.425.637.15.363.15.763V11.1l-8 7.975V22Zm8.5 0q-.2 0-.35-.15T14 21.5v-1.2q0-.2.088-.4.087-.2.212-.325l4.85-4.875 2.15 2.1-4.875 4.9q-.125.15-.325.225t-.4.075Zm7.525-5.9L19.9 13.975l.7-.7q.3-.3.725-.3t.7.3l.7.725q.275.3.275.712 0 .413-.275.688ZM14 9h4l-5-5v4q0 .425.288.712Q13.575 9 14 9"
    })
  });
};
const EditDocumentFilled = /*#__PURE__*/forwardRef(Component$4L);

const Component$4K = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m19.3 8.925-4.25-4.2 1.4-1.4q.575-.575 1.413-.575.837 0 1.412.575l1.4 1.4q.575.575.6 1.388t-.55 1.387ZM4 21q-.425 0-.712-.288Q3 20.425 3 20v-2.825q0-.2.075-.387.075-.188.225-.338l10.3-10.3 4.25 4.25-10.3 10.3q-.15.15-.337.225T6.825 21Z"
    })
  });
};
const EditFilled = /*#__PURE__*/forwardRef(Component$4K);

const Component$4J = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-120 345-75q-7 2-13 3t-12 1q-32 0-56-22.5T240-151v-218L136-538q-6-10-9-20.5t-3-21.5 3-21.5 9-20.5l136-220q11-18 29-28t39-10h280q21 0 39 10t29 28l136 220q6 10 9 20.5t3 21.5-3 21.5-9 20.5L720-369v218q0 35-24 57.5T640-71q-6 0-12-1t-13-3zm0-84 160 53v-129H320v129zM340-360h280l136-220-136-220H340L204-580zm98-170 141-142q11-12 27.5-11.5T635-672q12 12 12.5 28.5T636-615L466-445q-12 12-28 12t-28-12l-85-85q-12-12-12-28.5t12-28.5 28.5-12 28.5 12zm42 250H320h320z"
    })
  });
};
const EditorChoice = /*#__PURE__*/forwardRef(Component$4J);

const Component$4I = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-120 345-75q-7 2-13 3t-12 1q-32 0-56-22.5T240-151v-218L136-538q-6-10-9-20.5t-3-21.5 3-21.5 9-20.5l136-220q11-18 29-28t39-10h280q21 0 39 10t29 28l136 220q6 10 9 20.5t3 21.5-3 21.5-9 20.5L720-369v218q0 35-24 57.5T640-71q-6 0-12-1t-13-3zM340-360h280l136-220-136-220H340L204-580zm98-170 141-142q11-12 27.5-11.5T635-672q12 12 12.5 28.5T636-615L466-445q-12 12-28 12t-28-12l-85-85q-12-12-12-28.5t12-28.5 28.5-12 28.5 12z"
    })
  });
};
const EditorChoiceFilled = /*#__PURE__*/forwardRef(Component$4I);

const Component$4H = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M13.425 21.45q-.3.3-.663.437-.362.138-.762.138t-.762-.138q-.363-.137-.663-.437L2.55 13.425q-.3-.3-.438-.663-.137-.362-.137-.762t.137-.762.438-.663l8.025-8.025q.3-.3.663-.438.362-.137.762-.137t.762.137.663.438l8.025 8.025q.3.3.438.663.137.362.137.762t-.137.762q-.138.363-.438.663ZM12 20.025 20.025 12 12 3.975 3.975 12zM12 13q.425 0 .713-.288Q13 12.425 13 12V8q0-.425-.287-.713Q12.425 7 12 7t-.712.287Q11 7.575 11 8v4q0 .425.288.712.287.288.712.288m0 3q.425 0 .713-.288Q13 15.425 13 15t-.287-.713T12 14t-.712.287Q11 14.575 11 15t.288.712T12 16m0-4"
    })
  });
};
const EmergencyHome = /*#__PURE__*/forwardRef(Component$4H);

const Component$4G = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-79q-16 0-30.5-6T423-102L102-423q-11-12-17-26.5T79-480t6-31 17-26l321-321q12-12 26.5-17.5T480-881t31 5.5 26 17.5l321 321q12 11 17.5 26t5.5 31-5.5 30.5T858-423L537-102q-11 11-26 17t-31 6m0-361q17 0 28.5-11.5T520-480v-160q0-17-11.5-28.5T480-680t-28.5 11.5T440-640v160q0 17 11.5 28.5T480-440m0 120q17 0 28.5-11.5T520-360t-11.5-28.5T480-400t-28.5 11.5T440-360t11.5 28.5T480-320"
    })
  });
};
const EmergencyHomeFilled = /*#__PURE__*/forwardRef(Component$4G);

const Component$4F = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-280q17 0 28.5-11.5T520-320t-11.5-28.5T480-360t-28.5 11.5T440-320t11.5 28.5T480-280m0-160q17 0 28.5-11.5T520-480v-160q0-17-11.5-28.5T480-680t-28.5 11.5T440-640v160q0 17 11.5 28.5T480-440m0 360q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-320"
    })
  });
};
const Error = /*#__PURE__*/forwardRef(Component$4F);

const Component$4E = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-280q17 0 28.5-11.5T520-320t-11.5-28.5T480-360t-28.5 11.5T440-320t11.5 28.5T480-280m0-160q17 0 28.5-11.5T520-480v-160q0-17-11.5-28.5T480-680t-28.5 11.5T440-640v160q0 17 11.5 28.5T480-440m0 360q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80"
    })
  });
};
const ErrorFilled = /*#__PURE__*/forwardRef(Component$4E);

const Component$4D = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M15 21q-2.95 0-5.25-1.675T6.5 15H4q-.425 0-.712-.288Q3 14.425 3 14t.288-.713Q3.575 13 4 13h2.05Q6 12.725 6 12.5v-1q0-.225.05-.5H4q-.425 0-.712-.288Q3 10.425 3 10t.288-.713Q3.575 9 4 9h2.5q.95-2.65 3.25-4.325T15 3q1.375 0 2.613.375t2.312 1.075q.45.3.488.85t-.388.975q-.3.3-.762.35-.463.05-.888-.2-.75-.425-1.6-.675T15 5.5q-1.875 0-3.412.963Q10.05 7.425 9.25 9H14q.425 0 .713.287Q15 9.575 15 10t-.287.712T14 11H8.6q-.05.275-.075.5T8.5 12t.025.5.075.5H14q.425 0 .713.287.287.288.287.713t-.287.712T14 15H9.25q.8 1.575 2.338 2.538 1.537.962 3.412.962.9 0 1.775-.25t1.6-.675q.425-.25.875-.213t.775.363q.425.425.388.975-.038.55-.488.85-1.075.7-2.312 1.075Q16.375 21 15 21"
    })
  });
};
const EuroSymbol = /*#__PURE__*/forwardRef(Component$4D);

const Component$4C = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M580-240q-42 0-71-29t-29-71 29-71 71-29 71 29 29 71-29 71-71 29M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-40q0-17 11.5-28.5T280-880t28.5 11.5T320-840v40h320v-40q0-17 11.5-28.5T680-880t28.5 11.5T720-840v40h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80zm0-80h560v-400H200zm0-480h560v-80H200zm0 0v-80z"
    })
  });
};
const Event = /*#__PURE__*/forwardRef(Component$4C);

const Component$4B = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m438-342 139-139q12-12 29-12t29 12 12 29-12 29L466-254q-12 12-28 12t-28-12l-85-85q-12-12-12-29t12-29 29-12 29 12zM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-40q0-17 11.5-28.5T280-880t28.5 11.5T320-840v40h320v-40q0-17 11.5-28.5T680-880t28.5 11.5T720-840v40h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80zm0-80h560v-400H200zm0-480h560v-80H200zm0 0v-80z"
    })
  });
};
const EventAvailable = /*#__PURE__*/forwardRef(Component$4B);

const Component$4A = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m438-342 139-139q12-12 29-12t29 12 12 29-12 29L466-254q-12 12-28 12t-28-12l-85-85q-12-12-12-29t12-29 29-12 29 12zM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-40q0-17 11.5-28.5T280-880t28.5 11.5T320-840v40h320v-40q0-17 11.5-28.5T680-880t28.5 11.5T720-840v40h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80zm0-80h560v-400H200z"
    })
  });
};
const EventAvailableFilled = /*#__PURE__*/forwardRef(Component$4A);

const Component$4z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M580-240q-42 0-71-29t-29-71 29-71 71-29 71 29 29 71-29 71-71 29M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-40q0-17 11.5-28.5T280-880t28.5 11.5T320-840v40h320v-40q0-17 11.5-28.5T680-880t28.5 11.5T720-840v40h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80zm0-80h560v-400H200z"
    })
  });
};
const EventFilled = /*#__PURE__*/forwardRef(Component$4z);

const Component$4y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M11.3 14.8q.3.3.7.3t.7-.3l3.1-3.1q.275-.275.262-.7-.012-.425-.287-.7-.3-.3-.7-.3t-.7.3L12 12.675l-2.4-2.4q-.275-.275-.7-.263t-.7.288q-.3.3-.3.7t.3.7ZM12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22m0-2q3.325 0 5.663-2.337T20 12t-2.337-5.663Q15.325 4 12 4T6.338 6.337Q4 8.675 4 12t2.338 5.663Q8.675 20 12 20"
    })
  });
};
const ExpandCircleDown = /*#__PURE__*/forwardRef(Component$4y);

const Component$4x = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M11.3 14.8q.275.275.7.275t.7-.275l3.1-3.1q.275-.275.275-.688t-.3-.712q-.275-.275-.7-.275t-.7.275L12 12.675l-2.4-2.4Q9.325 10 8.913 10t-.713.3q-.275.275-.275.7t.275.7ZM12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22"
    })
  });
};
const ExpandCircleDownFilled = /*#__PURE__*/forwardRef(Component$4x);

const Component$4w = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M8.8 21H5q-.825 0-1.413-.587Q3 19.825 3 19v-3.8q1.2 0 2.1-.762.9-.763.9-1.938t-.9-1.938T3 9.8V6q0-.825.587-1.412Q4.175 4 5 4h4q0-1.05.725-1.775T11.5 1.5t1.775.725T14 4h4q.825 0 1.413.588Q20 5.175 20 6v4q1.05 0 1.775.725T22.5 12.5t-.725 1.775T20 15v4q0 .825-.587 1.413Q18.825 21 18 21h-3.8q0-1.25-.787-2.125Q12.625 18 11.5 18t-1.912.875T8.8 21M5 19h2.125q.6-1.65 1.925-2.325T11.5 16t2.45.675T15.875 19H18v-6h2q.2 0 .35-.15t.15-.35-.15-.35T20 12h-2V6h-6V4q0-.2-.15-.35t-.35-.15-.35.15T11 4v2H5v2.2q1.35.5 2.175 1.675T8 12.5q0 1.425-.825 2.6T5 16.8Zm7.75-7.75"
    })
  });
};
const Extension = /*#__PURE__*/forwardRef(Component$4w);

const Component$4v = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M8.8 21H5q-.825 0-1.413-.587Q3 19.825 3 19v-3.8q1.2 0 2.1-.762.9-.763.9-1.938t-.9-1.938T3 9.8V6q0-.825.587-1.412Q4.175 4 5 4h4q0-1.05.725-1.775T11.5 1.5t1.775.725T14 4h4q.825 0 1.413.588Q20 5.175 20 6v4q1.05 0 1.775.725T22.5 12.5t-.725 1.775T20 15v4q0 .825-.587 1.413Q18.825 21 18 21h-3.8q0-1.25-.787-2.125Q12.625 18 11.5 18t-1.912.875T8.8 21"
    })
  });
};
const ExtensionFilled = /*#__PURE__*/forwardRef(Component$4v);

const Component$4u = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M9.2 8.636H6.5V12h2.8v10h4.6V12h3.3l.3-3.364h-3.7V7.273c0-.818.2-1.091 1-1.091h2.6V2H14c-3.3 0-4.8 1.364-4.8 3.818z"
    })
  });
};
const Facebook = /*#__PURE__*/forwardRef(Component$4u);

const Component$4t = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M18 6q-.825 0-1.413-.588Q16 4.825 16 4t.587-1.413Q17.175 2 18 2t1.413.587Q20 3.175 20 4t-.587 1.412Q18.825 6 18 6m-1 16v-8q0-1-.512-1.8-.513-.8-1.313-1.25l.875-2.575q.2-.625.738-1Q17.325 7 18 7t1.212.375q.538.375.738 1l2.1 6.3q.175.5-.137.912Q21.6 16 21.1 16H20v5q0 .425-.288.712Q19.425 22 19 22Zm-4.5-10.5q-.625 0-1.062-.438Q11 10.625 11 10t.438-1.062Q11.875 8.5 12.5 8.5t1.062.438Q14 9.375 14 10t-.438 1.062q-.437.438-1.062.438M5.5 6q-.825 0-1.412-.588Q3.5 4.825 3.5 4t.588-1.413Q4.675 2 5.5 2t1.412.587Q7.5 3.175 7.5 4t-.588 1.412Q6.325 6 5.5 6m-1 16q-.425 0-.712-.288Q3.5 21.425 3.5 21v-6H3q-.425 0-.712-.288Q2 14.425 2 14V9q0-.825.588-1.413Q3.175 7 4 7h3q.825 0 1.412.587Q9 8.175 9 9v5q0 .425-.287.712Q8.425 15 8 15h-.5v6q0 .425-.287.712Q6.925 22 6.5 22Zm7.5 0q-.425 0-.712-.288Q11 21.425 11 21v-3q-.425 0-.712-.288Q10 17.425 10 17v-3q0-.625.438-1.062.437-.438 1.062-.438h2q.625 0 1.062.438Q15 13.375 15 14v3q0 .425-.287.712Q14.425 18 14 18v3q0 .425-.287.712Q13.425 22 13 22Z"
    })
  });
};
const FamilyRestroom = /*#__PURE__*/forwardRef(Component$4t);

const Component$4s = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 21.175q-.349 0-.713-.125a1.65 1.65 0 0 1-.637-.4l-1.725-1.575a68 68 0 0 1-4.788-4.813Q2.001 11.876 2 9q0-2.35 1.575-3.925T7.5 3.5q1.325 0 2.5.563T12 5.6a6 6 0 0 1 2-1.537 5.7 5.7 0 0 1 2.5-.563q2.35 0 3.925 1.575T22 9q0 2.875-2.125 5.275A60 60 0 0 1 15.05 19.1l-1.7 1.55a1.65 1.65 0 0 1-.637.4q-.363.125-.713.125M11.05 7.6q-.725-1.024-1.55-1.563-.825-.537-2-.537-1.5 0-2.5 1C4 7.5 4 8 4 9q0 1.3.925 2.762A19 19 0 0 0 7.138 14.6a38 38 0 0 0 2.65 2.575q1.362 1.2 2.212 1.975.85-.775 2.213-1.975t2.65-2.575a19 19 0 0 0 2.212-2.838Q20 10.3 20 9q0-1.5-1-2.5c-1-1-1.5-1-2.5-1q-1.175 0-2 .537-.825.539-1.55 1.563a1.14 1.14 0 0 1-.95.5 1.14 1.14 0 0 1-.95-.5"
    })
  });
};
const Favorite = /*#__PURE__*/forwardRef(Component$4s);

const Component$4r = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 21.175q-.349 0-.713-.125a1.65 1.65 0 0 1-.637-.4l-1.725-1.575a68 68 0 0 1-4.788-4.813Q2.001 11.876 2 9q0-2.35 1.575-3.925T7.5 3.5q1.325 0 2.5.563T12 5.6a6 6 0 0 1 2-1.537 5.7 5.7 0 0 1 2.5-.563q2.35 0 3.925 1.575T22 9q0 2.875-2.125 5.275A60 60 0 0 1 15.05 19.1l-1.7 1.55a1.65 1.65 0 0 1-.637.4q-.363.125-.713.125"
    })
  });
};
const FavoriteFilled = /*#__PURE__*/forwardRef(Component$4r);

const Component$4q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-50 0-85-35t-35-85v-280q0-50 35-85t85-35q27 0 49.5 11t39.5 29h31v-120q0-33 23.5-56.5T400-800h240q33 0 56.5 23.5T720-720v120h40q50 0 85 35t35 85v240q0 33-23.5 56.5T800-160H289q-17 18-39.5 29T200-120m0-80q17 0 28.5-11.5T240-240v-280q0-17-11.5-28.5T200-560t-28.5 11.5T160-520v280q0 17 11.5 28.5T200-200m200-400h240v-120H400zm-80 360h480v-240q0-17-11.5-28.5T760-520H320zm280-160q17 0 28.5-11.5T640-440t-11.5-28.5T600-480t-28.5 11.5T560-440t11.5 28.5T600-400m120 0q17 0 28.5-11.5T760-440t-11.5-28.5T720-480t-28.5 11.5T680-440t11.5 28.5T720-400M600-280q17 0 28.5-11.5T640-320t-11.5-28.5T600-360t-28.5 11.5T560-320t11.5 28.5T600-280m120 0q17 0 28.5-11.5T760-320t-11.5-28.5T720-360t-28.5 11.5T680-320t11.5 28.5T720-280m-360 0h160v-200H360zm-40 40v-280z"
    })
  });
};
const Fax = /*#__PURE__*/forwardRef(Component$4q);

const Component$4p = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M320-160v-560q0-33 23.5-56.5T400-800h240q33 0 56.5 23.5T720-720v120h40q50 0 85 35t35 85v240q0 33-23.5 56.5T800-160zm-140 40q42 0 71-29t29-71v-320q0-42-29-71t-71-29-71 29-29 71v320q0 42 29 71t71 29m220-480h240v-120H400zm240 200q17 0 28.5-11.5T680-440t-11.5-28.5T640-480t-28.5 11.5T600-440t11.5 28.5T640-400m120 0q17 0 28.5-11.5T800-440t-11.5-28.5T760-480t-28.5 11.5T720-440t11.5 28.5T760-400M640-280q17 0 28.5-11.5T680-320t-11.5-28.5T640-360t-28.5 11.5T600-320t11.5 28.5T640-280m120 0q17 0 28.5-11.5T800-320t-11.5-28.5T760-360t-28.5 11.5T720-320t11.5 28.5T760-280m-360 0h160v-200H400z"
    })
  });
};
const FaxFilled = /*#__PURE__*/forwardRef(Component$4p);

const Component$4o = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M760-200H320q-33 0-56.5-23.5T240-280v-560q0-33 23.5-56.5T320-920h247q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v367q0 33-23.5 56.5T760-200m0-440H620q-25 0-42.5-17.5T560-700v-140H320v560h440zM160-40q-33 0-56.5-23.5T80-120v-520q0-17 11.5-28.5T120-680t28.5 11.5T160-640v520h400q17 0 28.5 11.5T600-80t-11.5 28.5T560-40zm160-800v200zv560z"
    })
  });
};
const FileCopy = /*#__PURE__*/forwardRef(Component$4o);

const Component$4n = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M760-200H320q-33 0-56.5-23.5T240-280v-560q0-33 23.5-56.5T320-920h247q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v367q0 33-23.5 56.5T760-200m0-440L560-840v140q0 25 17.5 42.5T620-640zM160-40q-33 0-56.5-23.5T80-120v-520q0-17 11.5-28.5T120-680t28.5 11.5T160-640v520h400q17 0 28.5 11.5T600-80t-11.5 28.5T560-40z"
    })
  });
};
const FileCopyFilled = /*#__PURE__*/forwardRef(Component$4n);

const Component$4m = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M11 20q-.425 0-.712-.288Q10 19.425 10 19v-6L4.2 5.6q-.375-.5-.112-1.05Q4.35 4 5 4h14q.65 0 .913.55.262.55-.113 1.05L14 13v6q0 .425-.287.712Q13.425 20 13 20Zm1-7.7L16.95 6h-9.9Zm0 0"
    })
  });
};
const FilterAlt = /*#__PURE__*/forwardRef(Component$4m);

const Component$4l = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M11 20q-.425 0-.712-.288Q10 19.425 10 19v-6L4.2 5.6q-.375-.5-.112-1.05Q4.35 4 5 4h14q.65 0 .913.55.262.55-.113 1.05L14 13v6q0 .425-.287.712Q13.425 20 13 20Z"
    })
  });
};
const FilterAltFilled = /*#__PURE__*/forwardRef(Component$4l);

const Component$4k = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M19 21H5q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h14q.825 0 1.413.587Q21 4.175 21 5v14q0 .825-.587 1.413Q19.825 21 19 21M5 19h7v-8l7 8V5h-7v6Z"
    })
  });
};
const FilterBAndW = /*#__PURE__*/forwardRef(Component$4k);

const Component$4j = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m274-274-100-55q-11-6-12.5-17.5T168-366l12-12q4-4 9.5-5.5t10.5-.5l88 12 156-156-272-148q-15-8-17.5-25t9.5-29l10-10q7-7 15.5-9t17.5 0l363 93 157-155q17-17 42.5-17t42.5 17 17 42.5-17 42.5L656-570l93 361q2 10-.5 19.5T739-173l-5 5q-14 14-32.5 11T674-177L528-444 372-288l12 86q1 7-1 13t-7 11l-5 5q-10 10-24 8.5T326-179z"
    })
  });
};
const Flightsmode = /*#__PURE__*/forwardRef(Component$4j);

const Component$4i = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h207q16 0 30.5 6t25.5 17l57 57h320q33 0 56.5 23.5T880-640v400q0 33-23.5 56.5T800-160zm0-80h640v-400H447l-80-80H160zm0 0v-480z"
    })
  });
};
const Folder = /*#__PURE__*/forwardRef(Component$4i);

const Component$4h = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M120-120q-33 0-56.5-23.5T40-200v-480q0-17 11.5-28.5T80-720t28.5 11.5T120-680v480h640q17 0 28.5 11.5T800-160t-11.5 28.5T760-120zm160-160q-33 0-56.5-23.5T200-360v-440q0-33 23.5-56.5T280-880h167q16 0 30.5 6t25.5 17l57 57h280q33 0 56.5 23.5T920-720v360q0 33-23.5 56.5T840-280zm0-80h560v-360H527l-80-80H280zm0 0v-440z"
    })
  });
};
const FolderCopy = /*#__PURE__*/forwardRef(Component$4h);

const Component$4g = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M120-120q-33 0-56.5-23.5T40-200v-480q0-17 11.5-28.5T80-720t28.5 11.5T120-680v480h640q17 0 28.5 11.5T800-160t-11.5 28.5T760-120zm160-160q-33 0-56.5-23.5T200-360v-440q0-33 23.5-56.5T280-880h167q16 0 30.5 6t25.5 17l57 57h280q33 0 56.5 23.5T920-720v360q0 33-23.5 56.5T840-280z"
    })
  });
};
const FolderCopyFilled = /*#__PURE__*/forwardRef(Component$4g);

const Component$4f = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h207q16 0 30.5 6t25.5 17l57 57h320q33 0 56.5 23.5T880-640v400q0 33-23.5 56.5T800-160z"
    })
  });
};
const FolderFilled = /*#__PURE__*/forwardRef(Component$4f);

const Component$4e = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h207q16 0 30.5 6t25.5 17l57 57h320q33 0 56.5 23.5T880-640H447l-80-80H160v480l79-263q8-26 29.5-41.5T316-560h516q41 0 64.5 32.5T909-457l-72 240q-8 26-29.5 41.5T760-160zm84-80h516l72-240H316zm-84-262v-218zm84 262 72-240z"
    })
  });
};
const FolderOpen = /*#__PURE__*/forwardRef(Component$4e);

const Component$4d = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M880-640H314q-62 0-108 39t-46 99v262l79-263q8-26 29.5-41.5T316-560h516q41 0 64.5 32.5T909-457l-72 240q-8 26-29.5 41.5T760-160H160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h207q16 0 30.5 6t25.5 17l57 57h320q33 0 56.5 23.5T880-640"
    })
  });
};
const FolderOpenFilled = /*#__PURE__*/forwardRef(Component$4d);

const Component$4c = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M160-120q-17 0-28.5-11.5T120-160t11.5-28.5T160-200h640q17 0 28.5 11.5T840-160t-11.5 28.5T800-120zm160-160q-17 0-28.5-11.5T280-320t11.5-28.5T320-360h320q17 0 28.5 11.5T680-320t-11.5 28.5T640-280zM160-440q-17 0-28.5-11.5T120-480t11.5-28.5T160-520h640q17 0 28.5 11.5T840-480t-11.5 28.5T800-440zm160-160q-17 0-28.5-11.5T280-640t11.5-28.5T320-680h320q17 0 28.5 11.5T680-640t-11.5 28.5T640-600zM160-760q-17 0-28.5-11.5T120-800t11.5-28.5T160-840h640q17 0 28.5 11.5T840-800t-11.5 28.5T800-760z"
    })
  });
};
const FormatAlignCenter = /*#__PURE__*/forwardRef(Component$4c);

const Component$4b = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M160-120q-17 0-28.5-11.5T120-160t11.5-28.5T160-200h640q17 0 28.5 11.5T840-160t-11.5 28.5T800-120zm0-160q-17 0-28.5-11.5T120-320t11.5-28.5T160-360h640q17 0 28.5 11.5T840-320t-11.5 28.5T800-280zm0-160q-17 0-28.5-11.5T120-480t11.5-28.5T160-520h640q17 0 28.5 11.5T840-480t-11.5 28.5T800-440zm0-160q-17 0-28.5-11.5T120-640t11.5-28.5T160-680h640q17 0 28.5 11.5T840-640t-11.5 28.5T800-600zm0-160q-17 0-28.5-11.5T120-800t11.5-28.5T160-840h640q17 0 28.5 11.5T840-800t-11.5 28.5T800-760z"
    })
  });
};
const FormatAlignJustify = /*#__PURE__*/forwardRef(Component$4b);

const Component$4a = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M160-280q-17 0-28.5-11.5T120-320t11.5-28.5T160-360h400q17 0 28.5 11.5T600-320t-11.5 28.5T560-280zm0-320q-17 0-28.5-11.5T120-640t11.5-28.5T160-680h400q17 0 28.5 11.5T600-640t-11.5 28.5T560-600zm0 160q-17 0-28.5-11.5T120-480t11.5-28.5T160-520h640q17 0 28.5 11.5T840-480t-11.5 28.5T800-440zm0 320q-17 0-28.5-11.5T120-160t11.5-28.5T160-200h640q17 0 28.5 11.5T840-160t-11.5 28.5T800-120zm0-640q-17 0-28.5-11.5T120-800t11.5-28.5T160-840h640q17 0 28.5 11.5T840-800t-11.5 28.5T800-760z"
    })
  });
};
const FormatAlignLeft = /*#__PURE__*/forwardRef(Component$4a);

const Component$49 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M160-120q-17 0-28.5-11.5T120-160t11.5-28.5T160-200h640q17 0 28.5 11.5T840-160t-11.5 28.5T800-120zm240-160q-17 0-28.5-11.5T360-320t11.5-28.5T400-360h400q17 0 28.5 11.5T840-320t-11.5 28.5T800-280zM160-440q-17 0-28.5-11.5T120-480t11.5-28.5T160-520h640q17 0 28.5 11.5T840-480t-11.5 28.5T800-440zm240-160q-17 0-28.5-11.5T360-640t11.5-28.5T400-680h400q17 0 28.5 11.5T840-640t-11.5 28.5T800-600zM160-760q-17 0-28.5-11.5T120-800t11.5-28.5T160-840h640q17 0 28.5 11.5T840-800t-11.5 28.5T800-760z"
    })
  });
};
const FormatAlignRight = /*#__PURE__*/forwardRef(Component$49);

const Component$48 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M352-200q-33 0-56.5-23.5T272-280v-400q0-33 23.5-56.5T352-760h141q65 0 120 40t55 111q0 51-23 78.5T602-491q25 11 55.5 41t30.5 90q0 89-65 124.5T501-200zm41-112h104q48 0 58.5-24.5T566-372t-10.5-35.5T494-432H393zm0-228h93q33 0 48-17t15-38q0-24-17-39t-44-15h-95z"
    })
  });
};
const FormatBold = /*#__PURE__*/forwardRef(Component$48);

const Component$47 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M7.11 17c.48 0 .91-.3 1.06-.75l1.01-2.83h5.65l.99 2.82c.16.46.59.76 1.07.76.79 0 1.33-.79 1.05-1.52L13.69 4.17C13.43 3.47 12.75 3 12 3s-1.43.47-1.69 1.17L6.06 15.48c-.28.73.27 1.52 1.05 1.52m4.83-11.4h.12l2.03 5.79H9.91z"
    }), /*#__PURE__*/jsx("path", {
      fill: "var(--icon-accent-color)",
      d: "M4 20h16c1.1 0 2 .9 2 2s-.9 2-2 2H4c-1.1 0-2-.9-2-2s.9-2 2-2"
    })]
  });
};
const FormatColorText = /*#__PURE__*/forwardRef(Component$47);

const Component$46 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-280q-17 0-28.5-11.5T440-320t11.5-28.5T480-360h320q17 0 28.5 11.5T840-320t-11.5 28.5T800-280zm-234-74L134-466q-6-6-6-14t6-14l112-112q10-10 22-5t12 19v224q0 14-12 19t-22-5m-86 234q-17 0-28.5-11.5T120-160t11.5-28.5T160-200h640q17 0 28.5 11.5T840-160t-11.5 28.5T800-120zm0-640q-17 0-28.5-11.5T120-800t11.5-28.5T160-840h640q17 0 28.5 11.5T840-800t-11.5 28.5T800-760zm320 160q-17 0-28.5-11.5T440-640t11.5-28.5T480-680h320q17 0 28.5 11.5T840-640t-11.5 28.5T800-600zm0 160q-17 0-28.5-11.5T440-480t11.5-28.5T480-520h320q17 0 28.5 11.5T840-480t-11.5 28.5T800-440z"
    })
  });
};
const FormatIndentDecrease = /*#__PURE__*/forwardRef(Component$46);

const Component$45 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M160-120q-17 0-28.5-11.5T120-160t11.5-28.5T160-200h640q17 0 28.5 11.5T840-160t-11.5 28.5T800-120zm-40-248v-224q0-14 12-19t22 5l112 112q6 6 6 14t-6 14L154-354q-10 10-22 5t-12-19m360 88q-17 0-28.5-11.5T440-320t11.5-28.5T480-360h320q17 0 28.5 11.5T840-320t-11.5 28.5T800-280zM160-760q-17 0-28.5-11.5T120-800t11.5-28.5T160-840h640q17 0 28.5 11.5T840-800t-11.5 28.5T800-760zm320 160q-17 0-28.5-11.5T440-640t11.5-28.5T480-680h320q17 0 28.5 11.5T840-640t-11.5 28.5T800-600zm0 160q-17 0-28.5-11.5T440-480t11.5-28.5T480-520h320q17 0 28.5 11.5T840-480t-11.5 28.5T800-440z"
    })
  });
};
const FormatIndentIncrease = /*#__PURE__*/forwardRef(Component$45);

const Component$44 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M4 24q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 22q0-.824.587-1.413A1.93 1.93 0 0 1 4 20h16q.824 0 1.413.587Q22 21.176 22 22t-.587 1.413A1.93 1.93 0 0 1 20 24zm10.6-12L12 9.4l-4 4 2.575 2.6zm-1.175-4L16 10.575 20 6.6 17.4 4zm-2.1-.725 5.4 5.4L12 17.425q-.6.6-1.412.6-.813 0-1.413-.6l-.125.1q-.274.225-.6.35a1.9 1.9 0 0 1-.675.125h-3.05q-.35 0-.487-.3-.138-.3.112-.55l2.3-2.275q-.6-.6-.625-1.437A1.88 1.88 0 0 1 6.6 12zm0 0L16 2.6q.6-.6 1.413-.6.812 0 1.412.6l2.6 2.575q.6.6.6 1.413 0 .812-.6 1.412l-4.7 4.675z"
    }), /*#__PURE__*/jsx("path", {
      fill: "var(--icon-accent-color)",
      d: "M2.588 23.413Q3.175 24 4 24h16q.824 0 1.413-.587Q22 22.825 22 22q0-.824-.587-1.413A1.93 1.93 0 0 0 20 20H4q-.824 0-1.412.587A1.93 1.93 0 0 0 2 22q0 .824.587 1.413"
    })]
  });
};
const FormatInkHighlighter = /*#__PURE__*/forwardRef(Component$44);

const Component$43 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "m10.6 8 5.4 5.425-4 4q-.6.6-1.412.6-.813 0-1.413-.6l-.125.1q-.274.225-.6.35a1.9 1.9 0 0 1-.675.125h-3.05q-.35 0-.487-.3-.138-.3.112-.55l2.3-2.275q-.6-.6-.625-1.437A1.88 1.88 0 0 1 6.6 12zM12 6.575 16 2.6q.6-.6 1.413-.6.812 0 1.412.6l2.6 2.575q.6.6.6 1.413 0 .812-.6 1.412l-4 4z"
    }), /*#__PURE__*/jsx("path", {
      fill: "var(--icon-accent-color)",
      d: "M2.588 23.413Q3.175 24 4 24h16q.824 0 1.413-.587Q22 22.825 22 22q0-.824-.587-1.413A1.93 1.93 0 0 0 20 20H4q-.824 0-1.412.587A1.93 1.93 0 0 0 2 22q0 .824.587 1.413"
    })]
  });
};
const FormatInkHighlighterFilled = /*#__PURE__*/forwardRef(Component$43);

const Component$42 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M250-200q-21 0-35.5-14.5T200-250t14.5-35.5T250-300h110l120-360H370q-21 0-35.5-14.5T320-710t14.5-35.5T370-760h300q21 0 35.5 14.5T720-710t-14.5 35.5T670-660h-90L460-300h90q21 0 35.5 14.5T600-250t-14.5 35.5T550-200z"
    })
  });
};
const FormatItalic = /*#__PURE__*/forwardRef(Component$42);

const Component$41 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M4.5 13.5q-.625 0-1.062-.438Q3 12.625 3 12t.438-1.062Q3.875 10.5 4.5 10.5t1.062.438Q6 11.375 6 12t-.438 1.062q-.437.438-1.062.438m0-6q-.625 0-1.062-.438Q3 6.625 3 6t.438-1.062T4.5 4.5t1.062.438Q6 5.375 6 6t-.438 1.062T4.5 7.5m0 12q-.625 0-1.062-.438Q3 18.625 3 18t.438-1.062T4.5 16.5t1.062.438Q6 17.375 6 18t-.438 1.062T4.5 19.5M9 19q-.425 0-.712-.288Q8 18.425 8 18t.288-.712Q8.575 17 9 17h11q.425 0 .712.288.288.287.288.712t-.288.712Q20.425 19 20 19Zm0-6q-.425 0-.712-.288Q8 12.425 8 12t.288-.713T9 11h11q.425 0 .712.287.288.288.288.713t-.288.712Q20.425 13 20 13Zm0-6q-.425 0-.712-.287Q8 6.425 8 6t.288-.713Q8.575 5 9 5h11q.425 0 .712.287Q21 5.575 21 6t-.288.713Q20.425 7 20 7Z"
    })
  });
};
const FormatListBulleted = /*#__PURE__*/forwardRef(Component$41);

const Component$40 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M150-80q-13 0-21.5-8.5T120-110t8.5-21.5T150-140h70v-30h-30q-13 0-21.5-8.5T160-200t8.5-21.5T190-230h30v-30h-70q-13 0-21.5-8.5T120-290t8.5-21.5T150-320h90q17 0 28.5 11.5T280-280v40q0 17-11.5 28.5T240-200q17 0 28.5 11.5T280-160v40q0 17-11.5 28.5T240-80zm0-280q-13 0-21.5-8.5T120-390v-80q0-17 11.5-28.5T160-510h60v-30h-70q-13 0-21.5-8.5T120-570t8.5-21.5T150-600h90q17 0 28.5 11.5T280-560v70q0 17-11.5 28.5T240-450h-60v30h70q13 0 21.5 8.5T280-390t-8.5 21.5T250-360zm60-280q-13 0-21.5-8.5T180-670v-150h-30q-13 0-21.5-8.5T120-850t8.5-21.5T150-880h60q13 0 21.5 8.5T240-850v180q0 13-8.5 21.5T210-640m190 440q-17 0-28.5-11.5T360-240t11.5-28.5T400-280h400q17 0 28.5 11.5T840-240t-11.5 28.5T800-200zm0-240q-17 0-28.5-11.5T360-480t11.5-28.5T400-520h400q17 0 28.5 11.5T840-480t-11.5 28.5T800-440zm0-240q-17 0-28.5-11.5T360-720t11.5-28.5T400-760h400q17 0 28.5 11.5T840-720t-11.5 28.5T800-680z"
    })
  });
};
const FormatListNumbered = /*#__PURE__*/forwardRef(Component$40);

const Component$3$ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m262-300 58-100q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113q0 23-5.5 42.5T458-480L331-260q-5 9-14 14.5t-20 5.5q-23 0-34.5-20t-.5-40m360 0 58-100q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113q0 23-5.5 42.5T818-480L691-260q-5 9-14 14.5t-20 5.5q-23 0-34.5-20t-.5-40M320-500q25 0 42.5-17.5T380-560t-17.5-42.5T320-620t-42.5 17.5T260-560t17.5 42.5T320-500m360 0q25 0 42.5-17.5T740-560t-17.5-42.5T680-620t-42.5 17.5T620-560t17.5 42.5T680-500m-360-60"
    })
  });
};
const FormatQuote = /*#__PURE__*/forwardRef(Component$3$);

const Component$3_ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m262-300 58-100q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113q0 23-5.5 42.5T458-480L331-260q-5 9-14 14.5t-20 5.5q-23 0-34.5-20t-.5-40m360 0 58-100q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113q0 23-5.5 42.5T818-480L691-260q-5 9-14 14.5t-20 5.5q-23 0-34.5-20t-.5-40"
    })
  });
};
const FormatQuoteFilled = /*#__PURE__*/forwardRef(Component$3_);

const Component$3Z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M240-120q-17 0-28.5-11.5T200-160t11.5-28.5T240-200h480q17 0 28.5 11.5T760-160t-11.5 28.5T720-120zm240-160q-101 0-157-63t-56-167v-279q0-21 15.5-36t36.5-15 36 15 15 36v285q0 56 28 91t82 35 82-35 28-91v-285q0-21 15.5-36t36.5-15 36 15 15 36v279q0 104-56 167t-157 63"
    })
  });
};
const FormatUnderlined = /*#__PURE__*/forwardRef(Component$3Z);

const Component$3Y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M800-720H160v480h360v80H160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v280h-80zm-640 0v480-200 3zm320 200 320-200v80L501-453q-10 6-21 6t-21-6L160-640v-80zm287 360H640q-17 0-28.5-11.5T600-200t11.5-28.5T640-240h127l-36-36q-12-12-11.5-28t12.5-28q12-11 28-11.5t28 11.5l104 104q12 12 12 28t-12 28L788-68q-11 11-27.5 11.5T732-68q-11-11-11-28t11-28z"
    })
  });
};
const ForwardToInbox = /*#__PURE__*/forwardRef(Component$3Y);

const Component$3X = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M767-160H640q-17 0-28.5-11.5T600-200t11.5-28.5T640-240h127l-36-36q-12-12-11.5-28t12.5-28q12-11 28-11.5t28 11.5l104 104q12 12 12 28t-12 28L788-68q-11 11-27.5 11.5T732-68q-11-11-11-28t11-28zm-607 0q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v312q-27-16-57.5-24t-62.5-8q-100 0-170 70t-70 170v40zm320-360L212-688q-17-11-34.5-1T160-659q0 9 4 16.5t12 12.5l283 177q10 6 21 6t21-6l283-177q8-5 12-12.5t4-16.5q0-20-17.5-30t-34.5 1z"
    })
  });
};
const ForwardToInboxFilled = /*#__PURE__*/forwardRef(Component$3X);

const Component$3W = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M12.199 0A11.25 11.25 0 0 0 2.153 6.149v-1.23a1.09 1.09 0 0 0-1.077-1.107A1.087 1.087 0 0 0 0 4.92v3.816A1.09 1.09 0 0 0 1.076 9.84h4.306a1.106 1.106 0 0 0 0-2.213H3.707A9.41 9.41 0 0 1 12.2 2.214a9.73 9.73 0 0 1 9.568 9.838 9.74 9.74 0 0 1-9.568 9.837 9.43 9.43 0 0 1-8.97-6.517c-.24-.615-.837-.984-1.316-.738a1.063 1.063 0 0 0-.717 1.352 11.76 11.76 0 0 0 10.388 7.987c1.546.1 3.096-.107 4.562-.61a12.16 12.16 0 0 0 7.176-15.372A11.79 11.79 0 0 0 12.199 0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.96 17.948a5.98 5.98 0 0 0 5.98-5.983 5.98 5.98 0 0 0-5.98-5.983 5.98 5.98 0 0 0-5.98 5.983 5.98 5.98 0 0 0 5.98 5.983"
    })]
  });
};
const FrequencyAnnual = /*#__PURE__*/forwardRef(Component$3W);

const Component$3V = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M12.204 0a11.26 11.26 0 0 0-10.05 6.149V4.92a1.087 1.087 0 0 0-1.08-1.106A1.087 1.087 0 0 0 0 4.92v3.811A1.087 1.087 0 0 0 1.08 9.84h4.308a1.108 1.108 0 0 0 0-2.214h-1.68a9.41 9.41 0 0 1 8.496-5.412 9.736 9.736 0 0 1 9.572 9.84 9.735 9.735 0 0 1-9.572 9.84 9.44 9.44 0 0 1-8.974-6.517c-.24-.615-.84-.984-1.32-.738a1.066 1.066 0 0 0-.71 1.347 11.76 11.76 0 0 0 14.953 7.378 12.155 12.155 0 0 0 7.18-15.37A11.79 11.79 0 0 0 12.204 0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12.6 17.368V6.634c2.696.3 4.8 2.592 4.8 5.367a5.41 5.41 0 0 1-4.8 5.367"
    }), /*#__PURE__*/jsx("path", {
      d: "M13.2 7.353v9.296a4.81 4.81 0 0 0 3.6-4.648 4.81 4.81 0 0 0-3.6-4.648M12 6a6 6 0 0 1 0 12z"
    })]
  });
};
const FrequencyBiannual = /*#__PURE__*/forwardRef(Component$3V);

const Component$3U = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M12.204 0a11.26 11.26 0 0 0-10.05 6.149v-1.23a1.09 1.09 0 0 0-1.077-1.107A1.09 1.09 0 0 0 0 4.92v3.816A1.09 1.09 0 0 0 1.077 9.84h4.307a1.107 1.107 0 0 0 0-2.213H3.71a9.41 9.41 0 0 1 8.495-5.414 9.736 9.736 0 0 1 9.572 9.838 9.736 9.736 0 0 1-9.572 9.837 9.44 9.44 0 0 1-8.974-6.517c-.239-.615-.837-.984-1.316-.738a1.064 1.064 0 0 0-.718 1.352 11.76 11.76 0 0 0 14.957 7.377 12.155 12.155 0 0 0 7.179-15.371A11.79 11.79 0 0 0 12.204 0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 6.018a5.1 5.1 0 0 1 2.911.785l-2.91 5.198z"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 6.018c1.242.032 2.144.254 2.911.785l-2.91 5.198z"
    })]
  });
};
const FrequencyMonthly = /*#__PURE__*/forwardRef(Component$3U);

const Component$3T = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M12.204 0a11.26 11.26 0 0 0-10.05 6.149v-1.23a1.09 1.09 0 0 0-1.077-1.107A1.09 1.09 0 0 0 0 4.92v3.816A1.09 1.09 0 0 0 1.077 9.84h4.307a1.107 1.107 0 0 0 0-2.213H3.71a9.41 9.41 0 0 1 8.495-5.414 9.736 9.736 0 0 1 9.572 9.838 9.736 9.736 0 0 1-9.572 9.837 9.44 9.44 0 0 1-8.974-6.517c-.239-.615-.837-.984-1.316-.738a1.064 1.064 0 0 0-.718 1.352 11.76 11.76 0 0 0 14.957 7.377 12.155 12.155 0 0 0 7.179-15.371A11.79 11.79 0 0 0 12.204 0"
    }), /*#__PURE__*/jsx("path", {
      d: "M16.635 10.804h-3.438V7.366a4.8 4.8 0 0 1 3.438 3.438"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 6.019A5.983 5.983 0 0 1 17.983 12H12z"
    })]
  });
};
const FrequencyQuaterly = /*#__PURE__*/forwardRef(Component$3T);

const Component$3S = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M6 19q-.425 0-.713-.288Q5 18.425 5 18v-3q0-.425.287-.713Q5.575 14 6 14t.713.287Q7 14.575 7 15v2h2q.425 0 .713.288.287.287.287.712t-.287.712Q9.425 19 9 19Zm0-9q-.425 0-.713-.288Q5 9.425 5 9V6q0-.425.287-.713Q5.575 5 6 5h3q.425 0 .713.287Q10 5.575 10 6t-.287.713Q9.425 7 9 7H7v2q0 .425-.287.712Q6.425 10 6 10m9 9q-.425 0-.712-.288Q14 18.425 14 18t.288-.712Q14.575 17 15 17h2v-2q0-.425.288-.713Q17.575 14 18 14t.712.287Q19 14.575 19 15v3q0 .425-.288.712Q18.425 19 18 19Zm3-9q-.425 0-.712-.288Q17 9.425 17 9V7h-2q-.425 0-.712-.287Q14 6.425 14 6t.288-.713Q14.575 5 15 5h3q.425 0 .712.287Q19 5.575 19 6v3q0 .425-.288.712Q18.425 10 18 10"
    })
  });
};
const Fullscreen = /*#__PURE__*/forwardRef(Component$3S);

const Component$3R = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M9 19q-.425 0-.712-.288Q8 18.425 8 18v-2H6q-.425 0-.713-.288Q5 15.425 5 15t.287-.713Q5.575 14 6 14h3q.425 0 .713.287.287.288.287.713v3q0 .425-.287.712Q9.425 19 9 19m-3-9q-.425 0-.713-.288Q5 9.425 5 9t.287-.713Q5.575 8 6 8h2V6q0-.425.288-.713Q8.575 5 9 5t.713.287Q10 5.575 10 6v3q0 .425-.287.712Q9.425 10 9 10Zm9 9q-.425 0-.712-.288Q14 18.425 14 18v-3q0-.425.288-.713Q14.575 14 15 14h3q.425 0 .712.287.288.288.288.713t-.288.712Q18.425 16 18 16h-2v2q0 .425-.287.712Q15.425 19 15 19m0-9q-.425 0-.712-.288Q14 9.425 14 9V6q0-.425.288-.713Q14.575 5 15 5t.713.287Q16 5.575 16 6v2h2q.425 0 .712.287Q19 8.575 19 9t-.288.712Q18.425 10 18 10Z"
    })
  });
};
const FullscreenExit = /*#__PURE__*/forwardRef(Component$3R);

const Component$3Q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M18 22h-4.446a6 6 0 0 0 .536-2H18V9h-4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 13 8V4H6v9.85a6 6 0 0 0-2 1.249V4q0-.825.588-1.413A1.93 1.93 0 0 1 6 2h7.175a1.98 1.98 0 0 1 1.4.575l4.85 4.85a1.98 1.98 0 0 1 .575 1.4V20a1.93 1.93 0 0 1-.587 1.413A1.93 1.93 0 0 1 18 22m-13.279.862q.14.138.349.138h5.86a.475.475 0 0 0 .489-.48v-3.358h.83a.23.23 0 0 0 .232-.156q.06-.156-.073-.264l-4.078-3.61A.45.45 0 0 0 8 15q-.195 0-.33.132l-4.078 3.61q-.135.108-.073.264.06.156.232.156h.83v3.358q0 .204.14.342",
      clipRule: "evenodd"
    })
  });
};
const Gba = /*#__PURE__*/forwardRef(Component$3Q);

const Component$3P = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M14.109 19.473c0 .902-.2 1.759-.556 2.527H18a1.93 1.93 0 0 0 1.413-.587A1.93 1.93 0 0 0 20 20V8.825a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H6q-.824 0-1.412.587A1.93 1.93 0 0 0 4 4v11.098a6.001 6.001 0 0 1 10.109 4.374ZM13 8q0 .424.288.712A.97.97 0 0 0 14 9h4l-5-5zM4.721 22.862q.14.138.349.138h5.86a.475.475 0 0 0 .489-.48v-3.358h.83a.23.23 0 0 0 .232-.156q.06-.156-.073-.264l-4.078-3.61A.45.45 0 0 0 8 15q-.195 0-.33.132l-4.078 3.61q-.135.108-.073.264.06.156.232.156h.83v3.358q0 .204.14.342",
      clipRule: "evenodd"
    })
  });
};
const GbaFilled = /*#__PURE__*/forwardRef(Component$3P);

const Component$3O = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-520q-33 0-56.5-23.5T120-600v-160q0-33 23.5-56.5T200-840h160q33 0 56.5 23.5T440-760v160q0 33-23.5 56.5T360-520zm0 400q-33 0-56.5-23.5T120-200v-160q0-33 23.5-56.5T200-440h160q33 0 56.5 23.5T440-360v160q0 33-23.5 56.5T360-120zm400-400q-33 0-56.5-23.5T520-600v-160q0-33 23.5-56.5T600-840h160q33 0 56.5 23.5T840-760v160q0 33-23.5 56.5T760-520zm0 400q-33 0-56.5-23.5T520-200v-160q0-33 23.5-56.5T600-440h160q33 0 56.5 23.5T840-360v160q0 33-23.5 56.5T760-120zM200-600h160v-160H200zm400 0h160v-160H600zm0 400h160v-160H600zm-400 0h160v-160H200zm160-400"
    })
  });
};
const GridView = /*#__PURE__*/forwardRef(Component$3O);

const Component$3N = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-520q-33 0-56.5-23.5T120-600v-160q0-33 23.5-56.5T200-840h160q33 0 56.5 23.5T440-760v160q0 33-23.5 56.5T360-520zm0 400q-33 0-56.5-23.5T120-200v-160q0-33 23.5-56.5T200-440h160q33 0 56.5 23.5T440-360v160q0 33-23.5 56.5T360-120zm400-400q-33 0-56.5-23.5T520-600v-160q0-33 23.5-56.5T600-840h160q33 0 56.5 23.5T840-760v160q0 33-23.5 56.5T760-520zm0 400q-33 0-56.5-23.5T520-200v-160q0-33 23.5-56.5T600-440h160q33 0 56.5 23.5T840-360v160q0 33-23.5 56.5T760-120z"
    })
  });
};
const GridViewFilled = /*#__PURE__*/forwardRef(Component$3N);

const Component$3M = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M1 20v-2.8q0-.85.438-1.563A2.9 2.9 0 0 1 2.6 14.55a15 15 0 0 1 3.15-1.163A13.8 13.8 0 0 1 9 13q1.65 0 3.25.387 1.6.388 3.15 1.163.724.375 1.162 1.087T17 17.2V20zm18 0v-3q0-1.1-.612-2.113-.613-1.013-1.738-1.737 1.275.15 2.4.512c1.125.362 1.45.538 2.1.888q.9.5 1.375 1.112Q23 16.276 23 17v3zM9 12q-1.65 0-2.825-1.175T5 8c0-1.65.392-2.042 1.175-2.825Q7.35 4 9 4c1.65 0 2.042.392 2.825 1.175Q13 6.35 13 8c0 1.65-.392 2.042-1.175 2.825Q10.65 12 9 12m10-4q0 1.65-1.175 2.825T15 12q-.275 0-.7-.062a6 6 0 0 1-.7-.138 6 6 0 0 0 1.037-1.775Q15 9.05 15 8c0-1.05-.121-1.375-.363-2.025A6 6 0 0 0 13.6 4.2q.35-.125.7-.163Q14.65 4 15 4q1.65 0 2.825 1.175T19 8M3 18h12v-.8a.94.94 0 0 0-.137-.5 1 1 0 0 0-.363-.35 13 13 0 0 0-2.725-1.013 11.6 11.6 0 0 0-5.55 0A13 13 0 0 0 3.5 16.35a.97.97 0 0 0-.5.85zm6-8q.825 0 1.413-.588Q11 8.825 11 8q0-.824-.587-1.412A1.93 1.93 0 0 0 9 6q-.825 0-1.412.588A1.92 1.92 0 0 0 7 8q0 .825.588 1.412Q8.175 10 9 10"
    })
  });
};
const Group = /*#__PURE__*/forwardRef(Component$3M);

const Component$3L = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M1 20v-2.8q0-.85.438-1.563A2.9 2.9 0 0 1 2.6 14.55a15 15 0 0 1 3.15-1.163A13.8 13.8 0 0 1 9 13q1.65 0 3.25.387 1.6.388 3.15 1.163.724.375 1.162 1.087T17 17.2V20zm18 0v-3q0-1.1-.612-2.113-.613-1.013-1.738-1.737 1.275.15 2.4.512c1.125.362 1.45.538 2.1.888q.9.5 1.375 1.112Q23 16.276 23 17v3zM9 12q-1.65 0-2.825-1.175T5 8c0-1.65.392-2.042 1.175-2.825Q7.35 4 9 4c1.65 0 2.042.392 2.825 1.175Q13 6.35 13 8c0 1.65-.392 2.042-1.175 2.825Q10.65 12 9 12m10-4q0 1.65-1.175 2.825T15 12q-.275 0-.7-.062a6 6 0 0 1-.7-.138 6 6 0 0 0 1.037-1.775Q15 9.05 15 8c0-1.05-.121-1.375-.363-2.025A6 6 0 0 0 13.6 4.2q.35-.125.7-.163Q14.65 4 15 4q1.65 0 2.825 1.175T19 8"
    })
  });
};
const GroupFilled = /*#__PURE__*/forwardRef(Component$3L);

const Component$3K = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M280-120h-80q-33 0-56.5-23.5T120-200v-280q0-75 28.5-140.5t77-114 114-77T480-840t140.5 28.5 114 77 77 114T840-480v280q0 33-23.5 56.5T760-120h-80q-33 0-56.5-23.5T600-200v-160q0-33 23.5-56.5T680-440h80v-40q0-117-81.5-198.5T480-760t-198.5 81.5T200-480v40h80q33 0 56.5 23.5T360-360v160q0 33-23.5 56.5T280-120m0-240h-80v160h80zm400 0v160h80v-160zm-400 0h-80zm400 0h80z"
    })
  });
};
const Headphones = /*#__PURE__*/forwardRef(Component$3K);

const Component$3J = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M280-120h-80q-33 0-56.5-23.5T120-200v-280q0-75 28.5-140.5t77-114 114-77T480-840t140.5 28.5 114 77 77 114T840-480v280q0 33-23.5 56.5T760-120h-80q-33 0-56.5-23.5T600-200v-160q0-33 23.5-56.5T680-440h80v-40q0-117-81.5-198.5T480-760t-198.5 81.5T200-480v40h80q33 0 56.5 23.5T360-360v160q0 33-23.5 56.5T280-120"
    })
  });
};
const HeadphonesFilled = /*#__PURE__*/forwardRef(Component$3J);

const Component$3I = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M10.5 14.5v1q0 .624.438 1.063Q11.375 17 12 17q.624 0 1.063-.438.437-.436.437-1.062v-1h1q.624 0 1.063-.438Q16 13.626 16 13q0-.624-.438-1.063A1.45 1.45 0 0 0 14.5 11.5h-1v-1q0-.624-.438-1.063A1.45 1.45 0 0 0 12 9q-.624 0-1.063.438A1.45 1.45 0 0 0 10.5 10.5v1h-1q-.624 0-1.063.438A1.45 1.45 0 0 0 8 13q0 .624.438 1.063.437.437 1.062.437zM6 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 19v-9a1.99 1.99 0 0 1 .8-1.6l6-4.5q.525-.4 1.2-.4t1.2.4l6 4.5A1.99 1.99 0 0 1 20 10v9q0 .824-.587 1.413A1.93 1.93 0 0 1 18 21zm0-2h12v-9l-6-4.5L6 10z"
    })
  });
};
const Health = /*#__PURE__*/forwardRef(Component$3I);

const Component$3H = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M10.5 14.5v1q0 .624.438 1.063Q11.375 17 12 17q.624 0 1.063-.438.437-.436.437-1.062v-1h1q.624 0 1.063-.438Q16 13.626 16 13q0-.624-.438-1.063A1.45 1.45 0 0 0 14.5 11.5h-1v-1q0-.624-.438-1.063A1.45 1.45 0 0 0 12 9q-.624 0-1.063.438A1.45 1.45 0 0 0 10.5 10.5v1h-1q-.624 0-1.063.438A1.45 1.45 0 0 0 8 13q0 .624.438 1.063.437.437 1.062.437zM6 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 19v-9a1.99 1.99 0 0 1 .8-1.6l6-4.5q.525-.4 1.2-.4t1.2.4l6 4.5A1.99 1.99 0 0 1 20 10v9q0 .824-.587 1.413A1.93 1.93 0 0 1 18 21z"
    })
  });
};
const HealthFilled = /*#__PURE__*/forwardRef(Component$3H);

const Component$3G = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M11.95 18q.525 0 .888-.363.362-.362.362-.887t-.362-.887q-.363-.363-.888-.363t-.888.363q-.362.362-.362.887t.362.887q.363.363.888.363m.15-10.3q.7 0 1.125.387.425.388.425 1.013 0 .425-.287.862-.288.438-.813.913-.75.65-1.1 1.25t-.35 1.2q0 .35.263.587.262.238.612.238t.625-.25.35-.625q.075-.425.338-.787.262-.363.862-.938.775-.725 1.088-1.325.312-.6.312-1.325 0-1.275-.962-2.088Q13.625 6 12.1 6q-1.05 0-1.862.4T8.975 7.625q-.175.325-.125.637.05.313.35.513.325.2.713.125t.637-.425q.275-.375.663-.575.387-.2.887-.2M12 22q-2.05 0-3.875-.788-1.825-.787-3.187-2.137-1.363-1.35-2.15-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.15-3.175t3.187-2.138Q9.95 2 12 2q2.1 0 3.925.787 1.825.788 3.175 2.138T21.225 8.1 22 12t-.775 3.9-2.125 3.175-3.175 2.137T12 22m0-2q3.35 0 5.675-2.337T20 12t-2.325-5.663T12 4Q8.725 4 6.362 6.337T4 12t2.362 5.663Q8.725 20 12 20"
    })
  });
};
const Help = /*#__PURE__*/forwardRef(Component$3G);

const Component$3F = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M11.95 18q.525 0 .888-.363.362-.362.362-.887t-.362-.887q-.363-.363-.888-.363t-.888.363q-.362.362-.362.887t.362.887q.363.363.888.363m.15-10.3q.7 0 1.125.387.425.388.425 1.013 0 .425-.287.862-.288.438-.813.913-.75.65-1.1 1.25t-.35 1.2q0 .35.263.587.262.238.612.238t.625-.25.35-.625q.075-.425.338-.787.262-.363.862-.938.775-.725 1.088-1.325.312-.6.312-1.325 0-1.275-.962-2.088Q13.625 6 12.1 6q-1.05 0-1.862.4T8.975 7.625q-.175.325-.125.637.05.313.35.513.325.2.713.125t.637-.425q.275-.375.663-.575.387-.2.887-.2M12 22q-2.05 0-3.875-.788-1.825-.787-3.187-2.137-1.363-1.35-2.15-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.15-3.175t3.187-2.138Q9.95 2 12 2q2.1 0 3.925.787 1.825.788 3.175 2.138T21.225 8.1 22 12t-.775 3.9-2.125 3.175-3.175 2.137T12 22"
    })
  });
};
const HelpFilled = /*#__PURE__*/forwardRef(Component$3F);

const Component$3E = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M6.75 15q.325 0 .537-.213.213-.212.213-.537V13h2v1.25q0 .325.213.537.212.213.537.213t.538-.213.212-.537v-4.5q0-.325-.212-.538Q10.575 9 10.25 9t-.537.212-.213.538v1.75h-2V9.75q0-.325-.213-.538Q7.075 9 6.75 9t-.537.212Q6 9.425 6 9.75v4.5q0 .325.213.537.212.213.537.213m8.75 1.5q.325 0 .538-.212.212-.213.212-.538V15H17q.425 0 .712-.288Q18 14.425 18 14v-4q0-.425-.288-.713Q17.425 9 17 9h-3q-.425 0-.712.287Q13 9.575 13 10v4q0 .425.288.712.287.288.712.288h.75v.75q0 .325.213.538.212.212.537.212m-1-3v-3h2v3ZM4 20q-.825 0-1.412-.587Q2 18.825 2 18V6q0-.825.588-1.412Q3.175 4 4 4h16q.825 0 1.413.588Q22 5.175 22 6v12q0 .825-.587 1.413Q20.825 20 20 20Zm0-2V6zm0 0h16V6H4z"
    })
  });
};
const HighQuality = /*#__PURE__*/forwardRef(Component$3E);

const Component$3D = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M6.75 15q.325 0 .537-.213.213-.212.213-.537V13h2v1.25q0 .325.213.537.212.213.537.213t.538-.213.212-.537v-4.5q0-.325-.212-.538Q10.575 9 10.25 9t-.537.212-.213.538v1.75h-2V9.75q0-.325-.213-.538Q7.075 9 6.75 9t-.537.212Q6 9.425 6 9.75v4.5q0 .325.213.537.212.213.537.213m8.75 1.5q.325 0 .538-.212.212-.213.212-.538V15H17q.425 0 .712-.288Q18 14.425 18 14v-4q0-.425-.288-.713Q17.425 9 17 9h-3q-.425 0-.712.287Q13 9.575 13 10v4q0 .425.288.712.287.288.712.288h.75v.75q0 .325.213.538.212.212.537.212m-1-3v-3h2v3ZM4 20q-.825 0-1.412-.587Q2 18.825 2 18V6q0-.825.588-1.412Q3.175 4 4 4h16q.825 0 1.413.588Q22 5.175 22 6v12q0 .825-.587 1.413Q20.825 20 20 20Z"
    })
  });
};
const HighQualityFilled = /*#__PURE__*/forwardRef(Component$3D);

const Component$3C = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m13 11.6 2.5 2.5q.275.275.275.7t-.275.7-.7.275-.7-.275l-2.8-2.8q-.15-.15-.225-.338-.075-.187-.075-.387V8q0-.425.288-.713Q11.575 7 12 7t.713.287Q13 7.575 13 8ZM12 21q-3.025 0-5.425-1.788-2.4-1.787-3.225-4.662-.125-.45.088-.85.212-.4.662-.5.425-.1.763.187.337.288.462.713.65 2.2 2.513 3.55T12 19q2.925 0 4.962-2.038T19 12t-2.038-4.963Q14.925 5 12 5q-1.725 0-3.225.8T6.25 8H8q.425 0 .713.287Q9 8.575 9 9t-.287.712T8 10H4q-.425 0-.712-.288Q3 9.425 3 9V5q0-.425.288-.713Q3.575 4 4 4t.713.287Q5 4.575 5 5v1.35q1.275-1.6 3.113-2.475Q9.95 3 12 3q1.875 0 3.513.712 1.637.713 2.85 1.925 1.212 1.213 1.925 2.85Q21 10.125 21 12t-.712 3.512q-.713 1.638-1.925 2.85t-2.85 1.926Q13.875 21 12 21"
    })
  });
};
const History = /*#__PURE__*/forwardRef(Component$3C);

const Component$3B = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M268-120q-29 0-51.5-19T189-187l-61-366q-3-18 8.5-32.5T167-600h626q19 0 30.5 14.5T832-553l-61 366q-5 29-27.5 48T692-120zm-52-400 51 320h426l51-320zm184 160h160q17 0 28.5-11.5T600-400t-11.5-28.5T560-440H400q-17 0-28.5 11.5T360-400t11.5 28.5T400-360M240-640q-17 0-28.5-11.5T200-680t11.5-28.5T240-720h480q17 0 28.5 11.5T760-680t-11.5 28.5T720-640zm80-120q-17 0-28.5-11.5T280-800t11.5-28.5T320-840h320q17 0 28.5 11.5T680-800t-11.5 28.5T640-760zm-53 560h426z"
    })
  });
};
const HomeStorage = /*#__PURE__*/forwardRef(Component$3B);

const Component$3A = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M268-120q-29 0-51.5-19T189-187l-61-366q-3-18 8.5-32.5T167-600h626q19 0 30.5 14.5T832-553l-61 366q-5 29-27.5 48T692-120zm132-240h160q17 0 28.5-11.5T600-400t-11.5-28.5T560-440H400q-17 0-28.5 11.5T360-400t11.5 28.5T400-360M240-640q-17 0-28.5-11.5T200-680t11.5-28.5T240-720h480q17 0 28.5 11.5T760-680t-11.5 28.5T720-640zm80-120q-17 0-28.5-11.5T280-800t11.5-28.5T320-840h320q17 0 28.5 11.5T680-800t-11.5 28.5T640-760z"
    })
  });
};
const HomeStorageFilled = /*#__PURE__*/forwardRef(Component$3A);

const Component$3z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-440q-17 0-28.5-11.5T160-480t11.5-28.5T200-520h560q17 0 28.5 11.5T800-480t-11.5 28.5T760-440z"
    })
  });
};
const HorizontalRule = /*#__PURE__*/forwardRef(Component$3z);

const Component$3y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M10.969 20.5H5.814q-.438 0-.735-.294a.98.98 0 0 1-.296-.726v-7.136H3.03a.48.48 0 0 1-.49-.331q-.129-.332.155-.56l8.61-7.673A.95.95 0 0 1 12 3.5q.413 0 .696.28l3.428 3.059V5.208q0-.435.297-.727.296-.293.734-.293h1.031q.438 0 .734.293a.98.98 0 0 1 .297.727V9.59l2.088 1.861q.284.23.155.56a.48.48 0 0 1-.49.332h-1.753v7.136q0 .434-.297.726a1 1 0 0 1-.734.294h-5.155v-6.117h-2.062zm-4.124-2.039h2.062v-5.097q0-.435.297-.727.296-.293.734-.293h4.124a1.006 1.006 0 0 1 1.031 1.02v5.097h2.062v-7.952L12 5.921 6.845 10.51v7.952Z"
    })
  });
};
const House = /*#__PURE__*/forwardRef(Component$3y);

const Component$3x = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M9.938 20.5H5.814q-.438 0-.735-.294a.98.98 0 0 1-.296-.726v-7.136H3.03a.48.48 0 0 1-.49-.331q-.129-.332.155-.56l8.61-7.673A.95.95 0 0 1 12 3.5q.413 0 .696.28l3.428 3.059V5.208q0-.435.297-.727.296-.293.734-.293h1.031q.438 0 .734.293a.98.98 0 0 1 .297.727V9.59l2.088 1.861q.284.23.155.56a.48.48 0 0 1-.49.332h-1.753v7.136q0 .434-.297.726a1 1 0 0 1-.734.294h-4.124v-5.097a1.006 1.006 0 0 0-1.031-1.02h-2.062q-.438 0-.734.293a.98.98 0 0 0-.297.727z"
    })
  });
};
const HouseFilled = /*#__PURE__*/forwardRef(Component$3x);

const Component$3w = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M11.023 19.366H5.734c-.299 0-.499-.101-.698-.305a.93.93 0 0 1-.3-.71v-7.113H3.04a.55.55 0 0 1-.499-.305c-.1-.203 0-.406.1-.508l8.382-7.62c.2-.203.399-.305.698-.305.3 0 .5.102.699.305l3.293 3.048V4.126c0-.305.1-.508.299-.712.2-.203.4-.304.698-.304h.998c.3 0 .5.101.699.304.2.204.3.407.3.712v4.369l1.995 1.829c.2.203.2.304.1.508 0 .304-.2.406-.4.406h-.399c-.898-1.016-2.095-1.829-3.492-2.032l-4.79-4.37L6.732 9.41v7.925h3.093c.3.712.699 1.423 1.198 2.032ZM21.5 20.484a.93.93 0 0 1-.3.711c-.199.203-.398.305-.698.305s-.499-.102-.698-.305l-1.996-2.032c-.4.203-.698.407-1.098.508-.399.102-.798.203-1.297.203-1.197 0-2.295-.406-3.193-1.32-.898-.915-1.297-1.931-1.297-3.252s.4-2.337 1.297-3.251c.898-.915 1.896-1.321 3.193-1.321s2.295.406 3.193 1.32c.898.915 1.297 1.931 1.297 3.252 0 .407-.1.915-.2 1.321a3.8 3.8 0 0 1-.498 1.118l1.996 2.032c.2.203.299.406.299.711m-3.492-5.182c0-.711-.2-1.32-.699-1.829s-1.098-.711-1.796-.711-1.297.203-1.796.711-.699 1.118-.699 1.83c0 .71.2 1.32.699 1.828s1.098.711 1.796.711c.699 0 1.297-.203 1.796-.711s.699-1.118.699-1.829"
    })
  });
};
const HouseSearch = /*#__PURE__*/forwardRef(Component$3w);

const Component$3v = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M11.078 19.366h-5.36c-.298 0-.497-.101-.695-.305a.93.93 0 0 1-.298-.71v-7.113H3.037a.54.54 0 0 1-.496-.305c-.1-.203 0-.406.1-.508l8.337-7.62c.199-.203.397-.305.695-.305s.496.102.695.305l3.276 3.048V4.126c0-.305.099-.508.297-.712.199-.203.397-.304.695-.304h.993c.298 0 .496.101.695.304a.93.93 0 0 1 .297.712v4.369l1.986 1.829c.198.203.198.304.099.508-.1.203-.199.304-.496.304h-.397c-1.092-1.32-2.68-2.133-4.566-2.133-3.276 0-5.956 2.743-5.956 6.096q.297 2.591 1.787 4.267M21.5 20.484c0 .305-.1.508-.298.711s-.397.305-.695.305-.496-.102-.694-.305l-1.986-2.032c-.397.203-.695.407-1.092.508s-.794.203-1.29.203c-1.191 0-2.283-.406-3.176-1.32-.894-.915-1.29-1.931-1.29-3.252s.396-2.337 1.29-3.251c.893-.915 1.886-1.321 3.176-1.321s2.283.406 3.176 1.32c.894.915 1.29 1.931 1.29 3.252 0 .407-.098.915-.198 1.321a3.8 3.8 0 0 1-.496 1.118l1.985 2.032a.93.93 0 0 1 .298.711m-3.474-5.182c0-.711-.199-1.32-.695-1.829s-1.092-.711-1.787-.711-1.29.203-1.786.711c-.497.508-.695 1.118-.695 1.83 0 .71.198 1.32.695 1.828s1.092.711 1.786.711c.695 0 1.29-.203 1.787-.711s.695-1.118.695-1.829"
    })
  });
};
const HouseSearchFilled = /*#__PURE__*/forwardRef(Component$3v);

const Component$3u = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M40-390v-180q0-13 8.5-21.5T70-600t21.5 8.5T100-570v50h80v-50q0-13 8.5-21.5T210-600t21.5 8.5T240-570v180q0 13-8.5 21.5T210-360t-21.5-8.5T180-390v-70h-80v70q0 13-8.5 21.5T70-360t-21.5-8.5T40-390m300 0v-150h-30q-13 0-21.5-8.5T280-570t8.5-21.5T310-600h120q13 0 21.5 8.5T460-570t-8.5 21.5T430-540h-30v150q0 13-8.5 21.5T370-360t-21.5-8.5T340-390m220 0v-150h-30q-13 0-21.5-8.5T500-570t8.5-21.5T530-600h120q13 0 21.5 8.5T680-570t-8.5 21.5T650-540h-30v150q0 13-8.5 21.5T590-360t-21.5-8.5T560-390m160 0v-180q0-13 8.5-21.5T750-600h110q24 0 42 18t18 42v40q0 24-18 42t-42 18h-80v50q0 13-8.5 21.5T750-360t-21.5-8.5T720-390m60-110h80v-40h-80z"
    })
  });
};
const Http = /*#__PURE__*/forwardRef(Component$3u);

const Component$3t = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm0-80h560v-560H200zm0 0v-560zm80-80h400q12 0 18-11t-2-21L586-459q-6-8-16-8t-16 8L450-320l-74-99q-6-8-16-8t-16 8l-80 107q-8 10-2 21t18 11"
    })
  });
};
const Image = /*#__PURE__*/forwardRef(Component$3t);

const Component$3s = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm80-160h400q12 0 18-11t-2-21L586-459q-6-8-16-8t-16 8L450-320l-74-99q-6-8-16-8t-16 8l-80 107q-8 10-2 21t18 11"
    })
  });
};
const ImageFilled = /*#__PURE__*/forwardRef(Component$3s);

const Component$3r = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 22q-1.25 0-2.125-.875T2 19V5q0-1.25.875-2.125T5 2h14q1.25 0 2.125.875T22 5v14q0 1.25-.875 2.125T19 22Zm0-2h14q.425 0 .712-.288Q20 19.425 20 19V5q0-.425-.288-.713Q19.425 4 19 4H5q-.425 0-.713.287Q4 4.575 4 5v14q0 .425.287.712Q4.575 20 5 20m1-2 4-4 1.8 1.775L14 13l4 5Zm2-8q-.825 0-1.412-.588Q6 8.825 6 8t.588-1.412Q7.175 6 8 6t1.413.588Q10 7.175 10 8t-.587 1.412T8 10"
    })
  });
};
const Imagesmode = /*#__PURE__*/forwardRef(Component$3r);

const Component$3q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm80-160h400q12 0 18-11t-2-21L586-459q-6-8-16-8t-16 8L450-320l-74-99q-6-8-16-8t-16 8l-80 107q-8 10-2 21t18 11m60-280q25 0 42.5-17.5T400-620t-17.5-42.5T340-680t-42.5 17.5T280-620t17.5 42.5T340-560"
    })
  });
};
const ImagesmodeFilled = /*#__PURE__*/forwardRef(Component$3q);

const Component$3p = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M15.337 15.693a3.64 3.64 0 0 0 1.44-1.334c.345-.564.524-1.21.517-1.866 0-4.6-7.312-4.6-7.312-6.795 0-.9.824-1.4 2.369-1.4a10.5 10.5 0 0 1 3.913.8s.38.12.665.026c.254-.084.35-.278.426-.352.093-.207.145-.351.145-.526 0-.705-1.03-1.243-1.03-1.243a8.5 8.5 0 0 0-4.222-1c-3.295 0-5.15 1.3-5.15 3.7.009.55.165 1.09.454 1.563.289.474.7.866 1.195 1.137-.61.303-1.123.76-1.485 1.323a3.6 3.6 0 0 0-.575 1.877c0 4.6 7.312 4.6 7.312 6.795 0 .9-.824 1.4-2.369 1.4a10.5 10.5 0 0 1-3.913-.8s-.277-.12-.652.032c-.374.153-.423.288-.525.564-.085.228-.03.551.133.833.145.25.838.67.838.67a9.35 9.35 0 0 0 4.325.9c3.295 0 5.15-1.3 5.15-3.7a2.8 2.8 0 0 0-.44-1.532 2.94 2.94 0 0 0-1.209-1.072m-2.162-1.3c-2.06-1-3.708-1.8-3.708-3.1.012-.384.147-.755.387-1.06s.574-.53.952-.64c2.06 1 3.708 1.8 3.708 3.1a1.68 1.68 0 0 1-.362 1.078c-.244.31-.588.528-.977.622"
    })
  });
};
const Imprint = /*#__PURE__*/forwardRef(Component$3p);

const Component$3o = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 17q.425 0 .713-.288Q13 16.425 13 16v-4.025q0-.425-.287-.7Q12.425 11 12 11t-.712.287T11 12v4.025q0 .425.288.7.287.275.712.275m0-8q.425 0 .713-.288Q13 8.425 13 8t-.287-.713Q12.425 7 12 7t-.712.287Q11 7.575 11 8t.288.712Q11.575 9 12 9m0 13q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22m0-2q3.325 0 5.663-2.337T20 12t-2.337-5.663Q15.325 4 12 4T6.338 6.337Q4 8.675 4 12t2.338 5.663Q8.675 20 12 20"
    })
  });
};
const Info = /*#__PURE__*/forwardRef(Component$3o);

const Component$3n = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 17q.425 0 .713-.288Q13 16.425 13 16v-4.025q0-.425-.287-.7Q12.425 11 12 11t-.712.287T11 12v4.025q0 .425.288.7.287.275.712.275m0-8q.425 0 .713-.288Q13 8.425 13 8t-.287-.713Q12.425 7 12 7t-.712.287Q11 7.575 11 8t.288.712Q11.575 9 12 9m0 13q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22"
    })
  });
};
const InfoFilled = /*#__PURE__*/forwardRef(Component$3n);

const Component$3m = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m620-275 198-198q11-11 28-11t28 11 11 28-11 28L648-191q-12 12-28 12t-28-12L478-305q-11-11-11-28t11-28 28-11 28 11zM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h167q11-35 43-57.5t70-22.5q40 0 71.5 22.5T594-840h166q33 0 56.5 23.5T840-760v160q0 17-11.5 28.5T800-560t-28.5-11.5T760-600v-160h-80v80q0 17-11.5 28.5T640-640H320q-17 0-28.5-11.5T280-680v-80h-80v560h200q17 0 28.5 11.5T440-160t-11.5 28.5T400-120zm280-640q17 0 28.5-11.5T520-800t-11.5-28.5T480-840t-28.5 11.5T440-800t11.5 28.5T480-760"
    })
  });
};
const Inventory = /*#__PURE__*/forwardRef(Component$3m);

const Component$3l = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12a9.7 9.7 0 0 1 .788-3.9 10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.138A9.7 9.7 0 0 1 12 2a9.7 9.7 0 0 1 3.9.787 10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.325 0 5.663-2.337T20 12c0-3.325-.779-4.104-2.337-5.663Q15.325 4 12 4c-3.325 0-4.104.779-5.662 2.337Q4 8.675 4 12c0 3.325.78 4.104 2.338 5.663Q8.675 20 12 20"
    }), /*#__PURE__*/jsx("path", {
      d: "M15.553 9.861 9.88 15.536q-.3.3-.708.3-.405 0-.707-.3a1 1 0 0 1-.31-.7.93.93 0 0 1 .293-.697l5.674-5.675q.3-.3.707-.3t.708.3.309.698a.93.93 0 0 1-.292.699Z"
    })]
  });
};
const Irrelevant = /*#__PURE__*/forwardRef(Component$3l);

const Component$3k = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M8.1 21.212A9.7 9.7 0 0 0 12 22a9.7 9.7 0 0 0 3.9-.788 10.1 10.1 0 0 0 3.175-2.137q1.35-1.35 2.137-3.175A9.7 9.7 0 0 0 22 12a9.7 9.7 0 0 0-.788-3.9 10.1 10.1 0 0 0-2.137-3.175q-1.35-1.35-3.175-2.138A9.7 9.7 0 0 0 12 2a9.7 9.7 0 0 0-3.9.787 10.1 10.1 0 0 0-3.175 2.138Q3.575 6.275 2.788 8.1A9.7 9.7 0 0 0 2 12a9.7 9.7 0 0 0 .788 3.9 10.1 10.1 0 0 0 2.137 3.175q1.35 1.35 3.175 2.137m2.021-5.434 5.675-5.674q.3-.3.291-.699a1 1 0 0 0-.309-.698q-.3-.3-.708-.3-.405 0-.706.3l-5.675 5.675a.93.93 0 0 0-.292.698q.01.398.31.698t.707.3.707-.3",
      clipRule: "evenodd"
    })
  });
};
const IrrelevantFilled = /*#__PURE__*/forwardRef(Component$3k);

const Component$3j = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M280-400q-33 0-56.5-23.5T200-480t23.5-56.5T280-560t56.5 23.5T360-480t-23.5 56.5T280-400m0 160q-100 0-170-70T40-480t70-170 170-70q67 0 121.5 33t86.5 87h335q8 0 15.5 3t13.5 9l80 80q6 6 8.5 13t2.5 15-2.5 15-8.5 13L805-325q-5 5-12 8t-14 4-14-1-13-7l-52-39-57 43q-5 4-11 6t-12 2-12.5-2-11.5-6l-61-43h-47q-32 54-86.5 87T280-240m0-80q56 0 98.5-34t56.5-86h125l58 41v.5-.5l82-61 71 55 75-75h-.5.5l-40-40v-.5.5H435q-14-52-56.5-86T280-640q-66 0-113 47t-47 113 47 113 113 47"
    })
  });
};
const Key = /*#__PURE__*/forwardRef(Component$3j);

const Component$3i = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M280-360q-50 0-85-35t-35-85 35-85 85-35 85 35 35 85-35 85-85 35m0 120q77 0 139-44t87-116h14l52 52q6 6 13 8.5t15 2.5 15-2.5 13-8.5l52-52 70 55q6 5 13.5 7.5T779-336t14.5-4.5T805-350l90-103q5-6 7.5-13t2.5-15-3-14.5-8-11.5l-41-41q-6-6-13.5-9t-15.5-3H506q-24-68-84.5-114T280-720q-100 0-170 70T40-480t70 170 170 70"
    })
  });
};
const KeyFilled = /*#__PURE__*/forwardRef(Component$3i);

const Component$3h = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-400q-50 0-85-35t-35-85v-240q0-50 35-85t85-35 85 35 35 85v240q0 50-35 85t-85 35m0 280q-17 0-28.5-11.5T440-160v-83q-93-13-158-78t-79-156q-3-17 9-30t32-13q14 0 25 10.5t14 25.5q13 70 68 117t129 47 129-47 68-117q3-15 14.5-25.5T717-520q19 0 31 13t9 30q-14 91-79 156t-158 78v83q0 17-11.5 28.5T480-120m0-360q17 0 28.5-11.5T520-520v-240q0-17-11.5-28.5T480-800t-28.5 11.5T440-760v240q0 17 11.5 28.5T480-480"
    })
  });
};
const KeyboardVoice = /*#__PURE__*/forwardRef(Component$3h);

const Component$3g = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-400q-50 0-85-35t-35-85v-240q0-50 35-85t85-35 85 35 35 85v240q0 50-35 85t-85 35m0 280q-17 0-28.5-11.5T440-160v-84q-93-12-158-77t-79-156q-3-17 9-30t32-13q14 0 25 10.5t14 25.5q13 70 68 117t129 47 129-47 68-117q3-15 14.5-25.5T717-520q19 0 31 13t9 30q-14 91-79 156t-158 77v84q0 17-11.5 28.5T480-120"
    })
  });
};
const KeyboardVoiceFilled = /*#__PURE__*/forwardRef(Component$3g);

const Component$3f = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M660-368v-224q0-14-12-19t-22 5l-98 98q-12 12-12 28t12 28l98 98q10 10 22 5t12-19M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm200-80h360v-560H400z"
    })
  });
};
const LeftPanelCloseFilled = /*#__PURE__*/forwardRef(Component$3f);

const Component$3e = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M500-592v224q0 14 12 19t22-5l98-98q12-12 12-28t-12-28l-98-98q-10-10-22-5t-12 19M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm200-80h360v-560H400z"
    })
  });
};
const LeftPanelOpenFilled = /*#__PURE__*/forwardRef(Component$3e);

const Component$3d = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M9.025 14h5.95q.925-.675 1.475-1.713Q17 11.25 17 10q0-2.075-1.462-3.537Q14.075 5 12 5T8.463 6.463Q7 7.925 7 10q0 1.25.55 2.287Q8.1 13.325 9.025 14m.55-1.5q-.5-.5-.787-1.137Q8.5 10.725 8.5 10q0-1.45 1.025-2.475T12 6.5t2.475 1.025T15.5 10q0 .725-.287 1.363-.288.637-.788 1.137Zm.175 4h4.5q.325 0 .538-.212.212-.213.212-.538t-.212-.538Q14.575 15 14.25 15h-4.5q-.325 0-.537.212Q9 15.425 9 15.75t.213.538.537.212M12 19q.625 0 1.062-.438.438-.437.438-1.062h-3q0 .625.438 1.062Q11.375 19 12 19m0 3q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
    })
  });
};
const LightbulbCircle = /*#__PURE__*/forwardRef(Component$3d);

const Component$3c = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M9.025 14h5.95q.925-.675 1.475-1.713Q17 11.25 17 10q0-2.075-1.462-3.537Q14.075 5 12 5T8.463 6.463Q7 7.925 7 10q0 1.25.55 2.287Q8.1 13.325 9.025 14m.55-1.5q-.5-.5-.787-1.137Q8.5 10.725 8.5 10q0-1.45 1.025-2.475T12 6.5t2.475 1.025T15.5 10q0 .725-.287 1.363-.288.637-.788 1.137Zm.175 4h4.5q.325 0 .538-.212.212-.213.212-.538t-.212-.538Q14.575 15 14.25 15h-4.5q-.325 0-.537.212Q9 15.425 9 15.75t.213.538.537.212M12 19q.625 0 1.062-.438.438-.437.438-1.062h-3q0 .625.438 1.062Q11.375 19 12 19m0 3q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22"
    })
  });
};
const LightbulbCircleFilled = /*#__PURE__*/forwardRef(Component$3c);

const Component$3b = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M280-280q-83 0-141.5-58.5T80-480t58.5-141.5T280-680h120q17 0 28.5 11.5T440-640t-11.5 28.5T400-600H280q-50 0-85 35t-35 85 35 85 85 35h120q17 0 28.5 11.5T440-320t-11.5 28.5T400-280zm80-160q-17 0-28.5-11.5T320-480t11.5-28.5T360-520h240q17 0 28.5 11.5T640-480t-11.5 28.5T600-440zm200 160q-17 0-28.5-11.5T520-320t11.5-28.5T560-360h120q50 0 85-35t35-85-35-85-85-35H560q-17 0-28.5-11.5T520-640t11.5-28.5T560-680h120q83 0 141.5 58.5T880-480t-58.5 141.5T680-280z"
    })
  });
};
const Link = /*#__PURE__*/forwardRef(Component$3b);

const Component$3a = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M11.95 16.8q.525 0 .888-.362.362-.363.362-.888t-.362-.888-.888-.362-.888.362q-.362.363-.362.888t.362.888q.363.362.888.362m1-4.7q.075-.4.263-.7.187-.3.737-.85.925-.925 1.25-1.5t.325-1.3q0-1.275-.937-2.113-.938-.837-2.363-.837-1.075 0-1.913.437-.837.438-1.287 1.163-.225.35-.125.737.1.388.45.538t.688.013q.337-.138.537-.463.25-.35.675-.537t.875-.188q.7 0 1.125.375t.425.95q0 .475-.287.95-.288.475-.888 1-.65.575-1 1.175t-.35 1.125q0 .35.263.6.262.25.637.25.35 0 .587-.237.238-.238.313-.588M11.3 22.3 9 20H5q-.825 0-1.413-.587Q3 18.825 3 18V4q0-.825.587-1.413Q4.175 2 5 2h14q.825 0 1.413.587Q21 3.175 21 4v14q0 .825-.587 1.413Q19.825 20 19 20h-4l-2.3 2.3q-.275.275-.7.275t-.7-.275M5 18h4.8l2.2 2.2 2.2-2.2H19V4H5zM5 4v14z"
    })
  });
};
const LiveHelp = /*#__PURE__*/forwardRef(Component$3a);

const Component$39 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M11.3 22.3 9 20H5q-.825 0-1.413-.587Q3 18.825 3 18V4q0-.825.587-1.413Q4.175 2 5 2h14q.825 0 1.413.587Q21 3.175 21 4v14q0 .825-.587 1.413Q19.825 20 19 20h-4l-2.3 2.3q-.275.275-.7.275t-.7-.275m.65-5.5q.525 0 .888-.362.362-.363.362-.888t-.362-.888-.888-.362-.888.362q-.362.363-.362.888t.362.888q.363.362.888.362m1-4.7q.075-.4.263-.7.187-.3.737-.85.925-.925 1.25-1.5t.325-1.3q0-1.275-.937-2.113-.938-.837-2.363-.837-1.075 0-1.913.437-.837.438-1.287 1.163-.225.35-.125.737.1.388.45.538t.688.013q.337-.138.537-.463.25-.35.675-.537t.875-.188q.7 0 1.125.375t.425.95q0 .475-.287.95-.288.475-.888 1-.65.575-1 1.175t-.35 1.125q0 .35.263.6.262.25.637.25.35 0 .587-.237.238-.238.313-.588"
    })
  });
};
const LiveHelpFilled = /*#__PURE__*/forwardRef(Component$39);

const Component$38 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M120-80q-17 0-28.5-11.5T80-120v-320q0-17 11.5-28.5T120-480h120v-160q0-100 70-170t170-70h160q100 0 170 70t70 170v520q0 17-11.5 28.5T840-80t-28.5-11.5T800-120v-80H640v80q0 17-11.5 28.5T600-80zm520-200h160v-360q0-66-47-113t-113-47H480q-66 0-113 47t-47 113v160h280q17 0 28.5 11.5T640-440zM440-560q-17 0-28.5-11.5T400-600t11.5-28.5T440-640h240q17 0 28.5 11.5T720-600t-11.5 28.5T680-560zm-80 274 200-114H160zM160-160h400v-170l-160 91q-9 5-19 8t-21 3-21-3-19-8l-160-91zm0-240v26q0-9 0 0v53-9 170-170 9-53q0-10 0 0z"
    })
  });
};
const LocalPostOffice = /*#__PURE__*/forwardRef(Component$38);

const Component$37 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M120-80q-17 0-28.5-11.5T80-120v-320q0-17 11.5-28.5T120-480h120v-160q0-100 70-170t170-70h160q100 0 170 70t70 170v520q0 17-11.5 28.5T840-80t-28.5-11.5T800-120v-80H640v80q0 17-11.5 28.5T600-80zm520-200h160v-360q0-66-47-113t-113-47H480q-66 0-113 47t-47 113v160h280q17 0 28.5 11.5T640-440zM440-560q-17 0-28.5-11.5T400-600t11.5-28.5T440-640h240q17 0 28.5 11.5T720-600t-11.5 28.5T680-560zm-80 332q11 0 21-3t19-8l145-82q6-4 10.5-11t4.5-16q0-16-14-26t-31 0l-155 88-155-88q-16-9-30.5 0T160-348q0 9 4.5 16t10.5 11l145 82q9 5 19 8t21 3"
    })
  });
};
const LocalPostOfficeFilled = /*#__PURE__*/forwardRef(Component$37);

const Component$36 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M560-560q0-33-23.5-56.5T480-640q-10 0-19 2t-17 7l107 107q5-8 7-17t2-19m168 213-58-58q25-42 37.5-78.5T720-552q0-109-69.5-178.5T480-800q-44 0-82.5 13.5T328-747l-57-57q43-37 97-56.5T480-880q127 0 223.5 89T800-552q0 48-18 98.5T728-347m-157 71L244-603q-2 12-3 25t-1 26q0 71 59 162.5T480-186q26-23 48.5-45.5T571-276m-91 169q-14 0-28-5t-25-15q-65-60-115-117t-83.5-110.5-51-103T160-552q0-32 5-61t14-55L55-792q-12-12-12-28.5T55-849t28.5-12 28.5 12l736 736q12 12 11.5 28T847-57t-28.5 12T790-57L627-220q-17 18-38 39t-56 54q-11 10-25 15t-28 5m19-469"
    })
  });
};
const LocationOff = /*#__PURE__*/forwardRef(Component$36);

const Component$35 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-107q-14 0-28-5t-25-15q-65-60-115-117t-83.5-110.5-51-103T160-552q0-32 5-61t14-55L55-792q-12-12-12-28.5T55-849t28.5-12 28.5 12l736 736q12 12 12 28.5T848-56t-28.5 12T791-56L627-220q-25 26-50 51.5T533-127q-11 10-25 15t-28 5m248-240L551-524q5-8 7-17t2-19q0-33-23.5-56.5T480-640q-10 0-19 2t-17 7L271-804q43-37 97-56.5T480-880q127 0 223.5 89T800-552q0 48-18 98.5T728-347"
    })
  });
};
const LocationOffFilled = /*#__PURE__*/forwardRef(Component$35);

const Component$34 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 12q.825 0 1.413-.588Q14 10.825 14 10t-.587-1.413T12 8q-.825 0-1.412.587Q10 9.175 10 10t.588 1.412Q11.175 12 12 12m0 7.35q3.05-2.8 4.525-5.088Q18 11.975 18 10.2q0-2.725-1.738-4.463T12 4Q9.475 4 7.737 5.737T6 10.2q0 1.775 1.475 4.062T12 19.35m0 2.275q-.2 0-.4-.075t-.35-.2Q7.6 18.125 5.8 15.363T4 10.2q0-3.75 2.413-5.975T12 2t5.587 2.225T20 10.2q0 2.4-1.8 5.163-1.8 2.762-5.45 5.987-.15.125-.35.2t-.4.075M12 10.2"
    })
  });
};
const LocationOn = /*#__PURE__*/forwardRef(Component$34);

const Component$33 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 12q.825 0 1.413-.588Q14 10.825 14 10t-.587-1.413T12 8q-.825 0-1.412.587Q10 9.175 10 10t.588 1.412Q11.175 12 12 12m0 9.625q-.2 0-.4-.075t-.35-.2Q7.6 18.125 5.8 15.363T4 10.2q0-3.75 2.413-5.975T12 2t5.587 2.225T20 10.2q0 2.4-1.8 5.163-1.8 2.762-5.45 5.987-.15.125-.35.2t-.4.075"
    })
  });
};
const LocationOnFilled = /*#__PURE__*/forwardRef(Component$33);

const Component$32 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M6 22q-.825 0-1.412-.587Q4 20.825 4 20V10q0-.825.588-1.413Q5.175 8 6 8h1V6q0-2.075 1.463-3.538Q9.925 1 12 1t3.538 1.462Q17 3.925 17 6v2h1q.825 0 1.413.587Q20 9.175 20 10v10q0 .825-.587 1.413Q18.825 22 18 22Zm0-2h12V10H6zm6-3q.825 0 1.413-.587Q14 15.825 14 15t-.587-1.413T12 13q-.825 0-1.412.587Q10 14.175 10 15t.588 1.413Q11.175 17 12 17M9 8h6V6q0-1.25-.875-2.125T12 3t-2.125.875T9 6ZM6 20V10z"
    })
  });
};
const Lock = /*#__PURE__*/forwardRef(Component$32);

const Component$31 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M6 22q-.825 0-1.412-.587Q4 20.825 4 20V10q0-.825.588-1.413Q5.175 8 6 8h1V6q0-2.075 1.463-3.538Q9.925 1 12 1t3.538 1.462Q17 3.925 17 6v2h1q.825 0 1.413.587Q20 9.175 20 10v10q0 .825-.587 1.413Q18.825 22 18 22Zm6-5q.825 0 1.413-.587Q14 15.825 14 15t-.587-1.413T12 13q-.825 0-1.412.587Q10 14.175 10 15t.588 1.413Q11.175 17 12 17M9 8h6V6q0-1.25-.875-2.125T12 3t-2.125.875T9 6Z"
    })
  });
};
const LockFilled = /*#__PURE__*/forwardRef(Component$31);

const Component$30 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h360v-80q0-50-35-85t-85-35q-42 0-73.5 25.5T364-751q-4 14-16.5 22.5T320-720q-17 0-28.5-11t-8.5-26q14-69 69-116t128-47q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80zm0-80h480v-400H240zm240-120q33 0 56.5-23.5T560-360t-23.5-56.5T480-440t-56.5 23.5T400-360t23.5 56.5T480-280M240-160v-400z"
    })
  });
};
const LockOpen = /*#__PURE__*/forwardRef(Component$30);

const Component$2$ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h360v-80q0-50-35-85t-85-35q-42 0-73.5 25.5T364-751q-4 14-16.5 22.5T320-720q-17 0-28.5-11t-8.5-26q11-68 66.5-115.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80zm240-200q33 0 56.5-23.5T560-360t-23.5-56.5T480-440t-56.5 23.5T400-360t23.5 56.5T480-280"
    })
  });
};
const LockOpenFilled = /*#__PURE__*/forwardRef(Component$2$);

const Component$2_ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h240q17 0 28.5 11.5T480-800t-11.5 28.5T440-760H200v560h240q17 0 28.5 11.5T480-160t-11.5 28.5T440-120zm487-320H400q-17 0-28.5-11.5T360-480t11.5-28.5T400-520h287l-75-75q-11-11-11-27t11-28 28-12.5 29 11.5l143 143q12 12 12 28t-12 28L669-309q-12 12-28.5 11.5T612-310q-11-12-10.5-28.5T613-366z"
    })
  });
};
const Logout = /*#__PURE__*/forwardRef(Component$2_);

const Component$2Z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M600-680q-17 0-28.5-11.5T560-720t11.5-28.5T600-760h240q17 0 28.5 11.5T880-720t-11.5 28.5T840-680zm0 220q-17 0-28.5-11.5T560-500t11.5-28.5T600-540h240q17 0 28.5 11.5T880-500t-11.5 28.5T840-460zm0 220q-17 0-28.5-11.5T560-280t11.5-28.5T600-320h240q17 0 28.5 11.5T880-280t-11.5 28.5T840-240zm-296 80q-11-11-11-28t11-28l24-24q-105-6-176.5-81T80-500q0-109 75.5-184.5T340-760h100q17 0 28.5 11.5T480-720t-11.5 28.5T440-680H340q-75 0-127.5 52T160-501q0 71 47.5 122T326-322l-23-23q-11-11-11-27t12-28q11-11 28-11t28 11l92 92q6 6 8.5 13t2.5 15-2.5 15-8.5 13l-93 93q-11 11-27 11t-28-12"
    })
  });
};
const LowPriority = /*#__PURE__*/forwardRef(Component$2Z);

const Component$2Y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M4 20q-.825 0-1.412-.587Q2 18.825 2 18V6q0-.825.588-1.412Q3.175 4 4 4h16q.825 0 1.413.588Q22 5.175 22 6v12q0 .825-.587 1.413Q20.825 20 20 20ZM20 8l-7.475 4.675q-.125.075-.263.112-.137.038-.262.038t-.262-.038-.263-.112L4 8v10h16Zm-8 3 8-5H4ZM4 8v.25-1.475.025V6v.8-.013V8.25zv10Z"
    })
  });
};
const Mail = /*#__PURE__*/forwardRef(Component$2Y);

const Component$2X = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M4 20q-.825 0-1.412-.587Q2 18.825 2 18V6q0-.825.588-1.412Q3.175 4 4 4h16q.825 0 1.413.588Q22 5.175 22 6v12q0 .825-.587 1.413Q20.825 20 20 20Zm8-7.175q.125 0 .262-.038.138-.037.263-.112L19.6 8.25q.2-.125.3-.312.1-.188.1-.413 0-.5-.425-.75T18.7 6.8L12 11 5.3 6.8q-.45-.275-.875-.013Q4 7.05 4 7.525q0 .25.1.437.1.188.3.288l7.075 4.425q.125.075.263.112.137.038.262.038"
    })
  });
};
const MailFilled = /*#__PURE__*/forwardRef(Component$2X);

const Component$2W = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M400-480q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113-47 113-113 47M80-240v-32q0-33 17-62t47-44q51-26 115-44t141-18h14q6 0 12 2-8 18-13.5 37.5T404-360h-4q-71 0-127.5 18T180-306q-9 5-14.5 14t-5.5 20v32h252q6 21 16 41.5t22 38.5H160q-33 0-56.5-23.5T80-240m554 88-6-28q-12-5-22.5-10.5T584-204l-29 9q-13 4-25.5-1T510-212l-8-14q-7-12-5-26t13-23l22-19q-2-14-2-26t2-26l-22-19q-11-9-13-22.5t5-25.5l9-15q7-11 19-16t25-1l29 9q11-8 21.5-13.5T628-460l6-29q3-14 13.5-22.5T672-520h16q14 0 24.5 9t13.5 23l6 28q12 5 22.5 11t21.5 15l27-9q14-5 27 0t20 17l8 14q7 12 5 26t-13 23l-22 19q2 12 2 25t-2 25l22 19q11 9 13 22.5t-5 25.5l-9 15q-7 11-19 16t-25 1l-29-9q-11 8-21.5 13.5T732-180l-6 29q-3 14-13.5 22.5T688-120h-16q-14 0-24.5-9T634-152m46-88q33 0 56.5-23.5T760-320t-23.5-56.5T680-400t-56.5 23.5T600-320t23.5 56.5T680-240M400-560q33 0 56.5-23.5T480-640t-23.5-56.5T400-720t-56.5 23.5T320-640t23.5 56.5T400-560m12 320"
    })
  });
};
const ManageAccounts = /*#__PURE__*/forwardRef(Component$2W);

const Component$2V = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M5 22q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 20V4q0-.824.587-1.413A1.93 1.93 0 0 1 5 2h7.175a1.98 1.98 0 0 1 1.4.575l4.85 4.85a1.98 1.98 0 0 1 .575 1.4V10a.97.97 0 0 1-.288.713A.97.97 0 0 1 18 11a.97.97 0 0 1-.712-.287A.97.97 0 0 1 17 10V9h-4a.97.97 0 0 1-.713-.287A.97.97 0 0 1 12 8V4H5v16h4a.97.97 0 0 1 .713.288Q10 20.575 10 21c0 .425-.096.52-.287.712A.97.97 0 0 1 9 22z"
    }), /*#__PURE__*/jsx("path", {
      d: "M16 19.429q.312 0 .578-.161a1.3 1.3 0 0 0 .453-.482l1.469-2.5v4.285q0 .607.36 1.018.359.411.89.411c.531 0 .651-.137.89-.41q.36-.411.36-1.019V13.18a1.23 1.23 0 0 0-.297-.84.94.94 0 0 0-.734-.339h-.907a.9.9 0 0 0-.484.143 1.2 1.2 0 0 0-.39.393L16 16.286l-2.125-3.643a1.26 1.26 0 0 0-.438-.464 1.1 1.1 0 0 0-.593-.179h-.594q-.531 0-.89.41-.36.411-.36 1.019v7.142q0 .607.36 1.018.359.411.89.411c.531 0 .651-.137.89-.41q.36-.411.36-1.019v-4.285l1.469 2.5q.188.321.453.482.266.16.578.16Z"
    })]
  });
};
const ManualOffer = /*#__PURE__*/forwardRef(Component$2V);

const Component$2U = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M14.35 20.775 9 18.9l-4.65 1.8q-.5.2-.925-.113Q3 20.275 3 19.75v-14q0-.325.188-.575.187-.25.512-.375l4.65-1.575q.325-.1.65-.113t.65.113L15 5.1l4.65-1.8q.5-.2.925.112.425.313.425.838v14q0 .325-.188.575-.187.25-.512.375l-4.65 1.575q-.325.1-.65.112-.325.013-.65-.112M14 18.55V6.85l-4-1.4v11.7Zm2 0 3-1V5.7l-3 1.15ZM5 18.3l3-1.15V5.45l-3 1ZM16 6.85v11.7Zm-8-1.4v11.7Z"
    })
  });
};
const Map = /*#__PURE__*/forwardRef(Component$2U);

const Component$2T = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M14.35 20.775 9 18.9l-4.65 1.8q-.5.2-.925-.113Q3 20.275 3 19.75v-14q0-.325.188-.575.187-.25.512-.375l4.65-1.575q.325-.1.65-.113t.65.113L15 5.1l4.65-1.8q.5-.2.925.112.425.313.425.838v14q0 .325-.188.575-.187.25-.512.375l-4.65 1.575q-.325.1-.65.112-.325.013-.65-.112M14 18.55V6.85l-4-1.4v11.7Z"
    })
  });
};
const MapFilled = /*#__PURE__*/forwardRef(Component$2T);

const Component$2S = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M20.097 2.283a.9.9 0 0 1 .322.348q.115.219.115.502v9.51a5.7 5.7 0 0 0-2.059-1.701v-6.29l-3.089 1.184v4.568a5.6 5.6 0 0 0-2.06.638V5.836L9.209 4.394v12.047l1.201.42c.138.939.505 1.8 1.044 2.53l-3.275-1.148-4.788 1.854a.94.94 0 0 1-.502.064 1.2 1.2 0 0 1-.45-.167.9.9 0 0 1-.322-.348A1.06 1.06 0 0 1 2 19.144V4.703a.96.96 0 0 1 .193-.592q.193-.258.528-.386l4.788-1.622q.154-.051.322-.077a2.3 2.3 0 0 1 1.016.077l5.51 1.93 4.787-1.853a.94.94 0 0 1 .502-.064q.244.038.45.167ZM4.059 17.625l3.09-1.184V4.394l-3.09 1.03zm15.382.531 2.302 2.302a.87.87 0 0 1 .253.644.87.87 0 0 1-.253.645.87.87 0 0 1-.644.253.87.87 0 0 1-.645-.253l-2.302-2.302a5.7 5.7 0 0 1-1.035.46q-.553.185-1.174.185-1.726 0-2.935-1.209-1.208-1.208-1.208-2.934t1.208-2.935 2.935-1.208q1.726 0 2.935 1.208 1.208 1.209 1.208 2.935 0 .62-.184 1.174a5.7 5.7 0 0 1-.46 1.035Zm-3.498.092q.966 0 1.634-.667.667-.668.667-1.634a2.22 2.22 0 0 0-.667-1.634 2.22 2.22 0 0 0-1.634-.668q-.967 0-1.634.668-.668.668-.668 1.634t.668 1.634 1.634.667",
      clipRule: "evenodd"
    })
  });
};
const MapSearch = /*#__PURE__*/forwardRef(Component$2S);

const Component$2R = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m160-720 320 200 320-200zm0 560q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v200q0 17-11.5 28.5T840-480t-28.5-11.5T800-520v-120L501-453q-3 2-21 6-5 0-10.5-1.5T459-453L160-640v400h220q17 0 28.5 11.5T420-200t-11.5 28.5T380-160zm478-32 198-198q11-11 28-11t28 11 11 28-11 28L666-108q-12 12-28 12t-28-12L496-222q-11-11-11-28t11-28 28-11 28 11z"
    })
  });
};
const MarkEmailRead = /*#__PURE__*/forwardRef(Component$2R);

const Component$2Q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M160-240q-17 0-28.5-11.5T120-280t11.5-28.5T160-320h640q17 0 28.5 11.5T840-280t-11.5 28.5T800-240zm0-200q-17 0-28.5-11.5T120-480t11.5-28.5T160-520h640q17 0 28.5 11.5T840-480t-11.5 28.5T800-440zm0-200q-17 0-28.5-11.5T120-680t11.5-28.5T160-720h640q17 0 28.5 11.5T840-680t-11.5 28.5T800-640z"
    })
  });
};
const Menu = /*#__PURE__*/forwardRef(Component$2Q);

const Component$2P = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m710-362-58-58q9-15 15.5-31t9.5-33q3-15 14.5-25.5T717-520q19 0 31 13t9 30q-5 32-17 60.5T710-362M592-482l-72-72v-206q0-17-11.5-28.5T480-800t-28.5 11.5T440-760v126l-80-80v-46q0-50 35-85t85-35 85 35 35 85v240q0 11-2.5 20t-5.5 18M764-84 84-764q-11-11-11-28t11-28 28-11 28 11l680 680q11 11 11 28t-11 28-28 11-28-11m-324-76v-83q-93-13-158-78t-79-156q-3-17 9-30t32-13q14 0 25 10.5t14 25.5q13 70 68 117t129 47q34 0 64.5-10.5T600-360l57 57q-29 23-63.5 39T520-243v83q0 17-11.5 28.5T480-120t-28.5-11.5T440-160"
    })
  });
};
const MicOff = /*#__PURE__*/forwardRef(Component$2P);

const Component$2O = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m710-362-58-58q9-15 15.5-31t9.5-33q3-15 14.5-25.5T717-520q19 0 31 13t9 30q-5 32-17 60.5T710-362M592-482 360-714v-46q0-50 35-85t85-35 85 35 35 85v240q0 11-2.5 20t-5.5 18M764-84 84-764q-11-11-11-28t11-28 28-11 28 11l680 680q11 11 11 28t-11 28-28 11-28-11m-324-76v-84q-93-12-158-77t-79-156q-3-17 9-30t32-13q14 0 25 10.5t14 25.5q13 70 68 117t129 47q34 0 64.5-10.5T600-360l57 57q-29 23-63.5 38.5T520-244v84q0 17-11.5 28.5T480-120t-28.5-11.5T440-160"
    })
  });
};
const MicOffFilled = /*#__PURE__*/forwardRef(Component$2O);

const Component$2N = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M3.51 19.454 2.5 6.959 6.125 2l10.578 4.205 4.797 9.151-3.657 4.308L7.565 22zm1.269-.767 3.027 1.9.217-.049-3.676-7.204zm.611-6.222 3.966 7.77 1.395-.316 1.051-10.352zm6.725 7.147 2.954-.67 1.3-6.567-3.755 2.33zm4.37-.991.628-.143 2.795-3.292-1.99-3.794zm-3.702-5.578 4.528-2.81-1.336-2.548-2.776 1.255zM3.862 7.346l.34 4.207 7.11-3.213-4.925-4.452zm8.767.398 2.034-.918L9.217 4.66z"
    })
  });
};
const Monolith = /*#__PURE__*/forwardRef(Component$2N);

const Component$2M = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M620-520q25 0 42.5-17.5T680-580t-17.5-42.5T620-640t-42.5 17.5T560-580t17.5 42.5T620-520m-280 0q25 0 42.5-17.5T400-580t-17.5-42.5T340-640t-42.5 17.5T280-580t17.5 42.5T340-520M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-260q-57 0-107 28t-80 77q-6 12 1 23.5t21 11.5h329q14 0 21-11.5t1-23.5q-30-49-79.5-77T480-420"
    })
  });
};
const MoodBad = /*#__PURE__*/forwardRef(Component$2M);

const Component$2L = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 20q-.825 0-1.412-.587Q10 18.825 10 18t.588-1.413Q11.175 16 12 16t1.413.587Q14 17.175 14 18t-.587 1.413Q12.825 20 12 20m0-6q-.825 0-1.412-.588Q10 12.825 10 12t.588-1.413Q11.175 10 12 10t1.413.587T14 12q0 .825-.587 1.412Q12.825 14 12 14m0-6q-.825 0-1.412-.588Q10 6.825 10 6t.588-1.412Q11.175 4 12 4t1.413.588Q14 5.175 14 6t-.587 1.412Q12.825 8 12 8"
    })
  });
};
const MoreVert = /*#__PURE__*/forwardRef(Component$2L);

const Component$2K = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-42q-17 0-28.5-11.5T440-82v-40q-125-14-214.5-103.5T122-440H82q-17 0-28.5-11.5T42-480t11.5-28.5T82-520h40q14-125 103.5-214.5T440-838v-40q0-17 11.5-28.5T480-918t28.5 11.5T520-878v40q125 14 214.5 103.5T838-520h40q17 0 28.5 11.5T918-480t-11.5 28.5T878-440h-40q-14 125-103.5 214.5T520-122v40q0 17-11.5 28.5T480-42m0-158q116 0 198-82t82-198-82-198-198-82-198 82-82 198 82 198 198 82m0-120q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113-47 113-113 47m0-80q33 0 56.5-23.5T560-480t-23.5-56.5T480-560t-56.5 23.5T400-480t23.5 56.5T480-400m0-80"
    })
  });
};
const MyLocation = /*#__PURE__*/forwardRef(Component$2K);

const Component$2J = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-42q-17 0-28.5-11.5T440-82v-40q-125-14-214.5-103.5T122-440H82q-17 0-28.5-11.5T42-480t11.5-28.5T82-520h40q14-125 103.5-214.5T440-838v-40q0-17 11.5-28.5T480-918t28.5 11.5T520-878v40q125 14 214.5 103.5T838-520h40q17 0 28.5 11.5T918-480t-11.5 28.5T878-440h-40q-14 125-103.5 214.5T520-122v40q0 17-11.5 28.5T480-42m0-158q116 0 198-82t82-198-82-198-198-82-198 82-82 198 82 198 198 82m0-120q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113-47 113-113 47"
    })
  });
};
const MyLocationFilled = /*#__PURE__*/forwardRef(Component$2J);

const Component$2I = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-320q17 0 29.5-12.5T522-362t-12.5-29.5T480-404t-29.5 12.5T438-362t12.5 29.5T480-320m114-298q0-47-31-74.5T485-720q-46 0-77.5 21T376-651q0 10 4 16.5t12 9.5q11 4 21.5-.5T434-641q9-11 21-16t26-5q23 0 38 12.5t15 31.5q0 18-8.5 29T497-561q-25 21-35 43t-10 40q0 16 7.5 25t21.5 9q13 0 21-8t10-23 13.5-29.5T550-532q23-23 33.5-44.5T594-618M480-186q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800t-170.5 69.5T240-552q0 71 59 162.5T480-186m0 79q-14 0-28-5t-25-15q-65-60-115-117t-83.5-110.5-51-103T160-552q0-150 96.5-239T480-880t223.5 89T800-552q0 45-17.5 94.5t-51 103T648-244 533-127q-11 10-25 15t-28 5m0-453"
    })
  });
};
const NotListedLocation = /*#__PURE__*/forwardRef(Component$2I);

const Component$2H = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-320q17 0 29.5-12.5T522-362t-12.5-29.5T480-404t-29.5 12.5T438-362t12.5 29.5T480-320m114-298q0-47-31-74.5T485-720q-46 0-77.5 21T376-651q0 10 4 16.5t12 9.5q11 4 21.5-.5T434-641q9-11 21-16t26-5q23 0 38 12.5t15 31.5q0 18-8.5 29T497-561q-25 21-35 43t-10 40q0 16 7.5 25t21.5 9q13 0 21-8t10-23 13.5-29.5T550-532q23-23 33.5-44.5T594-618M480-107q-14 0-28-5t-25-15q-65-60-115-117t-83.5-110.5-51-103T160-552q0-150 96.5-239T480-880t223.5 89T800-552q0 45-17.5 94.5t-51 103T648-244 533-127q-11 10-25 15t-28 5"
    })
  });
};
const NotListedLocationFilled = /*#__PURE__*/forwardRef(Component$2H);

const Component$2G = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M11 15v2q0 .425.288.712.287.288.712.288t.713-.288Q13 17.425 13 17v-2h2q.425 0 .713-.288Q16 14.425 16 14t-.287-.713T15 13h-2v-2q0-.425-.287-.713Q12.425 10 12 10t-.712.287T11 11v2H9q-.425 0-.712.287Q8 13.575 8 14t.288.712T9 15Zm-5 7q-.825 0-1.412-.587Q4 20.825 4 20V4q0-.825.588-1.413Q5.175 2 6 2h7.175q.4 0 .763.15.362.15.637.425l4.85 4.85q.275.275.425.637.15.363.15.763V20q0 .825-.587 1.413Q18.825 22 18 22Zm7-14V4H6v16h12V9h-4q-.425 0-.712-.288Q13 8.425 13 8M6 4v5zv16z"
    })
  });
};
const NoteAdd = /*#__PURE__*/forwardRef(Component$2G);

const Component$2F = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M6 22q-.825 0-1.412-.587Q4 20.825 4 20V4q0-.825.588-1.413Q5.175 2 6 2h7.175q.4 0 .763.15.362.15.637.425l4.85 4.85q.275.275.425.637.15.363.15.763V20q0 .825-.587 1.413Q18.825 22 18 22Zm7-14q0 .425.288.712Q13.575 9 14 9h4l-5-5Zm-2 7v2q0 .425.288.712.287.288.712.288t.713-.288Q13 17.425 13 17v-2h2q.425 0 .713-.288Q16 14.425 16 14t-.287-.713T15 13h-2v-2q0-.425-.287-.713Q12.425 10 12 10t-.712.287T11 11v2H9q-.425 0-.712.287Q8 13.575 8 14t.288.712T9 15Z"
    })
  });
};
const NoteAddFilled = /*#__PURE__*/forwardRef(Component$2F);

const Component$2E = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.287 18.712Q4.575 19 5 19h14q.424 0 .712-.288A.97.97 0 0 0 20 18a.97.97 0 0 0-.288-.712A.97.97 0 0 0 19 17h-1v-3h-2v3H8v-7q0-1.65 1.175-2.825T12 6q.65 0 1.225.188a3.7 3.7 0 0 1 1.05.537L15.7 5.3a5.2 5.2 0 0 0-1.025-.675A5.5 5.5 0 0 0 13.5 4.2v-.7q0-.625-.438-1.063A1.45 1.45 0 0 0 12 2q-.624 0-1.063.438A1.45 1.45 0 0 0 10.5 3.5v.7a5.93 5.93 0 0 0-3.225 2.087Q6 7.875 6 10v7H5a.97.97 0 0 0-.713.288A.97.97 0 0 0 4 18q0 .424.287.712m6.3 2.7Q11.175 22 12 22c.825 0 1.02-.196 1.412-.587Q14 20.824 14 20h-4q0 .824.588 1.413ZM19 12a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 16 9q0-1.25.875-2.125A2.9 2.9 0 0 1 19 6q1.25 0 2.125.875C22 7.75 22 8.167 22 9s-.292 1.542-.875 2.125A2.9 2.9 0 0 1 19 12",
      clipRule: "evenodd"
    })
  });
};
const NotificationActive = /*#__PURE__*/forwardRef(Component$2E);

const Component$2D = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M10.588 21.413Q11.175 22 12 22t1.412-.587Q14 20.825 14 20h-4q0 .824.588 1.413m-6.3-2.7A.97.97 0 0 0 5 19h14q.424 0 .712-.288A.97.97 0 0 0 20 18a.97.97 0 0 0-.288-.712A.97.97 0 0 0 19 17h-1v-1.9q-1.925-.75-3.088-2.362Q13.75 11.126 13.75 9q0-1.15.363-2.175a6.2 6.2 0 0 1 1.087-1.9 4.2 4.2 0 0 0-.787-.438A5 5 0 0 0 13.5 4.2v-.7q0-.625-.438-1.063A1.45 1.45 0 0 0 12 2q-.624 0-1.063.438A1.45 1.45 0 0 0 10.5 3.5v.7a5.93 5.93 0 0 0-3.225 2.087Q6 7.875 6 10v7H5a.97.97 0 0 0-.713.288A.97.97 0 0 0 4 18q0 .424.287.712ZM19 12a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 16 9q0-1.25.875-2.125A2.9 2.9 0 0 1 19 6q1.25 0 2.125.875C22 7.75 22 8.167 22 9s-.292 1.542-.875 2.125A2.9 2.9 0 0 1 19 12",
      clipRule: "evenodd"
    })
  });
};
const NotificationActiveFilled = /*#__PURE__*/forwardRef(Component$2D);

const Component$2C = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 96 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200 856q-17 0-28.5-11.5T160 816t11.5-28.5T200 776h40V496q0-83 50-147.5T420 264v-28q0-25 17.5-42.5T480 176t42.5 17.5T540 236v28q80 20 130 84.5T720 496v280h40q17 0 28.5 11.5T800 816t-11.5 28.5T760 856zm280 120q-33 0-56.5-23.5T400 896h160q0 33-23.5 56.5T480 976M320 776h320V496q0-66-47-113t-113-47-113 47-47 113z"
    })
  });
};
const Notifications = /*#__PURE__*/forwardRef(Component$2C);

const Component$2B = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 96 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200 856q-17 0-28.5-11.5T160 816t11.5-28.5T200 776h40V496q0-83 50-147.5T420 264v-28q0-25 17.5-42.5T480 176t42.5 17.5T540 236v28q80 20 130 84.5T720 496v280h40q17 0 28.5 11.5T800 816t-11.5 28.5T760 856zm280 120q-33 0-56.5-23.5T400 896h160q0 33-23.5 56.5T480 976"
    })
  });
};
const NotificationsFilled = /*#__PURE__*/forwardRef(Component$2B);

const Component$2A = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.588 21.413Q5.175 22 6 22h12a1.93 1.93 0 0 0 1.413-.587A1.93 1.93 0 0 0 20 20V8.825a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H6q-.824 0-1.412.587A1.93 1.93 0 0 0 4 4v16q0 .825.588 1.413M13 4v4q0 .424.288.712A.97.97 0 0 0 14 9h4v11H6V4zm-2.5 14q.325 0 .538-.212a.73.73 0 0 0 .212-.538v-.75h1.5v.775a.73.73 0 0 0 .75.725q.325 0 .538-.212a.73.73 0 0 0 .212-.538V13a.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287h-2.5a.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713v4.275a.73.73 0 0 0 .75.725m2.25-4.5V15h-1.5v-1.5z",
      clipRule: "evenodd"
    })
  });
};
const Offer = /*#__PURE__*/forwardRef(Component$2A);

const Component$2z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.588 21.413Q5.175 22 6 22h12a1.93 1.93 0 0 0 1.413-.587A1.93 1.93 0 0 0 20 20V8.825a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H6q-.824 0-1.412.587A1.93 1.93 0 0 0 4 4v16q0 .825.588 1.413m8.7-12.701A.97.97 0 0 1 13 8V4l5 5h-4a.97.97 0 0 1-.712-.288M10.5 18q.325 0 .538-.212a.73.73 0 0 0 .212-.538v-.75h1.5v.775a.73.73 0 0 0 .75.725q.325 0 .538-.212a.73.73 0 0 0 .212-.538V13a.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287h-2.5a.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713v4.275a.73.73 0 0 0 .75.725m2.25-4.5V15h-1.5v-1.5z",
      clipRule: "evenodd"
    })
  });
};
const OfferFilled = /*#__PURE__*/forwardRef(Component$2z);

const Component$2y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M160-120q-17 0-28.5-11.5T120-160v-240q0-17 11.5-28.5T160-440t28.5 11.5T200-400v144l504-504H560q-17 0-28.5-11.5T520-800t11.5-28.5T560-840h240q17 0 28.5 11.5T840-800v240q0 17-11.5 28.5T800-520t-28.5-11.5T760-560v-144L256-200h144q17 0 28.5 11.5T440-160t-11.5 28.5T400-120z"
    })
  });
};
const OpenInFull = /*#__PURE__*/forwardRef(Component$2y);

const Component$2x = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 21q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h6q.425 0 .713.287Q12 3.575 12 4t-.287.712Q11.425 5 11 5H5v14h14v-6q0-.425.288-.713Q19.575 12 20 12t.712.287Q21 12.575 21 13v6q0 .825-.587 1.413Q19.825 21 19 21Zm4-6q-.275-.275-.275-.7T9 13.6L17.6 5H15q-.425 0-.712-.288Q14 4.425 14 4t.288-.713Q14.575 3 15 3h5q.425 0 .712.287Q21 3.575 21 4v5q0 .425-.288.712Q20.425 10 20 10t-.712-.288Q19 9.425 19 9V6.4l-8.625 8.625q-.275.275-.675.275T9 15"
    })
  });
};
const OpenInNew = /*#__PURE__*/forwardRef(Component$2x);

const Component$2w = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m11 9.85-.875.875q-.3.3-.712.287Q9 11 8.7 10.7q-.275-.3-.287-.7-.013-.4.287-.7l2.6-2.6q.15-.15.325-.212.175-.063.375-.063t.375.063.325.212l2.6 2.6q.3.3.288.7t-.288.7q-.3.3-.712.312-.413.013-.713-.287L13 9.85V13q0 .425-.287.712Q12.425 14 12 14t-.712-.288T11 13ZM5 21q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h14q.825 0 1.413.587Q21 4.175 21 5v14q0 .825-.587 1.413Q19.825 21 19 21Zm0-2h14v-3h-3q-.75.95-1.787 1.475Q13.175 18 12 18t-2.212-.525Q8.75 16.95 8 16H5zm7-3q.8 0 1.475-.413.675-.412 1.1-1.087.15-.225.375-.363t.5-.137H19V5H5v9h3.55q.275 0 .5.137.225.138.375.363.425.675 1.1 1.087Q11.2 16 12 16m-7 3h14Z"
    })
  });
};
const Outbox = /*#__PURE__*/forwardRef(Component$2w);

const Component$2v = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 21q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h14q.825 0 1.413.587Q21 4.175 21 5v14q0 .825-.587 1.413Q19.825 21 19 21Zm7-5q.8 0 1.475-.413.675-.412 1.1-1.087.15-.225.375-.363t.5-.137H19V5H5v9h3.55q.275 0 .5.137.225.138.375.363.425.675 1.1 1.087Q11.2 16 12 16m-1-6.15-.875.875q-.3.3-.712.287Q9 11 8.7 10.7q-.275-.3-.287-.7-.013-.4.287-.7l2.6-2.6q.15-.15.325-.212.175-.063.375-.063t.375.063.325.212l2.6 2.6q.3.3.288.7t-.288.7q-.3.3-.712.312-.413.013-.713-.287L13 9.85V13q0 .425-.287.712Q12.425 14 12 14t-.712-.288T11 13Z"
    })
  });
};
const OutboxFilled = /*#__PURE__*/forwardRef(Component$2v);

const Component$2u = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 22q-2.05 0-3.875-.788-1.825-.787-3.187-2.15-1.363-1.362-2.15-3.187Q2 14.05 2 12q0-2.075.812-3.9t2.201-3.175Q6.4 3.575 8.25 2.787T12.2 2q2 0 3.775.688t3.112 1.9q1.338 1.212 2.125 2.875Q22 9.125 22 11.05q0 2.875-1.75 4.412Q18.5 17 16 17h-1.85q-.225 0-.312.125-.088.125-.088.275 0 .3.375.862t.375 1.288q0 1.25-.688 1.85T12 22m-5.5-9q.65 0 1.075-.425T8 11.5t-.425-1.075T6.5 10t-1.075.425T5 11.5t.425 1.075T6.5 13m3-4q.65 0 1.075-.425T11 7.5t-.425-1.075T9.5 6t-1.075.425T8 7.5t.425 1.075T9.5 9m5 0q.65 0 1.075-.425T16 7.5t-.425-1.075T14.5 6t-1.075.425T13 7.5t.425 1.075T14.5 9m3 4q.65 0 1.075-.425T19 11.5t-.425-1.075T17.5 10t-1.075.425T16 11.5t.425 1.075T17.5 13M12 20q.225 0 .363-.125t.137-.325q0-.35-.375-.825T11.75 17.3q0-1.05.725-1.675T14.25 15H16q1.65 0 2.825-.963Q20 13.075 20 11.05q0-3.025-2.312-5.038Q15.375 4 12.2 4 8.8 4 6.4 6.325T4 12q0 3.325 2.338 5.663T12 20"
    })
  });
};
const Palette = /*#__PURE__*/forwardRef(Component$2u);

const Component$2t = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 22q-2.05 0-3.875-.788-1.825-.787-3.187-2.15-1.363-1.362-2.15-3.187Q2 14.05 2 12q0-2.075.812-3.9t2.201-3.175Q6.4 3.575 8.25 2.787T12.2 2q2 0 3.775.688t3.112 1.9q1.338 1.212 2.125 2.875Q22 9.125 22 11.05q0 2.875-1.75 4.412Q18.5 17 16 17h-1.85q-.225 0-.312.125-.088.125-.088.275 0 .3.375.862t.375 1.288q0 1.25-.688 1.85T12 22m-5.5-9q.65 0 1.075-.425T8 11.5t-.425-1.075T6.5 10t-1.075.425T5 11.5t.425 1.075T6.5 13m3-4q.65 0 1.075-.425T11 7.5t-.425-1.075T9.5 6t-1.075.425T8 7.5t.425 1.075T9.5 9m5 0q.65 0 1.075-.425T16 7.5t-.425-1.075T14.5 6t-1.075.425T13 7.5t.425 1.075T14.5 9m3 4q.65 0 1.075-.425T19 11.5t-.425-1.075T17.5 10t-1.075.425T16 11.5t.425 1.075T17.5 13"
    })
  });
};
const PaletteFilled = /*#__PURE__*/forwardRef(Component$2t);

const Component$2s = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M600-200q-33 0-56.5-23.5T520-280v-400q0-33 23.5-56.5T600-760h80q33 0 56.5 23.5T760-680v400q0 33-23.5 56.5T680-200zm-320 0q-33 0-56.5-23.5T200-280v-400q0-33 23.5-56.5T280-760h80q33 0 56.5 23.5T440-680v400q0 33-23.5 56.5T360-200zm320-80h80v-400h-80zm-320 0h80v-400h-80zm0-400v400zm320 0v400z"
    })
  });
};
const Pause = /*#__PURE__*/forwardRef(Component$2s);

const Component$2r = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M400-320q17 0 28.5-11.5T440-360v-240q0-17-11.5-28.5T400-640t-28.5 11.5T360-600v240q0 17 11.5 28.5T400-320m160 0q17 0 28.5-11.5T600-360v-240q0-17-11.5-28.5T560-640t-28.5 11.5T520-600v240q0 17 11.5 28.5T560-320M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-320"
    })
  });
};
const PauseCircle = /*#__PURE__*/forwardRef(Component$2r);

const Component$2q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M400-320q17 0 28.5-11.5T440-360v-240q0-17-11.5-28.5T400-640t-28.5 11.5T360-600v240q0 17 11.5 28.5T400-320m160 0q17 0 28.5-11.5T600-360v-240q0-17-11.5-28.5T560-640t-28.5 11.5T520-600v240q0 17 11.5 28.5T560-320M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80"
    })
  });
};
const PauseCircleFilled = /*#__PURE__*/forwardRef(Component$2q);

const Component$2p = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M640-200q-33 0-56.5-23.5T560-280v-400q0-33 23.5-56.5T640-760t56.5 23.5T720-680v400q0 33-23.5 56.5T640-200m-320 0q-33 0-56.5-23.5T240-280v-400q0-33 23.5-56.5T320-760t56.5 23.5T400-680v400q0 33-23.5 56.5T320-200"
    })
  });
};
const PauseFilled = /*#__PURE__*/forwardRef(Component$2p);

const Component$2o = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M560-440q-50 0-85-35t-35-85 35-85 85-35 85 35 35 85-35 85-85 35M280-320q-33 0-56.5-23.5T200-400v-320q0-33 23.5-56.5T280-800h560q33 0 56.5 23.5T920-720v320q0 33-23.5 56.5T840-320zm80-80h400q0-33 23.5-56.5T840-480v-160q-33 0-56.5-23.5T760-720H360q0 33-23.5 56.5T280-640v160q33 0 56.5 23.5T360-400M120-160q-33 0-56.5-23.5T40-240v-400q0-17 11.5-28.5T80-680t28.5 11.5T120-640v400h640q17 0 28.5 11.5T800-200t-11.5 28.5T760-160zm160-240v-320z"
    })
  });
};
const Payments = /*#__PURE__*/forwardRef(Component$2o);

const Component$2n = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M560-440q50 0 85-35t35-85-35-85-85-35-85 35-35 85 35 85 85 35M280-320q-33 0-56.5-23.5T200-400v-320q0-33 23.5-56.5T280-800h560q33 0 56.5 23.5T920-720v320q0 33-23.5 56.5T840-320zM120-160q-33 0-56.5-23.5T40-240v-400q0-17 11.5-28.5T80-680t28.5 11.5T120-640v400h640q17 0 28.5 11.5T800-200t-11.5 28.5T760-160zm160-480q33 0 56.5-23.5T360-720h-80zm560 0v-80h-80q0 33 23.5 56.5T840-640M280-400h80q0-33-23.5-56.5T280-480zm480 0h80v-80q-33 0-56.5 23.5T760-400"
    })
  });
};
const PaymentsFilled = /*#__PURE__*/forwardRef(Component$2n);

const Component$2m = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M280-420q25 0 42.5-17.5T340-480t-17.5-42.5T280-540t-42.5 17.5T220-480t17.5 42.5T280-420m200 0q25 0 42.5-17.5T540-480t-17.5-42.5T480-540t-42.5 17.5T420-480t17.5 42.5T480-420m200 0q25 0 42.5-17.5T740-480t-17.5-42.5T680-540t-42.5 17.5T620-480t17.5 42.5T680-420M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-320"
    })
  });
};
const Pending = /*#__PURE__*/forwardRef(Component$2m);

var Pending$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Pending: Pending
});

const Component$2l = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M280-420q25 0 42.5-17.5T340-480t-17.5-42.5T280-540t-42.5 17.5T220-480t17.5 42.5T280-420m200 0q25 0 42.5-17.5T540-480t-17.5-42.5T480-540t-42.5 17.5T420-480t17.5 42.5T480-420m200 0q25 0 42.5-17.5T740-480t-17.5-42.5T680-540t-42.5 17.5T620-480t17.5 42.5T680-420M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80"
    })
  });
};
const PendingFilled = /*#__PURE__*/forwardRef(Component$2l);

var PendingFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PendingFilled: PendingFilled
});

const Component$2k = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 12q-1.65 0-2.825-1.175T8 8c0-1.65.392-2.042 1.175-2.825Q10.35 4 12 4c1.65 0 2.042.392 2.825 1.175Q16 6.35 16 8c0 1.65-.392 2.042-1.175 2.825Q13.65 12 12 12m-8 8v-2.8q0-.85.438-1.563A2.9 2.9 0 0 1 5.6 14.55a15 15 0 0 1 3.15-1.163A13.8 13.8 0 0 1 12 13q1.65 0 3.25.387 1.6.388 3.15 1.163.724.375 1.162 1.087T20 17.2V20zm2-2h12v-.8a.94.94 0 0 0-.137-.5 1 1 0 0 0-.363-.35 13 13 0 0 0-2.725-1.013 11.6 11.6 0 0 0-5.55 0A13 13 0 0 0 6.5 16.35a.97.97 0 0 0-.5.85zm6-8q.825 0 1.413-.588Q14 8.825 14 8q0-.824-.587-1.412A1.93 1.93 0 0 0 12 6q-.825 0-1.412.588A1.92 1.92 0 0 0 10 8q0 .825.588 1.412Q11.175 10 12 10"
    })
  });
};
const Person = /*#__PURE__*/forwardRef(Component$2k);

const Component$2j = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M19 14c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7v-2h-2c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3h2V7c0-.3.1-.5.3-.7s.4-.3.7-.3.5.1.7.3.3.4.3.7v2h2c.3 0 .5.1.7.3s.3.4.3.7-.1.5-.3.7-.4.3-.7.3h-2v2c0 .3-.1.5-.3.7s-.4.3-.7.3M9 12c-1.1 0-2-.4-2.8-1.2S5 9.1 5 8s.4-2 1.2-2.8S7.9 4 9 4s2 .4 2.8 1.2S13 6.9 13 8s-.4 2-1.2 2.8S10.1 12 9 12m-7 8H1v-2.8c0-.6.1-1.1.4-1.6s.7-.8 1.2-1.1c1-.5 2.1-.9 3.1-1.2S7.9 13 9 13s2.2.1 3.2.4 2.1.6 3.2 1.2c.5.2.9.6 1.2 1.1s.4 1 .4 1.6V20zm1-2h12v-.8c0-.2 0-.4-.1-.5-.1-.2-.2-.3-.4-.4-.9-.5-1.8-.8-2.7-1S9.9 15 9 15s-1.9.1-2.8.3-1.8.6-2.7 1c-.1.1-.3.2-.4.4-.1.1-.1.3-.1.5zm6-8c.6 0 1-.2 1.4-.6s.6-.9.6-1.4-.2-1-.6-1.4S9.6 6 9 6s-1 .2-1.4.6S7 7.4 7 8s.2 1 .6 1.4.8.6 1.4.6"
    })
  });
};
const PersonAdd = /*#__PURE__*/forwardRef(Component$2j);

const Component$2i = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M19 14c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7v-2h-2c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3h2V7c0-.3.1-.5.3-.7s.4-.3.7-.3.5.1.7.3.3.4.3.7v2h2c.3 0 .5.1.7.3s.3.4.3.7-.1.5-.3.7-.4.3-.7.3h-2v2c0 .3-.1.5-.3.7s-.4.3-.7.3M9 12c-1.1 0-2-.4-2.8-1.2S5 9.1 5 8s.4-2 1.2-2.8S7.9 4 9 4s2 .4 2.8 1.2S13 6.9 13 8s-.4 2-1.2 2.8S10.1 12 9 12m-7 8H1v-2.8c0-.6.1-1.1.4-1.6s.7-.8 1.2-1.1c1-.5 2.1-.9 3.1-1.2S7.9 13 9 13s2.2.1 3.2.4 2.1.6 3.2 1.2c.5.2.9.6 1.2 1.1s.4 1 .4 1.6V20z"
    })
  });
};
const PersonAddFilled = /*#__PURE__*/forwardRef(Component$2i);

const Component$2h = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M10.7 10.2c.8.8 1.7 1.2 2.8 1.2s2-.4 2.8-1.2 1.2-1.7 1.2-2.8-.4-2-1.2-2.8-1.7-1.2-2.8-1.2-2 .4-2.8 1.2-1.2 1.7-1.2 2.8.4 2.1 1.2 2.8m4.2-1.4c-.4.4-.9.6-1.4.6s-1-.2-1.4-.6-.6-.9-.6-1.4.2-1 .6-1.4.9-.6 1.4-.6 1 .2 1.4.6.6.9.6 1.4-.2 1-.6 1.4m-4.6 4q.9.75 1.5 1.8c.6-.1 1.1-.1 1.7-.1.9 0 1.9.1 2.8.3s1.8.6 2.7 1c.1.1.3.2.4.3s.1.3.1.5v.8h-7c0 .7-.1 1.4-.3 2h9.3v-2.8c0-.6-.1-1.1-.4-1.6s-.7-.8-1.2-1.1c-1-.5-2.1-.9-3.1-1.2-1.1-.3-2.1-.4-3.2-.4-1.2.1-2.2.2-3.3.5M3.5 18h3.2l-.9.9c-.2.2-.3.4-.3.7s.1.5.3.7.4.3.7.3.5-.1.7-.3l2.6-2.6c.2-.2.3-.4.3-.7s-.1-.5-.3-.7l-2.6-2.6c-.2-.2-.4-.3-.7-.3s-.5.1-.7.3-.3.4-.3.7.1.5.3.7l.9.9H3.5c-.3 0-.5.1-.7.3s-.3.4-.3.7.1.5.3.7.4.3.7.3",
      clipRule: "evenodd"
    })
  });
};
const PersonArrow = /*#__PURE__*/forwardRef(Component$2h);

const Component$2g = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M10.7 10.2c.8.8 1.7 1.2 2.8 1.2s2-.4 2.8-1.2 1.2-1.7 1.2-2.8-.4-2-1.2-2.8-1.7-1.2-2.8-1.2-2 .4-2.8 1.2-1.2 1.7-1.2 2.8.4 2.1 1.2 2.8m-.4 2.6c1.3 1.1 2.2 2.8 2.2 4.6 0 .7-.1 1.4-.3 2h9.3v-2.8c0-.6-.1-1.1-.4-1.6s-.7-.8-1.2-1.1c-1-.5-2.1-.9-3.1-1.2-1.1-.3-2.1-.4-3.2-.4-1.2.1-2.2.2-3.3.5M3.5 18h3.2l-.9.9c-.2.2-.3.4-.3.7s.1.5.3.7.4.3.7.3.5-.1.7-.3l2.6-2.6c.2-.2.3-.4.3-.7s-.1-.5-.3-.7l-2.6-2.6c-.2-.2-.4-.3-.7-.3s-.5.1-.7.3-.3.4-.3.7.1.5.3.7l.9.9H3.5c-.3 0-.5.1-.7.3s-.3.4-.3.7.1.5.3.7.4.3.7.3"
    })
  });
};
const PersonArrowFilled = /*#__PURE__*/forwardRef(Component$2g);

const Component$2f = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M12 20H3v-2.8q0-.85.438-1.563A2.9 2.9 0 0 1 4.6 14.55a14.8 14.8 0 0 1 3.15-1.163A13.8 13.8 0 0 1 11 13c1.513 0 2.422.444 2.422.444s-1.295.756-2.422 1.58c-.933 0-1.858.088-2.775.313q-1.375.337-2.725 1.012a.97.97 0 0 0-.5.85v.8h5.438c.085.469 1.046 1.477 1.562 2Zm-1-8q-1.65 0-2.825-1.175T7 8c0-1.65.392-2.042 1.175-2.825Q9.35 4 11 4c1.65 0 2.042.392 2.825 1.175Q15 6.35 15 8c0 1.65-.392 2.042-1.175 2.825Q12.65 12 11 12m0-2q.825 0 1.412-.588Q13 8.825 13 8q0-.824-.588-1.412A1.93 1.93 0 0 0 11 6q-.825 0-1.412.588A1.93 1.93 0 0 0 9 8q0 .825.588 1.412Q10.175 10 11 10"
    }), /*#__PURE__*/jsx("path", {
      d: "M16.197 19.783c-.39.39-1.03.39-1.42 0l-2.07-2.09a.99.99 0 0 1 0-1.39l.01-.01a.984.984 0 0 1 1.4 0l1.37 1.37 4.43-4.46a.996.996 0 0 1 1.41 0l.01.01a.99.99 0 0 1 0 1.39z"
    })]
  });
};
const PersonCheck = /*#__PURE__*/forwardRef(Component$2f);

const Component$2e = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "m12 20-.86-.86a2.997 2.997 0 0 1 .02-4.26l.84-.82a9 9 0 0 0-1-.06c-2.67 0-8 1.34-8 4v2zm-1-8c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m5.18 7.78c-.39.39-1.03.39-1.42 0l-2.07-2.09a.99.99 0 0 1 0-1.39l.01-.01a.984.984 0 0 1 1.4 0l1.37 1.37 4.43-4.46a.996.996 0 0 1 1.41 0l.01.01a.99.99 0 0 1 0 1.39z"
    })
  });
};
const PersonCheckFilled = /*#__PURE__*/forwardRef(Component$2e);

const Component$2d = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 12q-1.65 0-2.825-1.175T8 8c0-1.65.392-2.042 1.175-2.825Q10.35 4 12 4c1.65 0 2.042.392 2.825 1.175Q16 6.35 16 8c0 1.65-.392 2.042-1.175 2.825Q13.65 12 12 12m-8 8v-2.8q0-.85.438-1.563A2.9 2.9 0 0 1 5.6 14.55a15 15 0 0 1 3.15-1.163A13.8 13.8 0 0 1 12 13q1.65 0 3.25.387 1.6.388 3.15 1.163.724.375 1.162 1.087T20 17.2V20z"
    })
  });
};
const PersonFilled = /*#__PURE__*/forwardRef(Component$2d);

const Component$2c = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M19.075 21.9 17.15 20H5q-.425 0-.713-.288Q4 19.425 4 19v-1.8q0-.85.438-1.563.437-.712 1.162-1.087 1.125-.575 2.288-.925t2.362-.525L2.075 4.925q-.3-.3-.287-.7.012-.4.312-.7t.712-.3.713.3L20.5 20.5q.3.3.3.7t-.3.7-.712.3q-.413 0-.713-.3M6 18h9.15l-3-3H12q-1.4 0-2.775.337-1.375.338-2.725 1.013-.225.125-.362.35-.138.225-.138.5Zm12.4-3.45q.725.35 1.15 1.063.425.712.45 1.537l-3.35-3.35q.45.175.888.35.437.175.862.4m-4.2-3.2-1.475-1.475q.575-.225.925-.738Q14 8.625 14 8q0-.825-.587-1.412Q12.825 6 12 6q-.625 0-1.137.35-.513.35-.738.925L8.65 5.8q.575-.85 1.45-1.325T12 4q1.65 0 2.825 1.175T16 8q0 1.025-.475 1.9T14.2 11.35m.95 6.65H6zm-3.725-9.425"
    })
  });
};
const PersonOff = /*#__PURE__*/forwardRef(Component$2c);

const Component$2b = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 20q-.425 0-.713-.288Q4 19.425 4 19v-1.8q0-.85.438-1.563.437-.712 1.162-1.087 1.125-.575 2.288-.925t2.362-.525L2.075 4.925q-.3-.3-.287-.7.012-.4.312-.7t.712-.3.713.3L20.5 20.5q.3.3.3.7t-.3.7-.712.3q-.413 0-.713-.3L17.15 20Zm15-2.85-3.35-3.35q.45.175.888.35.437.175.862.4.725.35 1.15 1.063.425.712.45 1.537m-5.8-5.8L8.65 5.8q.575-.85 1.45-1.325T12 4q1.65 0 2.825 1.175T16 8q0 1.025-.475 1.9T14.2 11.35"
    })
  });
};
const PersonOffFilled = /*#__PURE__*/forwardRef(Component$2b);

const Component$2a = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12.775 20H4v-2.8q0-.85.438-1.563A2.9 2.9 0 0 1 5.6 14.55a14.8 14.8 0 0 1 3.15-1.163A13.8 13.8 0 0 1 12 13v2a11.6 11.6 0 0 0-2.775.338Q7.85 15.675 6.5 16.35a.97.97 0 0 0-.5.85v.8h6.125a8.4 8.4 0 0 0 .65 2M18 22q-1.826-.45-2.912-2A5.87 5.87 0 0 1 14 16.55V14l4-2 4 2v2.55A5.87 5.87 0 0 1 20.913 20Q19.825 21.55 18 22m0-2.1a3.27 3.27 0 0 0 1.475-1.375Q20 17.6 20 16.55v-1.3l-2-1-2 1v1.3q0 1.05.525 1.975A3.27 3.27 0 0 0 18 19.9M12 12q-1.65 0-2.825-1.175T8 8c0-1.65.392-2.042 1.175-2.825Q10.35 4 12 4c1.65 0 2.042.392 2.825 1.175Q16 6.35 16 8c0 1.65-.392 2.042-1.175 2.825Q13.65 12 12 12m0-2q.825 0 1.412-.588Q14 8.825 14 8q0-.824-.588-1.412A1.93 1.93 0 0 0 12 6q-.825 0-1.412.588A1.93 1.93 0 0 0 10 8q0 .825.588 1.412Q11.175 10 12 10"
    })
  });
};
const PersonShield = /*#__PURE__*/forwardRef(Component$2a);

const Component$29 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M18 22q-1.826-.45-2.912-2A5.87 5.87 0 0 1 14 16.55V14l4-2 4 2v2.55A5.87 5.87 0 0 1 20.913 20Q19.825 21.55 18 22M4 20v-2.8q0-.85.438-1.563A2.9 2.9 0 0 1 5.6 14.55a14.8 14.8 0 0 1 3.15-1.163A13.8 13.8 0 0 1 12 13v3.55q0 .9.188 1.775A7 7 0 0 0 12.775 20zm8-8q-1.65 0-2.825-1.175T8 8c0-1.65.392-2.042 1.175-2.825Q10.35 4 12 4c1.65 0 2.042.392 2.825 1.175Q16 6.35 16 8c0 1.65-.392 2.042-1.175 2.825Q13.65 12 12 12"
    })
  });
};
const PersonShieldFilled = /*#__PURE__*/forwardRef(Component$29);

const Component$28 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M19.95 21q-3.225 0-6.287-1.438a19.1 19.1 0 0 1-5.425-3.8 19.1 19.1 0 0 1-3.8-5.425Q2.999 7.275 3 4.05q0-.45.3-.75t.75-.3H8.1a.96.96 0 0 1 .625.225.88.88 0 0 1 .325.575l.65 3.5q.05.35-.012.638a1 1 0 0 1-.288.512L7 10.9q1.05 1.8 2.625 3.375A18.3 18.3 0 0 0 13.1 17l2.35-2.35a1.4 1.4 0 0 1 .588-.338q.362-.111.712-.062l3.45.7q.35.075.575.338.225.262.225.612v4.05q0 .45-.3.75t-.75.3M7.7 7.35 6.05 9a11 11 0 0 1-.65-1.975A21 21 0 0 1 5.05 5h2.2zM19 18.95v-2.2l-2.35-.5L15 17.9q.975.425 1.975.7t2.025.35m2-14.947a.97.97 0 0 0-.289-.714.97.97 0 0 0-.714-.289h-4.013a.97.97 0 0 0-.715.289.97.97 0 0 0-.288.714q0 .426.288.715a.97.97 0 0 0 .715.288h1.605L13.276 9.32a.95.95 0 0 0-.276.702q0 .426.276.702a.95.95 0 0 0 .702.276.95.95 0 0 0 .702-.276l4.314-4.313v1.605q0 .426.288.715a.97.97 0 0 0 .715.288.97.97 0 0 0 .714-.288.97.97 0 0 0 .289-.715z",
      clipRule: "evenodd"
    })
  });
};
const PhoneCallback = /*#__PURE__*/forwardRef(Component$28);

const Component$27 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M13.663 19.562Q16.725 21 19.95 21q.45 0 .75-.3t.3-.75V15.9a.9.9 0 0 0-.225-.613 1.02 1.02 0 0 0-.575-.337l-3.45-.7a1.6 1.6 0 0 0-.712.062 1.4 1.4 0 0 0-.588.338L13.1 17a18.3 18.3 0 0 1-3.475-2.725A16.6 16.6 0 0 1 7 10.9l2.4-2.45q.225-.225.288-.513A1.8 1.8 0 0 0 9.7 7.3l-.65-3.5a.88.88 0 0 0-.325-.575A.96.96 0 0 0 8.1 3H4.05q-.45 0-.75.3t-.3.75q0 3.225 1.438 6.287a19 19 0 0 0 3.8 5.425 19 19 0 0 0 5.425 3.8m7.321-15.537a.96.96 0 0 0-.291-.712.98.98 0 0 0-.72-.288h-4.047a1 1 0 0 0-.722.288.96.96 0 0 0-.29.712.99.99 0 0 0 1.012 1h1.618l-4.35 4.3a.94.94 0 0 0-.278.7.94.94 0 0 0 .278.7.97.97 0 0 0 .708.275.97.97 0 0 0 .708-.275l4.35-4.3v1.6a.99.99 0 0 0 1.012 1 .98.98 0 0 0 .72-.287.96.96 0 0 0 .292-.713z",
      clipRule: "evenodd"
    })
  });
};
const PhoneCallbackFilled = /*#__PURE__*/forwardRef(Component$27);

const Component$26 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M692-585q-12-12-12-28.5t12-28.5l36-36H562q-17 0-28.5-11.5T522-718t11.5-28.5T562-758h166l-36-36q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T749-851l105 105q6 6 8.5 13t2.5 15-2.5 15-8.5 13L748-584q-12 12-28 11.5T692-585m106 465q-129 0-251.5-57.5t-217-152-152-217T120-798q0-18 12-30t30-12h162q14 0 25 9t13 23l26 140q2 14-.5 25.5T376-622l-96 98q42 72 105 135t139 109l94-94q9-9 23.5-13.5T670-390l138 28q14 3 23 13.5t9 24.5v162q0 18-12 30t-30 12M242-600l66-66-18-94h-88q5 41 14 81t26 79m518 398v-88l-94-20-66 66q39 17 79 28t81 14M242-600"
    })
  });
};
const PhoneForwarded = /*#__PURE__*/forwardRef(Component$26);

const Component$25 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M692-585q-12-12-12-28.5t12-28.5l36-36H562q-17 0-28.5-11.5T522-718t11.5-28.5T562-758h166l-36-36q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T749-851l105 105q6 6 8.5 13t2.5 15-2.5 15-8.5 13L748-584q-12 12-28 11.5T692-585m106 465q-129 0-251.5-57.5t-217-152-152-217T120-798q0-18 12-30t30-12h162q14 0 25 9t13 23l26 140q2 14-.5 25.5T376-622l-96 98q42 72 105 135t139 109l94-94q9-9 23.5-13.5T670-390l138 28q14 3 23 13.5t9 24.5v162q0 18-12 30t-30 12"
    })
  });
};
const PhoneForwardedFilled = /*#__PURE__*/forwardRef(Component$25);

const Component$24 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m136-144-92-90q-12-12-12-28t12-28q88-95 203-142.5T480-480t232.5 47.5T916-290q12 12 12 28t-12 28l-92 90q-11 11-25.5 12t-26.5-8l-116-88q-8-6-12-14t-4-18v-114q-38-12-78-19t-82-7-82 7-78 19v114q0 10-4 18t-12 14l-116 88q-12 9-26.5 8T136-144m32-80 72-56v-62q-29 15-56 34.5T128-264zm624 0 40-38q-29-26-56-45t-56-33v60zM478-521q-8 0-15-2.5t-13-8.5L280-702v64q0 17-11.5 28.5T240-598t-28.5-11.5T200-638v-160q0-17 11.5-28.5T240-838h160q17 0 28.5 11.5T440-798t-11.5 28.5T400-758h-64l141 141 198-198q12-12 28.5-12t28.5 12 12 28.5-12 28.5L506-532q-6 6-13 8.5t-15 2.5M240-342"
    })
  });
};
const PhoneMissed = /*#__PURE__*/forwardRef(Component$24);

const Component$23 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m137-144-92-90q-11-11-11-28t11-28q85-92 198-141t238-49 238 49.5T917-290q11 11 11 28t-11 28l-92 90q-11 11-25.5 12t-26.5-8l-116-88q-8-6-12-14t-4-18v-114q-39-13-79-19.5t-81-6.5-81 6.5-79 19.5v114q0 10-4 18t-12 14l-116 88q-12 9-26.5 8T137-144m343-377q-8 0-15-2.5t-13-8.5L282-702v64q0 17-11.5 28.5T242-598t-28.5-11.5T202-638v-160q0-17 11.5-28.5T242-838h160q17 0 28.5 11.5T442-798t-11.5 28.5T402-758h-64l141 141 198-198q12-12 28.5-12t28.5 12 12 28.5-12 28.5L508-532q-6 6-13 8.5t-15 2.5"
    })
  });
};
const PhoneMissedFilled = /*#__PURE__*/forwardRef(Component$23);

const Component$22 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M4 20q-.825 0-1.412-.587Q2 18.825 2 18V6q0-.825.588-1.412Q3.175 4 4 4h16q.825 0 1.413.588Q22 5.175 22 6v12q0 .825-.587 1.413Q20.825 20 20 20Zm3.075-5q.25 0 .413-.163.162-.162.162-.412V9.55q0-.225-.162-.388Q7.325 9 7.1 9q-.15 0-.325.062-.175.063-.3.138l-1.05.75q-.2.125-.225.337t.1.413q.125.2.325.225t.4-.1L6.5 10.5v3.925q0 .25.162.412.163.163.413.163m3.125 0H13q.2 0 .35-.15t.15-.35-.15-.35T13 14h-1.85l-.05-.05q.525-.5.863-.85t.537-.55q.45-.45.675-.9t.225-.95q0-.725-.55-1.212Q12.3 9 11.45 9q-.5 0-.937.238-.438.237-.713.637-.125.175-.05.375t.3.3q.175.075.375.012.2-.062.4-.262.125-.125.288-.188.162-.062.337-.062.375 0 .612.2.238.2.238.5 0 .275-.1.512-.1.238-.45.588l-.7.7-1.175 1.175q-.125.125-.2.312-.075.188-.075.363 0 .25.175.425T10.2 15m6.8 0q.9 0 1.45-.5t.55-1.3q0-.45-.25-.8t-.7-.55v-.05q.35-.2.55-.513.2-.312.2-.737 0-.675-.525-1.112T16.95 9q-.45 0-.863.2-.412.2-.687.525-.15.2-.075.412.075.213.35.338.15.05.313 0 .162-.05.337-.225.125-.125.275-.188.15-.062.35-.062.325 0 .538.188.212.187.212.462 0 .35-.25.55t-.65.2q-.15 0-.3.15t-.15.35.15.35.35.15q.5 0 .775.2t.275.55q0 .325-.275.562T17 13.95q-.275 0-.462-.088-.188-.087-.338-.287t-.362-.275q-.213-.075-.413 0-.2.1-.3.3t0 .4q.275.5.75.75T17 15M4 18h16V6H4zm0 0V6z"
    })
  });
};
const Pin = /*#__PURE__*/forwardRef(Component$22);

const Component$21 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M4 20q-.825 0-1.412-.587Q2 18.825 2 18V6q0-.825.588-1.412Q3.175 4 4 4h16q.825 0 1.413.588Q22 5.175 22 6v12q0 .825-.587 1.413Q20.825 20 20 20Zm3.075-5q.25 0 .413-.163.162-.162.162-.412V9.55q0-.225-.162-.388Q7.325 9 7.1 9q-.15 0-.325.062-.175.063-.3.138l-1.05.75q-.2.125-.225.337t.1.413q.125.2.325.225t.4-.1L6.5 10.5v3.925q0 .25.162.412.163.163.413.163m3.125 0H13q.2 0 .35-.15t.15-.35-.15-.35T13 14h-1.85l-.05-.05q.525-.5.863-.85t.537-.55q.45-.45.675-.9t.225-.95q0-.725-.55-1.212Q12.3 9 11.45 9q-.5 0-.937.238-.438.237-.713.637-.125.175-.05.375t.3.3q.175.075.375.012.2-.062.4-.262.125-.125.288-.188.162-.062.337-.062.375 0 .612.2.238.2.238.5 0 .275-.1.512-.1.238-.45.588l-.7.7-1.175 1.175q-.125.125-.2.312-.075.188-.075.363 0 .25.175.425T10.2 15m6.8 0q.9 0 1.45-.5t.55-1.3q0-.45-.25-.8t-.7-.55v-.05q.35-.2.55-.513.2-.312.2-.737 0-.675-.525-1.112T16.95 9q-.45 0-.863.2-.412.2-.687.525-.15.2-.075.412.075.213.35.338.15.05.313 0 .162-.05.337-.225.125-.125.275-.188.15-.062.35-.062.325 0 .538.188.212.187.212.462 0 .35-.25.55t-.65.2q-.15 0-.3.15t-.15.35.15.35.35.15q.5 0 .775.2t.275.55q0 .325-.275.562T17 13.95q-.275 0-.462-.088-.188-.087-.338-.287t-.362-.275q-.213-.075-.413 0-.2.1-.3.3t0 .4q.275.5.75.75T17 15"
    })
  });
};
const PinFilled = /*#__PURE__*/forwardRef(Component$21);

const Component$20 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M3 11a.97.97 0 0 1-.712-.287A.97.97 0 0 1 2 10a.97.97 0 0 1 .288-.713A.97.97 0 0 1 3 9h2.6L2 5.425q-.3-.3-.3-.713Q1.7 4.3 2 4t.713-.3q.412 0 .712.3L7 7.6V5a.97.97 0 0 1 .288-.713A.97.97 0 0 1 8 4q.424 0 .713.287Q9 4.575 9 5v5q0 .424-.287.713A.97.97 0 0 1 8 11zm1 9q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18v-4a.97.97 0 0 1 .288-.713A.97.97 0 0 1 3 13q.424 0 .713.287Q4 13.575 4 14v4h7a.97.97 0 0 1 .713.288Q12 18.575 12 19c0 .425-.096.52-.287.712A.97.97 0 0 1 11 20zm17-7a.97.97 0 0 1-.712-.287A.97.97 0 0 1 20 12V6h-8a.97.97 0 0 1-.713-.288A.97.97 0 0 1 11 5q0-.424.287-.713A.97.97 0 0 1 12 4h8q.824 0 1.413.587.586.589.587 1.413v6a.97.97 0 0 1-.288.713A.97.97 0 0 1 21 13m-6 7a.97.97 0 0 1-.713-.288A.97.97 0 0 1 14 19v-3q0-.424.287-.713A.97.97 0 0 1 15 15h6a.97.97 0 0 1 .712.287Q22 15.575 22 16v3q0 .424-.288.712A.97.97 0 0 1 21 20z"
    })
  });
};
const Pip = /*#__PURE__*/forwardRef(Component$20);

const Component$1$ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 25",
    children: /*#__PURE__*/jsx("path", {
      d: "M4 20.866q-.824 0-1.413-.588A1.93 1.93 0 0 1 2 18.866v-6q0-.426.288-.713A.97.97 0 0 1 3 11.866a.97.97 0 0 1 .712.287q.288.288.288.713v6h16v-12h-8a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712q0-.425.287-.713A.97.97 0 0 1 12 4.866h8q.824 0 1.413.587.587.588.587 1.413v12q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588zm10-6.575 2.375 2.375q.3.3.7.3t.7-.3.3-.713-.3-.712L15.4 12.866H17q.424 0 .712-.288a.97.97 0 0 0 .288-.712.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287h-4a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713v4q0 .424.287.712.288.288.713.288c.425 0 .52-.096.713-.288a.97.97 0 0 0 .287-.712V14.29ZM3 9.866a.97.97 0 0 1-.712-.288A.97.97 0 0 1 2 8.866v-3q0-.425.288-.713A.97.97 0 0 1 3 4.866h5q.424 0 .713.287.287.288.287.713v3a.97.97 0 0 1-.287.712.97.97 0 0 1-.713.288z"
    })
  });
};
const PipExit = /*#__PURE__*/forwardRef(Component$1$);

const Component$1_ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M381-239q-20 13-40.5 1.5T320-273v-414q0-24 20.5-35.5T381-721l326 207q18 12 18 34t-18 34zm19-107 210-134-210-134z"
    })
  });
};
const PlayArrow = /*#__PURE__*/forwardRef(Component$1_);

const Component$1Z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M381-239q-20 13-40.5 1.5T320-273v-414q0-24 20.5-35.5T381-721l326 207q18 12 18 34t-18 34z"
    })
  });
};
const PlayArrowFilled = /*#__PURE__*/forwardRef(Component$1Z);

const Component$1Y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M9.5 9.325v5.35q0 .6.525.875t1.025-.05l4.15-2.65q.475-.275.475-.85t-.475-.85L11.05 8.5q-.5-.325-1.025-.05t-.525.875M12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22m0-2q3.325 0 5.663-2.337T20 12t-2.337-5.663Q15.325 4 12 4T6.338 6.337Q4 8.675 4 12t2.338 5.663Q8.675 20 12 20"
    })
  });
};
const PlayCircle = /*#__PURE__*/forwardRef(Component$1Y);

const Component$1X = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M9.5 9.325v5.35q0 .575.525.875t1.025-.05l4.15-2.65q.475-.3.475-.85t-.475-.85L11.05 8.5q-.5-.35-1.025-.05t-.525.875M12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137T2.788 15.9 2 12t.788-3.9q.787-1.825 2.137-3.175T8.1 2.787Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138T21.212 8.1 22 12t-.788 3.9q-.787 1.825-2.137 3.175T15.9 21.212 12 22"
    })
  });
};
const PlayCircleFilled = /*#__PURE__*/forwardRef(Component$1X);

const Component$1W = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "m6 18.696-2.3 2.3c-.32.32-.68.39-1.09.21-.41-.17-.61-.49-.61-.94V4.696c0-.55.2-1.02.59-1.41s.86-.59 1.41-.59h16c.55 0 1.02.2 1.41.59s.59.86.59 1.41v12c0 .55-.2 1.02-.59 1.41s-.86.59-1.41.59zm-.85-2H20v-12H4v13.13l1.15-1.12z"
    }), /*#__PURE__*/jsx("path", {
      d: "M13.41 7.286c-.39-.39-.86-.59-1.41-.59s-1.02.2-1.41.59-.59.86-.59 1.41v1c-.28 0-.52.1-.71.29s-.29.43-.29.71v3c0 .28.1.52.29.71s.43.29.71.29h4c.28 0 .52-.1.71-.29s.29-.43.29-.71v-3c0-.28-.1-.52-.29-.71a.97.97 0 0 0-.71-.29v-1c0-.55-.2-1.02-.59-1.41M13 9.696h-2v-1c0-.28.1-.52.29-.71s.43-.29.71-.29.52.1.71.29.29.43.29.71z"
    })]
  });
};
const Postbox = /*#__PURE__*/forwardRef(Component$1W);

const Component$1V = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M12 7.695c-.28 0-.52.1-.71.29s-.29.43-.29.71v1h2v-1c0-.28-.1-.52-.29-.71a.97.97 0 0 0-.71-.29"
    }), /*#__PURE__*/jsx("path", {
      d: "M21.41 3.285c-.39-.39-.86-.59-1.41-.59H4c-.55 0-1.02.2-1.41.59S2 4.145 2 4.695v15.58c0 .45.2.76.61.94.41.17.77.1 1.09-.21l2.3-2.3h14c.55 0 1.02-.2 1.41-.59s.59-.86.59-1.41V4.695c0-.55-.2-1.02-.59-1.41M15 13.695c0 .28-.1.52-.29.71s-.43.29-.71.29h-4c-.28 0-.52-.1-.71-.29a.97.97 0 0 1-.29-.71v-3c0-.28.1-.52.29-.71s.43-.29.71-.29v-1c0-.55.2-1.02.59-1.41s.86-.59 1.41-.59 1.02.2 1.41.59.59.86.59 1.41v1c.28 0 .52.1.71.29s.29.43.29.71z"
    })]
  });
};
const PostboxFilled = /*#__PURE__*/forwardRef(Component$1V);

const Component$1U = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "m6.927 15.023 2.449-8.114c.16-.54.66-.909 1.22-.909.879 0 1.488.87 1.208 1.699L8.646 16.78a1.808 1.808 0 0 1-3.418 0L2.07 7.699A1.28 1.28 0 0 1 3.28 6c.559 0 1.059.37 1.219.91l2.428 8.102zm12.133.5h-4.337l-.55 1.638a1.214 1.214 0 1 1-2.289-.81l3.458-9.272c.24-.65.86-1.069 1.55-1.069s1.299.43 1.549 1.07l3.478 9.271c.3.8-.29 1.639-1.14 1.639-.52 0-.99-.33-1.149-.83l-.55-1.638zm-3.668-2h2.999l-1.51-4.486z"
    })
  });
};
const Preinquiry = /*#__PURE__*/forwardRef(Component$1U);

const Component$1T = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M6.626 9.026 8.663 2.27c.14-.45.55-.76 1.02-.76.729 0 1.248.72.998 1.41l-2.637 7.566c-.21.61-.78 1.01-1.428 1.01-.64 0-1.22-.41-1.429-1.02L2.56 2.909A1.06 1.06 0 0 1 3.569 1.5c.47 0 .879.31 1.019.76l2.028 6.756zm4.415 2.48c.44 0 .82-.28.959-.69l.46-1.37h3.606l.36 1.06h.08c.678 0 1.328.1 1.947.28.06-.2.07-.43-.01-.65L15.546 2.4c-.2-.54-.709-.89-1.288-.89s-1.09.36-1.29.9l-2.876 7.736c-.25.66.24 1.37.949 1.37zm3.217-7.467 1.258 3.738H13.02l1.239-3.738Zm5.784 9.925c-.98-.97-2.148-1.46-3.537-1.46s-2.557.49-3.536 1.46c-.979.98-1.458 2.149-1.458 3.538 0 1.39.489 2.56 1.458 3.539s2.148 1.459 3.536 1.459c1.389 0 2.558-.49 3.537-1.46.968-.969 1.458-2.148 1.458-3.538s-.49-2.558-1.459-3.538Zm-4.596.98c.29-.29.65-.44 1.06-.44.409 0 .768.15 1.058.44s.44.65.44 1.06c0 .409-.15.769-.44 1.059s-.65.44-1.059.44c-.41 0-.769-.15-1.059-.44s-.44-.65-.44-1.06.15-.77.44-1.06Zm2.488 5.197c-.43.24-.91.36-1.419.36-.51 0-.989-.12-1.418-.36q-.645-.36-1.05-.96c.37-.22.76-.38 1.17-.5a5.1 5.1 0 0 1 2.597 0c.42.12.809.28 1.179.5q-.405.6-1.05.96h-.01Z"
    })
  });
};
const PreinquiryConsultant = /*#__PURE__*/forwardRef(Component$1T);

const Component$1S = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M6.626 9.026 8.663 2.27c.14-.45.55-.76 1.02-.76.729 0 1.248.72.998 1.41l-2.637 7.566c-.21.61-.78 1.01-1.428 1.01-.64 0-1.22-.41-1.429-1.02L2.56 2.909A1.06 1.06 0 0 1 3.569 1.5c.47 0 .879.31 1.019.76l2.028 6.756zm9.88 6.477c-1.1 0-1.999.9-1.999 2 0 1.099.9 1.998 1.998 1.998 1.1 0 1.998-.9 1.998-1.999s-.899-1.999-1.998-1.999Zm0-1.499a3.5 3.5 0 0 1 3.496 3.498 3.5 3.5 0 0 1-3.497 3.499 3.5 3.5 0 0 1-3.496-3.499 3.5 3.5 0 0 1 3.496-3.498Zm0-1.5a4.998 4.998 0 0 0 0 9.996 4.998 4.998 0 0 0 0-9.995Zm-5.465-.999c.44 0 .82-.28.959-.69l.46-1.369h3.606l.36 1.06h.08c.678 0 1.328.1 1.947.28.06-.2.07-.43-.01-.65L15.546 2.4c-.2-.54-.709-.89-1.288-.89s-1.09.36-1.29.9l-2.876 7.736c-.25.66.24 1.37.949 1.37v-.01Zm3.217-7.466 1.258 3.738H13.02l1.239-3.738Z"
    })
  });
};
const PreinquiryState = /*#__PURE__*/forwardRef(Component$1S);

const Component$1R = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M6.626 9.026 8.663 2.27c.14-.45.55-.76 1.02-.76.729 0 1.248.72.998 1.41l-2.637 7.566c-.21.61-.78 1.01-1.428 1.01-.64 0-1.22-.41-1.429-1.02L2.56 2.909A1.06 1.06 0 0 1 3.569 1.5c.47 0 .879.31 1.019.76l2.028 6.756zm4.415 2.48c.44 0 .82-.28.959-.69l.46-1.37h3.606l.36 1.06h.08c.678 0 1.328.1 1.947.28.06-.2.07-.43-.01-.65L15.546 2.4c-.2-.54-.709-.89-1.288-.89s-1.09.36-1.29.9l-2.876 7.736c-.25.66.24 1.37.949 1.37zm3.217-7.467 1.258 3.738H13.02l1.239-3.738Zm5.784 9.925c-.98-.97-2.148-1.46-3.537-1.46s-2.557.49-3.536 1.46c-.979.98-1.458 2.149-1.458 3.538 0 1.39.489 2.56 1.458 3.539s2.148 1.459 3.536 1.459c1.389 0 2.558-.49 3.537-1.46.968-.969 1.458-2.148 1.458-3.538s-.49-2.558-1.459-3.538Zm-1.889 5.887-2.147-2.149v-3.198h.999v2.798l1.848 1.85-.7.7Z"
    })
  });
};
const PreinquiryTime = /*#__PURE__*/forwardRef(Component$1R);

const Component$1Q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm0-80h560v-480H200zm280-80q-82 0-146.5-44.5T240-440q29-71 93.5-115.5T480-600t146.5 44.5T720-440q-29 71-93.5 115.5T480-280m0-60q56 0 102-26.5t72-73.5q-26-47-72-73.5T480-540t-102 26.5-72 73.5q26 47 72 73.5T480-340m0-40q25 0 42.5-17.5T540-440t-17.5-42.5T480-500t-42.5 17.5T420-440t17.5 42.5T480-380"
    })
  });
};
const Preview = /*#__PURE__*/forwardRef(Component$1Q);

const Component$1P = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm0-80h560v-480H200zm280-80q-82 0-146.5-44.5T240-440q29-71 93.5-115.5T480-600t146.5 44.5T720-440q-29 71-93.5 115.5T480-280m0-100q-25 0-42.5-17.5T420-440t17.5-42.5T480-500t42.5 17.5T540-440t-17.5 42.5T480-380m0 40q42 0 71-29t29-71-29-71-71-29-71 29-29 71 29 71 71 29"
    })
  });
};
const PreviewFilled = /*#__PURE__*/forwardRef(Component$1P);

const Component$1O = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-120q-33 0-56.5-23.5T400-200t23.5-56.5T480-280t56.5 23.5T560-200t-23.5 56.5T480-120m0-240q-33 0-56.5-23.5T400-440v-320q0-33 23.5-56.5T480-840t56.5 23.5T560-760v320q0 33-23.5 56.5T480-360"
    })
  });
};
const PriorityHigh = /*#__PURE__*/forwardRef(Component$1O);

const Component$1N = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m640-480 80 80v80H520v240l-40 40-40-40v-240H240v-80l80-80v-280h-40v-80h400v80h-40zm-286 80h252l-46-46v-314H400v314zm126 0"
    })
  });
};
const PushPin = /*#__PURE__*/forwardRef(Component$1N);

const Component$1M = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m640-480 80 80v80H520v240l-40 40-40-40v-240H240v-80l80-80v-280h-40v-80h400v80h-40z"
    })
  });
};
const PushPinFilled = /*#__PURE__*/forwardRef(Component$1M);

const Component$1L = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-800v241-1 400zv200zm120 400h80q17 0 28.5-11.5T440-440t-11.5-28.5T400-480h-80q-17 0-28.5 11.5T280-440t11.5 28.5T320-400m0 160h40q17 0 28.5-11.5T400-280t-11.5-28.5T360-320h-40q-17 0-28.5 11.5T280-280t11.5 28.5T320-240M200-80q-33 0-56.5-23.5T120-160v-640q0-33 23.5-56.5T200-880h287q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v28q0 17-11.5 28T720-540t-28.5-11.5T680-580v-20H520q-17 0-28.5-11.5T480-640v-160H200v640h220q17 0 28.5 11.5T460-120t-11.5 28.5T420-80zm460-120q42 0 71-29t29-71-29-71-71-29-71 29-29 71 29 71 71 29M892-68q-11 11-28 11t-28-11l-80-80q-21 14-45.5 21t-50.5 7q-75 0-127.5-52.5T480-300t52.5-127.5T660-480t127.5 52.5T840-300q0 26-7 50.5T812-204l80 80q11 11 11 28t-11 28"
    })
  });
};
const QuickReferenceAll = /*#__PURE__*/forwardRef(Component$1L);

const Component$1K = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M660-200q42 0 71-29t29-71-29-71-71-29-71 29-29 71 29 71 71 29M892-68q-11 11-28 11t-28-11l-80-80q-21 14-45.5 21t-50.5 7q-75 0-127.5-52.5T480-300t52.5-127.5T660-480t127.5 52.5T840-300q0 26-7 50.5T812-204l80 80q11 11 11 28t-11 28M200-80q-33 0-56.5-23.5T120-160v-640q0-33 23.5-56.5T200-880h287q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v18q0 18-14.5 29t-32.5 6q-13-3-26-4.5t-27-1.5q-56 0-104.5 21T472-480H320q-17 0-28.5 11.5T280-440t11.5 28.5T320-400h100q-8 19-12.5 39t-6.5 41h-81q-17 0-28.5 11.5T280-280t11.5 28.5T320-240h87q7 31 21 58.5t34 50.5q14 15 6.5 33T443-80zm280-720v160q0 17 11.5 28.5T520-600h160zl200 200z"
    })
  });
};
const QuickReferenceAllFilled = /*#__PURE__*/forwardRef(Component$1K);

const Component$1J = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M9.9 19q-2.425 0-4.162-1.575T4 13.5q0-2.35 1.738-3.925T9.9 8h6.3l-1.9-1.9q-.275-.275-.275-.7t.275-.7.7-.275.7.275l3.6 3.6q.15.15.213.325.062.175.062.375t-.062.375-.213.325l-3.6 3.6q-.275.275-.7.275t-.7-.275-.275-.7.275-.7l1.9-1.9H9.9q-1.575 0-2.737 1T6 13.5 7.163 16q1.162 1 2.737 1H16q.425 0 .712.288.288.287.288.712t-.288.712Q16.425 19 16 19Z"
    })
  });
};
const Redo = /*#__PURE__*/forwardRef(Component$1J);

const Component$1I = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 20q-3.35 0-5.675-2.325T4 12t2.325-5.675T12 4q1.725 0 3.3.713 1.575.712 2.7 2.037V5q0-.425.288-.713Q18.575 4 19 4t.712.287Q20 4.575 20 5v5q0 .425-.288.712Q19.425 11 19 11h-5q-.425 0-.712-.288Q13 10.425 13 10t.288-.713T14 9h3.2q-.8-1.4-2.187-2.2Q13.625 6 12 6 9.5 6 7.75 7.75T6 12t1.75 4.25T12 18q1.725 0 3.188-.913 1.462-.912 2.187-2.437.125-.275.413-.462.287-.188.587-.188.575 0 .863.4.287.4.062.9-.95 2.125-2.925 3.412Q14.4 20 12 20"
    })
  });
};
const Refresh = /*#__PURE__*/forwardRef(Component$1I);

const Component$1H = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M240-440q-17 0-28.5-11.5T200-480t11.5-28.5T240-520h480q17 0 28.5 11.5T760-480t-11.5 28.5T720-440z"
    })
  });
};
const Remove = /*#__PURE__*/forwardRef(Component$1H);

const Component$1G = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m273-480 116 116q12 12 11.5 28T388-308q-12 11-28 11.5T332-308L148-492q-12-12-12-28t12-28l184-184q11-11 27.5-11t28.5 11q12 12 12 28.5T388-675L273-560h367q83 0 141.5 58.5T840-360v120q0 17-11.5 28.5T800-200t-28.5-11.5T760-240v-120q0-50-35-85t-85-35z"
    })
  });
};
const Reply = /*#__PURE__*/forwardRef(Component$1G);

const Component$1F = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m193-520 156 156q12 12 11.5 28T348-308q-12 11-28 11.5T292-308L108-492q-6-6-8.5-13T97-520t2.5-15 8.5-13l184-184q11-11 27.5-11t28.5 11q12 12 12 28.5T348-675zm240 40 116 116q12 12 11.5 28T548-308q-12 11-28 11.5T492-308L308-492q-6-6-8.5-13t-2.5-15 2.5-15 8.5-13l184-184q11-11 27.5-11t28.5 11q12 12 12 28.5T548-675L433-560h247q83 0 141.5 58.5T880-360v120q0 17-11.5 28.5T840-200t-28.5-11.5T800-240v-120q0-50-35-85t-85-35z"
    })
  });
};
const ReplyAll = /*#__PURE__*/forwardRef(Component$1F);

const Component$1E = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 21q-3.15 0-5.575-1.913Q4 17.175 3.275 14.2a.74.74 0 0 1 .15-.688.97.97 0 0 1 .675-.362 1.1 1.1 0 0 1 .725.15q.325.2.45.6.6 2.25 2.475 3.675T12 19q2.925 0 4.962-2.038Q19.001 14.925 19 12q0-2.925-2.038-4.963Q14.925 5.001 12 5a6.75 6.75 0 0 0-3.225.8A7.4 7.4 0 0 0 6.25 8H8q.424 0 .713.287Q9 8.575 9 9c0 .425-.096.52-.287.713A.97.97 0 0 1 8 10H4a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 9V5a.97.97 0 0 1 .288-.713A.97.97 0 0 1 4 4q.424 0 .713.287Q5 4.575 5 5v1.35a8.7 8.7 0 0 1 3.113-2.475A8.9 8.9 0 0 1 12 3q1.874 0 3.512.712a9.2 9.2 0 0 1 2.85 1.925 9.2 9.2 0 0 1 1.926 2.85A8.7 8.7 0 0 1 21 12q0 1.874-.712 3.512a9.2 9.2 0 0 1-1.925 2.85 9.2 9.2 0 0 1-2.85 1.926A8.7 8.7 0 0 1 12 21"
    })
  });
};
const Reset = /*#__PURE__*/forwardRef(Component$1E);

const Component$1D = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M280-120q-33 0-56.5-23.5T200-200v-520q-17 0-28.5-11.5T160-760t11.5-28.5T200-800h160q0-17 11.5-28.5T400-840h160q17 0 28.5 11.5T600-800h160q17 0 28.5 11.5T800-760t-11.5 28.5T760-720v520q0 33-23.5 56.5T680-120zm400-600H280v520h400zm-400 0v520zm160 234v126q0 17 11.5 28.5T480-320t28.5-11.5T520-360v-126l36 35q11 11 27.5 11t28.5-12q11-11 11-28t-11-28L508-612q-12-12-28-12t-28 12L348-508q-11 11-11.5 27.5T348-452q11 11 27.5 11.5T404-451z"
    })
  });
};
const RestoreFromTrash = /*#__PURE__*/forwardRef(Component$1D);

const Component$1C = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M280-120q-33 0-56.5-23.5T200-200v-520q-17 0-28.5-11.5T160-760t11.5-28.5T200-800h160q0-17 11.5-28.5T400-840h160q17 0 28.5 11.5T600-800h160q17 0 28.5 11.5T800-760t-11.5 28.5T760-720v520q0 33-23.5 56.5T680-120zm160-366v126q0 17 11.5 28.5T480-320t28.5-11.5T520-360v-126l36 35q11 11 27.5 11t28.5-12q11-11 11-28t-11-28L508-612q-12-12-28-12t-28 12L348-508q-11 11-11.5 27.5T348-452q11 11 27.5 11.5T404-451z"
    })
  });
};
const RestoreFromTrashFilled = /*#__PURE__*/forwardRef(Component$1C);

const Component$1B = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M388-530q17-18 41-29t51-11q54 0 92 38t38 92-38 92-92 38q-36 0-65.5-18T368-375q-6-11-17.5-14.5T328-388q-12 5-16.5 17.5T314-347q24 44 68 70.5t98 26.5q78 0 134-56t56-134-56-134-134-56q-38 0-71 14t-59 38v-32q0-13-8.5-21.5T320-640t-21.5 8.5T290-610v110q0 13 8.5 21.5T320-470h110q13 0 21.5-8.5T460-500t-8.5-21.5T430-530zM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h287q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v447q0 33-23.5 56.5T720-80zm0-80h480v-446L526-800H240zm0 0v-640z"
    })
  });
};
const RestorePage = /*#__PURE__*/forwardRef(Component$1B);

const Component$1A = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M388-530q17-18 41-29t51-11q54 0 92 38t38 92-38 92-92 38q-36 0-65.5-18T368-375q-6-11-17.5-14.5T328-388q-12 5-16.5 17.5T314-347q24 44 68 70.5t98 26.5q78 0 134-56t56-134-56-134-134-56q-38 0-71 14t-59 38v-32q0-13-8.5-21.5T320-640t-21.5 8.5T290-610v110q0 13 8.5 21.5T320-470h110q13 0 21.5-8.5T460-500t-8.5-21.5T430-530zM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h287q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v447q0 33-23.5 56.5T720-80z"
    })
  });
};
const RestorePageFilled = /*#__PURE__*/forwardRef(Component$1A);

const Component$1z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M300-368q0 14 12 19t22-5l98-98q12-12 12-28t-12-28l-98-98q-10-10-22-5t-12 19zM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm360-80v-560H200v560z"
    })
  });
};
const RightPanelCloseFilled = /*#__PURE__*/forwardRef(Component$1z);

const Component$1y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M460-368v-224q0-14-12-19t-22 5l-98 98q-12 12-12 28t12 28l98 98q10 10 22 5t12-19M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm360-80v-560H200v560z"
    })
  });
};
const RightPanelOpenFilled = /*#__PURE__*/forwardRef(Component$1y);

const Component$1x = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      d: "M4.18 12.407q-.525 0-.837-.363-.312-.362-.188-.862.15-.625.4-1.212.25-.588.575-1.138.276-.425.738-.475.463-.05.862.325a1 1 0 0 1 .263.538.82.82 0 0 1-.113.612 4.7 4.7 0 0 0-.45.887 9 9 0 0 0-.3.938.95.95 0 0 1-.337.537.94.94 0 0 1-.613.213m5.475 9.725q-.6-.15-1.187-.4a9 9 0 0 1-1.163-.575q-.424-.275-.475-.738t.325-.862a1 1 0 0 1 .538-.262.82.82 0 0 1 .612.112q.426.274.888.45.462.175.937.3.325.076.538.337.212.263.212.613 0 .526-.362.838-.363.312-.863.187m-5.525-4.15a12 12 0 0 1-.575-1.162 8 8 0 0 1-.4-1.188q-.124-.5.188-.862c.312-.362.504-.363.887-.363q.3 0 .563.213.262.212.337.537.126.476.3.938.175.462.45.887a.84.84 0 0 1 .125.6.96.96 0 0 1-.275.55q-.375.375-.85.325a.98.98 0 0 1-.75-.475m9.975 4.125q-.5.125-.862-.175-.363-.3-.363-.825 0-.3.213-.587a.9.9 0 0 1 .537-.363q2.325-.575 3.788-2.45t1.462-4.3q0-2.925-2.037-4.962T11.88 6.407h-.2l.9.9a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-2.6-2.6a.9.9 0 0 1-.212-.325 1.1 1.1 0 0 1-.063-.375q0-.2.063-.375a.9.9 0 0 1 .212-.325l2.6-2.6a.95.95 0 0 1 .7-.275q.426 0 .725.275.275.3.275.725a.95.95 0 0 1-.275.7l-.875.875h.15q3.75 0 6.375 2.625c2.625 2.625 2.625 3.875 2.625 6.375q0 3.1-1.9 5.5t-4.875 3.2"
    }), /*#__PURE__*/jsx("path", {
      d: "M14.555 16.657h1q.412 0 .707-.294a.96.96 0 0 0 .293-.706v-3a.96.96 0 0 0-.293-.706.96.96 0 0 0-.707-.294h-1a.96.96 0 0 0-.706.294.96.96 0 0 0-.294.706v3q0 .412.294.706a.96.96 0 0 0 .706.294m0-4h1v3h-1zm-3.5 4h1q.412 0 .707-.294a.96.96 0 0 0 .293-.706v-.75a.72.72 0 0 0-.218-.531.72.72 0 0 0-.532-.219.72.72 0 0 0 .532-.219.72.72 0 0 0 .218-.531v-.75a.96.96 0 0 0-.293-.706.96.96 0 0 0-.707-.294h-1a.96.96 0 0 0-.706.294.96.96 0 0 0-.294.706v.75a.72.72 0 0 0 .22.531.72.72 0 0 0 .53.219.72.72 0 0 0-.53.219.72.72 0 0 0-.22.531v.75q0 .412.294.706a.96.96 0 0 0 .706.294m0-4h1v1h-1zm0 3v-1h1v1zm-2.75-3v3.5q0 .212.144.356a.48.48 0 0 0 .356.144q.212 0 .357-.144a.48.48 0 0 0 .143-.356v-4a.48.48 0 0 0-.143-.356.48.48 0 0 0-.357-.144h-1a.48.48 0 0 0-.356.144.48.48 0 0 0-.144.356q0 .212.144.356a.48.48 0 0 0 .356.144z"
    })]
  });
};
const Rotate180 = /*#__PURE__*/forwardRef(Component$1x);

const Component$1w = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M172-478q-21 0-33.5-14.5T131-527q6-25 16-48.5t23-45.5q11-17 29.5-19t34.5 13q8 8 10.5 21.5T240-581q-11 17-18 35.5T210-508q-3 13-13.5 21.5T172-478M391-89q-24-6-47.5-16T297-128q-17-11-19-29.5t13-34.5q8-8 21.5-10.5T337-198q17 11 35.5 18t37.5 12q13 3 21.5 13.5T440-130q0 21-14.5 33.5T391-89M170-255q-13-23-23-46.5T131-349q-5-20 7.5-34.5T174-398q12 0 22.5 8.5T210-368q5 19 12 37.5t18 35.5q7 11 5 24t-11 22q-15 15-34 13t-30-19M569-90q-20 5-34.5-7T520-130q0-12 8.5-23.5T550-168q93-23 151.5-98T760-438q0-117-81.5-198.5T480-718h-8l36 36q11 11 11 28t-11 28-28 11-28-11L348-730q-6-6-8.5-13t-2.5-15 2.5-15 8.5-13l104-104q11-11 28-11t29 11q11 12 11 29t-11 28l-35 35h6q150 0 255 105t105 255q0 124-76 220T569-90"
    })
  });
};
const RotateLeft = /*#__PURE__*/forwardRef(Component$1w);

const Component$1v = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M19.75 12.05q-.3 0-.587-.213-.288-.212-.363-.537-.125-.475-.312-.938-.188-.462-.438-.887-.175-.275-.125-.613T18.2 8.3q.375-.35.862-.3.488.05.738.475.325.55.575 1.125t.4 1.2q.125.5-.187.875-.313.375-.838.375m-6.7 8.7q0-.3.213-.587.212-.288.537-.363.475-.125.938-.312.462-.188.887-.438.275-.175.613-.125t.562.275q.35.375.3.862-.05.488-.475.738-.575.325-1.15.563t-1.175.412q-.5.125-.875-.175t-.375-.85m5.15-2.95q-.225-.2-.275-.55t.125-.625q.25-.425.438-.887.187-.463.312-.938.075-.325.35-.538.275-.212.6-.212.55 0 .85.375t.175.875q-.175.6-.412 1.175-.238.575-.563 1.15-.25.425-.738.475-.487.05-.862-.3m-8.375 3.95q-2.975-.8-4.875-3.2t-1.9-5.5q0-3.75 2.625-6.375T12.05 4.05h.15l-.875-.875q-.275-.275-.275-.7t.3-.725q.275-.275.7-.275t.725.275l2.575 2.6q.15.15.212.325.063.175.063.375t-.063.375q-.062.175-.212.325l-2.6 2.6q-.275.275-.7.275t-.7-.275-.275-.7.275-.7l.9-.9h-.2q-2.925 0-4.962 2.038T5.05 13.05q0 2.425 1.475 4.287T10.3 19.8q.325.075.538.35.212.275.212.6 0 .525-.362.825-.363.3-.863.175"
    })
  });
};
const RotateRight = /*#__PURE__*/forwardRef(Component$1v);

const Component$1u = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    fill: "var(--icon-color)",
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m680-264-76 76q-11 11-28 11t-28-11-11-28 11-28l76-76-76-76q-11-11-11-28t11-28 28-11 28 11l76 76 76-76q11-11 28-11t28 11 11 28-11 28l-76 76 76 76q11 11 11 28t-11 28-28 11-28-11zm-26-369 142-142q12-12 28-11.5t28 12.5q11 12 11 28t-11 28L683-548q-12 12-28 12t-28-12l-86-86q-11-11-11-28t11-28 28-11 28 11zM120-360h280q17 0 28.5 11.5T440-320t-11.5 28.5T400-280H120q-17 0-28.5-11.5T80-320t11.5-28.5T120-360m0-320h280q17 0 28.5 11.5T440-640t-11.5 28.5T400-600H120q-17 0-28.5-11.5T80-640t11.5-28.5T120-680"
    })
  });
};
const Rule = /*#__PURE__*/forwardRef(Component$1u);

const Component$1t = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 21q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h11.175q.4 0 .763.15.362.15.637.425l2.85 2.85q.275.275.425.637.15.363.15.763V19q0 .825-.587 1.413Q19.825 21 19 21ZM19 7.85 16.15 5H5v14h14ZM12 18q1.25 0 2.125-.875T15 15t-.875-2.125T12 12t-2.125.875T9 15t.875 2.125T12 18m-5-8h7q.425 0 .713-.288Q15 9.425 15 9V7q0-.425-.287-.713Q14.425 6 14 6H7q-.425 0-.713.287Q6 6.575 6 7v2q0 .425.287.712Q6.575 10 7 10M5 7.85V19 5Z"
    })
  });
};
const Save = /*#__PURE__*/forwardRef(Component$1t);

const Component$1s = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 21q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h11.175q.4 0 .763.15.362.15.637.425l2.85 2.85q.275.275.425.637.15.363.15.763V19q0 .825-.587 1.413Q19.825 21 19 21Zm7-3q1.25 0 2.125-.875T15 15t-.875-2.125T12 12t-2.125.875T9 15t.875 2.125T12 18m-5-8h7q.425 0 .713-.288Q15 9.425 15 9V7q0-.425-.287-.713Q14.425 6 14 6H7q-.425 0-.713.287Q6 6.575 6 7v2q0 .425.287.712Q6.575 10 7 10"
    })
  });
};
const SaveFilled = /*#__PURE__*/forwardRef(Component$1s);

const Component$1r = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M237-120q-23 0-44.5-16T164-175q-25-84-41-145.5t-25.5-108T84-511t-4-69q0-92 64-156t156-64h200q27-36 68.5-58t91.5-22q25 0 42.5 17.5T720-820q0 6-1.5 12t-3.5 11q-4 11-7.5 22t-5.5 24l91 91h47q17 0 28.5 11.5T880-620v210q0 13-7.5 23T852-372l-85 28-50 167q-8 26-29 41.5T640-120h-80q-33 0-56.5-23.5T480-200h-80q0 33-23.5 56.5T320-120zm3-80h80v-80h240v80h80l62-206 98-33v-141h-40L620-720q0-20 2.5-39t7.5-37q-29 8-51 27.5T547-720H300q-58 0-99 41t-41 99q0 41 21 140.5T240-200m400-320q17 0 28.5-11.5T680-560t-11.5-28.5T640-600t-28.5 11.5T600-560t11.5 28.5T640-520m-160-80q17 0 28.5-11.5T520-640t-11.5-28.5T480-680H360q-17 0-28.5 11.5T320-640t11.5 28.5T360-600zm0 102"
    })
  });
};
const Savings = /*#__PURE__*/forwardRef(Component$1r);

const Component$1q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M237-120q-23 0-44.5-16T164-175q-25-84-41-145.5t-25.5-108T84-511t-4-69q0-92 64-156t156-64h200q27-36 68.5-58t91.5-22q25 0 42.5 17.5T720-820q0 6-1.5 12t-3.5 11q-4 11-7.5 22t-5.5 24l91 91h47q17 0 28.5 11.5T880-620v210q0 13-7.5 23T852-372l-85 28-50 167q-8 26-29 41.5T640-120h-80q-33 0-56.5-23.5T480-200h-80q0 33-23.5 56.5T320-120zm403-400q17 0 28.5-11.5T680-560t-11.5-28.5T640-600t-28.5 11.5T600-560t11.5 28.5T640-520m-160-80q17 0 28.5-11.5T520-640t-11.5-28.5T480-680H360q-17 0-28.5 11.5T320-640t11.5 28.5T360-600z"
    })
  });
};
const SavingsFilled = /*#__PURE__*/forwardRef(Component$1q);

const Component$1p = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M240-800v200zv640-9.5 9.5zm0 720q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h287q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v141q-19-7-39-10.5t-41-3.5v-120H600q-33 0-56.5-23.5T520-680v-120H240v640h254q8 23 20 43t28 37zm480-103-56 55q-11 11-27.5 11.5T608-128q-11-11-11-28t11-28l56-56-56-56q-11-11-11-28t11-28 28-11 28 11l56 56 56-56q11-11 27.5-11.5T832-352q11 11 11 28t-11 28l-55 56 55 56q11 11 11.5 27.5T832-128q-11 11-28 11t-28-11z"
    })
  });
};
const ScanDelete = /*#__PURE__*/forwardRef(Component$1p);

const Component$1o = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M720-600 520-800v120q0 33 23.5 56.5T600-600zm0 417-56 55q-11 11-27.5 11.5T608-128q-11-11-11-28t11-28l56-56-56-56q-11-11-11-28t11-28 28-11 28 11l56 56 56-56q11-11 27.5-11.5T832-352q11 11 11 28t-11 28l-55 56 55 56q11 11 11.5 27.5T832-128q-11 11-28 11t-28-11zM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h287q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v141q-19-7-39.5-10.5T719-480q-100 0-169.5 69.5T480-241q0 45 16 86.5T542-80z"
    })
  });
};
const ScanDeleteFilled = /*#__PURE__*/forwardRef(Component$1o);

const Component$1n = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M520-496v-144q0-17-11.5-28.5T480-680t-28.5 11.5T440-640v159q0 8 3 15.5t9 13.5l132 132q11 11 28 11t28-11 11-28-11-28zM480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q133 0 226.5-93.5T800-480t-93.5-226.5T480-800t-226.5 93.5T160-480t93.5 226.5T480-160"
    })
  });
};
const Schedule = /*#__PURE__*/forwardRef(Component$1n);

const Component$1m = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M520-496v-144q0-17-11.5-28.5T480-680t-28.5 11.5T440-640v159q0 8 3 15.5t9 13.5l132 132q11 11 28 11t28-11 11-28-11-28zM480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80"
    })
  });
};
const ScheduleFilled = /*#__PURE__*/forwardRef(Component$1m);

const Component$1l = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M440-520h80v56q0 7 6 9.5t11-2.5l89-89q6-6 6-14t-6-14l-89-89q-5-5-11-2.5t-6 9.5v56h-80q-50 0-85 35t-35 85v40q0 17 11.5 28.5T360-400t28.5-11.5T400-440v-40q0-17 11.5-28.5T440-520M80-120q-17 0-28.5-11.5T40-160t11.5-28.5T80-200h800q17 0 28.5 11.5T920-160t-11.5 28.5T880-120zm80-120q-33 0-56.5-23.5T80-320v-440q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v440q0 33-23.5 56.5T800-240zm0-80h640v-440H160zm0 0v-440z"
    })
  });
};
const ScreenShare = /*#__PURE__*/forwardRef(Component$1l);

const Component$1k = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M440-520h80v56q0 7 6 9.5t11-2.5l89-89q6-6 6-14t-6-14l-89-89q-5-5-11-2.5t-6 9.5v56h-80q-50 0-85 35t-35 85v40q0 17 11.5 28.5T360-400t28.5-11.5T400-440v-40q0-17 11.5-28.5T440-520M80-120q-17 0-28.5-11.5T40-160t11.5-28.5T80-200h800q17 0 28.5 11.5T920-160t-11.5 28.5T880-120zm80-120q-33 0-56.5-23.5T80-320v-440q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v440q0 33-23.5 56.5T800-240z"
    })
  });
};
const ScreenShareFilled = /*#__PURE__*/forwardRef(Component$1k);

const Component$1j = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M380-320q-109 0-184.5-75.5T120-580t75.5-184.5T380-840t184.5 75.5T640-580q0 44-14 83t-38 69l224 224q11 11 11 28t-11 28-28 11-28-11L532-372q-30 24-69 38t-83 14m0-80q75 0 127.5-52.5T560-580t-52.5-127.5T380-760t-127.5 52.5T200-580t52.5 127.5T380-400"
    })
  });
};
const Search = /*#__PURE__*/forwardRef(Component$1j);

const Component$1i = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M3 5q0-.825.587-1.413Q4.175 3 5 3v2Zm0 8v-2h2v2Zm4 8v-2h2v2ZM3 9V7h2v2Zm8-4V3h2v2Zm8 0V3q.825 0 1.413.587Q21 4.175 21 5ZM5 21q-.825 0-1.413-.587Q3 19.825 3 19h2Zm-2-4v-2h2v2ZM7 5V3h2v2Zm4 16v-2h2v2Zm8-8v-2h2v2Zm0 8v-2h2q0 .825-.587 1.413Q19.825 21 19 21m0-12V7h2v2Zm0 8v-2h2v2Zm-4 4v-2h2v2Zm0-16V3h2v2ZM8 17q-.425 0-.713-.288Q7 16.425 7 16V8q0-.425.287-.713Q7.575 7 8 7h8q.425 0 .712.287Q17 7.575 17 8v8q0 .425-.288.712Q16.425 17 16 17Zm1-2h6V9H9Z"
    })
  });
};
const SelectAll = /*#__PURE__*/forwardRef(Component$1i);

const Component$1h = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M3 18.5v-13q0-.55.45-.838t.95-.087l15.4 6.5q.625.275.625.925t-.625.925l-15.4 6.5q-.5.2-.95-.088Q3 19.05 3 18.5M5 17l11.85-5L5 7v3.5l6 1.5-6 1.5Zm0-5V7v10Z"
    })
  });
};
const Send = /*#__PURE__*/forwardRef(Component$1h);

const Component$1g = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M4.4 19.425q-.5.2-.95-.088Q3 19.05 3 18.5v-3.725q0-.35.2-.625t.55-.35L11 12l-7.25-1.8q-.35-.075-.55-.35T3 9.225V5.5q0-.55.45-.838t.95-.087l15.4 6.5q.625.275.625.925t-.625.925Z"
    })
  });
};
const SendFilled = /*#__PURE__*/forwardRef(Component$1g);

const Component$1f = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-420q-54 0-101.5 23.5T302-328q-11 16-3 32t26 16q8 0 14.5-3.5T351-294q23-31 57-48.5t72-17.5 72 17.5 57 48.5q4 7 10.5 10.5T634-280q18 0 26-16.5t-3-33.5q-29-44-76.5-67T480-420m140-100q25 0 42.5-17.5T680-580t-17.5-42.5T620-640t-42.5 17.5T560-580t17.5 42.5T620-520m-280 0q25 0 42.5-17.5T400-580t-17.5-42.5T340-640t-42.5 17.5T280-580t17.5 42.5T340-520M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93"
    })
  });
};
const SentimentDissatisfied = /*#__PURE__*/forwardRef(Component$1f);

const Component$1e = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M620-520q25 0 42.5-17.5T680-580t-17.5-42.5T620-640t-42.5 17.5T560-580t17.5 42.5T620-520m-280 0q25 0 42.5-17.5T400-580t-17.5-42.5T340-640t-42.5 17.5T280-580t17.5 42.5T340-520m50 180h180q13 0 21.5-8.5T600-370t-8.5-21.5T570-400H390q-13 0-21.5 8.5T360-370t8.5 21.5T390-340m90 260q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93"
    })
  });
};
const SentimentNeutral = /*#__PURE__*/forwardRef(Component$1e);

const Component$1d = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-260q53 0 100.5-23t76.5-67q11-17 3-33.5T634-400q-8 0-14.5 3.5T609-386q-23 31-57 48.5T480-320t-72-17.5-57-48.5q-5-7-11.5-10.5T325-400q-18 0-26 16t3 32q29 45 76.5 68.5T480-260m140-260q25 0 42.5-17.5T680-580t-17.5-42.5T620-640t-42.5 17.5T560-580t17.5 42.5T620-520m-280 0q25 0 42.5-17.5T400-580t-17.5-42.5T340-640t-42.5 17.5T280-580t17.5 42.5T340-520M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93"
    })
  });
};
const SentimentSatisfied = /*#__PURE__*/forwardRef(Component$1d);

const Component$1c = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-260q58 0 107-28t79-76q6-12-1-24t-21-12H316q-14 0-21 12t-1 24q30 48 79.5 76T480-260M356-562l21 21q9 9 21 9t21-9 8.5-21-8.5-21l-35-36q-12-12-28.5-12T327-619l-36 36q-9 9-9 21t9 21q8 8 20.5 8.5T333-540zm248 0 23 22q9 8 21 8t21-9 9-21-9-21l-36-36q-12-12-28.5-12T576-619l-36 36q-8 9-8 21t9 21 21 9 21-9zM480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93"
    })
  });
};
const SentimentVerySatisfied = /*#__PURE__*/forwardRef(Component$1c);

const Component$1b = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M13.875 22h-3.75q-.375 0-.65-.25t-.325-.625l-.3-2.325q-.325-.125-.612-.3-.288-.175-.563-.375l-2.175.9q-.35.125-.7.025t-.55-.425L2.4 15.4q-.2-.325-.125-.7t.375-.6l1.875-1.425Q4.5 12.5 4.5 12.337v-.675q0-.162.025-.337L2.65 9.9q-.3-.225-.375-.6t.125-.7l1.85-3.225q.175-.35.537-.438.363-.087.713.038l2.175.9q.275-.2.575-.375t.6-.3l.3-2.325q.05-.375.325-.625t.65-.25h3.75q.375 0 .65.25t.325.625l.3 2.325q.325.125.613.3.287.175.562.375l2.175-.9q.35-.125.7-.025t.55.425L21.6 8.6q.2.325.125.7t-.375.6l-1.875 1.425q.025.175.025.337v.675q0 .163-.05.338l1.875 1.425q.3.225.375.6t-.125.7l-1.85 3.2q-.2.325-.562.438t-.713-.013l-2.125-.9q-.275.2-.575.375t-.6.3l-.3 2.325q-.05.375-.325.625t-.65.25m-1.825-6.5q1.45 0 2.475-1.025T15.55 12t-1.025-2.475T12.05 8.5q-1.475 0-2.488 1.025T8.55 12t1.012 2.475Q10.575 15.5 12.05 15.5m0-2q-.625 0-1.062-.438-.438-.437-.438-1.062t.438-1.062q.437-.438 1.062-.438t1.063.438q.437.437.437 1.062t-.437 1.062q-.438.438-1.063.438M11 20h1.975l.35-2.65q.775-.2 1.438-.588t1.212-.937l2.475 1.025.975-1.7-2.15-1.625q.125-.35.175-.738.05-.387.05-.787t-.05-.788-.175-.737l2.15-1.625-.975-1.7-2.475 1.05q-.55-.575-1.212-.963-.663-.387-1.438-.587L13 4h-1.975l-.35 2.65q-.775.2-1.437.587-.663.388-1.213.938L5.55 7.15l-.975 1.7 2.15 1.6q-.125.375-.175.75t-.05.8q0 .4.05.775t.175.75l-2.15 1.625.975 1.7 2.475-1.05q.55.575 1.213.962.662.388 1.437.588Z"
    })
  });
};
const Settings = /*#__PURE__*/forwardRef(Component$1b);

const Component$1a = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m723-260-57 58q-6 6-6 14t6 14 14 6 14-6l78-78q12-12 12-28t-12-28l-78-78q-6-6-14-6t-14 6-6 14 6 14l58 58H580q-8 0-14 6t-6 14 6 14 14 6zM680-80q-83 0-141.5-58.5T480-280t58.5-141.5T680-480t141.5 58.5T880-280t-58.5 141.5T680-80m-257 0q-27 0-41.5-18T363-142l-9-66q-13-5-24.5-12T307-235l-62 26q-25 11-50 2t-39-32l-47-82q-14-23-8-49t27-43l53-40q-1-7-1-13.5v-27q0-6.5 1-13.5l-53-40q-21-17-27-43t8-49l47-82q14-23 39-32t50 2l62 26q11-8 23-15t24-12l9-66q4-26 23.5-44t46.5-18h94q27 0 46.5 18t23.5 44l9 66q13 5 24.5 12t22.5 15l62-26q25-11 50-2t39 32l47 82q14 23 8 49t-27 43l-24 18q-13 11-29 8.5T752-536t-9-29 15-27l19-14-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q17 17 36.5 30.5T400-275q1 44 14.5 83.5T451-119q8 12-1 25.5T423-80m59-540q-58 0-99 40.5T342-480q0 21 6 41t18 38q11 15 28.5 19t31.5-7q14-10 16.5-26.5T434-444q-6-8-9-16.5t-3-19.5q0-25 17.5-42.5T482-540q10 0 19.5 3.5T519-527q12 9 27 6.5t25-16.5 6.5-31-17.5-28q-14-12-34-18t-44-6"
    })
  });
};
const SettingsBRoll = /*#__PURE__*/forwardRef(Component$1a);

const Component$19 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m723-260-57 58q-6 6-6 14t6 14 14 6 14-6l78-78q12-12 12-28t-12-28l-78-78q-6-6-14-6t-14 6-6 14 6 14l58 58H580q-8 0-14 6t-6 14 6 14 14 6zM680-80q-83 0-141.5-58.5T480-280t58.5-141.5T680-480t141.5 58.5T880-280t-58.5 141.5T680-80m-257 0q-24 0-40-18.5T363-142l-9-66q-13-5-24.5-12T307-235l-62 26q-25 11-50 2t-39-32l-47-82q-14-23-8-49t27-43l53-40q-1-7-1-13.5v-27q0-6.5 1-13.5l-53-40q-21-17-27-43t8-49l47-82q14-23 39-32t50 2l62 26q11-8 22.5-15t24.5-12l9-66q4-26 24-44t46-18h94q26 0 46 18t24 44l9 66q13 5 24.5 12t22.5 15l62-26q25-11 50-2t39 32l47 82q14 23 8 49t-27 43l-8 6q-8 6-17 6.5t-18-3.5q-21-9-42.5-14.5T702-559q-25-2-49.5 2t-49.5 7q-19-32-51-51t-70-19q-58 0-99 41t-41 99q0 38 19 70.5t52 51.5q-7 20-10 41t-3 42q0 42 13.5 81.5T451-119q8 12-1 25.5T423-80"
    })
  });
};
const SettingsBRollFilled = /*#__PURE__*/forwardRef(Component$19);

const Component$18 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M13.875 22h-3.75q-.375 0-.65-.25t-.325-.625l-.3-2.325q-.325-.125-.612-.3-.288-.175-.563-.375l-2.175.9q-.35.125-.7.025t-.55-.425L2.4 15.4q-.2-.325-.125-.7t.375-.6l1.875-1.425Q4.5 12.5 4.5 12.337v-.675q0-.162.025-.337L2.65 9.9q-.3-.225-.375-.6t.125-.7l1.85-3.225q.175-.35.537-.438.363-.087.713.038l2.175.9q.275-.2.575-.375t.6-.3l.3-2.325q.05-.375.325-.625t.65-.25h3.75q.375 0 .65.25t.325.625l.3 2.325q.325.125.613.3.287.175.562.375l2.175-.9q.35-.125.7-.025t.55.425L21.6 8.6q.2.325.125.7t-.375.6l-1.875 1.425q.025.175.025.337v.675q0 .163-.05.338l1.875 1.425q.3.225.375.6t-.125.7l-1.85 3.2q-.2.325-.562.438t-.713-.013l-2.125-.9q-.275.2-.575.375t-.6.3l-.3 2.325q-.05.375-.325.625t-.65.25m-1.825-6.5q1.45 0 2.475-1.025T15.55 12t-1.025-2.475T12.05 8.5q-1.475 0-2.488 1.025T8.55 12t1.012 2.475Q10.575 15.5 12.05 15.5"
    })
  });
};
const SettingsFilled = /*#__PURE__*/forwardRef(Component$18);

const Component$17 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M720-80q-50 0-85-35t-35-85q0-7 1-14.5t3-13.5L322-392q-17 15-38 23.5t-44 8.5q-50 0-85-35t-35-85 35-85 85-35q23 0 44 8.5t38 23.5l282-164q-2-6-3-13.5t-1-14.5q0-50 35-85t85-35 85 35 35 85-35 85-85 35q-23 0-44-8.5T638-672L356-508q2 6 3 13.5t1 14.5-1 14.5-3 13.5l282 164q17-15 38-23.5t44-8.5q50 0 85 35t35 85-35 85-85 35m0-640q17 0 28.5-11.5T760-760t-11.5-28.5T720-800t-28.5 11.5T680-760t11.5 28.5T720-720M240-440q17 0 28.5-11.5T280-480t-11.5-28.5T240-520t-28.5 11.5T200-480t11.5 28.5T240-440m480 280q17 0 28.5-11.5T760-200t-11.5-28.5T720-240t-28.5 11.5T680-200t11.5 28.5T720-160m0-40"
    })
  });
};
const Share = /*#__PURE__*/forwardRef(Component$17);

const Component$16 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M720-80q-50 0-85-35t-35-85q0-7 1-14.5t3-13.5L322-392q-17 15-38 23.5t-44 8.5q-50 0-85-35t-35-85 35-85 85-35q23 0 44 8.5t38 23.5l282-164q-2-6-3-13.5t-1-14.5q0-50 35-85t85-35 85 35 35 85-35 85-85 35q-23 0-44-8.5T638-672L356-508q2 6 3 13.5t1 14.5-1 14.5-3 13.5l282 164q17-15 38-23.5t44-8.5q50 0 85 35t35 85-35 85-85 35"
    })
  });
};
const ShareFilled = /*#__PURE__*/forwardRef(Component$16);

const Component$15 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 21.875a2 2 0 0 1-.625-.1Q8 20.65 6 17.613t-2-6.538V6.35q0-.625.362-1.125.363-.5.938-.725l6-2.25a2.1 2.1 0 0 1 .7-.125q.35 0 .7.125l6 2.25q.575.225.938.725.362.5.362 1.125v4.725q0 3.5-2 6.538-2 3.037-5.375 4.162a2 2 0 0 1-.625.1m0-2q2.6-.825 4.3-3.3c1.7-2.475 1.7-3.483 1.7-5.5V6.35L12 4.1 6 6.35v4.725q0 3.025 1.7 5.5c1.7 2.475 2.567 2.75 4.3 3.3"
    })
  });
};
const Shield = /*#__PURE__*/forwardRef(Component$15);

const Component$14 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 21.875a2 2 0 0 1-.625-.1Q8 20.65 6 17.613t-2-6.538V6.35q0-.625.362-1.125.363-.5.938-.725l6-2.25a2.1 2.1 0 0 1 .7-.125q.35 0 .7.125l6 2.25q.575.225.938.725.362.5.362 1.125v4.725q0 3.5-2 6.538-2 3.037-5.375 4.162a2 2 0 0 1-.625.1"
    })
  });
};
const ShieldFilled = /*#__PURE__*/forwardRef(Component$14);

const Component$13 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M6 22c-.5 0-1-.2-1.4-.6S4 20.5 4 20V4c0-.5.2-1 .6-1.4S5.5 2 6 2h7.2c.3 0 .5.1.8.1.2.1.5.2.6.4l4.9 4.9c.2.2.3.4.4.6.1.3.1.6.1.8v1.4c0 .3-.1.5-.3.7s-.4.3-.7.3-.5-.1-.7-.3-.3-.4-.3-.7V9h-4c-.3 0-.5-.1-.7-.3S13 8.3 13 8V4H6v16h5c.3 0 .5.1.7.3s.3.4.3.7-.1.5-.3.7-.4.3-.7.3zm10.5 1.2c-.1 0-.3 0-.4-.1-.1 0-.3-.1-.4-.2L14 21.2c-.5-.6-.9-1.1-1.2-1.6s-.6-1-.8-1.5-.3-1-.3-1.4c0-1.5.5-2.7 1.4-3.5 1-.9 2.1-1.3 3.3-1.3s2.4.4 3.3 1.3c1 .9 1.4 2.1 1.4 3.5 0 .4-.1.9-.3 1.4s-.4 1-.8 1.5c-.3.5-.7 1.1-1.2 1.6-.5.6-1.1 1.1-1.7 1.7-.1.1-.2.2-.4.2.1.1 0 .1-.2.1m.2-5.7c.3 0 .6-.1.8-.3s.3-.5.3-.8-.1-.6-.3-.8-.5-.3-.8-.3-.6.1-.8.3-.3.5-.3.8.1.6.3.8.4.3.8.3"
    })
  });
};
const SiteMap = /*#__PURE__*/forwardRef(Component$13);

const Component$12 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M4 15q-1.25 0-2.125-.875T1 12t.875-2.125T4 9V7q0-.825.588-1.412Q5.175 5 6 5h3q0-1.25.875-2.125T12 2t2.125.875T15 5h3q.825 0 1.413.588Q20 6.175 20 7v2q1.25 0 2.125.875T23 12t-.875 2.125T20 15v4q0 .825-.587 1.413Q18.825 21 18 21H6q-.825 0-1.412-.587Q4 19.825 4 19Zm5-2q.625 0 1.062-.438.438-.437.438-1.062t-.438-1.062Q9.625 10 9 10t-1.062.438Q7.5 10.875 7.5 11.5t.438 1.062Q8.375 13 9 13m6 0q.625 0 1.062-.438.438-.437.438-1.062t-.438-1.062Q15.625 10 15 10t-1.062.438q-.438.437-.438 1.062t.438 1.062Q14.375 13 15 13m-6 4h6q.425 0 .713-.288Q16 16.425 16 16t-.287-.713T15 15H9q-.425 0-.712.287Q8 15.575 8 16t.288.712T9 17m-3 2h12V7H6Zm0 0V7z"
    })
  });
};
const SmartToy = /*#__PURE__*/forwardRef(Component$12);

const Component$11 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M4 15q-1.25 0-2.125-.875T1 12t.875-2.125T4 9V7q0-.825.588-1.412Q5.175 5 6 5h3q0-1.25.875-2.125T12 2t2.125.875T15 5h3q.825 0 1.413.588Q20 6.175 20 7v2q1.25 0 2.125.875T23 12t-.875 2.125T20 15v4q0 .825-.587 1.413Q18.825 21 18 21H6q-.825 0-1.412-.587Q4 19.825 4 19Zm5-2q.625 0 1.062-.438.438-.437.438-1.062t-.438-1.062Q9.625 10 9 10t-1.062.438Q7.5 10.875 7.5 11.5t.438 1.062Q8.375 13 9 13m6 0q.625 0 1.062-.438.438-.437.438-1.062t-.438-1.062Q15.625 10 15 10t-1.062.438q-.438.437-.438 1.062t.438 1.062Q14.375 13 15 13m-6 4h6q.425 0 .713-.288Q16 16.425 16 16t-.287-.713T15 15H9q-.425 0-.712.287Q8 15.575 8 16t.288.712T9 17"
    })
  });
};
const SmartToyFilled = /*#__PURE__*/forwardRef(Component$11);

const Component$10 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M8 11q.425 0 .713-.288Q9 10.425 9 10t-.287-.713T8 9t-.713.287Q7 9.575 7 10t.287.712Q7.575 11 8 11m4 0q.425 0 .713-.288Q13 10.425 13 10t-.287-.713T12 9t-.712.287Q11 9.575 11 10t.288.712T12 11m4 0q.425 0 .712-.288Q17 10.425 17 10t-.288-.713Q16.425 9 16 9t-.712.287Q15 9.575 15 10t.288.712T16 11M2 19.575V4q0-.825.588-1.413Q3.175 2 4 2h16q.825 0 1.413.587Q22 3.175 22 4v12q0 .825-.587 1.413Q20.825 18 20 18H6l-2.3 2.3q-.475.475-1.088.212Q2 20.25 2 19.575m2-2.4L5.175 16H20V4H4ZM4 4v13.175Z"
    })
  });
};
const Sms = /*#__PURE__*/forwardRef(Component$10);

const Component$$ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M8 11q.425 0 .713-.288Q9 10.425 9 10t-.287-.713T8 9t-.713.287Q7 9.575 7 10t.287.712Q7.575 11 8 11m4 0q.425 0 .713-.288Q13 10.425 13 10t-.287-.713T12 9t-.712.287Q11 9.575 11 10t.288.712T12 11m4 0q.425 0 .712-.288Q17 10.425 17 10t-.288-.713Q16.425 9 16 9t-.712.287Q15 9.575 15 10t.288.712T16 11M2 19.575V4q0-.825.588-1.413Q3.175 2 4 2h16q.825 0 1.413.587Q22 3.175 22 4v12q0 .825-.587 1.413Q20.825 18 20 18H6l-2.3 2.3q-.475.475-1.088.212Q2 20.25 2 19.575"
    })
  });
};
const SmsFilled = /*#__PURE__*/forwardRef(Component$$);

const Component$_ = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M160-240q-17 0-28.5-11.5T120-280t11.5-28.5T160-320h160q17 0 28.5 11.5T360-280t-11.5 28.5T320-240zm0-200q-17 0-28.5-11.5T120-480t11.5-28.5T160-520h400q17 0 28.5 11.5T600-480t-11.5 28.5T560-440zm0-200q-17 0-28.5-11.5T120-680t11.5-28.5T160-720h640q17 0 28.5 11.5T840-680t-11.5 28.5T800-640z"
    })
  });
};
const Sort = /*#__PURE__*/forwardRef(Component$_);

const Component$Z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97zm126 18L314-169q-11 7-23 6t-21-8-14-17.5-2-23.5l44-189-147-127q-10-9-12.5-20.5T140-571t12-18 22-9l194-17 75-178q5-12 15.5-18t21.5-6 21.5 6 15.5 18l75 178 194 17q14 2 22 9t12 18 1.5 22.5T809-528L662-401l44 189q3 13-2 23.5T690-171t-21 8-23-6zm0-201"
    })
  });
};
const Star = /*#__PURE__*/forwardRef(Component$Z);

const Component$Y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-269 314-169q-11 7-23 6t-21-8-14-17.5-2-23.5l44-189-147-127q-10-9-12.5-20.5T140-571t12-18 22-9l194-17 75-178q5-12 15.5-18t21.5-6 21.5 6 15.5 18l75 178 194 17q14 2 22 9t12 18 1.5 22.5T809-528L662-401l44 189q3 13-2 23.5T690-171t-21 8-23-6z"
    })
  });
};
const StarFilled = /*#__PURE__*/forwardRef(Component$Y);

const Component$X = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m-.28-13.51v2.29c0 .12.18.24.36.24s.36-.12.36-.24V6.49c0-.12-.18-.24-.36-.24s-.36.12-.36.24M16.3 7.7l-1.63 1.63c-.06.12-.06.24.06.42s.36.12.48.06l1.63-1.63c.12-.06.06-.3-.06-.42s-.42-.18-.48-.06m1.39 3.8h-1.57c-.12 0-.18.18-.18.36s.06.36.18.36h1.57c.12 0 .18-.18.18-.36s-.06-.36-.18-.36m-.9 3.68-1.09-1.09c-.06-.06-.24 0-.36.12s-.18.3-.12.36l1.15 1.09c.06.06.24 0 .36-.12s.18-.24.06-.36M8.05 11.5H6.48c-.12 0-.18.18-.18.36s.06.36.18.36h1.57c.12 0 .18-.18.18-.36s-.06-.36-.18-.36m.42 2.59-1.09 1.09c-.06.06 0 .24.12.36s.3.18.36.12l1.09-1.09c.06-.06 0-.24-.12-.36s-.3-.18-.36-.12M7.32 8.18l1.63 1.63c.06.06.24.06.42-.12s.18-.3.12-.42L7.86 7.7c-.12-.12-.3-.06-.42.06s-.18.36-.12.42m7.24 4.4c0-1.39-1.15-2.53-2.53-2.53S9.5 11.2 9.5 12.58c0 .78.36 1.45.9 1.93v1.21c0 .12.06.24.18.24h2.83c.12 0 .24-.12.24-.24v-1.21c.6-.42.9-1.15.9-1.93zm-1.45 4.1h-2.17c-.12 0-.24.12-.24.3s.12.3.24.3h2.17c.12 0 .24-.12.24-.3-.06-.18-.12-.3-.24-.3m-.18 1.09h-1.81l.48.48c.05.06.19.08.24.08h.34s.18.01.27-.09l.48-.48z"
    })
  });
};
const StateIdea = /*#__PURE__*/forwardRef(Component$X);

const Component$W = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-.28 4.49c0-.12.18-.24.36-.24s.36.12.36.24v2.29c0 .12-.18.24-.36.24s-.36-.12-.36-.24zm-5.43 5.37c0-.18.06-.36.18-.36h1.57c.12 0 .18.18.18.36s-.06.36-.18.36H6.47c-.12 0-.18-.18-.18-.36m2.65 2.71-1.09 1.09c-.06.06-.24 0-.36-.12s-.18-.3-.12-.36l1.09-1.09c.06-.06.24 0 .36.12s.18.3.12.36m0-4.76L7.31 8.18c-.06-.06 0-.3.12-.42s.3-.18.42-.06l1.63 1.57c.06.12.06.24-.12.42s-.36.18-.42.12m3.5 8.44c-.09.1-.27.09-.27.09h-.34c-.05 0-.19-.03-.24-.08l-.48-.48h1.81l-.48.48zm.66-.96h-2.17c-.12 0-.24-.12-.24-.3s.12-.3.24-.3h2.17c.12 0 .18.12.24.3 0 .18-.12.3-.24.3m.54-2.77v1.21c0 .12-.12.24-.24.24h-2.83c-.12 0-.18-.12-.18-.24v-1.21c-.54-.48-.9-1.15-.9-1.93 0-1.39 1.15-2.53 2.53-2.53s2.53 1.15 2.53 2.53c0 .78-.3 1.51-.9 1.93zm1.08-4.76c-.12-.18-.12-.3-.06-.42l1.63-1.63c.06-.12.36-.06.48.06s.18.36.06.42L15.2 9.82c-.12.06-.36.12-.48-.06m1.99 5.79c-.12.12-.3.18-.36.12l-1.15-1.09c-.06-.06 0-.24.12-.36s.3-.18.36-.12l1.09 1.09c.12.12.06.24-.06.36m.96-3.32H16.1c-.12 0-.18-.18-.18-.36s.06-.36.18-.36h1.57c.12 0 .18.18.18.36s-.06.36-.18.36"
    })
  });
};
const StateIdeaFilled = /*#__PURE__*/forwardRef(Component$W);

const Component$V = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M7.78 17.11c-.23.09-.45.07-.65-.06-.21-.13-.31-.32-.31-.58v-3.1l5.51-1.38-5.51-1.38v-3.1c0-.25.1-.44.31-.58.21-.13.42-.15.65-.06l10.61 4.48c.29.13.43.34.43.64s-.14.51-.43.64z"
    })
  });
};
const StateSend = /*#__PURE__*/forwardRef(Component$V);

const Component$U = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m6.39 10.64L7.78 17.12c-.23.09-.45.07-.65-.06-.21-.13-.31-.32-.31-.58v-3.1L12.33 12l-5.51-1.38v-3.1c0-.25.1-.44.31-.58s.42-.15.65-.06l10.61 4.48c.29.13.43.34.43.64s-.14.51-.43.64"
    })
  });
};
const StateSendFilled = /*#__PURE__*/forwardRef(Component$U);

const Component$T = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M8.67 16.53H6.84v-6.11h1.83zm9.17-4.47c0 .07 0 .13-.02.18-.01.06-.03.11-.06.17l-1.52 3.55c-.08.17-.19.31-.34.41q-.225.15-.51.15H9.58v-6.11l3.67-3.67.41.28c.15.11.27.25.34.42s.09.34.04.52l-.48 2.44h3.36c.25 0 .47.09.65.27s.27.39.27.65z"
    })
  });
};
const StateThumb = /*#__PURE__*/forwardRef(Component$T);

const Component$S = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M8.67 16.53H6.84v-6.11h1.83zm9.17-4.47c0 .07 0 .13-.02.18-.01.06-.03.11-.06.17l-1.52 3.55c-.08.17-.19.31-.34.41q-.225.15-.51.15H9.58v-6.11l3.67-3.67.41.28c.15.11.27.25.34.42s.09.34.04.52l-.48 2.44h3.36c.25 0 .47.09.65.27s.27.39.27.65z"
    })
  });
};
const StateThumbFilled = /*#__PURE__*/forwardRef(Component$S);

const Component$R = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-200h360v-160q0-17 11.5-28.5T600-400h160v-360H200zm0 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v367q0 16-6 30.5T817-337L623-143q-11 11-25.5 17t-30.5 6zm240-280H320q-17 0-28.5-11.5T280-440t11.5-28.5T320-480h120q17 0 28.5 11.5T480-440t-11.5 28.5T440-400m200-160H320q-17 0-28.5-11.5T280-600t11.5-28.5T320-640h320q17 0 28.5 11.5T680-600t-11.5 28.5T640-560M200-200v-560z"
    })
  });
};
const StickyNote2 = /*#__PURE__*/forwardRef(Component$R);

const Component$Q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m560-200 200-200H600q-17 0-28.5 11.5T560-360zm-360 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v367q0 16-6 30.5T817-337L623-143q-11 11-25.5 17t-30.5 6zm120-280h120q17 0 28.5-11.5T480-440t-11.5-28.5T440-480H320q-17 0-28.5 11.5T280-440t11.5 28.5T320-400m0-160h320q17 0 28.5-11.5T680-600t-11.5-28.5T640-640H320q-17 0-28.5 11.5T280-600t11.5 28.5T320-560"
    })
  });
};
const StickyNote2Filled = /*#__PURE__*/forwardRef(Component$Q);

const Component$P = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M360-320h240q17 0 28.5-11.5T640-360v-240q0-17-11.5-28.5T600-640H360q-17 0-28.5 11.5T320-600v240q0 17 11.5 28.5T360-320M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-320"
    })
  });
};
const StopCircle = /*#__PURE__*/forwardRef(Component$P);

const Component$O = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M577-497 474-600h46v-56q0-7 6-9.5t11 2.5l89 89q6 6 6 14t-6 14zm251 251-74-74h46v-440H314l-80-80h566q33 0 56.5 23.5T880-760v440q0 26-14.5 45.5T828-246M728-120H80q-17 0-28.5-11.5T40-160t11.5-28.5T80-200h567l-40-40H160q-33 0-56.5-23.5T80-320v-446l-25-26q-11-12-11-28t12-28q11-11 28-11t28 11l736 736q11 11 11 28t-11 28-28 11-28-11zM400-446v6q0 17-11.5 28.5T360-400t-28.5-11.5T320-440v-40q0-11 1-21t6-19L160-687v367h366zm-57-58"
    })
  });
};
const StopScreenShare = /*#__PURE__*/forwardRef(Component$O);

const Component$N = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M728-120H80q-17 0-28.5-11.5T40-160t11.5-28.5T80-200h567l-40-40H160q-33 0-56.5-23.5T80-320v-446l-25-26q-11-12-11-28t12-28q11-11 28-11t28 11l736 736q11 11 11 28t-11 28-28 11-28-11zM400-446l-73-74q-5 9-6 19t-1 21v40q0 17 11.5 28.5T360-400t28.5-11.5T400-440zm428 200L577-497l49-49q6-6 6-14t-6-14l-89-89q-5-5-11-2.5t-6 9.5v56h-46L234-840h566q33 0 56.5 23.5T880-760v440q0 26-14.5 45.5T828-246"
    })
  });
};
const StopScreenShareFilled = /*#__PURE__*/forwardRef(Component$N);

const Component$M = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M486-160q-65 0-117-32.5T285-284q-9-17-2-36t27-27q17-8 34.5-1t28.5 25q18 30 47.5 48.5T488-256q42 0 76-20t34-64q0-18-7-33t-19-27h112q5 14 7.5 28.5T694-340q0 86-61.5 133T486-160M120-480q-17 0-28.5-11.5T80-520t11.5-28.5T120-560h720q17 0 28.5 11.5T880-520t-11.5 28.5T840-480zm170-160q2-69 54.5-117.5T482-806q54 0 97 21.5t72 66.5q11 17 4 36t-27 28q-15 7-32.5 1.5T564-675q-13-15-33-25t-47-10q-41 0-68 18.5T386-640z"
    })
  });
};
const StrikethroughS = /*#__PURE__*/forwardRef(Component$M);

const Component$L = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m233-320 75 75q11 11 11 27.5T308-189q-12 12-28.5 12T251-189L108-332q-6-6-8.5-13T97-360t2.5-15 8.5-13l144-144q12-12 28-11.5t28 12.5q11 12 11.5 28T308-475l-75 75h247q17 0 28.5 11.5T520-360t-11.5 28.5T480-320zm494-240H480q-17 0-28.5-11.5T440-600t11.5-28.5T480-640h247l-75-75q-11-11-11-27.5t11-28.5q12-12 28.5-12t28.5 12l143 143q6 6 8.5 13t2.5 15-2.5 15-8.5 13L708-428q-12 12-28 11.5T652-429q-11-12-11.5-28t11.5-28z"
    })
  });
};
const SwapHoriz = /*#__PURE__*/forwardRef(Component$L);

const Component$K = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 25",
    children: [/*#__PURE__*/jsx("path", {
      d: "M15.375 8.576 12 5.201 8.625 8.576zm1.925-.2q.475.476.212 1.088-.262.612-.937.612h-9.15q-.675 0-.938-.612-.262-.613.213-1.088l4.6-4.6q.15-.15.325-.212Q11.8 3.5 12 3.5t.375.063a.9.9 0 0 1 .325.212z"
    }), /*#__PURE__*/jsx("path", {
      fill: "var(--icon-accent-color)",
      d: "m8.622 15.574 3.376 3.375 3.375-3.375zm-1.925.2c-.356-.317-.332-.68-.212-1.088.144-.492.447-.612.937-.612h9.15q.675 0 .938.612.262.613-.213 1.088l-4.6 4.6q-.15.15-.324.212a1.1 1.1 0 0 1-.375.063q-.201 0-.375-.063a.9.9 0 0 1-.325-.212z"
    })]
  });
};
const Switch = /*#__PURE__*/forwardRef(Component$K);

const Component$J = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 25",
    children: [/*#__PURE__*/jsx("path", {
      d: "m11.3 3.775-4.6 4.6q-.475.476-.212 1.088.262.612.937.612h9.15q.674 0 .938-.612.262-.613-.213-1.088l-4.6-4.6a.9.9 0 0 0-.325-.212A1.1 1.1 0 0 0 12 3.5q-.2 0-.375.063a.9.9 0 0 0-.325.212"
    }), /*#__PURE__*/jsx("path", {
      fill: "var(--icon-accent-color)",
      d: "m12.7 20.375 4.6-4.6q.475-.476.212-1.088-.262-.612-.937-.612h-9.15q-.675 0-.938.612-.262.613.213 1.088l4.6 4.6q.15.15.325.212.175.063.375.063t.375-.063a.9.9 0 0 0 .325-.212"
    })]
  });
};
const SwitchFilled = /*#__PURE__*/forwardRef(Component$J);

const Component$I = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m620-345 135-135-135-135zm8 77q-19 19-43.5 8.5T560-297v-366q0-27 24.5-37.5T628-692l184 184q6 6 8.5 13t2.5 15-2.5 15-8.5 13zm-296 0L148-452q-6-6-8.5-13t-2.5-15 2.5-15 8.5-13l184-184q19-19 43.5-8.5T400-663v366q0 27-24.5 37.5T332-268"
    })
  });
};
const SwitchLeft = /*#__PURE__*/forwardRef(Component$I);

const Component$H = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block",
      "transform": "rotate(90deg)"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m620-345 135-135-135-135zm8 77q-19 19-43.5 8.5T560-297v-366q0-27 24.5-37.5T628-692l184 184q6 6 8.5 13t2.5 15-2.5 15-8.5 13zm-296 0L148-452q-6-6-8.5-13t-2.5-15 2.5-15 8.5-13l184-184q19-19 43.5-8.5T400-663v366q0 27-24.5 37.5T332-268"
    })
  });
};
const SwitchUp = /*#__PURE__*/forwardRef(Component$H);

const Component$G = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block",
      "transform": "rotate(270deg)"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "m620-345 135-135-135-135zm8 77q-19 19-43.5 8.5T560-297v-366q0-27 24.5-37.5T628-692l184 184q6 6 8.5 13t2.5 15-2.5 15-8.5 13zm-296 0L148-452q-6-6-8.5-13t-2.5-15 2.5-15 8.5-13l184-184q19-19 43.5-8.5T400-663v366q0 27-24.5 37.5T332-268"
    })
  });
};
const SwitchDown = /*#__PURE__*/forwardRef(Component$G);

const Component$F = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M340-345v-270L205-480zm-8 77L148-452q-6-6-8.5-13t-2.5-15 2.5-15 8.5-13l184-184q19-19 43.5-8.5T400-663v366q0 27-24.5 37.5T332-268m296 0q-19 19-43.5 8.5T560-297v-366q0-27 24.5-37.5T628-692l184 184q6 6 8.5 13t2.5 15-2.5 15-8.5 13z"
    })
  });
};
const SwitchRight = /*#__PURE__*/forwardRef(Component$F);

const Component$E = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M15.375 19.25q-.525.25-.95-.038-.425-.287-.425-.937 0-.25.163-.487.162-.238.412-.363 1.575-.75 2.5-2.225T18 11.95q0-1.125-.425-2.188Q17.15 8.7 16.25 7.8L16 7.55V9q0 .425-.287.712Q15.425 10 15 10t-.712-.288T14 9V5q0-.425.288-.713Q14.575 4 15 4h4q.425 0 .712.287Q20 4.575 20 5t-.288.713Q19.425 6 19 6h-1.75l.4.35q1.225 1.225 1.788 2.662Q20 10.45 20 11.95q0 2.4-1.25 4.362t-3.375 2.938M5 20q-.425 0-.713-.288Q4 19.425 4 19t.287-.712Q4.575 18 5 18h1.75l-.4-.35q-1.225-1.225-1.788-2.662Q4 13.55 4 12.05q0-2.4 1.25-4.363Q6.5 5.725 8.625 4.75q.525-.25.95.037.425.288.425.938 0 .25-.162.487-.163.238-.413.363-1.575.75-2.5 2.225T6 12.05q0 1.125.425 2.187Q6.85 15.3 7.75 16.2l.25.25V15q0-.425.288-.713Q8.575 14 9 14t.713.287T10 15v4q0 .425-.287.712Q9.425 20 9 20Z"
    })
  });
};
const Sync = /*#__PURE__*/forwardRef(Component$E);

const Component$D = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-280q-17 0-28.5-11.5T440-320t11.5-28.5T480-360t28.5 11.5T520-320t-11.5 28.5T480-280m0-160q-17 0-28.5-11.5T440-480v-160q0-17 11.5-28.5T480-680t28.5 11.5T520-640v160q0 17-11.5 28.5T480-440m-280-40q0 54 21.5 99.5T280-302v-58q0-17 11.5-28.5T320-400t28.5 11.5T360-360v160q0 17-11.5 28.5T320-160H160q-17 0-28.5-11.5T120-200t11.5-28.5T160-240h69q-51-44-80-106t-29-134q0-94 49-170t128-116q14-8 29.5-1t20.5 23-1.5 31-20.5 23q-56 31-90.5 86.5T200-480m560 0q0-54-21.5-99.5T680-658v58q0 17-11.5 28.5T640-560t-28.5-11.5T600-600v-160q0-17 11.5-28.5T640-800h160q17 0 28.5 11.5T840-760t-11.5 28.5T800-720h-69q51 44 80 106t29 134q0 94-49 170.5T663-193q-14 8-29.5.5T613-216t1.5-31 20.5-23q56-31 90.5-86.5T760-480"
    })
  });
};
const SyncProblem = /*#__PURE__*/forwardRef(Component$D);

const Component$C = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M19 19v-3H5v3zm0-5v-4H5v4zm0-6V5H5v3zM5 21q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h14q.825 0 1.413.587Q21 4.175 21 5v14q0 .825-.587 1.413Q19.825 21 19 21Z"
    })
  });
};
const TableRows = /*#__PURE__*/forwardRef(Component$C);

const Component$B = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M21 6.625q0 .425-.288.713-.287.287-.712.287H4q-.425 0-.712-.287Q3 7.05 3 6.625V4q0-.425.288-.713Q3.575 3 4 3h16q.425 0 .712.287Q21 3.575 21 4Zm0 6.725q0 .425-.288.712-.287.288-.712.288H4q-.425 0-.712-.288Q3 13.775 3 13.35v-2.725q0-.425.288-.713.287-.287.712-.287h16q.425 0 .712.287.288.288.288.713ZM21 20q0 .425-.288.712Q20.425 21 20 21H4q-.425 0-.712-.288Q3 20.425 3 20v-2.65q0-.425.288-.712.287-.288.712-.288h16q.425 0 .712.288.288.287.288.712Z"
    })
  });
};
const TableRowsFilled = /*#__PURE__*/forwardRef(Component$B);

const Component$A = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.5 22c-.6 0-1-.2-1.4-.6s-.6-.9-.6-1.4V6c0-.6.2-1 .6-1.4S3.9 4 4.5 4h4.2c.2-.6.6-1.1 1.1-1.5.5-.3 1.1-.5 1.7-.5s1.2.2 1.7.5c.5.4.9.9 1.1 1.5h4.2c.5 0 1 .2 1.4.6s.6.8.6 1.4v6.7c-.6-.3-1.3-.5-2-.6V6h-14v14h6.1c.1.7.3 1.4.6 2zm7-16.7a.73.73 0 0 0 .75-.75.73.73 0 0 0-.75-.75.73.73 0 0 0-.75.75.73.73 0 0 0 .75.75",
      clipRule: "evenodd"
    }), /*#__PURE__*/jsx("path", {
      d: "M15.5 12c.2 0 .4.1.5.2-1.3.2-2.5.9-3.4 1.8H7.5c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3zm-8 4h3.7c-.3.6-.5 1.3-.6 2H7.5c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3m8-6c.3 0 .5-.1.7-.3s.3-.4.3-.7-.1-.5-.3-.7-.4-.3-.7-.3h-8c-.3 0-.5.1-.7.3s-.3.4-.3.7.1.5.3.7.4.3.7.3zm1.1 9.8 3.6-3.5c.2-.2.5-.3.8-.3s.5.1.7.3.3.4.3.7-.1.5-.3.7l-4.3 4.2c-.2.2-.4.3-.7.3s-.5-.1-.7-.3l-2.2-2.1c-.2-.2-.3-.4-.3-.7s.1-.5.3-.7.4-.3.7-.3.5.1.7.3z"
    })]
  });
};
const TaskDone = /*#__PURE__*/forwardRef(Component$A);

const Component$z = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.5 22h6.7q-.45-.75-.6-1.5c0-.189-.022-.422-.046-.669-.026-.275-.054-.567-.054-.831v-.5c0-.1.025-.175.05-.25a.7.7 0 0 0 .05-.25H7.5c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3h3.7c.086-.345.321-.69.513-.97l.087-.13c.2-.3.5-.6.8-.9H7.5c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3h9v.1c.2-.1.3-.1.5-.1h.5c.5 0 1 .1 1.5.2s1 .3 1.5.5V6c0-.6-.2-1-.6-1.4S19 4 18.5 4h-4.2c-.2-.6-.6-1.1-1.1-1.5-.5-.3-1.1-.5-1.7-.5s-1.2.2-1.7.5c-.5.4-.9.9-1.1 1.5H4.5c-.6 0-1 .2-1.4.6s-.6.8-.6 1.4v14c0 .5.2 1 .6 1.4s.8.6 1.4.6m11-12h-8c-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3h8c.3 0 .5.1.7.3s.3.4.3.7-.1.5-.3.7-.4.3-.7.3m-4-4.7a.73.73 0 0 0 .75-.75.73.73 0 0 0-.75-.75.73.73 0 0 0-.75.75.73.73 0 0 0 .75.75",
      clipRule: "evenodd"
    }), /*#__PURE__*/jsx("path", {
      d: "m16.6 19.8 3.6-3.5c.2-.2.4-.3.8-.3.3 0 .5.1.7.3s.3.4.3.7-.1.5-.3.7l-4.3 4.2c-.2.2-.4.3-.7.3s-.5-.1-.7-.3l-2.2-2.1c-.2-.2-.3-.4-.3-.7s.1-.5.3-.7.4-.3.7-.3.5.1.7.3z"
    })]
  });
};
const TaskDoneFilled = /*#__PURE__*/forwardRef(Component$z);

const Component$y = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.48 22c-.496 0-.99-.2-1.386-.6S2.5 20.5 2.5 20V6c0-.6.198-1 .594-1.4S3.885 4 4.479 4h4.156c.198-.6.594-1.1 1.089-1.4a2.67 2.67 0 0 1 1.682-.6c.753 0 1.139.153 1.72.553.594.409.95.847 1.147 1.447h4.06c.495 0 1.087.141 1.482.541.396.4.594.9.594 1.4l.02 4.675c-.127-.107-.314-.116-.413-.116-.297 0-.495.1-.693.3l-.99 1V6H4.48v14h6.927v1.5c0 .2 0 .3.1.4.049 0 .098.025.148.05a.35.35 0 0 0 .148.05zm7.55-16.913a.72.72 0 0 1-.532.213.72.72 0 0 1-.532-.213.73.73 0 0 1-.21-.537q0-.325.21-.538a.72.72 0 0 1 .532-.212q.322 0 .532.212c.21.212.21.321.21.538a.73.73 0 0 1-.21.537",
      clipRule: "evenodd"
    }), /*#__PURE__*/jsx("path", {
      d: "M13.088 16.3c.199.2.297.3.297.5L12.1 18H7.448c-.297 0-.495-.1-.693-.3s-.297-.4-.297-.7.1-.5.297-.7c.198-.2.396-.3.693-.3h4.948c.297 0 .495.1.692.3m2.277-2.3c.296 0 .494-.1.692-.3s.297-.4.297-.7-.099-.5-.297-.7-.395-.3-.692-.3H7.448c-.297 0-.495.1-.693.3s-.297.4-.297.7.1.5.297.7c.198.2.396.3.693.3zm-7.917-4h7.917c.296 0 .494-.1.692-.3s.297-.4.297-.7-.099-.5-.297-.7-.395-.3-.692-.3H7.448c-.297 0-.495.1-.693.3s-.297.4-.297.7.1.5.297.7c.198.2.396.3.693.3m5.64 12c-.197 0-.296 0-.395-.1s-.1-.3-.1-.4v-1.2c0-.1 0-.3.1-.4 0-.1.099-.2.198-.3l4.75-4.9 2.177 2.1-4.85 4.9a.5.5 0 0 1-.148.1.5.5 0 0 0-.148.1c-.1.1-.297.1-.396.1zm5.344-8 2.078 2.1.693-.7c.198-.2.297-.4.297-.7s-.099-.5-.297-.7l-.693-.7c-.198-.2-.395-.3-.692-.3s-.495.1-.693.3z"
    })]
  });
};
const TaskEdit = /*#__PURE__*/forwardRef(Component$y);

const Component$x = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsxs("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M4.48 22c-.496 0-.99-.2-1.386-.6S2.5 20.5 2.5 20V6c0-.6.198-1 .594-1.4S3.885 4 4.479 4h4.156c.297-.6.597-.994 1.188-1.4.575-.395.985-.6 1.682-.6.698 0 1.118.19 1.682.6.561.406.891.8 1.089 1.4h4.156c.495 0 .99.2 1.386.6s.593.9.593 1.4v4.6c-.198-.1-.296-.1-.395-.1-.297 0-.495.1-.693.3l-7.719 7.8-.198.8v2.1c0 .2 0 .3.1.4.049 0 .098.025.148.05a.35.35 0 0 0 .148.05zm2.275-4.3c.198.2.396.3.693.3h2.375c.297 0 .495-.1.693-.3s.296-.4.296-.7-.098-.5-.296-.7-.396-.3-.693-.3H7.448c-.297 0-.495.1-.693.3s-.297.4-.297.7.1.5.297.7m.693-3.7h5.64c.297 0 .594-.1.693-.3.198-.2.297-.4.297-.7s-.099-.5-.297-.7-.396-.3-.693-.3h-5.64c-.297 0-.495.1-.693.3s-.297.4-.297.7.1.5.297.7c.198.2.396.3.693.3m0-4h7.917c.296 0 .593-.1.692-.3.198-.2.297-.4.297-.7s-.099-.5-.297-.7-.395-.3-.692-.3H7.448c-.297 0-.495.1-.693.3s-.297.4-.297.7.1.5.297.7c.198.2.495.3.693.3M11.5 5.3a.73.73 0 0 0 .75-.75.73.73 0 0 0-.75-.75.73.73 0 0 0-.75.75.73.73 0 0 0 .75.75",
      clipRule: "evenodd"
    }), /*#__PURE__*/jsx("path", {
      d: "M13.188 22c-.198 0-.297 0-.396-.1s-.198-.3-.1-.4v-1.2c0-.1 0-.3.1-.4 0-.1.099-.2.198-.3l4.75-4.9 2.177 2.1-4.85 4.9a.5.5 0 0 1-.148.1.5.5 0 0 0-.148.1c-.1.1-.297.1-.396.1zm5.244-8 2.078 2.1.693-.7c.198-.2.297-.4.297-.7s-.099-.5-.297-.7l-.693-.7c-.198-.2-.395-.3-.692-.3s-.495.1-.693.3z"
    })]
  });
};
const TaskEditFilled = /*#__PURE__*/forwardRef(Component$x);

const Component$w = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M106-200q-27 0-40-18t-3-44l170-452q8-19 27.5-32.5T301-760q20 0 39 13.5t27 32.5l169 451q10 26-2.5 44.5T492-200q-11 0-22-7.5T455-226l-42-117H187l-41 116q-4 11-15.5 19t-24.5 8m110-224h168l-82-232h-4zm424-16q-17 0-28.5-11.5T600-480t11.5-28.5T640-520h240q17 0 28.5 11.5T920-480t-11.5 28.5T880-440z"
    })
  });
};
const TextDecrease = /*#__PURE__*/forwardRef(Component$w);

const Component$v = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M106-200q-27 0-40-18t-3-44l170-452q8-19 27.5-32.5T301-760q20 0 39 13.5t27 32.5l169 451q10 26-2.5 44.5T492-200q-11 0-22-7.5T455-226l-42-117H187l-41 116q-4 11-15.5 19t-24.5 8m110-224h168l-82-232h-4zm544 104q-17 0-28.5-11.5T720-360v-80h-80q-17 0-28.5-11.5T600-480t11.5-28.5T640-520h80v-80q0-17 11.5-28.5T760-640t28.5 11.5T800-600v80h80q17 0 28.5 11.5T920-480t-11.5 28.5T880-440h-80v80q0 17-11.5 28.5T760-320"
    })
  });
};
const TextIncrease = /*#__PURE__*/forwardRef(Component$v);

const Component$u = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M280-120v-520l240-238q15-15 35.5-17.5T595-888t28 28 4 37l-45 183h258q32 0 56 24t24 56v80q0 7-2 15t-4 15L794-168q-9 20-30 34t-44 14zm80-486v406h360l120-280v-80H480l54-220zM160-120q-33 0-56.5-23.5T80-200v-360q0-33 23.5-56.5T160-640h120v80H160v360h120v80zm200-80v-406z"
    })
  });
};
const ThumbUp = /*#__PURE__*/forwardRef(Component$u);

const Component$t = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M400-120q-33 0-56.5-23.5T320-200v-407q0-16 6.5-30.5T344-663l217-216q15-14 35.5-17t39.5 7 27.5 28 3.5 37l-45 184h218q32 0 56 24t24 56v80q0 7-1.5 15t-4.5 15L794-168q-9 20-30 34t-44 14zm-240 0q-33 0-56.5-23.5T80-200v-360q0-33 23.5-56.5T160-640t56.5 23.5T240-560v360q0 33-23.5 56.5T160-120"
    })
  });
};
const ThumbUpFilled = /*#__PURE__*/forwardRef(Component$t);

const Component$s = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-160q-25 0-42.5-17.5T420-220v-460H260q-25 0-42.5-17.5T200-740t17.5-42.5T260-800h440q25 0 42.5 17.5T760-740t-17.5 42.5T700-680H540v460q0 25-17.5 42.5T480-160"
    })
  });
};
const Title = /*#__PURE__*/forwardRef(Component$s);

const Component$r = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M160-120q-33 0-56.5-23.5T80-200v-440q0-33 23.5-56.5T160-720h160v-80q0-33 23.5-56.5T400-880h160q33 0 56.5 23.5T640-800v80h160q33 0 56.5 23.5T880-640v440q0 33-23.5 56.5T800-120zm240-600h160v-80H400zm-160 80h-80v440h80zm400 440v-440H320v440zm80-440v440h80v-440zM480-420"
    })
  });
};
const Trip = /*#__PURE__*/forwardRef(Component$r);

const Component$q = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M720-120v-600h80q33 0 56.5 23.5T880-640v440q0 33-23.5 56.5T800-120zM400-720h160v-80H400zm-80 600v-680q0-33 23.5-56.5T400-880h160q33 0 56.5 23.5T640-800v680zm-160 0q-33 0-56.5-23.5T80-200v-440q0-33 23.5-56.5T160-720h80v600z"
    })
  });
};
const TripFilled = /*#__PURE__*/forwardRef(Component$q);

const Component$p = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M8.29 20.5c7.547 0 11.675-6.541 11.675-12.213 0-.186 0-.371-.012-.555A8.6 8.6 0 0 0 22 5.51a7.9 7.9 0 0 1-2.357.675 4.28 4.28 0 0 0 1.804-2.374c-.805.5-1.686.853-2.605 1.042a4.06 4.06 0 0 0-2.328-1.296 3.95 3.95 0 0 0-2.602.451 4.22 4.22 0 0 0-1.803 2.014 4.48 4.48 0 0 0-.26 2.746 11.25 11.25 0 0 1-4.684-1.302 11.8 11.8 0 0 1-3.773-3.183 4.47 4.47 0 0 0-.45 3.128 4.3 4.3 0 0 0 1.72 2.602A3.94 3.94 0 0 1 2.8 9.476v.054c0 .991.328 1.952.928 2.719a4.08 4.08 0 0 0 2.364 1.49 3.9 3.9 0 0 1-1.853.073 4.3 4.3 0 0 0 1.46 2.133 4 4 0 0 0 2.374.848 8 8 0 0 1-5.096 1.84q-.49 0-.977-.061a11.25 11.25 0 0 0 6.29 1.925"
    })
  });
};
const TwitterFilled = /*#__PURE__*/forwardRef(Component$p);

const Component$o = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 21q-.825 0-1.413-.587Q3 19.825 3 19V6.5q0-.35.125-.663.125-.312.325-.587l1.4-1.7q.2-.275.5-.413T6 3h12q.35 0 .65.137.3.138.5.413l1.4 1.7q.2.275.325.587Q21 6.15 21 6.5V19q0 .825-.587 1.413Q19.825 21 19 21Zm.4-15h13.2l-.85-1H6.25ZM5 19h14V8H5zm7-2q.425 0 .713-.288Q13 16.425 13 16v-3.2l.9.9q.275.275.7.275t.7-.275.275-.7-.275-.7l-2.6-2.6q-.15-.15-.325-.213-.175-.062-.375-.062t-.375.062q-.175.063-.325.213l-2.6 2.6q-.275.275-.275.7t.275.7.7.275.7-.275l.9-.9V16q0 .425.288.712.287.288.712.288m-7 2V8z"
    })
  });
};
const Unarchive = /*#__PURE__*/forwardRef(Component$o);

const Component$n = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5 21q-.825 0-1.413-.587Q3 19.825 3 19V6.5q0-.35.125-.663.125-.312.325-.587l1.4-1.7q.2-.275.5-.413T6 3h12q.35 0 .65.137.3.138.5.413l1.4 1.7q.2.275.325.587Q21 6.15 21 6.5V19q0 .825-.587 1.413Q19.825 21 19 21Zm.4-15h13.2l-.85-1H6.25ZM12 17q.425 0 .713-.288Q13 16.425 13 16v-3.2l.9.9q.275.275.7.275t.7-.275.275-.7-.275-.7l-2.6-2.6q-.15-.15-.325-.213-.175-.062-.375-.062t-.375.062q-.175.063-.325.213l-2.6 2.6q-.275.275-.275.7t.275.7.7.275.7-.275l.9-.9V16q0 .425.288.712.287.288.712.288"
    })
  });
};
const UnarchiveFilled = /*#__PURE__*/forwardRef(Component$n);

const Component$m = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M8 19q-.425 0-.713-.288Q7 18.425 7 18t.287-.712Q7.575 17 8 17h6.1q1.575 0 2.737-1T18 13.5 16.837 11q-1.162-1-2.737-1H7.8l1.9 1.9q.275.275.275.7t-.275.7-.7.275-.7-.275L4.7 9.7q-.15-.15-.213-.325Q4.425 9.2 4.425 9t.062-.375T4.7 8.3l3.6-3.6q.275-.275.7-.275t.7.275.275.7-.275.7L7.8 8h6.3q2.425 0 4.163 1.575Q20 11.15 20 13.5t-1.737 3.925T14.1 19Z"
    })
  });
};
const Undo = /*#__PURE__*/forwardRef(Component$m);

const Component$l = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-581q-8 0-15.5-3t-12.5-8L328-716q-11-11-11-28t11-28 28-11 28 11l96 96 96-96q11-11 28-11t28 11 11 28-11 28L508-592q-6 6-13 8.5t-15 2.5M328-188q-11-11-11-28t11-28l124-124q6-6 13-8.5t15-2.5 15.5 2.5T508-368l125 125q11 11 10.5 27.5T632-188t-28 11-28-11l-96-96-96 96q-11 11-28 11t-28-11"
    })
  });
};
const UnfoldLess = /*#__PURE__*/forwardRef(Component$l);

const Component$k = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M8.225 8.325Q7.95 8.05 7.95 7.6t.275-.725L11.3 3.8q.15-.15.325-.213.175-.062.375-.062t.388.062q.187.063.312.213l3.1 3.1q.275.275.262.712-.012.438-.287.713t-.725.275-.725-.275L12 6 9.65 8.35q-.275.275-.712.263-.438-.013-.713-.288M12 20.575q-.2 0-.375-.075t-.325-.2l-3.075-3.075q-.275-.275-.275-.725t.275-.725.725-.275.725.275L12 18.1l2.35-2.35q.275-.275.712-.262.438.012.713.287t.275.725-.275.725L12.7 20.3q-.125.125-.312.2-.188.075-.388.075"
    })
  });
};
const UnfoldMore = /*#__PURE__*/forwardRef(Component$k);

const Component$j = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480q0-62 17-117.5T146-701l-91-91q-12-12-12-28.5T55-849t28.5-12 28.5 12l736 736q12 12 12 28t-12 28-28.5 12T791-57l-90-89q-48 32-103.5 49T480-80m0-80q45 0 85.5-12t76.5-33L487-360l-35 35q-12 12-28.5 12T395-325L282-438q-11-11-11-28t11-28 28-11 28 11l86 86 7-8-226-226q-21 36-33 76.5T160-480q0 133 93.5 226.5T480-160m335-100-59-59q21-35 32.5-75.5T800-480q0-133-93.5-226.5T480-800q-45 0-85.5 11.5T319-756l-59-59q48-31 103.5-48T480-880q83 0 156 31.5T763-763t85.5 127T880-480q0 61-17 116.5T815-260M602-474l-56-56 76-76q11-11 28-11t28 11 11 28-11 28zm-178 50"
    })
  });
};
const Unpublished = /*#__PURE__*/forwardRef(Component$j);

const Component$i = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480q0-62 17-117.5T146-701l-91-91q-12-12-12-28.5T55-849t28.5-12 28.5 12l736 736q12 12 12 28t-12 28-28.5 12T791-57l-90-89q-48 32-103.5 49T480-80m335-180L602-474l76-76q11-11 11-28t-11-28q-12-12-28.5-12T622-606l-76 77-286-286q48-31 103.5-48T480-880q83 0 156 31.5T763-763t85.5 127T880-480q0 61-17 116.5T815-260M282-438l114 114q12 12 28 12t28-12l36-36-56-56-8 8-86-86q-11-11-28-11t-28 11-11 28 11 28"
    })
  });
};
const UnpublishedFilled = /*#__PURE__*/forwardRef(Component$i);

const Component$h = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 16q-.425 0-.712-.288Q11 15.425 11 15V7.85L9.125 9.725q-.3.3-.7.3T7.7 9.7q-.3-.3-.287-.713.012-.412.287-.687l3.6-3.6q.15-.15.325-.213.175-.062.375-.062t.375.062.325.213l3.6 3.6q.3.3.287.712-.012.413-.287.688-.3.3-.712.312-.413.013-.713-.287L13 7.85V15q0 .425-.287.712Q12.425 16 12 16m-6 4q-.825 0-1.412-.587Q4 18.825 4 18v-2q0-.425.287-.713Q4.575 15 5 15t.713.287Q6 15.575 6 16v2h12v-2q0-.425.288-.713Q18.575 15 19 15t.712.287Q20 15.575 20 16v2q0 .825-.587 1.413Q18.825 20 18 20Z"
    })
  });
};
const Upload = /*#__PURE__*/forwardRef(Component$h);

const Component$g = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M440-367v127q0 17 11.5 28.5T480-200t28.5-11.5T520-240v-127l36 36q6 6 13.5 9t15 2.5T599-323t13-9q11-12 11.5-28T612-388L508-492q-6-6-13-8.5t-15-2.5-15 2.5-13 8.5L348-388q-12 12-11.5 28t12.5 28q12 11 28 11.5t28-11.5zM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h287q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v447q0 33-23.5 56.5T720-80zm280-560v-160H240v640h480v-440H560q-17 0-28.5-11.5T520-640M240-800v200zv640z"
    })
  });
};
const UploadFile = /*#__PURE__*/forwardRef(Component$g);

const Component$f = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M440-367v127q0 17 11.5 28.5T480-200t28.5-11.5T520-240v-127l36 36q6 6 13.5 9t15 2.5T599-323t13-9q11-12 11.5-28T612-388L508-492q-6-6-13-8.5t-15-2.5-15 2.5-13 8.5L348-388q-12 12-11.5 28t12.5 28q12 11 28 11.5t28-11.5zM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h287q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v447q0 33-23.5 56.5T720-80zm280-560q0 17 11.5 28.5T560-600h160L520-800z"
    })
  });
};
const UploadFileFilled = /*#__PURE__*/forwardRef(Component$f);

const Component$e = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-520q-33 0-56.5-23.5T120-600v-160q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v160q0 33-23.5 56.5T760-520zm0-80h560v-160H200zm0 480q-33 0-56.5-23.5T120-200v-160q0-33 23.5-56.5T200-440h560q33 0 56.5 23.5T840-360v160q0 33-23.5 56.5T760-120zm0-80h560v-160H200zm0-560v160zm0 400v160z"
    })
  });
};
const ViewAgenda = /*#__PURE__*/forwardRef(Component$e);

const Component$d = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 -960 960 960",
    children: /*#__PURE__*/jsx("path", {
      d: "M200-520q-33 0-56.5-23.5T120-600v-160q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v160q0 33-23.5 56.5T760-520zm0 400q-33 0-56.5-23.5T120-200v-160q0-33 23.5-56.5T200-440h560q33 0 56.5 23.5T840-360v160q0 33-23.5 56.5T760-120z"
    })
  });
};
const ViewAgendaFilled = /*#__PURE__*/forwardRef(Component$d);

const Component$c = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M4.975 15q-.425 0-.7-.288Q4 14.425 4 14t.287-.713Q4.575 13 5 13h14.025q.425 0 .7.287.275.288.275.713t-.288.712Q19.425 15 19 15Zm0 4q-.425 0-.7-.288Q4 18.425 4 18t.287-.712Q4.575 17 5 17h14.025q.425 0 .7.288.275.287.275.712t-.288.712Q19.425 19 19 19Zm0-8q-.425 0-.7-.288Q4 10.425 4 10t.287-.713Q4.575 9 5 9h14.025q.425 0 .7.287Q20 9.575 20 10t-.288.712Q19.425 11 19 11Zm0-4q-.425 0-.7-.287Q4 6.425 4 6t.287-.713Q4.575 5 5 5h14.025q.425 0 .7.287Q20 5.575 20 6t-.288.713Q19.425 7 19 7Z"
    })
  });
};
const ViewHeadline = /*#__PURE__*/forwardRef(Component$c);

const Component$b = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 16q1.875 0 3.188-1.312Q16.5 13.375 16.5 11.5t-1.312-3.188Q13.875 7 12 7T8.812 8.312Q7.5 9.625 7.5 11.5t1.312 3.188Q10.125 16 12 16m0-1.8q-1.125 0-1.912-.788Q9.3 12.625 9.3 11.5t.788-1.913Q10.875 8.8 12 8.8t1.913.787q.787.788.787 1.913t-.787 1.912T12 14.2m0 4.8q-3.475 0-6.35-1.837Q2.775 15.325 1.3 12.2q-.075-.125-.1-.313-.025-.187-.025-.387t.025-.388.1-.312q1.475-3.125 4.35-4.962Q8.525 4 12 4t6.35 1.838T22.7 10.8q.075.125.1.312.025.188.025.388t-.025.387-.1.313q-1.475 3.125-4.35 4.963Q15.475 19 12 19m0-2q2.825 0 5.188-1.488T20.8 11.5q-1.25-2.525-3.612-4.013T12 6Q9.175 6 6.812 7.487T3.2 11.5q1.25 2.525 3.612 4.012Q9.175 17 12 17"
    })
  });
};
const Visibility = /*#__PURE__*/forwardRef(Component$b);

const Component$a = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M12 16q1.875 0 3.188-1.312Q16.5 13.375 16.5 11.5t-1.312-3.188Q13.875 7 12 7T8.812 8.312Q7.5 9.625 7.5 11.5t1.312 3.188Q10.125 16 12 16m0-1.8q-1.125 0-1.912-.788Q9.3 12.625 9.3 11.5t.788-1.913Q10.875 8.8 12 8.8t1.913.787q.787.788.787 1.913t-.787 1.912T12 14.2m0 4.8q-3.475 0-6.35-1.837Q2.775 15.325 1.3 12.2q-.075-.125-.1-.313-.025-.187-.025-.387t.025-.388.1-.312q1.475-3.125 4.35-4.962Q8.525 4 12 4t6.35 1.838T22.7 10.8q.075.125.1.312.025.188.025.388t-.025.387-.1.313q-1.475 3.125-4.35 4.963Q15.475 19 12 19"
    })
  });
};
const VisibilityFilled = /*#__PURE__*/forwardRef(Component$a);

const Component$9 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m16.1 13.3-1.45-1.45q.225-1.175-.675-2.2t-2.325-.8L10.2 7.4q.425-.2.862-.3Q11.5 7 12 7q1.875 0 3.188 1.312Q16.5 9.625 16.5 11.5q0 .5-.1.938t-.3.862m3.2 3.15-1.45-1.4q.95-.725 1.688-1.588.737-.862 1.262-1.962-1.25-2.525-3.588-4.013T12 6q-.725 0-1.425.1T9.2 6.4L7.65 4.85q1.025-.425 2.1-.638Q10.825 4 12 4q3.575 0 6.425 1.887T22.7 10.8q.075.125.1.312.025.188.025.388t-.037.387q-.038.188-.088.313-.575 1.275-1.437 2.35t-1.963 1.9m-.2 5.45-3.5-3.45q-.875.275-1.762.413Q12.95 19 12 19q-3.575 0-6.425-1.887T1.3 12.2q-.075-.125-.1-.313-.025-.187-.025-.387t.025-.375.1-.3Q1.825 9.7 2.55 8.75T4.15 7L2.075 4.9Q1.8 4.625 1.8 4.212t.3-.712q.275-.275.7-.275t.7.275l17 17q.275.275.288.688t-.288.712q-.275.275-.7.275t-.7-.275M5.55 8.4q-.725.65-1.325 1.425T3.2 11.5q1.25 2.525 3.587 4.012Q9.125 17 12 17q.5 0 .975-.062.475-.063.975-.138l-.9-.95q-.275.075-.525.112T12 16q-1.875 0-3.188-1.312Q7.5 13.375 7.5 11.5q0-.275.037-.525.038-.25.113-.525Zm4.2 4.2"
    })
  });
};
const VisibilityOff = /*#__PURE__*/forwardRef(Component$9);

const Component$8 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m19.3 16.5-3.2-3.2q.2-.425.3-.862.1-.438.1-.938 0-1.875-1.312-3.188Q13.875 7 12 7q-.5 0-.938.1t-.862.3L7.65 4.85q1.025-.425 2.1-.638Q10.825 4 12 4q3.575 0 6.425 1.887T22.7 10.8q.075.125.1.312.025.188.025.388t-.037.387q-.038.188-.088.313-.575 1.275-1.437 2.375T19.3 16.5m-.2 5.4-3.5-3.45q-.875.275-1.762.413Q12.95 19 12 19q-3.575 0-6.425-1.887T1.3 12.2q-.075-.125-.1-.313-.025-.187-.025-.387t.025-.375.1-.3Q1.825 9.7 2.55 8.75T4.15 7L2.075 4.9Q1.8 4.625 1.8 4.212t.3-.712q.275-.275.7-.275t.7.275l17 17q.275.275.288.688t-.288.712q-.275.275-.7.275t-.7-.275M12 16q.275 0 .512-.025.238-.025.513-.1l-5.4-5.4q-.075.275-.1.513-.025.237-.025.512 0 1.875 1.312 3.188Q10.125 16 12 16m2.65-4.15-3-3q1.425-.225 2.325.8t.675 2.2"
    })
  });
};
const VisibilityOffFilled = /*#__PURE__*/forwardRef(Component$8);

const Component$7 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M2.725 21q-.575 0-.85-.5t0-1l9.25-16Q11.4 3 12 3t.875.5l9.25 16q.275.5 0 1t-.85.5ZM12 10q-.425 0-.712.287Q11 10.575 11 11v3q0 .425.288.712.287.288.712.288t.713-.288T13 14v-3q0-.425-.287-.713Q12.425 10 12 10m0 8q.425 0 .713-.288Q13 17.425 13 17t-.287-.712Q12.425 16 12 16t-.712.288Q11 16.575 11 17t.288.712Q11.575 18 12 18m-7.55 1h15.1L12 6Z"
    })
  });
};
const Warning = /*#__PURE__*/forwardRef(Component$7);

const Component$6 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M2.725 21q-.575 0-.85-.5t0-1l9.25-16Q11.4 3 12 3t.875.5l9.25 16q.275.5 0 1t-.85.5ZM12 10q-.425 0-.712.287Q11 10.575 11 11v3q0 .425.288.712.287.288.712.288t.713-.288T13 14v-3q0-.425-.287-.713Q12.425 10 12 10m0 8q.425 0 .713-.288Q13 17.425 13 17t-.287-.712Q12.425 16 12 16t-.712.288Q11 16.575 11 17t.288.712Q11.575 18 12 18"
    })
  });
};
const WarningFilled = /*#__PURE__*/forwardRef(Component$6);

const Component$5 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      d: "M2 21.5c.5-1.704 1.2-3.207 1.7-4.91-3.8-6.315.9-13.53 7.3-14.032 6-.6 11 3.508 11 9.12 0 5.913-6 10.924-12.8 8.92-.5-.1-1.2-.601-1.8-.701-.8 0-1.9.5-2.8.801-.9.3-1.7.602-2.6.802m5.6-3.307c5.5 3.207 12.1-.401 12.6-5.613.5-4.71-3.4-8.92-8.7-8.518-6 .4-9.7 7.316-5.9 12.327-.3.902-.6 1.704-.9 2.605 1-.2 1.9-.6 2.9-.801M9.8 7.269c.6 1.102 1.5 2.906 0 3.608.7 1.503 2 2.505 3.6 3.207.5-.3.9-.802 1.3-1.303.9.3 1.8.802 2.6 1.303.1 1.704-1.4 2.305-2.7 2.205-2.7-.1-6.3-3.308-7.2-5.713-.5-1.203.1-3.909 2.4-3.307",
      clipRule: "evenodd"
    })
  });
};
const Whatsapp = /*#__PURE__*/forwardRef(Component$5);

const Component$4 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "M5.3 14.275q-.45-.45-.425-1.075t.5-.975q1.375-1.05 3.063-1.638Q10.125 10 12 10q1.9 0 3.588.6 1.687.6 3.062 1.675.475.35.488.963.012.612-.438 1.062-.425.425-1.037.438-.613.012-1.138-.338-.975-.675-2.112-1.037Q13.275 13 12 13t-2.412.375Q8.45 13.75 7.5 14.4q-.55.375-1.162.338-.613-.038-1.038-.463M1.05 10.05Q.625 9.625.625 9.012q0-.612.45-1.012 2.225-1.875 5-2.938Q8.85 4 12 4t5.925 1.062q2.775 1.063 5 2.938.45.4.463 1 .012.6-.438 1.05-.425.425-1.037.45-.613.025-1.113-.375-1.825-1.475-4.062-2.3T12 7q-2.5 0-4.737.825t-4.063 2.3q-.5.4-1.112.375t-1.038-.45M12 20q-.85 0-1.425-.575T10 18t.575-1.425T12 16t1.425.575T14 18t-.575 1.425T12 20"
    })
  });
};
const Wifi = /*#__PURE__*/forwardRef(Component$4);

const Component$3 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M4 21q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 19V8q0-.824.587-1.412A1.93 1.93 0 0 1 4 6h4V4q0-.824.588-1.413A1.93 1.93 0 0 1 10 2h4q.825 0 1.412.587Q16 3.176 16 4v2h4q.824 0 1.413.588Q22 7.175 22 8v11q0 .824-.587 1.413A1.93 1.93 0 0 1 20 21zm0-2h16V8H4zm6-13h4V4h-4z"
    })
  });
};
const Work = /*#__PURE__*/forwardRef(Component$3);

const Component$2 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/jsx("path", {
      d: "M4 21q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 19V8q0-.824.587-1.412A1.93 1.93 0 0 1 4 6h4V4q0-.824.588-1.413A1.93 1.93 0 0 1 10 2h4q.825 0 1.412.587Q16 3.176 16 4v2h4q.824 0 1.413.588Q22 7.175 22 8v11q0 .824-.587 1.413A1.93 1.93 0 0 1 20 21zm6-15h4V4h-4z"
    })
  });
};
const WorkFilled = /*#__PURE__*/forwardRef(Component$2);

const Component$1 = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m18.9 20.3-5.6-5.6q-.75.6-1.725.95T9.5 16q-2.725 0-4.612-1.887T3 9.5t1.888-4.613Q6.775 3 9.5 3t4.613 1.887T16 9.5q0 1.1-.35 2.075T14.7 13.3l5.625 5.625q.275.275.263.687t-.288.688q-.275.275-.7.275t-.7-.275M9.5 14q1.875 0 3.188-1.312Q14 11.375 14 9.5t-1.312-3.188Q11.375 5 9.5 5T6.312 6.312Q5 7.625 5 9.5t1.312 3.188Q7.625 14 9.5 14m0-1.5q-.425 0-.712-.288-.288-.287-.288-.712v-1H7.475q-.425 0-.7-.288Q6.5 9.925 6.5 9.5t.287-.713Q7.075 8.5 7.5 8.5h1V7.475q0-.425.288-.7.287-.275.712-.275t.713.287q.287.288.287.713v1h1.025q.425 0 .7.287.275.288.275.713t-.287.712-.713.288h-1v1.025q0 .425-.287.7-.288.275-.713.275"
    })
  });
};
const ZoomIn = /*#__PURE__*/forwardRef(Component$1);

const Component = ({
  size = "DEFAULT",
  className,
  title
}, ref) => {
  return /*#__PURE__*/jsx("svg", {
    style: {
      "display": "block"
    },
    viewBox: "0 0 24 24",
    fill: "var(--icon-color)",
    ref: ref,
    role: !!title ? "img" : undefined,
    "aria-label": title,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    height: size === "DEFAULT" ? 24 : size === "SMALL" ? 16 : size,
    children: /*#__PURE__*/jsx("path", {
      d: "m18.9 20.3-5.6-5.6q-.75.6-1.725.95T9.5 16q-2.725 0-4.612-1.887T3 9.5t1.888-4.613Q6.775 3 9.5 3t4.613 1.887T16 9.5q0 1.1-.35 2.075T14.7 13.3l5.625 5.625q.275.275.263.687t-.288.688q-.275.275-.7.275t-.7-.275M9.5 14q1.875 0 3.188-1.312Q14 11.375 14 9.5t-1.312-3.188Q11.375 5 9.5 5T6.312 6.312Q5 7.625 5 9.5t1.312 3.188Q7.625 14 9.5 14m-1.525-3.5q-.425 0-.7-.288Q7 9.925 7 9.5t.287-.713Q7.575 8.5 8 8.5h3.025q.425 0 .7.287.275.288.275.713t-.287.712T11 10.5Z"
    })
  });
};
const ZoomOut = /*#__PURE__*/forwardRef(Component);

export { AccessibilityFilled, AccountBalance, AccountBalanceFilled, AccountTree, AccountTreeFilled, Add, AddCircle, AddCircleFilled, AddLink, AddListicon, AdsClick, AlarmOn, AlarmOnFilled, Anchor, Apartment, Apps, Archive, ArchiveFilled, ArrowBackwards, ArrowCircleCount, ArrowCircleCountFilled, ArrowCircleLeft, ArrowCircleLeftFilled, ArrowCircleRight, ArrowCircleRightFilled, ArrowCircleRightFilled as ArrowFilled, ArrowForward, ArrowForwardIos, Article, ArticleFilled, AssignState, AssignStateFilled, Assignment, AssignmentAdd, AssignmentAddFilled, AssignmentFilled, AttachFile, AttachFileAdd, AutoCreate, Autorenew, BankAnonymous, BelowCompany, BelowUnit, Book, BookFilled, Bookmark, BookmarkFilled, Brightness1, Brightness1Filled, BugReport, BugReportFilled, Bulb, Calculate, CalculateFilled, CalendarMonth, CalendarMonthFilled, Call, CallEnd, CallEndFilled, CallFilled, Cancel, CancelFilled, ChatLeft, ChatLeftFilled, ChatRight, ChatRightFilled, Check, CheckCircle, CheckCircleFilled, Checklist, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, Circle, CircleFilled, Close, CloseFullscreen, Code, CodeBlocks, CodeBlocksFilled, Coin, CoinFilled, Commissionmodel, CommissionmodelFilled, CompareArrows, Condition, ConnectionStateFilled, Contacts, ContactsFilled, ContentCopy, ContentCopyFilled, ContinueSigning, ContinueSigningFilled, CreateOffer, CropSquare, CropSquareFilled, DarkMode, DarkModeFilled, DataTable, DataTableFilled, Delete, DeleteFilled, DeleteForever, DeleteForeverFilled, Description, DescriptionFilled, Deselect, DesktopWindows, DesktopWindowsFilled, Dialpad, DirectionsAlt, DirectionsAltFilled, DoNotDisturbOff, DoNotDisturbOffFilled, DoNotDisturbOn, DoNotDisturbOnFilled, DockToLeft, DockToLeftFilled, DocumentExcel, DocumentExcelFilled, DocumentGeneral, DocumentGeneralFilled, DocumentInfo, DocumentInfoFilled, DocumentJson, DocumentJsonFilled, DocumentLeft, DocumentLeftFilled, DocumentPdf, DocumentPdfFilled, DocumentRight, DocumentRightFilled, DocumentSubscribe, DocumentSubscribeFilled, DocumentTime, DocumentTimeFilled, DocumentWord, DocumentWordFilled, DoneAll, DoneAllCircle, DoneAllCircleFilled, DoneOutline, DoubleArrow, Download, Draft, DraftFilled, DraftOrders, DraftOrdersFilled, DragHandle, Duplicate, DuplicateFilled, Edit, EditDocument, EditDocumentFilled, EditFilled, EditorChoice, EditorChoiceFilled, EmergencyHome, EmergencyHomeFilled, Error, ErrorFilled, EuroSymbol, Event, EventAvailable, EventAvailableFilled, EventFilled, ExpandCircleDown, ExpandCircleDownFilled, Extension, ExtensionFilled, Facebook, FamilyRestroom, Favorite, FavoriteFilled, Fax, FaxFilled, FileCopy, FileCopyFilled, FilterAlt, FilterAltFilled, FilterBAndW, Flightsmode, Folder, FolderCopy, FolderCopyFilled, FolderFilled, FolderOpen, FolderOpenFilled, FormatAlignCenter, FormatAlignJustify, FormatAlignLeft, FormatAlignRight, FormatBold, FormatColorText, FormatIndentDecrease, FormatIndentIncrease, FormatInkHighlighter, FormatInkHighlighterFilled, FormatItalic, FormatListBulleted, FormatListNumbered, FormatQuote, FormatQuoteFilled, FormatUnderlined, ForwardToInbox, ForwardToInboxFilled, FrequencyAnnual, FrequencyBiannual, FrequencyMonthly, FrequencyQuaterly, Fullscreen, FullscreenExit, Gba, GbaFilled, GridView, GridViewFilled, Group, GroupFilled, Headphones, HeadphonesFilled, Health, HealthFilled, Help, HelpFilled, HighQuality, HighQualityFilled, History, HomeStorage, HomeStorageFilled, HorizontalRule, House, HouseFilled, HouseSearch, HouseSearchFilled, Http, Image, ImageFilled, Imagesmode, ImagesmodeFilled, Imprint, Info, InfoFilled, Inventory, Irrelevant, IrrelevantFilled, Key, KeyFilled, KeyboardVoice, KeyboardVoiceFilled, LeftPanelCloseFilled, LeftPanelOpenFilled, LightbulbCircle, LightbulbCircleFilled, Link, LiveHelp, LiveHelpFilled, LocalPostOffice, LocalPostOfficeFilled, LocationOff, LocationOffFilled, LocationOn, LocationOnFilled, Lock, LockFilled, LockOpen, LockOpenFilled, Logout, LowPriority, Mail, MailFilled, ManageAccounts, ManualOffer, Map, MapFilled, MapSearch, MarkEmailRead, Menu, MicOff, MicOffFilled, Monolith, MoodBad, MoreVert, MyLocation, MyLocationFilled, NotListedLocation, NotListedLocationFilled, NoteAdd, NoteAddFilled, NotificationActive, NotificationActiveFilled, Notifications, NotificationsFilled, Offer, OfferFilled, OpenInFull, OpenInNew, Outbox, OutboxFilled, Palette, PaletteFilled, Pause, PauseCircle, PauseCircleFilled, PauseFilled, Payments, PaymentsFilled, Pending, PendingFilled, Person, PersonAdd, PersonAddFilled, PersonArrow, PersonArrowFilled, PersonCheck, PersonCheckFilled, PersonFilled, PersonOff, PersonOffFilled, PersonShield, PersonShieldFilled, PhoneCallback, PhoneCallbackFilled, PhoneForwarded, PhoneForwardedFilled, PhoneMissed, PhoneMissedFilled, Pin, PinFilled, Pip, PipExit, PlayArrow, PlayArrowFilled, PlayCircle, PlayCircleFilled, Postbox, PostboxFilled, Preinquiry, PreinquiryConsultant, PreinquiryState, PreinquiryTime, Preview, PreviewFilled, PriorityHigh, PushPin, PushPinFilled, QuickReferenceAll, QuickReferenceAllFilled, Redo, Refresh, Remove, Reply, ReplyAll, Reset, RestoreFromTrash, RestoreFromTrashFilled, RestorePage, RestorePageFilled, RightPanelCloseFilled, RightPanelOpenFilled, Rotate180, RotateLeft, RotateRight, Rule, Save, SaveFilled, Savings, SavingsFilled, ScanDelete, ScanDeleteFilled, Schedule, ScheduleFilled, ScreenShare, ScreenShareFilled, Search, SelectAll, Send, SendFilled, SentimentDissatisfied, SentimentNeutral, SentimentSatisfied, SentimentVerySatisfied, Settings, SettingsBRoll, SettingsBRollFilled, SettingsFilled, Share, ShareFilled, Shield, ShieldFilled, SiteMap, SmartToy, SmartToyFilled, Sms, SmsFilled, Sort, Star, StarFilled, StateIdea, StateIdeaFilled, Pending as StatePending, PendingFilled as StatePendingFilled, StateSend, StateSendFilled, StateThumb, StateThumbFilled, Pending$1 as StatusPending, PendingFilled$1 as StatusPendingFilled, StickyNote2, StickyNote2Filled, StopCircle, StopScreenShare, StopScreenShareFilled, StrikethroughS, SwapHoriz, Switch, SwitchDown, SwitchFilled, SwitchLeft, SwitchRight, SwitchUp, Sync, SyncProblem, TableRows, TableRowsFilled, TaskDone, TaskDoneFilled, TaskEdit, TaskEditFilled, TextDecrease, TextIncrease, ThumbUp, ThumbUpFilled, Title, Trip, TripFilled, TwitterFilled, Unarchive, UnarchiveFilled, Undo, UnfoldLess, UnfoldMore, Unpublished, UnpublishedFilled, Upload, UploadFile, UploadFileFilled, ViewAgenda, ViewAgendaFilled, ViewHeadline, Visibility, VisibilityFilled, VisibilityOff, VisibilityOffFilled, Warning, WarningFilled, Whatsapp, Wifi, Work, WorkFilled, ZoomIn, ZoomOut };
//# sourceMappingURL=index.js.map
